function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e83) { throw _e83; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e84) { didErr = true; err = _e84; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*! For license information please see admin.js.LICENSE.txt */
!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["@asgerb/apparatus"] = t() : e["@asgerb/apparatus"] = t();
}(self, function () {
  return function () {
    var e = {
      6599: function _(e, t, n) {
        "use strict";

        n.d(t, {
          Mx: function Mx() {
            return N;
          },
          Qr: function Qr() {
            return V;
          }
        });

        var r = /*#__PURE__*/function () {
          function r(e, t, n) {
            _classCallCheck(this, r);

            this.eventTarget = e, this.eventName = t, this.eventOptions = n, this.unorderedBindings = new Set();
          }

          _createClass(r, [{
            key: "connect",
            value: function connect() {
              this.eventTarget.addEventListener(this.eventName, this, this.eventOptions);
            }
          }, {
            key: "disconnect",
            value: function disconnect() {
              this.eventTarget.removeEventListener(this.eventName, this, this.eventOptions);
            }
          }, {
            key: "bindingConnected",
            value: function bindingConnected(e) {
              this.unorderedBindings.add(e);
            }
          }, {
            key: "bindingDisconnected",
            value: function bindingDisconnected(e) {
              this.unorderedBindings.delete(e);
            }
          }, {
            key: "handleEvent",
            value: function handleEvent(e) {
              var t = function (e) {
                if ("immediatePropagationStopped" in e) return e;
                {
                  var _t = e.stopImmediatePropagation;
                  return Object.assign(e, {
                    immediatePropagationStopped: !1,
                    stopImmediatePropagation: function stopImmediatePropagation() {
                      this.immediatePropagationStopped = !0, _t.call(this);
                    }
                  });
                }
              }(e);

              var _iterator = _createForOfIteratorHelper(this.bindings),
                  _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var _e2 = _step.value;
                  if (t.immediatePropagationStopped) break;

                  _e2.handleEvent(t);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }
          }, {
            key: "bindings",
            get: function get() {
              return Array.from(this.unorderedBindings).sort(function (e, t) {
                var n = e.index,
                    _r = t.index;
                return n < _r ? -1 : n > _r ? 1 : 0;
              });
            }
          }]);

          return r;
        }();

        var o = /*#__PURE__*/function () {
          function o(e) {
            _classCallCheck(this, o);

            this.application = e, this.eventListenerMaps = new Map(), this.started = !1;
          }

          _createClass(o, [{
            key: "start",
            value: function start() {
              this.started || (this.started = !0, this.eventListeners.forEach(function (e) {
                return e.connect();
              }));
            }
          }, {
            key: "stop",
            value: function stop() {
              this.started && (this.started = !1, this.eventListeners.forEach(function (e) {
                return e.disconnect();
              }));
            }
          }, {
            key: "eventListeners",
            get: function get() {
              return Array.from(this.eventListenerMaps.values()).reduce(function (e, t) {
                return e.concat(Array.from(t.values()));
              }, []);
            }
          }, {
            key: "bindingConnected",
            value: function bindingConnected(e) {
              this.fetchEventListenerForBinding(e).bindingConnected(e);
            }
          }, {
            key: "bindingDisconnected",
            value: function bindingDisconnected(e) {
              this.fetchEventListenerForBinding(e).bindingDisconnected(e);
            }
          }, {
            key: "handleError",
            value: function handleError(e, t) {
              var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              this.application.handleError(e, "Error ".concat(t), n);
            }
          }, {
            key: "fetchEventListenerForBinding",
            value: function fetchEventListenerForBinding(e) {
              var t = e.eventTarget,
                  n = e.eventName,
                  r = e.eventOptions;
              return this.fetchEventListener(t, n, r);
            }
          }, {
            key: "fetchEventListener",
            value: function fetchEventListener(e, t, n) {
              var r = this.fetchEventListenerMapForEventTarget(e),
                  _o = this.cacheKey(t, n);

              var i = r.get(_o);
              return i || (i = this.createEventListener(e, t, n), r.set(_o, i)), i;
            }
          }, {
            key: "createEventListener",
            value: function createEventListener(e, t, n) {
              var _o2 = new r(e, t, n);

              return this.started && _o2.connect(), _o2;
            }
          }, {
            key: "fetchEventListenerMapForEventTarget",
            value: function fetchEventListenerMapForEventTarget(e) {
              var t = this.eventListenerMaps.get(e);
              return t || (t = new Map(), this.eventListenerMaps.set(e, t)), t;
            }
          }, {
            key: "cacheKey",
            value: function cacheKey(e, t) {
              var n = [e];
              return Object.keys(t).sort().forEach(function (e) {
                n.push("".concat(t[e] ? "" : "!").concat(e));
              }), n.join(":");
            }
          }]);

          return o;
        }();

        var i = /^((.+?)(@(window|document))?->)?(.+?)(#([^:]+?))(:(.+))?$/;

        function s(e) {
          return e.replace(/(?:[_-])([a-z0-9])/g, function (e, t) {
            return t.toUpperCase();
          });
        }

        function a(e) {
          return e.charAt(0).toUpperCase() + e.slice(1);
        }

        function l(e) {
          return e.replace(/([A-Z])/g, function (e, t) {
            return "-".concat(t.toLowerCase());
          });
        }

        var c = {
          a: function a(e) {
            return "click";
          },
          button: function button(e) {
            return "click";
          },
          form: function form(e) {
            return "submit";
          },
          details: function details(e) {
            return "toggle";
          },
          input: function input(e) {
            return "submit" == e.getAttribute("type") ? "click" : "input";
          },
          select: function select(e) {
            return "change";
          },
          textarea: function textarea(e) {
            return "input";
          }
        };

        function u(e) {
          throw new Error(e);
        }

        function d(e) {
          try {
            return JSON.parse(e);
          } catch (t) {
            return e;
          }
        }

        var h = /*#__PURE__*/function () {
          function h(e, t) {
            _classCallCheck(this, h);

            this.context = e, this.action = t;
          }

          _createClass(h, [{
            key: "index",
            get: function get() {
              return this.action.index;
            }
          }, {
            key: "eventTarget",
            get: function get() {
              return this.action.eventTarget;
            }
          }, {
            key: "eventOptions",
            get: function get() {
              return this.action.eventOptions;
            }
          }, {
            key: "identifier",
            get: function get() {
              return this.context.identifier;
            }
          }, {
            key: "handleEvent",
            value: function handleEvent(e) {
              this.willBeInvokedByEvent(e) && this.invokeWithEvent(e);
            }
          }, {
            key: "eventName",
            get: function get() {
              return this.action.eventName;
            }
          }, {
            key: "method",
            get: function get() {
              var e = this.controller[this.methodName];
              if ("function" == typeof e) return e;
              throw new Error("Action \"".concat(this.action, "\" references undefined method \"").concat(this.methodName, "\""));
            }
          }, {
            key: "invokeWithEvent",
            value: function invokeWithEvent(e) {
              var t = e.target,
                  n = e.currentTarget;

              try {
                var _r2 = this.action.params,
                    _o3 = Object.assign(e, {
                  params: _r2
                });

                this.method.call(this.controller, _o3), this.context.logDebugActivity(this.methodName, {
                  event: e,
                  target: t,
                  currentTarget: n,
                  action: this.methodName
                });
              } catch (t) {
                var _n = this.identifier,
                    _r3 = this.controller,
                    _o4 = this.element,
                    _i = this.index,
                    _s = {
                  identifier: _n,
                  controller: _r3,
                  element: _o4,
                  index: _i,
                  event: e
                };
                this.context.handleError(t, "invoking action \"".concat(this.action, "\""), _s);
              }
            }
          }, {
            key: "willBeInvokedByEvent",
            value: function willBeInvokedByEvent(e) {
              var t = e.target;
              return this.element === t || (t instanceof Element && this.element.contains(t) ? this.scope.containsElement(t) : this.scope.containsElement(this.action.element));
            }
          }, {
            key: "controller",
            get: function get() {
              return this.context.controller;
            }
          }, {
            key: "methodName",
            get: function get() {
              return this.action.methodName;
            }
          }, {
            key: "element",
            get: function get() {
              return this.scope.element;
            }
          }, {
            key: "scope",
            get: function get() {
              return this.context.scope;
            }
          }]);

          return h;
        }();

        var f = /*#__PURE__*/function () {
          function f(e, t) {
            var _this = this;

            _classCallCheck(this, f);

            this.mutationObserverInit = {
              attributes: !0,
              childList: !0,
              subtree: !0
            }, this.element = e, this.started = !1, this.delegate = t, this.elements = new Set(), this.mutationObserver = new MutationObserver(function (e) {
              return _this.processMutations(e);
            });
          }

          _createClass(f, [{
            key: "start",
            value: function start() {
              this.started || (this.started = !0, this.mutationObserver.observe(this.element, this.mutationObserverInit), this.refresh());
            }
          }, {
            key: "pause",
            value: function pause(e) {
              this.started && (this.mutationObserver.disconnect(), this.started = !1), e(), this.started || (this.mutationObserver.observe(this.element, this.mutationObserverInit), this.started = !0);
            }
          }, {
            key: "stop",
            value: function stop() {
              this.started && (this.mutationObserver.takeRecords(), this.mutationObserver.disconnect(), this.started = !1);
            }
          }, {
            key: "refresh",
            value: function refresh() {
              if (this.started) {
                var _e3 = new Set(this.matchElementsInTree());

                for (var _i2 = 0, _Array$from = Array.from(this.elements); _i2 < _Array$from.length; _i2++) {
                  var _t2 = _Array$from[_i2];
                  _e3.has(_t2) || this.removeElement(_t2);
                }

                for (var _i3 = 0, _Array$from2 = Array.from(_e3); _i3 < _Array$from2.length; _i3++) {
                  var _t3 = _Array$from2[_i3];
                  this.addElement(_t3);
                }
              }
            }
          }, {
            key: "processMutations",
            value: function processMutations(e) {
              if (this.started) {
                var _iterator2 = _createForOfIteratorHelper(e),
                    _step2;

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    var _t4 = _step2.value;
                    this.processMutation(_t4);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
              }
            }
          }, {
            key: "processMutation",
            value: function processMutation(e) {
              "attributes" == e.type ? this.processAttributeChange(e.target, e.attributeName) : "childList" == e.type && (this.processRemovedNodes(e.removedNodes), this.processAddedNodes(e.addedNodes));
            }
          }, {
            key: "processAttributeChange",
            value: function processAttributeChange(e, t) {
              var n = e;
              this.elements.has(n) ? this.delegate.elementAttributeChanged && this.matchElement(n) ? this.delegate.elementAttributeChanged(n, t) : this.removeElement(n) : this.matchElement(n) && this.addElement(n);
            }
          }, {
            key: "processRemovedNodes",
            value: function processRemovedNodes(e) {
              for (var _i4 = 0, _Array$from3 = Array.from(e); _i4 < _Array$from3.length; _i4++) {
                var _t5 = _Array$from3[_i4];

                var _e4 = this.elementFromNode(_t5);

                _e4 && this.processTree(_e4, this.removeElement);
              }
            }
          }, {
            key: "processAddedNodes",
            value: function processAddedNodes(e) {
              for (var _i5 = 0, _Array$from4 = Array.from(e); _i5 < _Array$from4.length; _i5++) {
                var _t6 = _Array$from4[_i5];

                var _e5 = this.elementFromNode(_t6);

                _e5 && this.elementIsActive(_e5) && this.processTree(_e5, this.addElement);
              }
            }
          }, {
            key: "matchElement",
            value: function matchElement(e) {
              return this.delegate.matchElement(e);
            }
          }, {
            key: "matchElementsInTree",
            value: function matchElementsInTree() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.element;
              return this.delegate.matchElementsInTree(e);
            }
          }, {
            key: "processTree",
            value: function processTree(e, t) {
              var _iterator3 = _createForOfIteratorHelper(this.matchElementsInTree(e)),
                  _step3;

              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var _n2 = _step3.value;
                  t.call(this, _n2);
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            }
          }, {
            key: "elementFromNode",
            value: function elementFromNode(e) {
              if (e.nodeType == Node.ELEMENT_NODE) return e;
            }
          }, {
            key: "elementIsActive",
            value: function elementIsActive(e) {
              return e.isConnected == this.element.isConnected && this.element.contains(e);
            }
          }, {
            key: "addElement",
            value: function addElement(e) {
              this.elements.has(e) || this.elementIsActive(e) && (this.elements.add(e), this.delegate.elementMatched && this.delegate.elementMatched(e));
            }
          }, {
            key: "removeElement",
            value: function removeElement(e) {
              this.elements.has(e) && (this.elements.delete(e), this.delegate.elementUnmatched && this.delegate.elementUnmatched(e));
            }
          }]);

          return f;
        }();

        var p = /*#__PURE__*/function () {
          function p(e, t, n) {
            _classCallCheck(this, p);

            this.attributeName = t, this.delegate = n, this.elementObserver = new f(e, this);
          }

          _createClass(p, [{
            key: "element",
            get: function get() {
              return this.elementObserver.element;
            }
          }, {
            key: "selector",
            get: function get() {
              return "[".concat(this.attributeName, "]");
            }
          }, {
            key: "start",
            value: function start() {
              this.elementObserver.start();
            }
          }, {
            key: "pause",
            value: function pause(e) {
              this.elementObserver.pause(e);
            }
          }, {
            key: "stop",
            value: function stop() {
              this.elementObserver.stop();
            }
          }, {
            key: "refresh",
            value: function refresh() {
              this.elementObserver.refresh();
            }
          }, {
            key: "started",
            get: function get() {
              return this.elementObserver.started;
            }
          }, {
            key: "matchElement",
            value: function matchElement(e) {
              return e.hasAttribute(this.attributeName);
            }
          }, {
            key: "matchElementsInTree",
            value: function matchElementsInTree(e) {
              var t = this.matchElement(e) ? [e] : [],
                  n = Array.from(e.querySelectorAll(this.selector));
              return t.concat(n);
            }
          }, {
            key: "elementMatched",
            value: function elementMatched(e) {
              this.delegate.elementMatchedAttribute && this.delegate.elementMatchedAttribute(e, this.attributeName);
            }
          }, {
            key: "elementUnmatched",
            value: function elementUnmatched(e) {
              this.delegate.elementUnmatchedAttribute && this.delegate.elementUnmatchedAttribute(e, this.attributeName);
            }
          }, {
            key: "elementAttributeChanged",
            value: function elementAttributeChanged(e, t) {
              this.delegate.elementAttributeValueChanged && this.attributeName == t && this.delegate.elementAttributeValueChanged(e, t);
            }
          }]);

          return p;
        }();

        var g = /*#__PURE__*/function () {
          function g(e, t) {
            var _this2 = this;

            _classCallCheck(this, g);

            this.element = e, this.delegate = t, this.started = !1, this.stringMap = new Map(), this.mutationObserver = new MutationObserver(function (e) {
              return _this2.processMutations(e);
            });
          }

          _createClass(g, [{
            key: "start",
            value: function start() {
              this.started || (this.started = !0, this.mutationObserver.observe(this.element, {
                attributes: !0,
                attributeOldValue: !0
              }), this.refresh());
            }
          }, {
            key: "stop",
            value: function stop() {
              this.started && (this.mutationObserver.takeRecords(), this.mutationObserver.disconnect(), this.started = !1);
            }
          }, {
            key: "refresh",
            value: function refresh() {
              if (this.started) {
                var _iterator4 = _createForOfIteratorHelper(this.knownAttributeNames),
                    _step4;

                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    var _e6 = _step4.value;
                    this.refreshAttribute(_e6, null);
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }
              }
            }
          }, {
            key: "processMutations",
            value: function processMutations(e) {
              if (this.started) {
                var _iterator5 = _createForOfIteratorHelper(e),
                    _step5;

                try {
                  for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                    var _t7 = _step5.value;
                    this.processMutation(_t7);
                  }
                } catch (err) {
                  _iterator5.e(err);
                } finally {
                  _iterator5.f();
                }
              }
            }
          }, {
            key: "processMutation",
            value: function processMutation(e) {
              var t = e.attributeName;
              t && this.refreshAttribute(t, e.oldValue);
            }
          }, {
            key: "refreshAttribute",
            value: function refreshAttribute(e, t) {
              var n = this.delegate.getStringMapKeyForAttribute(e);

              if (null != n) {
                this.stringMap.has(e) || this.stringMapKeyAdded(n, e);

                var _r4 = this.element.getAttribute(e);

                if (this.stringMap.get(e) != _r4 && this.stringMapValueChanged(_r4, n, t), null == _r4) {
                  var _t8 = this.stringMap.get(e);

                  this.stringMap.delete(e), _t8 && this.stringMapKeyRemoved(n, e, _t8);
                } else this.stringMap.set(e, _r4);
              }
            }
          }, {
            key: "stringMapKeyAdded",
            value: function stringMapKeyAdded(e, t) {
              this.delegate.stringMapKeyAdded && this.delegate.stringMapKeyAdded(e, t);
            }
          }, {
            key: "stringMapValueChanged",
            value: function stringMapValueChanged(e, t, n) {
              this.delegate.stringMapValueChanged && this.delegate.stringMapValueChanged(e, t, n);
            }
          }, {
            key: "stringMapKeyRemoved",
            value: function stringMapKeyRemoved(e, t, n) {
              this.delegate.stringMapKeyRemoved && this.delegate.stringMapKeyRemoved(e, t, n);
            }
          }, {
            key: "knownAttributeNames",
            get: function get() {
              return Array.from(new Set(this.currentAttributeNames.concat(this.recordedAttributeNames)));
            }
          }, {
            key: "currentAttributeNames",
            get: function get() {
              return Array.from(this.element.attributes).map(function (e) {
                return e.name;
              });
            }
          }, {
            key: "recordedAttributeNames",
            get: function get() {
              return Array.from(this.stringMap.keys());
            }
          }]);

          return g;
        }();

        function m(e, t) {
          var n = e.get(t);
          return n || (n = new Set(), e.set(t, n)), n;
        }

        var v = /*#__PURE__*/function () {
          function v() {
            _classCallCheck(this, v);

            this.valuesByKey = new Map();
          }

          _createClass(v, [{
            key: "keys",
            get: function get() {
              return Array.from(this.valuesByKey.keys());
            }
          }, {
            key: "values",
            get: function get() {
              return Array.from(this.valuesByKey.values()).reduce(function (e, t) {
                return e.concat(Array.from(t));
              }, []);
            }
          }, {
            key: "size",
            get: function get() {
              return Array.from(this.valuesByKey.values()).reduce(function (e, t) {
                return e + t.size;
              }, 0);
            }
          }, {
            key: "add",
            value: function add(e, t) {
              !function (e, t, n) {
                m(e, t).add(n);
              }(this.valuesByKey, e, t);
            }
          }, {
            key: "delete",
            value: function _delete(e, t) {
              !function (e, t, n) {
                m(e, t).delete(n), function (e, t) {
                  var n = e.get(t);
                  null != n && 0 == n.size && e.delete(t);
                }(e, t);
              }(this.valuesByKey, e, t);
            }
          }, {
            key: "has",
            value: function has(e, t) {
              var n = this.valuesByKey.get(e);
              return null != n && n.has(t);
            }
          }, {
            key: "hasKey",
            value: function hasKey(e) {
              return this.valuesByKey.has(e);
            }
          }, {
            key: "hasValue",
            value: function hasValue(e) {
              return Array.from(this.valuesByKey.values()).some(function (t) {
                return t.has(e);
              });
            }
          }, {
            key: "getValuesForKey",
            value: function getValuesForKey(e) {
              var t = this.valuesByKey.get(e);
              return t ? Array.from(t) : [];
            }
          }, {
            key: "getKeysForValue",
            value: function getKeysForValue(e) {
              return Array.from(this.valuesByKey).filter(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    t = _ref2[0],
                    n = _ref2[1];

                return n.has(e);
              }).map(function (_ref3) {
                var _ref4 = _slicedToArray(_ref3, 2),
                    e = _ref4[0],
                    t = _ref4[1];

                return e;
              });
            }
          }]);

          return v;
        }();

        var y = /*#__PURE__*/function () {
          function y(e, t, n) {
            _classCallCheck(this, y);

            this.attributeObserver = new p(e, t, this), this.delegate = n, this.tokensByElement = new v();
          }

          _createClass(y, [{
            key: "started",
            get: function get() {
              return this.attributeObserver.started;
            }
          }, {
            key: "start",
            value: function start() {
              this.attributeObserver.start();
            }
          }, {
            key: "pause",
            value: function pause(e) {
              this.attributeObserver.pause(e);
            }
          }, {
            key: "stop",
            value: function stop() {
              this.attributeObserver.stop();
            }
          }, {
            key: "refresh",
            value: function refresh() {
              this.attributeObserver.refresh();
            }
          }, {
            key: "element",
            get: function get() {
              return this.attributeObserver.element;
            }
          }, {
            key: "attributeName",
            get: function get() {
              return this.attributeObserver.attributeName;
            }
          }, {
            key: "elementMatchedAttribute",
            value: function elementMatchedAttribute(e) {
              this.tokensMatched(this.readTokensForElement(e));
            }
          }, {
            key: "elementAttributeValueChanged",
            value: function elementAttributeValueChanged(e) {
              var _this$refreshTokensFo = this.refreshTokensForElement(e),
                  _this$refreshTokensFo2 = _slicedToArray(_this$refreshTokensFo, 2),
                  t = _this$refreshTokensFo2[0],
                  n = _this$refreshTokensFo2[1];

              this.tokensUnmatched(t), this.tokensMatched(n);
            }
          }, {
            key: "elementUnmatchedAttribute",
            value: function elementUnmatchedAttribute(e) {
              this.tokensUnmatched(this.tokensByElement.getValuesForKey(e));
            }
          }, {
            key: "tokensMatched",
            value: function tokensMatched(e) {
              var _this3 = this;

              e.forEach(function (e) {
                return _this3.tokenMatched(e);
              });
            }
          }, {
            key: "tokensUnmatched",
            value: function tokensUnmatched(e) {
              var _this4 = this;

              e.forEach(function (e) {
                return _this4.tokenUnmatched(e);
              });
            }
          }, {
            key: "tokenMatched",
            value: function tokenMatched(e) {
              this.delegate.tokenMatched(e), this.tokensByElement.add(e.element, e);
            }
          }, {
            key: "tokenUnmatched",
            value: function tokenUnmatched(e) {
              this.delegate.tokenUnmatched(e), this.tokensByElement.delete(e.element, e);
            }
          }, {
            key: "refreshTokensForElement",
            value: function refreshTokensForElement(e) {
              var t = this.tokensByElement.getValuesForKey(e),
                  n = this.readTokensForElement(e),
                  r = function (e, t) {
                var n = Math.max(e.length, t.length);
                return Array.from({
                  length: n
                }, function (n, r) {
                  return [e[r], t[r]];
                });
              }(t, n).findIndex(function (_ref5) {
                var _ref6 = _slicedToArray(_ref5, 2),
                    e = _ref6[0],
                    t = _ref6[1];

                return r = t, !((n = e) && r && n.index == r.index && n.content == r.content);
                var n, r;
              });

              return -1 == r ? [[], []] : [t.slice(r), n.slice(r)];
            }
          }, {
            key: "readTokensForElement",
            value: function readTokensForElement(e) {
              var t = this.attributeName;
              return function (e, t, n) {
                return e.trim().split(/\s+/).filter(function (e) {
                  return e.length;
                }).map(function (e, r) {
                  return {
                    element: t,
                    attributeName: n,
                    content: e,
                    index: r
                  };
                });
              }(e.getAttribute(t) || "", e, t);
            }
          }]);

          return y;
        }();

        var b = /*#__PURE__*/function () {
          function b(e, t, n) {
            _classCallCheck(this, b);

            this.tokenListObserver = new y(e, t, this), this.delegate = n, this.parseResultsByToken = new WeakMap(), this.valuesByTokenByElement = new WeakMap();
          }

          _createClass(b, [{
            key: "started",
            get: function get() {
              return this.tokenListObserver.started;
            }
          }, {
            key: "start",
            value: function start() {
              this.tokenListObserver.start();
            }
          }, {
            key: "stop",
            value: function stop() {
              this.tokenListObserver.stop();
            }
          }, {
            key: "refresh",
            value: function refresh() {
              this.tokenListObserver.refresh();
            }
          }, {
            key: "element",
            get: function get() {
              return this.tokenListObserver.element;
            }
          }, {
            key: "attributeName",
            get: function get() {
              return this.tokenListObserver.attributeName;
            }
          }, {
            key: "tokenMatched",
            value: function tokenMatched(e) {
              var t = e.element,
                  _this$fetchParseResul = this.fetchParseResultForToken(e),
                  n = _this$fetchParseResul.value;

              n && (this.fetchValuesByTokenForElement(t).set(e, n), this.delegate.elementMatchedValue(t, n));
            }
          }, {
            key: "tokenUnmatched",
            value: function tokenUnmatched(e) {
              var t = e.element,
                  _this$fetchParseResul2 = this.fetchParseResultForToken(e),
                  n = _this$fetchParseResul2.value;

              n && (this.fetchValuesByTokenForElement(t).delete(e), this.delegate.elementUnmatchedValue(t, n));
            }
          }, {
            key: "fetchParseResultForToken",
            value: function fetchParseResultForToken(e) {
              var t = this.parseResultsByToken.get(e);
              return t || (t = this.parseToken(e), this.parseResultsByToken.set(e, t)), t;
            }
          }, {
            key: "fetchValuesByTokenForElement",
            value: function fetchValuesByTokenForElement(e) {
              var t = this.valuesByTokenByElement.get(e);
              return t || (t = new Map(), this.valuesByTokenByElement.set(e, t)), t;
            }
          }, {
            key: "parseToken",
            value: function parseToken(e) {
              try {
                return {
                  value: this.delegate.parseValueForToken(e)
                };
              } catch (e) {
                return {
                  error: e
                };
              }
            }
          }]);

          return b;
        }();

        var w = /*#__PURE__*/function () {
          function w(e, t) {
            _classCallCheck(this, w);

            this.context = e, this.delegate = t, this.bindingsByAction = new Map();
          }

          _createClass(w, [{
            key: "start",
            value: function start() {
              this.valueListObserver || (this.valueListObserver = new b(this.element, this.actionAttribute, this), this.valueListObserver.start());
            }
          }, {
            key: "stop",
            value: function stop() {
              this.valueListObserver && (this.valueListObserver.stop(), delete this.valueListObserver, this.disconnectAllActions());
            }
          }, {
            key: "element",
            get: function get() {
              return this.context.element;
            }
          }, {
            key: "identifier",
            get: function get() {
              return this.context.identifier;
            }
          }, {
            key: "actionAttribute",
            get: function get() {
              return this.schema.actionAttribute;
            }
          }, {
            key: "schema",
            get: function get() {
              return this.context.schema;
            }
          }, {
            key: "bindings",
            get: function get() {
              return Array.from(this.bindingsByAction.values());
            }
          }, {
            key: "connectAction",
            value: function connectAction(e) {
              var t = new h(this.context, e);
              this.bindingsByAction.set(e, t), this.delegate.bindingConnected(t);
            }
          }, {
            key: "disconnectAction",
            value: function disconnectAction(e) {
              var t = this.bindingsByAction.get(e);
              t && (this.bindingsByAction.delete(e), this.delegate.bindingDisconnected(t));
            }
          }, {
            key: "disconnectAllActions",
            value: function disconnectAllActions() {
              var _this5 = this;

              this.bindings.forEach(function (e) {
                return _this5.delegate.bindingDisconnected(e);
              }), this.bindingsByAction.clear();
            }
          }, {
            key: "parseValueForToken",
            value: function parseValueForToken(e) {
              var t = /*#__PURE__*/function () {
                function _class(e, t, n) {
                  _classCallCheck(this, _class);

                  this.element = e, this.index = t, this.eventTarget = n.eventTarget || e, this.eventName = n.eventName || function (e) {
                    var t = e.tagName.toLowerCase();
                    if (t in c) return c[t](e);
                  }(e) || u("missing event name"), this.eventOptions = n.eventOptions || {}, this.identifier = n.identifier || u("missing identifier"), this.methodName = n.methodName || u("missing method name");
                }

                _createClass(_class, [{
                  key: "toString",
                  value: function toString() {
                    var e = this.eventTargetName ? "@".concat(this.eventTargetName) : "";
                    return "".concat(this.eventName).concat(e, "->").concat(this.identifier, "#").concat(this.methodName);
                  }
                }, {
                  key: "params",
                  get: function get() {
                    return this.eventTarget instanceof Element ? this.getParamsFromEventTargetAttributes(this.eventTarget) : {};
                  }
                }, {
                  key: "getParamsFromEventTargetAttributes",
                  value: function getParamsFromEventTargetAttributes(e) {
                    var t = {},
                        n = new RegExp("^data-".concat(this.identifier, "-(.+)-param$"));
                    return Array.from(e.attributes).forEach(function (_ref7) {
                      var e = _ref7.name,
                          r = _ref7.value;
                      var o = e.match(n),
                          i = o && o[1];
                      i && Object.assign(t, _defineProperty({}, s(i), d(r)));
                    }), t;
                  }
                }, {
                  key: "eventTargetName",
                  get: function get() {
                    return (e = this.eventTarget) == window ? "window" : e == document ? "document" : void 0;
                    var e;
                  }
                }], [{
                  key: "forToken",
                  value: function forToken(e) {
                    return new this(e.element, e.index, function (e) {
                      var t = e.trim().match(i) || [];
                      return {
                        eventTarget: (n = t[4], "window" == n ? window : "document" == n ? document : void 0),
                        eventName: t[2],
                        eventOptions: t[9] ? (r = t[9], r.split(":").reduce(function (e, t) {
                          return Object.assign(e, _defineProperty({}, t.replace(/^!/, ""), !/^!/.test(t)));
                        }, {})) : {},
                        identifier: t[5],
                        methodName: t[7]
                      };
                      var n, r;
                    }(e.content));
                  }
                }]);

                return _class;
              }().forToken(e);

              if (t.identifier == this.identifier) return t;
            }
          }, {
            key: "elementMatchedValue",
            value: function elementMatchedValue(e, t) {
              this.connectAction(t);
            }
          }, {
            key: "elementUnmatchedValue",
            value: function elementUnmatchedValue(e, t) {
              this.disconnectAction(t);
            }
          }]);

          return w;
        }();

        var O = /*#__PURE__*/function () {
          function O(e, t) {
            _classCallCheck(this, O);

            this.context = e, this.receiver = t, this.stringMapObserver = new g(this.element, this), this.valueDescriptorMap = this.controller.valueDescriptorMap, this.invokeChangedCallbacksForDefaultValues();
          }

          _createClass(O, [{
            key: "start",
            value: function start() {
              this.stringMapObserver.start();
            }
          }, {
            key: "stop",
            value: function stop() {
              this.stringMapObserver.stop();
            }
          }, {
            key: "element",
            get: function get() {
              return this.context.element;
            }
          }, {
            key: "controller",
            get: function get() {
              return this.context.controller;
            }
          }, {
            key: "getStringMapKeyForAttribute",
            value: function getStringMapKeyForAttribute(e) {
              if (e in this.valueDescriptorMap) return this.valueDescriptorMap[e].name;
            }
          }, {
            key: "stringMapKeyAdded",
            value: function stringMapKeyAdded(e, t) {
              var n = this.valueDescriptorMap[t];
              this.hasValue(e) || this.invokeChangedCallback(e, n.writer(this.receiver[e]), n.writer(n.defaultValue));
            }
          }, {
            key: "stringMapValueChanged",
            value: function stringMapValueChanged(e, t, n) {
              var r = this.valueDescriptorNameMap[t];
              null !== e && (null === n && (n = r.writer(r.defaultValue)), this.invokeChangedCallback(t, e, n));
            }
          }, {
            key: "stringMapKeyRemoved",
            value: function stringMapKeyRemoved(e, t, n) {
              var r = this.valueDescriptorNameMap[e];
              this.hasValue(e) ? this.invokeChangedCallback(e, r.writer(this.receiver[e]), n) : this.invokeChangedCallback(e, r.writer(r.defaultValue), n);
            }
          }, {
            key: "invokeChangedCallbacksForDefaultValues",
            value: function invokeChangedCallbacksForDefaultValues() {
              var _iterator6 = _createForOfIteratorHelper(this.valueDescriptors),
                  _step6;

              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  var _ref9 = _step6.value;
                  var _e7 = _ref9.key;
                  var _t9 = _ref9.name;
                  var _n3 = _ref9.defaultValue;
                  var _r5 = _ref9.writer;
                  null == _n3 || this.controller.data.has(_e7) || this.invokeChangedCallback(_t9, _r5(_n3), void 0);
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
            }
          }, {
            key: "invokeChangedCallback",
            value: function invokeChangedCallback(e, t, n) {
              var r = "".concat(e, "Changed"),
                  o = this.receiver[r];

              if ("function" == typeof o) {
                var _r6 = this.valueDescriptorNameMap[e],
                    _i6 = _r6.reader(t);

                var _s2 = n;
                n && (_s2 = _r6.reader(n)), o.call(this.receiver, _i6, _s2);
              }
            }
          }, {
            key: "valueDescriptors",
            get: function get() {
              var e = this.valueDescriptorMap;
              return Object.keys(e).map(function (t) {
                return e[t];
              });
            }
          }, {
            key: "valueDescriptorNameMap",
            get: function get() {
              var _this6 = this;

              var e = {};
              return Object.keys(this.valueDescriptorMap).forEach(function (t) {
                var n = _this6.valueDescriptorMap[t];
                e[n.name] = n;
              }), e;
            }
          }, {
            key: "hasValue",
            value: function hasValue(e) {
              var t = "has".concat(a(this.valueDescriptorNameMap[e].name));
              return this.receiver[t];
            }
          }]);

          return O;
        }();

        var E = /*#__PURE__*/function () {
          function E(e, t) {
            _classCallCheck(this, E);

            this.context = e, this.delegate = t, this.targetsByName = new v();
          }

          _createClass(E, [{
            key: "start",
            value: function start() {
              this.tokenListObserver || (this.tokenListObserver = new y(this.element, this.attributeName, this), this.tokenListObserver.start());
            }
          }, {
            key: "stop",
            value: function stop() {
              this.tokenListObserver && (this.disconnectAllTargets(), this.tokenListObserver.stop(), delete this.tokenListObserver);
            }
          }, {
            key: "tokenMatched",
            value: function tokenMatched(_ref10) {
              var e = _ref10.element,
                  t = _ref10.content;
              this.scope.containsElement(e) && this.connectTarget(e, t);
            }
          }, {
            key: "tokenUnmatched",
            value: function tokenUnmatched(_ref11) {
              var e = _ref11.element,
                  t = _ref11.content;
              this.disconnectTarget(e, t);
            }
          }, {
            key: "connectTarget",
            value: function connectTarget(e, t) {
              var _this7 = this;

              var n;
              this.targetsByName.has(t, e) || (this.targetsByName.add(t, e), null === (n = this.tokenListObserver) || void 0 === n || n.pause(function () {
                return _this7.delegate.targetConnected(e, t);
              }));
            }
          }, {
            key: "disconnectTarget",
            value: function disconnectTarget(e, t) {
              var _this8 = this;

              var n;
              this.targetsByName.has(t, e) && (this.targetsByName.delete(t, e), null === (n = this.tokenListObserver) || void 0 === n || n.pause(function () {
                return _this8.delegate.targetDisconnected(e, t);
              }));
            }
          }, {
            key: "disconnectAllTargets",
            value: function disconnectAllTargets() {
              var _iterator7 = _createForOfIteratorHelper(this.targetsByName.keys),
                  _step7;

              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  var _e8 = _step7.value;

                  var _iterator8 = _createForOfIteratorHelper(this.targetsByName.getValuesForKey(_e8)),
                      _step8;

                  try {
                    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                      var _t10 = _step8.value;
                      this.disconnectTarget(_t10, _e8);
                    }
                  } catch (err) {
                    _iterator8.e(err);
                  } finally {
                    _iterator8.f();
                  }
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
            }
          }, {
            key: "attributeName",
            get: function get() {
              return "data-".concat(this.context.identifier, "-target");
            }
          }, {
            key: "element",
            get: function get() {
              return this.context.element;
            }
          }, {
            key: "scope",
            get: function get() {
              return this.context.scope;
            }
          }]);

          return E;
        }();

        var _ = /*#__PURE__*/function () {
          function _(e, t) {
            var _this9 = this;

            _classCallCheck(this, _);

            this.logDebugActivity = function (e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var n = _this9.identifier,
                  r = _this9.controller,
                  o = _this9.element;
              t = Object.assign({
                identifier: n,
                controller: r,
                element: o
              }, t), _this9.application.logDebugActivity(_this9.identifier, e, t);
            }, this.module = e, this.scope = t, this.controller = new e.controllerConstructor(this), this.bindingObserver = new w(this, this.dispatcher), this.valueObserver = new O(this, this.controller), this.targetObserver = new E(this, this);

            try {
              this.controller.initialize(), this.logDebugActivity("initialize");
            } catch (e) {
              this.handleError(e, "initializing controller");
            }
          }

          _createClass(_, [{
            key: "connect",
            value: function connect() {
              this.bindingObserver.start(), this.valueObserver.start(), this.targetObserver.start();

              try {
                this.controller.connect(), this.logDebugActivity("connect");
              } catch (e) {
                this.handleError(e, "connecting controller");
              }
            }
          }, {
            key: "disconnect",
            value: function disconnect() {
              try {
                this.controller.disconnect(), this.logDebugActivity("disconnect");
              } catch (e) {
                this.handleError(e, "disconnecting controller");
              }

              this.targetObserver.stop(), this.valueObserver.stop(), this.bindingObserver.stop();
            }
          }, {
            key: "application",
            get: function get() {
              return this.module.application;
            }
          }, {
            key: "identifier",
            get: function get() {
              return this.module.identifier;
            }
          }, {
            key: "schema",
            get: function get() {
              return this.application.schema;
            }
          }, {
            key: "dispatcher",
            get: function get() {
              return this.application.dispatcher;
            }
          }, {
            key: "element",
            get: function get() {
              return this.scope.element;
            }
          }, {
            key: "parentElement",
            get: function get() {
              return this.element.parentElement;
            }
          }, {
            key: "handleError",
            value: function handleError(e, t) {
              var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              var r = this.identifier,
                  o = this.controller,
                  i = this.element;
              n = Object.assign({
                identifier: r,
                controller: o,
                element: i
              }, n), this.application.handleError(e, "Error ".concat(t), n);
            }
          }, {
            key: "targetConnected",
            value: function targetConnected(e, t) {
              this.invokeControllerMethod("".concat(t, "TargetConnected"), e);
            }
          }, {
            key: "targetDisconnected",
            value: function targetDisconnected(e, t) {
              this.invokeControllerMethod("".concat(t, "TargetDisconnected"), e);
            }
          }, {
            key: "invokeControllerMethod",
            value: function invokeControllerMethod(e) {
              var n = this.controller;

              for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                t[_key - 1] = arguments[_key];
              }

              "function" == typeof n[e] && n[e].apply(n, t);
            }
          }]);

          return _;
        }();

        function S(e, t) {
          var n = x(e);
          return Array.from(n.reduce(function (e, n) {
            return function (e, t) {
              var n = e[t];
              return Array.isArray(n) ? n : [];
            }(n, t).forEach(function (t) {
              return e.add(t);
            }), e;
          }, new Set()));
        }

        function x(e) {
          var t = [];

          for (; e;) {
            t.push(e), e = Object.getPrototypeOf(e);
          }

          return t.reverse();
        }

        var C = "function" == typeof Object.getOwnPropertySymbols ? function (e) {
          return [].concat(_toConsumableArray(Object.getOwnPropertyNames(e)), _toConsumableArray(Object.getOwnPropertySymbols(e)));
        } : Object.getOwnPropertyNames,
            k = function () {
          function e(e) {
            function t() {
              return Reflect.construct(e, arguments, this instanceof t ? this.constructor : void 0);
            }

            return t.prototype = Object.create(e.prototype, {
              constructor: {
                value: t
              }
            }), Reflect.setPrototypeOf(t, e), t;
          }

          try {
            return function () {
              var t = e(function () {
                this.a.call(this);
              });
              t.prototype.a = function () {}, new t();
            }(), e;
          } catch (e) {
            return function (e) {
              return /*#__PURE__*/function (_e9) {
                _inherits(_class2, _e9);

                var _super = _createSuper(_class2);

                function _class2() {
                  _classCallCheck(this, _class2);

                  return _super.apply(this, arguments);
                }

                return _class2;
              }(e);
            };
          }
        }();

        var P = /*#__PURE__*/function () {
          function P(e, t) {
            _classCallCheck(this, P);

            this.application = e, this.definition = function (e) {
              return {
                identifier: e.identifier,
                controllerConstructor: (t = e.controllerConstructor, function (e, t) {
                  var n = k(e),
                      r = function (e, t) {
                    return C(t).reduce(function (n, r) {
                      var o = function (e, t, n) {
                        var r = Object.getOwnPropertyDescriptor(e, n);

                        if (!r || !("value" in r)) {
                          var _e10 = Object.getOwnPropertyDescriptor(t, n).value;
                          return r && (_e10.get = r.get || _e10.get, _e10.set = r.set || _e10.set), _e10;
                        }
                      }(e, t, r);

                      return o && Object.assign(n, _defineProperty({}, r, o)), n;
                    }, {});
                  }(e.prototype, t);

                  return Object.defineProperties(n.prototype, r), n;
                }(t, function (e) {
                  return S(e, "blessings").reduce(function (t, n) {
                    var r = n(e);

                    for (var _e11 in r) {
                      var _n4 = t[_e11] || {};

                      t[_e11] = Object.assign(_n4, r[_e11]);
                    }

                    return t;
                  }, {});
                }(t)))
              };
              var t;
            }(t), this.contextsByScope = new WeakMap(), this.connectedContexts = new Set();
          }

          _createClass(P, [{
            key: "identifier",
            get: function get() {
              return this.definition.identifier;
            }
          }, {
            key: "controllerConstructor",
            get: function get() {
              return this.definition.controllerConstructor;
            }
          }, {
            key: "contexts",
            get: function get() {
              return Array.from(this.connectedContexts);
            }
          }, {
            key: "connectContextForScope",
            value: function connectContextForScope(e) {
              var t = this.fetchContextForScope(e);
              this.connectedContexts.add(t), t.connect();
            }
          }, {
            key: "disconnectContextForScope",
            value: function disconnectContextForScope(e) {
              var t = this.contextsByScope.get(e);
              t && (this.connectedContexts.delete(t), t.disconnect());
            }
          }, {
            key: "fetchContextForScope",
            value: function fetchContextForScope(e) {
              var t = this.contextsByScope.get(e);
              return t || (t = new _(this, e), this.contextsByScope.set(e, t)), t;
            }
          }]);

          return P;
        }();

        var j = /*#__PURE__*/function () {
          function j(e) {
            _classCallCheck(this, j);

            this.scope = e;
          }

          _createClass(j, [{
            key: "has",
            value: function has(e) {
              return this.data.has(this.getDataKey(e));
            }
          }, {
            key: "get",
            value: function get(e) {
              return this.getAll(e)[0];
            }
          }, {
            key: "getAll",
            value: function getAll(e) {
              return (this.data.get(this.getDataKey(e)) || "").match(/[^\s]+/g) || [];
            }
          }, {
            key: "getAttributeName",
            value: function getAttributeName(e) {
              return this.data.getAttributeNameForKey(this.getDataKey(e));
            }
          }, {
            key: "getDataKey",
            value: function getDataKey(e) {
              return "".concat(e, "-class");
            }
          }, {
            key: "data",
            get: function get() {
              return this.scope.data;
            }
          }]);

          return j;
        }();

        var T = /*#__PURE__*/function () {
          function T(e) {
            _classCallCheck(this, T);

            this.scope = e;
          }

          _createClass(T, [{
            key: "element",
            get: function get() {
              return this.scope.element;
            }
          }, {
            key: "identifier",
            get: function get() {
              return this.scope.identifier;
            }
          }, {
            key: "get",
            value: function get(e) {
              var t = this.getAttributeNameForKey(e);
              return this.element.getAttribute(t);
            }
          }, {
            key: "set",
            value: function set(e, t) {
              var n = this.getAttributeNameForKey(e);
              return this.element.setAttribute(n, t), this.get(e);
            }
          }, {
            key: "has",
            value: function has(e) {
              var t = this.getAttributeNameForKey(e);
              return this.element.hasAttribute(t);
            }
          }, {
            key: "delete",
            value: function _delete(e) {
              if (this.has(e)) {
                var _t11 = this.getAttributeNameForKey(e);

                return this.element.removeAttribute(_t11), !0;
              }

              return !1;
            }
          }, {
            key: "getAttributeNameForKey",
            value: function getAttributeNameForKey(e) {
              return "data-".concat(this.identifier, "-").concat(l(e));
            }
          }]);

          return T;
        }();

        var D = /*#__PURE__*/function () {
          function D(e) {
            _classCallCheck(this, D);

            this.warnedKeysByObject = new WeakMap(), this.logger = e;
          }

          _createClass(D, [{
            key: "warn",
            value: function warn(e, t, n) {
              var r = this.warnedKeysByObject.get(e);
              r || (r = new Set(), this.warnedKeysByObject.set(e, r)), r.has(t) || (r.add(t), this.logger.warn(n, e));
            }
          }]);

          return D;
        }();

        function M(e, t) {
          return "[".concat(e, "~=\"").concat(t, "\"]");
        }

        var A = /*#__PURE__*/function () {
          function A(e) {
            _classCallCheck(this, A);

            this.scope = e;
          }

          _createClass(A, [{
            key: "element",
            get: function get() {
              return this.scope.element;
            }
          }, {
            key: "identifier",
            get: function get() {
              return this.scope.identifier;
            }
          }, {
            key: "schema",
            get: function get() {
              return this.scope.schema;
            }
          }, {
            key: "has",
            value: function has(e) {
              return null != this.find(e);
            }
          }, {
            key: "find",
            value: function find() {
              var _this10 = this;

              for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                e[_key2] = arguments[_key2];
              }

              return e.reduce(function (e, t) {
                return e || _this10.findTarget(t) || _this10.findLegacyTarget(t);
              }, void 0);
            }
          }, {
            key: "findAll",
            value: function findAll() {
              var _this11 = this;

              for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                e[_key3] = arguments[_key3];
              }

              return e.reduce(function (e, t) {
                return [].concat(_toConsumableArray(e), _toConsumableArray(_this11.findAllTargets(t)), _toConsumableArray(_this11.findAllLegacyTargets(t)));
              }, []);
            }
          }, {
            key: "findTarget",
            value: function findTarget(e) {
              var t = this.getSelectorForTargetName(e);
              return this.scope.findElement(t);
            }
          }, {
            key: "findAllTargets",
            value: function findAllTargets(e) {
              var t = this.getSelectorForTargetName(e);
              return this.scope.findAllElements(t);
            }
          }, {
            key: "getSelectorForTargetName",
            value: function getSelectorForTargetName(e) {
              return M(this.schema.targetAttributeForScope(this.identifier), e);
            }
          }, {
            key: "findLegacyTarget",
            value: function findLegacyTarget(e) {
              var t = this.getLegacySelectorForTargetName(e);
              return this.deprecate(this.scope.findElement(t), e);
            }
          }, {
            key: "findAllLegacyTargets",
            value: function findAllLegacyTargets(e) {
              var _this12 = this;

              var t = this.getLegacySelectorForTargetName(e);
              return this.scope.findAllElements(t).map(function (t) {
                return _this12.deprecate(t, e);
              });
            }
          }, {
            key: "getLegacySelectorForTargetName",
            value: function getLegacySelectorForTargetName(e) {
              var t = "".concat(this.identifier, ".").concat(e);
              return M(this.schema.targetAttribute, t);
            }
          }, {
            key: "deprecate",
            value: function deprecate(e, t) {
              if (e) {
                var _n5 = this.identifier,
                    _r7 = this.schema.targetAttribute,
                    _o5 = this.schema.targetAttributeForScope(_n5);

                this.guide.warn(e, "target:".concat(t), "Please replace ".concat(_r7, "=\"").concat(_n5, ".").concat(t, "\" with ").concat(_o5, "=\"").concat(t, "\". The ").concat(_r7, " attribute is deprecated and will be removed in a future version of Stimulus."));
              }

              return e;
            }
          }, {
            key: "guide",
            get: function get() {
              return this.scope.guide;
            }
          }]);

          return A;
        }();

        var F = /*#__PURE__*/function () {
          function F(e, t, n, r) {
            var _this13 = this;

            _classCallCheck(this, F);

            this.targets = new A(this), this.classes = new j(this), this.data = new T(this), this.containsElement = function (e) {
              return e.closest(_this13.controllerSelector) === _this13.element;
            }, this.schema = e, this.element = t, this.identifier = n, this.guide = new D(r);
          }

          _createClass(F, [{
            key: "findElement",
            value: function findElement(e) {
              return this.element.matches(e) ? this.element : this.queryElements(e).find(this.containsElement);
            }
          }, {
            key: "findAllElements",
            value: function findAllElements(e) {
              return [].concat(_toConsumableArray(this.element.matches(e) ? [this.element] : []), _toConsumableArray(this.queryElements(e).filter(this.containsElement)));
            }
          }, {
            key: "queryElements",
            value: function queryElements(e) {
              return Array.from(this.element.querySelectorAll(e));
            }
          }, {
            key: "controllerSelector",
            get: function get() {
              return M(this.schema.controllerAttribute, this.identifier);
            }
          }]);

          return F;
        }();

        var L = /*#__PURE__*/function () {
          function L(e, t, n) {
            _classCallCheck(this, L);

            this.element = e, this.schema = t, this.delegate = n, this.valueListObserver = new b(this.element, this.controllerAttribute, this), this.scopesByIdentifierByElement = new WeakMap(), this.scopeReferenceCounts = new WeakMap();
          }

          _createClass(L, [{
            key: "start",
            value: function start() {
              this.valueListObserver.start();
            }
          }, {
            key: "stop",
            value: function stop() {
              this.valueListObserver.stop();
            }
          }, {
            key: "controllerAttribute",
            get: function get() {
              return this.schema.controllerAttribute;
            }
          }, {
            key: "parseValueForToken",
            value: function parseValueForToken(e) {
              var t = e.element,
                  n = e.content,
                  r = this.fetchScopesByIdentifierForElement(t);
              var o = r.get(n);
              return o || (o = this.delegate.createScopeForElementAndIdentifier(t, n), r.set(n, o)), o;
            }
          }, {
            key: "elementMatchedValue",
            value: function elementMatchedValue(e, t) {
              var n = (this.scopeReferenceCounts.get(t) || 0) + 1;
              this.scopeReferenceCounts.set(t, n), 1 == n && this.delegate.scopeConnected(t);
            }
          }, {
            key: "elementUnmatchedValue",
            value: function elementUnmatchedValue(e, t) {
              var n = this.scopeReferenceCounts.get(t);
              n && (this.scopeReferenceCounts.set(t, n - 1), 1 == n && this.delegate.scopeDisconnected(t));
            }
          }, {
            key: "fetchScopesByIdentifierForElement",
            value: function fetchScopesByIdentifierForElement(e) {
              var t = this.scopesByIdentifierByElement.get(e);
              return t || (t = new Map(), this.scopesByIdentifierByElement.set(e, t)), t;
            }
          }]);

          return L;
        }();

        var I = /*#__PURE__*/function () {
          function I(e) {
            _classCallCheck(this, I);

            this.application = e, this.scopeObserver = new L(this.element, this.schema, this), this.scopesByIdentifier = new v(), this.modulesByIdentifier = new Map();
          }

          _createClass(I, [{
            key: "element",
            get: function get() {
              return this.application.element;
            }
          }, {
            key: "schema",
            get: function get() {
              return this.application.schema;
            }
          }, {
            key: "logger",
            get: function get() {
              return this.application.logger;
            }
          }, {
            key: "controllerAttribute",
            get: function get() {
              return this.schema.controllerAttribute;
            }
          }, {
            key: "modules",
            get: function get() {
              return Array.from(this.modulesByIdentifier.values());
            }
          }, {
            key: "contexts",
            get: function get() {
              return this.modules.reduce(function (e, t) {
                return e.concat(t.contexts);
              }, []);
            }
          }, {
            key: "start",
            value: function start() {
              this.scopeObserver.start();
            }
          }, {
            key: "stop",
            value: function stop() {
              this.scopeObserver.stop();
            }
          }, {
            key: "loadDefinition",
            value: function loadDefinition(e) {
              this.unloadIdentifier(e.identifier);
              var t = new P(this.application, e);
              this.connectModule(t);
            }
          }, {
            key: "unloadIdentifier",
            value: function unloadIdentifier(e) {
              var t = this.modulesByIdentifier.get(e);
              t && this.disconnectModule(t);
            }
          }, {
            key: "getContextForElementAndIdentifier",
            value: function getContextForElementAndIdentifier(e, t) {
              var n = this.modulesByIdentifier.get(t);
              if (n) return n.contexts.find(function (t) {
                return t.element == e;
              });
            }
          }, {
            key: "handleError",
            value: function handleError(e, t, n) {
              this.application.handleError(e, t, n);
            }
          }, {
            key: "createScopeForElementAndIdentifier",
            value: function createScopeForElementAndIdentifier(e, t) {
              return new F(this.schema, e, t, this.logger);
            }
          }, {
            key: "scopeConnected",
            value: function scopeConnected(e) {
              this.scopesByIdentifier.add(e.identifier, e);
              var t = this.modulesByIdentifier.get(e.identifier);
              t && t.connectContextForScope(e);
            }
          }, {
            key: "scopeDisconnected",
            value: function scopeDisconnected(e) {
              this.scopesByIdentifier.delete(e.identifier, e);
              var t = this.modulesByIdentifier.get(e.identifier);
              t && t.disconnectContextForScope(e);
            }
          }, {
            key: "connectModule",
            value: function connectModule(e) {
              this.modulesByIdentifier.set(e.identifier, e), this.scopesByIdentifier.getValuesForKey(e.identifier).forEach(function (t) {
                return e.connectContextForScope(t);
              });
            }
          }, {
            key: "disconnectModule",
            value: function disconnectModule(e) {
              this.modulesByIdentifier.delete(e.identifier), this.scopesByIdentifier.getValuesForKey(e.identifier).forEach(function (t) {
                return e.disconnectContextForScope(t);
              });
            }
          }]);

          return I;
        }();

        var R = {
          controllerAttribute: "data-controller",
          actionAttribute: "data-action",
          targetAttribute: "data-target",
          targetAttributeForScope: function targetAttributeForScope(e) {
            return "data-".concat(e, "-target");
          }
        };

        var N = /*#__PURE__*/function () {
          function N() {
            var _this14 = this;

            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.documentElement;
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : R;

            _classCallCheck(this, N);

            this.logger = console, this.debug = !1, this.logDebugActivity = function (e, t) {
              var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              _this14.debug && _this14.logFormattedMessage(e, t, n);
            }, this.element = e, this.schema = t, this.dispatcher = new o(this), this.router = new I(this);
          }

          _createClass(N, [{
            key: "start",
            value: function () {
              var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return new Promise(function (e) {
                          "loading" == document.readyState ? document.addEventListener("DOMContentLoaded", function () {
                            return e();
                          }) : e();
                        });

                      case 2:
                        this.logDebugActivity("application", "starting");
                        this.dispatcher.start();
                        this.router.start();
                        this.logDebugActivity("application", "start");

                      case 6:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, this);
              }));

              function start() {
                return _start.apply(this, arguments);
              }

              return start;
            }()
          }, {
            key: "stop",
            value: function stop() {
              this.logDebugActivity("application", "stopping"), this.dispatcher.stop(), this.router.stop(), this.logDebugActivity("application", "stop");
            }
          }, {
            key: "register",
            value: function register(e, t) {
              t.shouldLoad && this.load({
                identifier: e,
                controllerConstructor: t
              });
            }
          }, {
            key: "load",
            value: function load(e) {
              var _this15 = this;

              for (var _len4 = arguments.length, t = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
                t[_key4 - 1] = arguments[_key4];
              }

              (Array.isArray(e) ? e : [e].concat(t)).forEach(function (e) {
                return _this15.router.loadDefinition(e);
              });
            }
          }, {
            key: "unload",
            value: function unload(e) {
              var _this16 = this;

              for (var _len5 = arguments.length, t = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
                t[_key5 - 1] = arguments[_key5];
              }

              (Array.isArray(e) ? e : [e].concat(t)).forEach(function (e) {
                return _this16.router.unloadIdentifier(e);
              });
            }
          }, {
            key: "controllers",
            get: function get() {
              return this.router.contexts.map(function (e) {
                return e.controller;
              });
            }
          }, {
            key: "getControllerForElementAndIdentifier",
            value: function getControllerForElementAndIdentifier(e, t) {
              var n = this.router.getContextForElementAndIdentifier(e, t);
              return n ? n.controller : null;
            }
          }, {
            key: "handleError",
            value: function handleError(e, t, n) {
              var r;
              this.logger.error("%s\n\n%o\n\n%o", t, e, n), null === (r = window.onerror) || void 0 === r || r.call(window, t, "", 0, 0, e);
            }
          }, {
            key: "logFormattedMessage",
            value: function logFormattedMessage(e, t) {
              var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              n = Object.assign({
                application: this
              }, n), this.logger.groupCollapsed("".concat(e, " #").concat(t)), this.logger.log("details:", Object.assign({}, n)), this.logger.groupEnd();
            }
          }], [{
            key: "start",
            value: function start(e, t) {
              var n = new N(e, t);
              return n.start(), n;
            }
          }]);

          return N;
        }();

        function B(_ref12) {
          var _ref13 = _slicedToArray(_ref12, 2),
              e = _ref13[0],
              t = _ref13[1];

          return function (e, t) {
            var n = "".concat(l(e), "-value"),
                r = function (e) {
              var t = function (e) {
                var t = $(e.type);

                if (t) {
                  var _n6 = H(e.default);

                  if (t !== _n6) throw new Error("Type \"".concat(t, "\" must match the type of the default value. Given default value: \"").concat(e.default, "\" as \"").concat(_n6, "\""));
                  return t;
                }
              }(e),
                  n = H(e),
                  r = $(e),
                  o = t || n || r;

              if (o) return o;
              throw new Error("Unknown value type \"".concat(e, "\""));
            }(t);

            return {
              type: r,
              key: n,
              name: s(n),

              get defaultValue() {
                return function (e) {
                  var t = $(e);
                  if (t) return U[t];
                  var n = e.default;
                  return void 0 !== n ? n : e;
                }(t);
              },

              get hasCustomDefaultValue() {
                return void 0 !== H(t);
              },

              reader: z[r],
              writer: Y[r] || Y.default
            };
          }(e, t);
        }

        function $(e) {
          switch (e) {
            case Array:
              return "array";

            case Boolean:
              return "boolean";

            case Number:
              return "number";

            case Object:
              return "object";

            case String:
              return "string";
          }
        }

        function H(e) {
          switch (_typeof(e)) {
            case "boolean":
              return "boolean";

            case "number":
              return "number";

            case "string":
              return "string";
          }

          return Array.isArray(e) ? "array" : "[object Object]" === Object.prototype.toString.call(e) ? "object" : void 0;
        }

        var U = {
          get array() {
            return [];
          },

          boolean: !1,
          number: 0,

          get object() {
            return {};
          },

          string: ""
        },
            z = {
          array: function array(e) {
            var t = JSON.parse(e);
            if (!Array.isArray(t)) throw new TypeError("Expected array");
            return t;
          },
          boolean: function boolean(e) {
            return !("0" == e || "false" == e);
          },
          number: function number(e) {
            return Number(e);
          },
          object: function object(e) {
            var t = JSON.parse(e);
            if (null === t || "object" != _typeof(t) || Array.isArray(t)) throw new TypeError("Expected object");
            return t;
          },
          string: function string(e) {
            return e;
          }
        },
            Y = {
          default: function _default(e) {
            return "".concat(e);
          },
          array: q,
          object: q
        };

        function q(e) {
          return JSON.stringify(e);
        }

        var V = /*#__PURE__*/function () {
          function V(e) {
            _classCallCheck(this, V);

            this.context = e;
          }

          _createClass(V, [{
            key: "application",
            get: function get() {
              return this.context.application;
            }
          }, {
            key: "scope",
            get: function get() {
              return this.context.scope;
            }
          }, {
            key: "element",
            get: function get() {
              return this.scope.element;
            }
          }, {
            key: "identifier",
            get: function get() {
              return this.scope.identifier;
            }
          }, {
            key: "targets",
            get: function get() {
              return this.scope.targets;
            }
          }, {
            key: "classes",
            get: function get() {
              return this.scope.classes;
            }
          }, {
            key: "data",
            get: function get() {
              return this.scope.data;
            }
          }, {
            key: "initialize",
            value: function initialize() {}
          }, {
            key: "connect",
            value: function connect() {}
          }, {
            key: "disconnect",
            value: function disconnect() {}
          }, {
            key: "dispatch",
            value: function dispatch(e) {
              var _ref14 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                  _ref14$target = _ref14.target,
                  t = _ref14$target === void 0 ? this.element : _ref14$target,
                  _ref14$detail = _ref14.detail,
                  n = _ref14$detail === void 0 ? {} : _ref14$detail,
                  _ref14$prefix = _ref14.prefix,
                  r = _ref14$prefix === void 0 ? this.identifier : _ref14$prefix,
                  _ref14$bubbles = _ref14.bubbles,
                  o = _ref14$bubbles === void 0 ? !0 : _ref14$bubbles,
                  _ref14$cancelable = _ref14.cancelable,
                  i = _ref14$cancelable === void 0 ? !0 : _ref14$cancelable;

              var s = new CustomEvent(r ? "".concat(r, ":").concat(e) : e, {
                detail: n,
                bubbles: o,
                cancelable: i
              });
              return t.dispatchEvent(s), s;
            }
          }], [{
            key: "shouldLoad",
            get: function get() {
              return !0;
            }
          }]);

          return V;
        }();

        V.blessings = [function (e) {
          return S(e, "classes").reduce(function (e, t) {
            var _Object$assign4;

            return Object.assign(e, (_Object$assign4 = {}, _defineProperty(_Object$assign4, "".concat(n = t, "Class"), {
              get: function get() {
                var e = this.classes;
                if (e.has(n)) return e.get(n);
                {
                  var _t12 = e.getAttributeName(n);

                  throw new Error("Missing attribute \"".concat(_t12, "\""));
                }
              }
            }), _defineProperty(_Object$assign4, "".concat(n, "Classes"), {
              get: function get() {
                return this.classes.getAll(n);
              }
            }), _defineProperty(_Object$assign4, "has".concat(a(n), "Class"), {
              get: function get() {
                return this.classes.has(n);
              }
            }), _Object$assign4));
            var n;
          }, {});
        }, function (e) {
          return S(e, "targets").reduce(function (e, t) {
            var _Object$assign5;

            return Object.assign(e, (_Object$assign5 = {}, _defineProperty(_Object$assign5, "".concat(n = t, "Target"), {
              get: function get() {
                var e = this.targets.find(n);
                if (e) return e;
                throw new Error("Missing target element \"".concat(n, "\" for \"").concat(this.identifier, "\" controller"));
              }
            }), _defineProperty(_Object$assign5, "".concat(n, "Targets"), {
              get: function get() {
                return this.targets.findAll(n);
              }
            }), _defineProperty(_Object$assign5, "has".concat(a(n), "Target"), {
              get: function get() {
                return this.targets.has(n);
              }
            }), _Object$assign5));
            var n;
          }, {});
        }, function (e) {
          var t = function (e, t) {
            return x(e).reduce(function (e, n) {
              return e.push.apply(e, _toConsumableArray(function (e, t) {
                var n = e[t];
                return n ? Object.keys(n).map(function (e) {
                  return [e, n[e]];
                }) : [];
              }(n, t))), e;
            }, []);
          }(e, "values"),
              n = {
            valueDescriptorMap: {
              get: function get() {
                var _this17 = this;

                return t.reduce(function (e, t) {
                  var n = B(t),
                      r = _this17.data.getAttributeNameForKey(n.key);

                  return Object.assign(e, _defineProperty({}, r, n));
                }, {});
              }
            }
          };

          return t.reduce(function (e, t) {
            return Object.assign(e, function (e) {
              var _ref15;

              var t = B(e),
                  n = t.key,
                  r = t.name,
                  o = t.reader,
                  i = t.writer;
              return _ref15 = {}, _defineProperty(_ref15, r, {
                get: function get() {
                  var e = this.data.get(n);
                  return null !== e ? o(e) : t.defaultValue;
                },
                set: function set(e) {
                  void 0 === e ? this.data.delete(n) : this.data.set(n, i(e));
                }
              }), _defineProperty(_ref15, "has".concat(a(r)), {
                get: function get() {
                  return this.data.has(n) || t.hasCustomDefaultValue;
                }
              }), _ref15;
            }(t));
          }, n);
        }], V.targets = [], V.values = {};
      },
      9404: function _(e, t, n) {
        "use strict";

        n.d(t, {
          r$: function r$() {
            return a;
          },
          v_: function v_() {
            return s;
          }
        });

        var r = /*#__PURE__*/function () {
          function r(e) {
            _classCallCheck(this, r);

            this.response = e;
          }

          _createClass(r, [{
            key: "statusCode",
            get: function get() {
              return this.response.status;
            }
          }, {
            key: "redirected",
            get: function get() {
              return this.response.redirected;
            }
          }, {
            key: "ok",
            get: function get() {
              return this.response.ok;
            }
          }, {
            key: "unauthenticated",
            get: function get() {
              return 401 === this.statusCode;
            }
          }, {
            key: "unprocessableEntity",
            get: function get() {
              return 422 === this.statusCode;
            }
          }, {
            key: "authenticationURL",
            get: function get() {
              return this.response.headers.get("WWW-Authenticate");
            }
          }, {
            key: "contentType",
            get: function get() {
              return (this.response.headers.get("Content-Type") || "").replace(/;.*$/, "");
            }
          }, {
            key: "headers",
            get: function get() {
              return this.response.headers;
            }
          }, {
            key: "html",
            get: function get() {
              return this.contentType.match(/^(application|text)\/(html|xhtml\+xml)$/) ? this.text : Promise.reject(new Error("Expected an HTML response but got \"".concat(this.contentType, "\" instead")));
            }
          }, {
            key: "json",
            get: function get() {
              return this.contentType.match(/^application\/.*json$/) ? this.responseJson || (this.responseJson = this.response.json()) : Promise.reject(new Error("Expected a JSON response but got \"".concat(this.contentType, "\" instead")));
            }
          }, {
            key: "text",
            get: function get() {
              return this.responseText || (this.responseText = this.response.text());
            }
          }, {
            key: "isTurboStream",
            get: function get() {
              return this.contentType.match(/^text\/vnd\.turbo-stream\.html/);
            }
          }, {
            key: "renderTurboStream",
            value: function () {
              var _renderTurboStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        if (this.isTurboStream) {
                          _context2.next = 2;
                          break;
                        }

                        return _context2.abrupt("return", Promise.reject(new Error("Expected a Turbo Stream response but got \"".concat(this.contentType, "\" instead"))));

                      case 2:
                        if (!window.Turbo) {
                          _context2.next = 11;
                          break;
                        }

                        _context2.t0 = window.Turbo;
                        _context2.next = 6;
                        return this.text;

                      case 6:
                        _context2.t1 = _context2.sent;
                        _context2.next = 9;
                        return _context2.t0.renderStreamMessage.call(_context2.t0, _context2.t1);

                      case 9:
                        _context2.next = 12;
                        break;

                      case 11:
                        console.warn("You must set `window.Turbo = Turbo` to automatically process Turbo Stream events with request.js");

                      case 12:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, this);
              }));

              function renderTurboStream() {
                return _renderTurboStream.apply(this, arguments);
              }

              return renderTurboStream;
            }()
          }]);

          return r;
        }();

        function o(e) {
          var t = document.head.querySelector("meta[name=\"".concat(e, "\"]"));
          return t && t.content;
        }

        var i = /*#__PURE__*/function () {
          function i(e, t) {
            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            _classCallCheck(this, i);

            this.method = e, this.options = n, this.originalUrl = t.toString();
          }

          _createClass(i, [{
            key: "perform",
            value: function () {
              var _perform = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                var _e12, e;

                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.prev = 0;

                        _e12 = /*#__PURE__*/function () {
                          function _class3() {
                            _classCallCheck(this, _class3);
                          }

                          _createClass(_class3, null, [{
                            key: "register",
                            value: function register(e) {
                              this.interceptor = e;
                            }
                          }, {
                            key: "get",
                            value: function get() {
                              return this.interceptor;
                            }
                          }, {
                            key: "reset",
                            value: function reset() {
                              this.interceptor = void 0;
                            }
                          }]);

                          return _class3;
                        }().get();

                        _context3.t0 = _e12;

                        if (!_context3.t0) {
                          _context3.next = 6;
                          break;
                        }

                        _context3.next = 6;
                        return _e12(this);

                      case 6:
                        _context3.next = 11;
                        break;

                      case 8:
                        _context3.prev = 8;
                        _context3.t1 = _context3["catch"](0);
                        console.error(_context3.t1);

                      case 11:
                        _context3.t2 = r;
                        _context3.next = 14;
                        return window.fetch(this.url, this.fetchOptions);

                      case 14:
                        _context3.t3 = _context3.sent;
                        e = new _context3.t2(_context3.t3);

                        if (!(e.unauthenticated && e.authenticationURL)) {
                          _context3.next = 20;
                          break;
                        }

                        _context3.t4 = Promise.reject(window.location.href = e.authenticationURL);
                        _context3.next = 25;
                        break;

                      case 20:
                        _context3.t5 = e.ok && e.isTurboStream;

                        if (!_context3.t5) {
                          _context3.next = 24;
                          break;
                        }

                        _context3.next = 24;
                        return e.renderTurboStream();

                      case 24:
                        _context3.t4 = e;

                      case 25:
                        return _context3.abrupt("return", _context3.t4);

                      case 26:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, this, [[0, 8]]);
              }));

              function perform() {
                return _perform.apply(this, arguments);
              }

              return perform;
            }()
          }, {
            key: "addHeader",
            value: function addHeader(e, t) {
              var n = this.additionalHeaders;
              n[e] = t, this.options.headers = n;
            }
          }, {
            key: "fetchOptions",
            get: function get() {
              return {
                method: this.method.toUpperCase(),
                headers: this.headers,
                body: this.formattedBody,
                signal: this.signal,
                credentials: "same-origin",
                redirect: this.redirect
              };
            }
          }, {
            key: "headers",
            get: function get() {
              return function (e) {
                var t = {};

                for (var _n7 in e) {
                  var _r8 = e[_n7];
                  void 0 !== _r8 && (t[_n7] = _r8);
                }

                return t;
              }(Object.assign({
                "X-Requested-With": "XMLHttpRequest",
                "X-CSRF-Token": this.csrfToken,
                "Content-Type": this.contentType,
                Accept: this.accept
              }, this.additionalHeaders));
            }
          }, {
            key: "csrfToken",
            get: function get() {
              return function (e) {
                var t = document.cookie ? document.cookie.split("; ") : [],
                    n = "".concat(encodeURIComponent(e), "="),
                    r = t.find(function (e) {
                  return e.startsWith(n);
                });

                if (r) {
                  var _e13 = r.split("=").slice(1).join("=");

                  if (_e13) return decodeURIComponent(_e13);
                }
              }(o("csrf-param")) || o("csrf-token");
            }
          }, {
            key: "contentType",
            get: function get() {
              return this.options.contentType ? this.options.contentType : null == this.body || this.body instanceof window.FormData ? void 0 : this.body instanceof window.File ? this.body.type : "application/json";
            }
          }, {
            key: "accept",
            get: function get() {
              switch (this.responseKind) {
                case "html":
                  return "text/html, application/xhtml+xml";

                case "turbo-stream":
                  return "text/vnd.turbo-stream.html, text/html, application/xhtml+xml";

                case "json":
                  return "application/json, application/vnd.api+json";

                default:
                  return "*/*";
              }
            }
          }, {
            key: "body",
            get: function get() {
              return this.options.body;
            }
          }, {
            key: "query",
            get: function get() {
              var e = (this.originalUrl.split("?")[1] || "").split("#")[0],
                  t = new URLSearchParams(e);
              var n = this.options.query;
              var r;
              n instanceof window.FormData ? (r = n, n = _toConsumableArray(r).reduce(function (e, _ref16) {
                var _ref17 = _slicedToArray(_ref16, 2),
                    t = _ref17[0],
                    n = _ref17[1];

                return e.concat("string" == typeof n ? [[t, n]] : []);
              }, [])) : n = n instanceof window.URLSearchParams ? n.entries() : Object.entries(n || {}), function (e, t) {
                var _iterator9 = _createForOfIteratorHelper(t),
                    _step9;

                try {
                  for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                    var _ref20 = _step9.value;

                    var _ref19 = _slicedToArray(_ref20, 2);

                    var _n8 = _ref19[0];
                    var _r9 = _ref19[1];
                    _r9 instanceof window.File || (e.has(_n8) ? (e.delete(_n8), e.set(_n8, _r9)) : e.append(_n8, _r9));
                  }
                } catch (err) {
                  _iterator9.e(err);
                } finally {
                  _iterator9.f();
                }
              }(t, n);
              var o = t.toString();
              return o.length > 0 ? "?".concat(o) : "";
            }
          }, {
            key: "url",
            get: function get() {
              return this.originalUrl.split("?")[0].split("#")[0] + this.query;
            }
          }, {
            key: "responseKind",
            get: function get() {
              return this.options.responseKind || "html";
            }
          }, {
            key: "signal",
            get: function get() {
              return this.options.signal;
            }
          }, {
            key: "redirect",
            get: function get() {
              return this.options.redirect || "follow";
            }
          }, {
            key: "additionalHeaders",
            get: function get() {
              return this.options.headers || {};
            }
          }, {
            key: "formattedBody",
            get: function get() {
              var e = "[object String]" === Object.prototype.toString.call(this.body);
              return "application/json" !== this.headers["Content-Type"] || e ? this.body : JSON.stringify(this.body);
            }
          }]);

          return i;
        }();

        function s(_x, _x2) {
          return _s3.apply(this, arguments);
        }

        function _s3() {
          _s3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e, t) {
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    return _context4.abrupt("return", new i("post", e, t).perform());

                  case 1:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));
          return _s3.apply(this, arguments);
        }

        function a(_x3, _x4) {
          return _a.apply(this, arguments);
        }

        function _a() {
          _a = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e, t) {
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    return _context5.abrupt("return", new i("patch", e, t).perform());

                  case 1:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          }));
          return _a.apply(this, arguments);
        }
      },
      8535: function _(e, t, n) {
        var r, o;
        (function () {
          (function () {
            (function () {
              this.Rails = {
                linkClickSelector: "a[data-confirm], a[data-method], a[data-remote]:not([disabled]), a[data-disable-with], a[data-disable]",
                buttonClickSelector: {
                  selector: "button[data-remote]:not([form]), button[data-confirm]:not([form])",
                  exclude: "form button"
                },
                inputChangeSelector: "select[data-remote], input[data-remote], textarea[data-remote]",
                formSubmitSelector: "form:not([data-turbo=true])",
                formInputClickSelector: "form:not([data-turbo=true]) input[type=submit], form:not([data-turbo=true]) input[type=image], form:not([data-turbo=true]) button[type=submit], form:not([data-turbo=true]) button:not([type]), input[type=submit][form], input[type=image][form], button[type=submit][form], button[form]:not([type])",
                formDisableSelector: "input[data-disable-with]:enabled, button[data-disable-with]:enabled, textarea[data-disable-with]:enabled, input[data-disable]:enabled, button[data-disable]:enabled, textarea[data-disable]:enabled",
                formEnableSelector: "input[data-disable-with]:disabled, button[data-disable-with]:disabled, textarea[data-disable-with]:disabled, input[data-disable]:disabled, button[data-disable]:disabled, textarea[data-disable]:disabled",
                fileInputSelector: "input[name][type=file]:not([disabled])",
                linkDisableSelector: "a[data-disable-with], a[data-disable]",
                buttonDisableSelector: "button[data-remote][data-disable-with], button[data-remote][data-disable]"
              };
            }).call(this);
          }).call(this);
          var i = this.Rails;
          (function () {
            (function () {
              var e;
              e = null, i.loadCSPNonce = function () {
                var t;
                return e = null != (t = document.querySelector("meta[name=csp-nonce]")) ? t.content : void 0;
              }, i.cspNonce = function () {
                return null != e ? e : i.loadCSPNonce();
              };
            }).call(this), function () {
              var e;
              e = Element.prototype.matches || Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector, i.matches = function (t, n) {
                return null != n.exclude ? e.call(t, n.selector) && !e.call(t, n.exclude) : e.call(t, n);
              }, i.getData = function (e, t) {
                var n;
                return null != (n = e._ujsData) ? n[t] : void 0;
              }, i.setData = function (e, t, n) {
                return null == e._ujsData && (e._ujsData = {}), e._ujsData[t] = n;
              }, i.$ = function (e) {
                return Array.prototype.slice.call(document.querySelectorAll(e));
              };
            }.call(this), function () {
              var e, t, n;
              e = i.$, n = i.csrfToken = function () {
                var e;
                return (e = document.querySelector("meta[name=csrf-token]")) && e.content;
              }, t = i.csrfParam = function () {
                var e;
                return (e = document.querySelector("meta[name=csrf-param]")) && e.content;
              }, i.CSRFProtection = function (e) {
                var t;
                if (null != (t = n())) return e.setRequestHeader("X-CSRF-Token", t);
              }, i.refreshCSRFTokens = function () {
                var r, o;
                if (o = n(), r = t(), null != o && null != r) return e('form input[name="' + r + '"]').forEach(function (e) {
                  return e.value = o;
                });
              };
            }.call(this), function () {
              var e, t, n, r;
              n = i.matches, "function" != typeof (e = window.CustomEvent) && ((e = function e(_e14, t) {
                var n;
                return (n = document.createEvent("CustomEvent")).initCustomEvent(_e14, t.bubbles, t.cancelable, t.detail), n;
              }).prototype = window.Event.prototype, r = e.prototype.preventDefault, e.prototype.preventDefault = function () {
                var e;
                return e = r.call(this), this.cancelable && !this.defaultPrevented && Object.defineProperty(this, "defaultPrevented", {
                  get: function get() {
                    return !0;
                  }
                }), e;
              }), t = i.fire = function (t, n, r) {
                var o;
                return o = new e(n, {
                  bubbles: !0,
                  cancelable: !0,
                  detail: r
                }), t.dispatchEvent(o), !o.defaultPrevented;
              }, i.stopEverything = function (e) {
                return t(e.target, "ujs:everythingStopped"), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation();
              }, i.delegate = function (e, t, r, o) {
                return e.addEventListener(r, function (e) {
                  var r;

                  for (r = e.target; r instanceof Element && !n(r, t);) {
                    r = r.parentNode;
                  }

                  if (r instanceof Element && !1 === o.call(r, e)) return e.preventDefault(), e.stopPropagation();
                });
              };
            }.call(this), function () {
              var e, t, n, r, o, s;
              r = i.cspNonce, t = i.CSRFProtection, i.fire, e = {
                "*": "*/*",
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript",
                script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
              }, i.ajax = function (e) {
                var t;
                return e = o(e), t = n(e, function () {
                  var n, r;
                  return r = s(null != (n = t.response) ? n : t.responseText, t.getResponseHeader("Content-Type")), 2 === Math.floor(t.status / 100) ? "function" == typeof e.success && e.success(r, t.statusText, t) : "function" == typeof e.error && e.error(r, t.statusText, t), "function" == typeof e.complete ? e.complete(t, t.statusText) : void 0;
                }), !(null != e.beforeSend && !e.beforeSend(t, e)) && (t.readyState === XMLHttpRequest.OPENED ? t.send(e.data) : void 0);
              }, o = function o(t) {
                return t.url = t.url || location.href, t.type = t.type.toUpperCase(), "GET" === t.type && t.data && (t.url.indexOf("?") < 0 ? t.url += "?" + t.data : t.url += "&" + t.data), null == e[t.dataType] && (t.dataType = "*"), t.accept = e[t.dataType], "*" !== t.dataType && (t.accept += ", */*; q=0.01"), t;
              }, n = function n(e, _n9) {
                var r;
                return (r = new XMLHttpRequest()).open(e.type, e.url, !0), r.setRequestHeader("Accept", e.accept), "string" == typeof e.data && r.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8"), e.crossDomain || (r.setRequestHeader("X-Requested-With", "XMLHttpRequest"), t(r)), r.withCredentials = !!e.withCredentials, r.onreadystatechange = function () {
                  if (r.readyState === XMLHttpRequest.DONE) return _n9(r);
                }, r;
              }, s = function s(e, t) {
                var n, o;
                if ("string" == typeof e && "string" == typeof t) if (t.match(/\bjson\b/)) try {
                  e = JSON.parse(e);
                } catch (e) {} else if (t.match(/\b(?:java|ecma)script\b/)) (o = document.createElement("script")).setAttribute("nonce", r()), o.text = e, document.head.appendChild(o).parentNode.removeChild(o);else if (t.match(/\b(xml|html|svg)\b/)) {
                  n = new DOMParser(), t = t.replace(/;.+/, "");

                  try {
                    e = n.parseFromString(e, t);
                  } catch (e) {}
                }
                return e;
              }, i.href = function (e) {
                return e.href;
              }, i.isCrossDomain = function (e) {
                var t, n;
                (t = document.createElement("a")).href = location.href, n = document.createElement("a");

                try {
                  return n.href = e, !((!n.protocol || ":" === n.protocol) && !n.host || t.protocol + "//" + t.host == n.protocol + "//" + n.host);
                } catch (e) {
                  return !0;
                }
              };
            }.call(this), function () {
              var e, t;
              e = i.matches, t = function t(e) {
                return Array.prototype.slice.call(e);
              }, i.serializeElement = function (n, r) {
                var o, i;
                return o = [n], e(n, "form") && (o = t(n.elements)), i = [], o.forEach(function (n) {
                  if (n.name && !n.disabled && !e(n, "fieldset[disabled] *")) return e(n, "select") ? t(n.options).forEach(function (e) {
                    if (e.selected) return i.push({
                      name: n.name,
                      value: e.value
                    });
                  }) : n.checked || -1 === ["radio", "checkbox", "submit"].indexOf(n.type) ? i.push({
                    name: n.name,
                    value: n.value
                  }) : void 0;
                }), r && i.push(r), i.map(function (e) {
                  return null != e.name ? encodeURIComponent(e.name) + "=" + encodeURIComponent(e.value) : e;
                }).join("&");
              }, i.formElements = function (n, r) {
                return e(n, "form") ? t(n.elements).filter(function (t) {
                  return e(t, r);
                }) : t(n.querySelectorAll(r));
              };
            }.call(this), function () {
              var e, t, n;
              t = i.fire, n = i.stopEverything, i.handleConfirm = function (t) {
                if (!e(this)) return n(t);
              }, i.confirm = function (e, t) {
                return confirm(e);
              }, e = function e(_e15) {
                var n, r, o;
                if (!(o = _e15.getAttribute("data-confirm"))) return !0;

                if (n = !1, t(_e15, "confirm")) {
                  try {
                    n = i.confirm(o, _e15);
                  } catch (e) {}

                  r = t(_e15, "confirm:complete", [n]);
                }

                return n && r;
              };
            }.call(this), function () {
              var e, t, n, r, o, s, a, l, c, u, d, h;
              u = i.matches, l = i.getData, d = i.setData, h = i.stopEverything, a = i.formElements, i.handleDisabledElement = function (e) {
                if (this.disabled) return h(e);
              }, i.enableElement = function (e) {
                var t;

                if (e instanceof Event) {
                  if (c(e)) return;
                  t = e.target;
                } else t = e;

                return u(t, i.linkDisableSelector) ? s(t) : u(t, i.buttonDisableSelector) || u(t, i.formEnableSelector) ? r(t) : u(t, i.formSubmitSelector) ? o(t) : void 0;
              }, i.disableElement = function (r) {
                var o;
                return o = r instanceof Event ? r.target : r, u(o, i.linkDisableSelector) ? n(o) : u(o, i.buttonDisableSelector) || u(o, i.formDisableSelector) ? e(o) : u(o, i.formSubmitSelector) ? t(o) : void 0;
              }, n = function n(e) {
                var t;
                if (!l(e, "ujs:disabled")) return null != (t = e.getAttribute("data-disable-with")) && (d(e, "ujs:enable-with", e.innerHTML), e.innerHTML = t), e.addEventListener("click", h), d(e, "ujs:disabled", !0);
              }, s = function s(e) {
                var t;
                return null != (t = l(e, "ujs:enable-with")) && (e.innerHTML = t, d(e, "ujs:enable-with", null)), e.removeEventListener("click", h), d(e, "ujs:disabled", null);
              }, t = function t(_t13) {
                return a(_t13, i.formDisableSelector).forEach(e);
              }, e = function e(_e16) {
                var t;
                if (!l(_e16, "ujs:disabled")) return null != (t = _e16.getAttribute("data-disable-with")) && (u(_e16, "button") ? (d(_e16, "ujs:enable-with", _e16.innerHTML), _e16.innerHTML = t) : (d(_e16, "ujs:enable-with", _e16.value), _e16.value = t)), _e16.disabled = !0, d(_e16, "ujs:disabled", !0);
              }, o = function o(e) {
                return a(e, i.formEnableSelector).forEach(r);
              }, r = function r(e) {
                var t;
                return null != (t = l(e, "ujs:enable-with")) && (u(e, "button") ? e.innerHTML = t : e.value = t, d(e, "ujs:enable-with", null)), e.disabled = !1, d(e, "ujs:disabled", null);
              }, c = function c(e) {
                var t, n;
                return null != (null != (n = null != (t = e.detail) ? t[0] : void 0) ? n.getResponseHeader("X-Xhr-Redirect") : void 0);
              };
            }.call(this), function () {
              var e;
              e = i.stopEverything, i.handleMethod = function (t) {
                var n, r, o, s, a, l, c;
                if (c = (l = this).getAttribute("data-method")) return a = i.href(l), r = i.csrfToken(), n = i.csrfParam(), o = document.createElement("form"), s = "<input name='_method' value='" + c + "' type='hidden' />", null == n || null == r || i.isCrossDomain(a) || (s += "<input name='" + n + "' value='" + r + "' type='hidden' />"), s += '<input type="submit" />', o.method = "post", o.action = a, o.target = l.target, o.innerHTML = s, o.style.display = "none", document.body.appendChild(o), o.querySelector('[type="submit"]').click(), e(t);
              };
            }.call(this), function () {
              var e,
                  t,
                  n,
                  r,
                  o,
                  s,
                  a,
                  l,
                  c,
                  u = [].slice;
              s = i.matches, n = i.getData, l = i.setData, t = i.fire, c = i.stopEverything, e = i.ajax, r = i.isCrossDomain, a = i.serializeElement, o = function o(e) {
                var t;
                return null != (t = e.getAttribute("data-remote")) && "false" !== t;
              }, i.handleRemote = function (d) {
                var h, f, p, g, m, v, y;
                return !o(g = this) || (t(g, "ajax:before") ? (y = g.getAttribute("data-with-credentials"), p = g.getAttribute("data-type") || "script", s(g, i.formSubmitSelector) ? (h = n(g, "ujs:submit-button"), m = n(g, "ujs:submit-button-formmethod") || g.method, v = n(g, "ujs:submit-button-formaction") || g.getAttribute("action") || location.href, "GET" === m.toUpperCase() && (v = v.replace(/\?.*$/, "")), "multipart/form-data" === g.enctype ? (f = new FormData(g), null != h && f.append(h.name, h.value)) : f = a(g, h), l(g, "ujs:submit-button", null), l(g, "ujs:submit-button-formmethod", null), l(g, "ujs:submit-button-formaction", null)) : s(g, i.buttonClickSelector) || s(g, i.inputChangeSelector) ? (m = g.getAttribute("data-method"), v = g.getAttribute("data-url"), f = a(g, g.getAttribute("data-params"))) : (m = g.getAttribute("data-method"), v = i.href(g), f = g.getAttribute("data-params")), e({
                  type: m || "GET",
                  url: v,
                  data: f,
                  dataType: p,
                  beforeSend: function beforeSend(e, n) {
                    return t(g, "ajax:beforeSend", [e, n]) ? t(g, "ajax:send", [e]) : (t(g, "ajax:stopped"), !1);
                  },
                  success: function success() {
                    var e;
                    return e = 1 <= arguments.length ? u.call(arguments, 0) : [], t(g, "ajax:success", e);
                  },
                  error: function error() {
                    var e;
                    return e = 1 <= arguments.length ? u.call(arguments, 0) : [], t(g, "ajax:error", e);
                  },
                  complete: function complete() {
                    var e;
                    return e = 1 <= arguments.length ? u.call(arguments, 0) : [], t(g, "ajax:complete", e);
                  },
                  crossDomain: r(v),
                  withCredentials: null != y && "false" !== y
                }), c(d)) : (t(g, "ajax:stopped"), !1));
              }, i.formSubmitButtonClick = function (e) {
                var t, n;
                if (n = (t = this).form) return t.name && l(n, "ujs:submit-button", {
                  name: t.name,
                  value: t.value
                }), l(n, "ujs:formnovalidate-button", t.formNoValidate), l(n, "ujs:submit-button-formaction", t.getAttribute("formaction")), l(n, "ujs:submit-button-formmethod", t.getAttribute("formmethod"));
              }, i.preventInsignificantClick = function (e) {
                var t, n, r;
                if (r = (this.getAttribute("data-method") || "GET").toUpperCase(), t = this.getAttribute("data-params"), n = (e.metaKey || e.ctrlKey) && "GET" === r && !t, null != e.button && 0 !== e.button || n) return e.stopImmediatePropagation();
              };
            }.call(this), function () {
              var e, t, n, r, o, s, a, l, c, u, d, h, f, p, g;

              if (s = i.fire, n = i.delegate, l = i.getData, e = i.$, g = i.refreshCSRFTokens, t = i.CSRFProtection, f = i.loadCSPNonce, o = i.enableElement, r = i.disableElement, u = i.handleDisabledElement, c = i.handleConfirm, p = i.preventInsignificantClick, h = i.handleRemote, a = i.formSubmitButtonClick, d = i.handleMethod, "undefined" != typeof jQuery && null !== jQuery && null != jQuery.ajax) {
                if (jQuery.rails) throw new Error("If you load both jquery_ujs and rails-ujs, use rails-ujs only.");
                jQuery.rails = i, jQuery.ajaxPrefilter(function (e, n, r) {
                  if (!e.crossDomain) return t(r);
                });
              }

              i.start = function () {
                if (window._rails_loaded) throw new Error("rails-ujs has already been loaded!");
                return window.addEventListener("pageshow", function () {
                  return e(i.formEnableSelector).forEach(function (e) {
                    if (l(e, "ujs:disabled")) return o(e);
                  }), e(i.linkDisableSelector).forEach(function (e) {
                    if (l(e, "ujs:disabled")) return o(e);
                  });
                }), n(document, i.linkDisableSelector, "ajax:complete", o), n(document, i.linkDisableSelector, "ajax:stopped", o), n(document, i.buttonDisableSelector, "ajax:complete", o), n(document, i.buttonDisableSelector, "ajax:stopped", o), n(document, i.linkClickSelector, "click", p), n(document, i.linkClickSelector, "click", u), n(document, i.linkClickSelector, "click", c), n(document, i.linkClickSelector, "click", r), n(document, i.linkClickSelector, "click", h), n(document, i.linkClickSelector, "click", d), n(document, i.buttonClickSelector, "click", p), n(document, i.buttonClickSelector, "click", u), n(document, i.buttonClickSelector, "click", c), n(document, i.buttonClickSelector, "click", r), n(document, i.buttonClickSelector, "click", h), n(document, i.inputChangeSelector, "change", u), n(document, i.inputChangeSelector, "change", c), n(document, i.inputChangeSelector, "change", h), n(document, i.formSubmitSelector, "submit", u), n(document, i.formSubmitSelector, "submit", c), n(document, i.formSubmitSelector, "submit", h), n(document, i.formSubmitSelector, "submit", function (e) {
                  return setTimeout(function () {
                    return r(e);
                  }, 13);
                }), n(document, i.formSubmitSelector, "ajax:send", r), n(document, i.formSubmitSelector, "ajax:complete", o), n(document, i.formInputClickSelector, "click", p), n(document, i.formInputClickSelector, "click", u), n(document, i.formInputClickSelector, "click", c), n(document, i.formInputClickSelector, "click", a), document.addEventListener("DOMContentLoaded", g), document.addEventListener("DOMContentLoaded", f), window._rails_loaded = !0;
              }, window.Rails === i && s(document, "rails:attachBindings") && i.start();
            }.call(this);
          }).call(this), e.exports ? e.exports = i : void 0 === (o = "function" == typeof (r = i) ? r.call(t, n, t, e) : r) || (e.exports = o);
        }).call(this);
      },
      4320: function _(e) {
        var t;
        window, t = function t() {
          return function (e) {
            var t = {};

            function n(r) {
              if (t[r]) return t[r].exports;
              var o = t[r] = {
                i: r,
                l: !1,
                exports: {}
              };
              return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
            }

            return n.m = e, n.c = t, n.d = function (e, t, r) {
              n.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: r
              });
            }, n.r = function (e) {
              "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
              }), Object.defineProperty(e, "__esModule", {
                value: !0
              });
            }, n.t = function (e, t) {
              if (1 & t && (e = n(e)), 8 & t) return e;
              if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
              var r = Object.create(null);
              if (n.r(r), Object.defineProperty(r, "default", {
                enumerable: !0,
                value: e
              }), 2 & t && "string" != typeof e) for (var o in e) {
                n.d(r, o, function (t) {
                  return e[t];
                }.bind(null, o));
              }
              return r;
            }, n.n = function (e) {
              var t = e && e.__esModule ? function () {
                return e.default;
              } : function () {
                return e;
              };
              return n.d(t, "a", t), t;
            }, n.o = function (e, t) {
              return Object.prototype.hasOwnProperty.call(e, t);
            }, n.p = "", n(n.s = 66);
          }([function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r,
                o = (r = n(64)) && r.__esModule ? r : {
              default: r
            };
            t.default = o.default;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r,
                o = (r = n(60)) && r.__esModule ? r : {
              default: r
            };
            t.default = o.default;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = n(51);
            Object.defineProperty(t, "closest", {
              enumerable: !0,
              get: function get() {
                return i(r).default;
              }
            });
            var o = n(49);

            function i(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            Object.defineProperty(t, "requestNextAnimationFrame", {
              enumerable: !0,
              get: function get() {
                return i(o).default;
              }
            });
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = n(44);
            Object.keys(r).forEach(function (e) {
              "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                enumerable: !0,
                get: function get() {
                  return r[e];
                }
              });
            });
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r,
                o = (r = n(47)) && r.__esModule ? r : {
              default: r
            };
            t.default = o.default;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = n(14);
            Object.keys(r).forEach(function (e) {
              "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                enumerable: !0,
                get: function get() {
                  return r[e];
                }
              });
            });
            var o = n(13);
            Object.keys(o).forEach(function (e) {
              "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                enumerable: !0,
                get: function get() {
                  return o[e];
                }
              });
            });
            var i = n(12);
            Object.keys(i).forEach(function (e) {
              "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                enumerable: !0,
                get: function get() {
                  return i[e];
                }
              });
            });
            var s = n(6);
            Object.keys(s).forEach(function (e) {
              "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                enumerable: !0,
                get: function get() {
                  return s[e];
                }
              });
            });
            var a,
                l = (a = n(37)) && a.__esModule ? a : {
              default: a
            };
            t.default = l.default;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = n(4);
            Object.defineProperty(t, "Sensor", {
              enumerable: !0,
              get: function get() {
                return c(r).default;
              }
            });
            var o = n(46);
            Object.defineProperty(t, "MouseSensor", {
              enumerable: !0,
              get: function get() {
                return c(o).default;
              }
            });
            var i = n(43);
            Object.defineProperty(t, "TouchSensor", {
              enumerable: !0,
              get: function get() {
                return c(i).default;
              }
            });
            var s = n(41);
            Object.defineProperty(t, "DragSensor", {
              enumerable: !0,
              get: function get() {
                return c(s).default;
              }
            });
            var a = n(39);
            Object.defineProperty(t, "ForceTouchSensor", {
              enumerable: !0,
              get: function get() {
                return c(a).default;
              }
            });
            var l = n(3);

            function c(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            Object.keys(l).forEach(function (e) {
              "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                enumerable: !0,
                get: function get() {
                  return l[e];
                }
              });
            });
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = n(18);
            Object.keys(r).forEach(function (e) {
              "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                enumerable: !0,
                get: function get() {
                  return r[e];
                }
              });
            });
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = n(23);
            Object.keys(r).forEach(function (e) {
              "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                enumerable: !0,
                get: function get() {
                  return r[e];
                }
              });
            });
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = n(27);
            Object.keys(r).forEach(function (e) {
              "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                enumerable: !0,
                get: function get() {
                  return r[e];
                }
              });
            });
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = n(30);
            Object.keys(r).forEach(function (e) {
              "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                enumerable: !0,
                get: function get() {
                  return r[e];
                }
              });
            });
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = n(33);
            Object.keys(r).forEach(function (e) {
              "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                enumerable: !0,
                get: function get() {
                  return r[e];
                }
              });
            });
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = n(62);
            Object.defineProperty(t, "Announcement", {
              enumerable: !0,
              get: function get() {
                return a(r).default;
              }
            }), Object.defineProperty(t, "defaultAnnouncementOptions", {
              enumerable: !0,
              get: function get() {
                return r.defaultOptions;
              }
            });
            var o = n(59);
            Object.defineProperty(t, "Focusable", {
              enumerable: !0,
              get: function get() {
                return a(o).default;
              }
            });
            var i = n(57);
            Object.defineProperty(t, "Mirror", {
              enumerable: !0,
              get: function get() {
                return a(i).default;
              }
            }), Object.defineProperty(t, "defaultMirrorOptions", {
              enumerable: !0,
              get: function get() {
                return i.defaultOptions;
              }
            });
            var s = n(53);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            Object.defineProperty(t, "Scrollable", {
              enumerable: !0,
              get: function get() {
                return a(s).default;
              }
            }), Object.defineProperty(t, "defaultScrollableOptions", {
              enumerable: !0,
              get: function get() {
                return s.defaultOptions;
              }
            });
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = n(63);
            Object.keys(r).forEach(function (e) {
              "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                enumerable: !0,
                get: function get() {
                  return r[e];
                }
              });
            });
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = n(65);
            Object.keys(r).forEach(function (e) {
              "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                enumerable: !0,
                get: function get() {
                  return r[e];
                }
              });
            });
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.defaultOptions = void 0;

            var r,
                o = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            },
                i = (r = n(1)) && r.__esModule ? r : {
              default: r
            };

            var s = Symbol("onSortableSorted"),
                a = t.defaultOptions = {
              duration: 150,
              easingFunction: "ease-in-out",
              horizontal: !1
            };

            var l = /*#__PURE__*/function (_i$default) {
              _inherits(l, _i$default);

              var _super2 = _createSuper(l);

              function l(e) {
                var _this18;

                _classCallCheck(this, l);

                _this18 = _super2.call(this, e), _this18.options = o({}, a, _this18.getOptions()), _this18.lastAnimationFrame = null, _this18[s] = _this18[s].bind(_assertThisInitialized(_this18));
                return _this18;
              }

              _createClass(l, [{
                key: "attach",
                value: function attach() {
                  this.draggable.on("sortable:sorted", this[s]);
                }
              }, {
                key: "detach",
                value: function detach() {
                  this.draggable.off("sortable:sorted", this[s]);
                }
              }, {
                key: "getOptions",
                value: function getOptions() {
                  return this.draggable.options.swapAnimation || {};
                }
              }, {
                key: s,
                value: function value(_ref21) {
                  var _this19 = this;

                  var e = _ref21.oldIndex,
                      t = _ref21.newIndex,
                      n = _ref21.dragEvent;
                  var r = n.source,
                      o = n.over;
                  cancelAnimationFrame(this.lastAnimationFrame), this.lastAnimationFrame = requestAnimationFrame(function () {
                    e >= t ? c(r, o, _this19.options) : c(o, r, _this19.options);
                  });
                }
              }]);

              return l;
            }(i.default);

            function c(e, t, _ref22) {
              var n = _ref22.duration,
                  r = _ref22.easingFunction,
                  o = _ref22.horizontal;

              for (var _i7 = 0, _arr2 = [e, t]; _i7 < _arr2.length; _i7++) {
                var _n10 = _arr2[_i7];
                _n10.style.pointerEvents = "none";
              }

              if (o) {
                var _n11 = e.offsetWidth;
                e.style.transform = "translate3d(".concat(_n11, "px, 0, 0)"), t.style.transform = "translate3d(-".concat(_n11, "px, 0, 0)");
              } else {
                var _n12 = e.offsetHeight;
                e.style.transform = "translate3d(0, ".concat(_n12, "px, 0)"), t.style.transform = "translate3d(0, -".concat(_n12, "px, 0)");
              }

              requestAnimationFrame(function () {
                for (var _i8 = 0, _arr3 = [e, t]; _i8 < _arr3.length; _i8++) {
                  var _o6 = _arr3[_i8];
                  _o6.addEventListener("transitionend", u), _o6.style.transition = "transform ".concat(n, "ms ").concat(r), _o6.style.transform = "";
                }
              });
            }

            function u(e) {
              e.target.style.transition = "", e.target.style.pointerEvents = "", e.target.removeEventListener("transitionend", u);
            }

            t.default = l;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.defaultOptions = void 0;
            var r,
                o = n(15),
                i = (r = o) && r.__esModule ? r : {
              default: r
            };
            t.default = i.default, t.defaultOptions = o.defaultOptions;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r,
                o = (r = n(1)) && r.__esModule ? r : {
              default: r
            },
                i = n(7);
            var s = Symbol("onDragStart"),
                a = Symbol("onDragStop"),
                l = Symbol("onDragOver"),
                c = Symbol("onDragOut"),
                u = Symbol("onMirrorCreated"),
                d = Symbol("onMirrorDestroy");

            var h = /*#__PURE__*/function (_o$default) {
              _inherits(h, _o$default);

              var _super3 = _createSuper(h);

              function h(e) {
                var _this20;

                _classCallCheck(this, h);

                _this20 = _super3.call(this, e), _this20.firstSource = null, _this20.mirror = null, _this20[s] = _this20[s].bind(_assertThisInitialized(_this20)), _this20[a] = _this20[a].bind(_assertThisInitialized(_this20)), _this20[l] = _this20[l].bind(_assertThisInitialized(_this20)), _this20[c] = _this20[c].bind(_assertThisInitialized(_this20)), _this20[u] = _this20[u].bind(_assertThisInitialized(_this20)), _this20[d] = _this20[d].bind(_assertThisInitialized(_this20));
                return _this20;
              }

              _createClass(h, [{
                key: "attach",
                value: function attach() {
                  this.draggable.on("drag:start", this[s]).on("drag:stop", this[a]).on("drag:over", this[l]).on("drag:out", this[c]).on("droppable:over", this[l]).on("droppable:out", this[c]).on("mirror:created", this[u]).on("mirror:destroy", this[d]);
                }
              }, {
                key: "detach",
                value: function detach() {
                  this.draggable.off("drag:start", this[s]).off("drag:stop", this[a]).off("drag:over", this[l]).off("drag:out", this[c]).off("droppable:over", this[l]).off("droppable:out", this[c]).off("mirror:created", this[u]).off("mirror:destroy", this[d]);
                }
              }, {
                key: s,
                value: function value(e) {
                  e.canceled() || (this.firstSource = e.source);
                }
              }, {
                key: a,
                value: function value() {
                  this.firstSource = null;
                }
              }, {
                key: l,
                value: function value(e) {
                  var _this21 = this;

                  if (e.canceled()) return;
                  var t = e.source || e.dragEvent.source;
                  if (t === this.firstSource) return void (this.firstSource = null);
                  var n = new i.SnapInEvent({
                    dragEvent: e,
                    snappable: e.over || e.droppable
                  });
                  this.draggable.trigger(n), n.canceled() || (this.mirror && (this.mirror.style.display = "none"), t.classList.remove(this.draggable.getClassNameFor("source:dragging")), t.classList.add(this.draggable.getClassNameFor("source:placed")), setTimeout(function () {
                    t.classList.remove(_this21.draggable.getClassNameFor("source:placed"));
                  }, this.draggable.options.placedTimeout));
                }
              }, {
                key: c,
                value: function value(e) {
                  if (e.canceled()) return;
                  var t = e.source || e.dragEvent.source,
                      n = new i.SnapOutEvent({
                    dragEvent: e,
                    snappable: e.over || e.droppable
                  });
                  this.draggable.trigger(n), n.canceled() || (this.mirror && (this.mirror.style.display = ""), t.classList.add(this.draggable.getClassNameFor("source:dragging")));
                }
              }, {
                key: u,
                value: function value(_ref23) {
                  var e = _ref23.mirror;
                  this.mirror = e;
                }
              }, {
                key: d,
                value: function value() {
                  this.mirror = null;
                }
              }]);

              return h;
            }(o.default);

            t.default = h;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.SnapOutEvent = t.SnapInEvent = t.SnapEvent = void 0;
            var r,
                o = (r = n(0)) && r.__esModule ? r : {
              default: r
            };

            var i = /*#__PURE__*/function (_o$default2) {
              _inherits(i, _o$default2);

              var _super4 = _createSuper(i);

              function i() {
                _classCallCheck(this, i);

                return _super4.apply(this, arguments);
              }

              _createClass(i, [{
                key: "dragEvent",
                get: function get() {
                  return this.data.dragEvent;
                }
              }, {
                key: "snappable",
                get: function get() {
                  return this.data.snappable;
                }
              }]);

              return i;
            }(o.default);

            t.SnapEvent = i, i.type = "snap";

            var s = /*#__PURE__*/function (_i9) {
              _inherits(s, _i9);

              var _super5 = _createSuper(s);

              function s() {
                _classCallCheck(this, s);

                return _super5.apply(this, arguments);
              }

              return s;
            }(i);

            t.SnapInEvent = s, s.type = "snap:in", s.cancelable = !0;

            var a = /*#__PURE__*/function (_i10) {
              _inherits(a, _i10);

              var _super6 = _createSuper(a);

              function a() {
                _classCallCheck(this, a);

                return _super6.apply(this, arguments);
              }

              return a;
            }(i);

            t.SnapOutEvent = a, a.type = "snap:out", a.cancelable = !0;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = n(7);
            Object.keys(r).forEach(function (e) {
              "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                enumerable: !0,
                get: function get() {
                  return r[e];
                }
              });
            });
            var o,
                i = (o = n(17)) && o.__esModule ? o : {
              default: o
            };
            t.default = i.default;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.defaultOptions = void 0;

            var r,
                o = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            },
                i = (r = n(1)) && r.__esModule ? r : {
              default: r
            },
                s = n(2);

            var a = Symbol("onMirrorCreated"),
                l = Symbol("onMirrorDestroy"),
                c = Symbol("onDragOver"),
                u = Symbol("resize"),
                d = t.defaultOptions = {};

            var h = /*#__PURE__*/function (_i$default2) {
              _inherits(h, _i$default2);

              var _super7 = _createSuper(h);

              function h(e) {
                var _this22;

                _classCallCheck(this, h);

                _this22 = _super7.call(this, e), _this22.options = o({}, d, _this22.getOptions()), _this22.lastWidth = 0, _this22.lastHeight = 0, _this22.mirror = null, _this22[a] = _this22[a].bind(_assertThisInitialized(_this22)), _this22[l] = _this22[l].bind(_assertThisInitialized(_this22)), _this22[c] = _this22[c].bind(_assertThisInitialized(_this22));
                return _this22;
              }

              _createClass(h, [{
                key: "attach",
                value: function attach() {
                  this.draggable.on("mirror:created", this[a]).on("drag:over", this[c]).on("drag:over:container", this[c]);
                }
              }, {
                key: "detach",
                value: function detach() {
                  this.draggable.off("mirror:created", this[a]).off("mirror:destroy", this[l]).off("drag:over", this[c]).off("drag:over:container", this[c]);
                }
              }, {
                key: "getOptions",
                value: function getOptions() {
                  return this.draggable.options.resizeMirror || {};
                }
              }, {
                key: a,
                value: function value(_ref24) {
                  var e = _ref24.mirror;
                  this.mirror = e;
                }
              }, {
                key: l,
                value: function value() {
                  this.mirror = null;
                }
              }, {
                key: c,
                value: function value(e) {
                  this[u](e);
                }
              }, {
                key: u,
                value: function value(_ref25) {
                  var _this23 = this;

                  var e = _ref25.overContainer,
                      t = _ref25.over;
                  requestAnimationFrame(function () {
                    _this23.mirror.parentNode !== e && e.appendChild(_this23.mirror);

                    var n = t || _this23.draggable.getDraggableElementsForContainer(e)[0];

                    n && (0, s.requestNextAnimationFrame)(function () {
                      var e = n.getBoundingClientRect();
                      _this23.lastHeight === e.height && _this23.lastWidth === e.width || (_this23.mirror.style.width = "".concat(e.width, "px"), _this23.mirror.style.height = "".concat(e.height, "px"), _this23.lastWidth = e.width, _this23.lastHeight = e.height);
                    });
                  });
                }
              }]);

              return h;
            }(i.default);

            t.default = h;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.defaultOptions = void 0;
            var r,
                o = n(20),
                i = (r = o) && r.__esModule ? r : {
              default: r
            };
            t.default = i.default, t.defaultOptions = o.defaultOptions;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r,
                o = (r = n(1)) && r.__esModule ? r : {
              default: r
            },
                i = n(2),
                s = n(8);
            var a = Symbol("onDragMove"),
                l = Symbol("onDragStop"),
                c = Symbol("onRequestAnimationFrame");

            var u = /*#__PURE__*/function (_o$default3) {
              _inherits(u, _o$default3);

              var _super8 = _createSuper(u);

              function u(e) {
                var _this24;

                _classCallCheck(this, u);

                _this24 = _super8.call(this, e), _this24.currentlyCollidingElement = null, _this24.lastCollidingElement = null, _this24.currentAnimationFrame = null, _this24[a] = _this24[a].bind(_assertThisInitialized(_this24)), _this24[l] = _this24[l].bind(_assertThisInitialized(_this24)), _this24[c] = _this24[c].bind(_assertThisInitialized(_this24));
                return _this24;
              }

              _createClass(u, [{
                key: "attach",
                value: function attach() {
                  this.draggable.on("drag:move", this[a]).on("drag:stop", this[l]);
                }
              }, {
                key: "detach",
                value: function detach() {
                  this.draggable.off("drag:move", this[a]).off("drag:stop", this[l]);
                }
              }, {
                key: "getCollidables",
                value: function getCollidables() {
                  var e = this.draggable.options.collidables;
                  return "string" == typeof e ? Array.prototype.slice.call(document.querySelectorAll(e)) : e instanceof NodeList || e instanceof Array ? Array.prototype.slice.call(e) : e instanceof HTMLElement ? [e] : "function" == typeof e ? e() : [];
                }
              }, {
                key: a,
                value: function value(e) {
                  var t = e.sensorEvent.target;
                  this.currentAnimationFrame = requestAnimationFrame(this[c](t)), this.currentlyCollidingElement && e.cancel();
                  var n = new s.CollidableInEvent({
                    dragEvent: e,
                    collidingElement: this.currentlyCollidingElement
                  }),
                      r = new s.CollidableOutEvent({
                    dragEvent: e,
                    collidingElement: this.lastCollidingElement
                  }),
                      o = Boolean(this.currentlyCollidingElement && this.lastCollidingElement !== this.currentlyCollidingElement),
                      i = Boolean(!this.currentlyCollidingElement && this.lastCollidingElement);
                  o ? (this.lastCollidingElement && this.draggable.trigger(r), this.draggable.trigger(n)) : i && this.draggable.trigger(r), this.lastCollidingElement = this.currentlyCollidingElement;
                }
              }, {
                key: l,
                value: function value(e) {
                  var t = this.currentlyCollidingElement || this.lastCollidingElement,
                      n = new s.CollidableOutEvent({
                    dragEvent: e,
                    collidingElement: t
                  });
                  t && this.draggable.trigger(n), this.lastCollidingElement = null, this.currentlyCollidingElement = null;
                }
              }, {
                key: c,
                value: function value(e) {
                  var _this25 = this;

                  return function () {
                    var t = _this25.getCollidables();

                    _this25.currentlyCollidingElement = (0, i.closest)(e, function (e) {
                      return t.includes(e);
                    });
                  };
                }
              }]);

              return u;
            }(o.default);

            t.default = u;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.CollidableOutEvent = t.CollidableInEvent = t.CollidableEvent = void 0;
            var r,
                o = (r = n(0)) && r.__esModule ? r : {
              default: r
            };

            var i = /*#__PURE__*/function (_o$default4) {
              _inherits(i, _o$default4);

              var _super9 = _createSuper(i);

              function i() {
                _classCallCheck(this, i);

                return _super9.apply(this, arguments);
              }

              _createClass(i, [{
                key: "dragEvent",
                get: function get() {
                  return this.data.dragEvent;
                }
              }]);

              return i;
            }(o.default);

            t.CollidableEvent = i, i.type = "collidable";

            var s = /*#__PURE__*/function (_i11) {
              _inherits(s, _i11);

              var _super10 = _createSuper(s);

              function s() {
                _classCallCheck(this, s);

                return _super10.apply(this, arguments);
              }

              _createClass(s, [{
                key: "collidingElement",
                get: function get() {
                  return this.data.collidingElement;
                }
              }]);

              return s;
            }(i);

            t.CollidableInEvent = s, s.type = "collidable:in";

            var a = /*#__PURE__*/function (_i12) {
              _inherits(a, _i12);

              var _super11 = _createSuper(a);

              function a() {
                _classCallCheck(this, a);

                return _super11.apply(this, arguments);
              }

              _createClass(a, [{
                key: "collidingElement",
                get: function get() {
                  return this.data.collidingElement;
                }
              }]);

              return a;
            }(i);

            t.CollidableOutEvent = a, a.type = "collidable:out";
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = n(8);
            Object.keys(r).forEach(function (e) {
              "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                enumerable: !0,
                get: function get() {
                  return r[e];
                }
              });
            });
            var o,
                i = (o = n(22)) && o.__esModule ? o : {
              default: o
            };
            t.default = i.default;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = n(24);
            Object.defineProperty(t, "Collidable", {
              enumerable: !0,
              get: function get() {
                return a(r).default;
              }
            });
            var o = n(21);
            Object.defineProperty(t, "ResizeMirror", {
              enumerable: !0,
              get: function get() {
                return a(o).default;
              }
            }), Object.defineProperty(t, "defaultResizeMirrorOptions", {
              enumerable: !0,
              get: function get() {
                return o.defaultOptions;
              }
            });
            var i = n(19);
            Object.defineProperty(t, "Snappable", {
              enumerable: !0,
              get: function get() {
                return a(i).default;
              }
            });
            var s = n(16);

            function a(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            Object.defineProperty(t, "SwapAnimation", {
              enumerable: !0,
              get: function get() {
                return a(s).default;
              }
            }), Object.defineProperty(t, "defaultSwapAnimationOptions", {
              enumerable: !0,
              get: function get() {
                return s.defaultOptions;
              }
            });
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });

            var r,
                o = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            },
                i = (r = n(5)) && r.__esModule ? r : {
              default: r
            },
                s = n(9);

            var a = Symbol("onDragStart"),
                l = Symbol("onDragOverContainer"),
                c = Symbol("onDragOver"),
                u = Symbol("onDragStop"),
                d = {
              "sortable:sorted": function sortableSorted(_ref26) {
                var e = _ref26.dragEvent;
                var t = e.source.textContent.trim() || e.source.id || "sortable element";

                if (e.over) {
                  var _n13 = e.over.textContent.trim() || e.over.id || "sortable element";

                  return e.source.compareDocumentPosition(e.over) & Node.DOCUMENT_POSITION_FOLLOWING ? "Placed ".concat(t, " after ").concat(_n13) : "Placed ".concat(t, " before ").concat(_n13);
                }

                return "Placed ".concat(t, " into a different container");
              }
            };

            var h = /*#__PURE__*/function (_i$default3) {
              _inherits(h, _i$default3);

              var _super12 = _createSuper(h);

              function h() {
                var _this26;

                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                _classCallCheck(this, h);

                _this26 = _super12.call(this, e, o({}, t, {
                  announcements: o({}, d, t.announcements || {})
                })), _this26.startIndex = null, _this26.startContainer = null, _this26[a] = _this26[a].bind(_assertThisInitialized(_this26)), _this26[l] = _this26[l].bind(_assertThisInitialized(_this26)), _this26[c] = _this26[c].bind(_assertThisInitialized(_this26)), _this26[u] = _this26[u].bind(_assertThisInitialized(_this26)), _this26.on("drag:start", _this26[a]).on("drag:over:container", _this26[l]).on("drag:over", _this26[c]).on("drag:stop", _this26[u]);
                return _this26;
              }

              _createClass(h, [{
                key: "destroy",
                value: function destroy() {
                  _get(_getPrototypeOf(h.prototype), "destroy", this).call(this), this.off("drag:start", this[a]).off("drag:over:container", this[l]).off("drag:over", this[c]).off("drag:stop", this[u]);
                }
              }, {
                key: "index",
                value: function index(e) {
                  return this.getDraggableElementsForContainer(e.parentNode).indexOf(e);
                }
              }, {
                key: a,
                value: function value(e) {
                  this.startContainer = e.source.parentNode, this.startIndex = this.index(e.source);
                  var t = new s.SortableStartEvent({
                    dragEvent: e,
                    startIndex: this.startIndex,
                    startContainer: this.startContainer
                  });
                  this.trigger(t), t.canceled() && e.cancel();
                }
              }, {
                key: l,
                value: function value(e) {
                  if (e.canceled()) return;
                  var t = e.source,
                      n = e.over,
                      r = e.overContainer,
                      o = this.index(t),
                      i = new s.SortableSortEvent({
                    dragEvent: e,
                    currentIndex: o,
                    source: t,
                    over: n
                  });
                  if (this.trigger(i), i.canceled()) return;
                  var a = p({
                    source: t,
                    over: n,
                    overContainer: r,
                    children: this.getDraggableElementsForContainer(r)
                  });
                  if (!a) return;
                  var l = a.oldContainer,
                      c = a.newContainer,
                      u = this.index(e.source),
                      d = new s.SortableSortedEvent({
                    dragEvent: e,
                    oldIndex: o,
                    newIndex: u,
                    oldContainer: l,
                    newContainer: c
                  });
                  this.trigger(d);
                }
              }, {
                key: c,
                value: function value(e) {
                  if (e.over === e.originalSource || e.over === e.source) return;
                  var t = e.source,
                      n = e.over,
                      r = e.overContainer,
                      o = this.index(t),
                      i = new s.SortableSortEvent({
                    dragEvent: e,
                    currentIndex: o,
                    source: t,
                    over: n
                  });
                  if (this.trigger(i), i.canceled()) return;
                  var a = p({
                    source: t,
                    over: n,
                    overContainer: r,
                    children: this.getDraggableElementsForContainer(r)
                  });
                  if (!a) return;
                  var l = a.oldContainer,
                      c = a.newContainer,
                      u = this.index(t),
                      d = new s.SortableSortedEvent({
                    dragEvent: e,
                    oldIndex: o,
                    newIndex: u,
                    oldContainer: l,
                    newContainer: c
                  });
                  this.trigger(d);
                }
              }, {
                key: u,
                value: function value(e) {
                  var t = new s.SortableStopEvent({
                    dragEvent: e,
                    oldIndex: this.startIndex,
                    newIndex: this.index(e.source),
                    oldContainer: this.startContainer,
                    newContainer: e.source.parentNode
                  });
                  this.trigger(t), this.startIndex = null, this.startContainer = null;
                }
              }]);

              return h;
            }(i.default);

            function f(e) {
              return Array.prototype.indexOf.call(e.parentNode.children, e);
            }

            function p(_ref27) {
              var e = _ref27.source,
                  t = _ref27.over,
                  n = _ref27.overContainer,
                  r = _ref27.children;
              var o = !r.length,
                  i = e.parentNode !== n,
                  s = t && !i;
              return o ? function (e, t) {
                var n = e.parentNode;
                return t.appendChild(e), {
                  oldContainer: n,
                  newContainer: t
                };
              }(e, n) : s ? function (e, t) {
                return f(e) < f(t) ? e.parentNode.insertBefore(e, t.nextElementSibling) : e.parentNode.insertBefore(e, t), {
                  oldContainer: e.parentNode,
                  newContainer: e.parentNode
                };
              }(e, t) : i ? function (e, t, n) {
                var r = e.parentNode;
                return t ? t.parentNode.insertBefore(e, t) : n.appendChild(e), {
                  oldContainer: r,
                  newContainer: e.parentNode
                };
              }(e, t, n) : null;
            }

            t.default = h;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.SortableStopEvent = t.SortableSortedEvent = t.SortableSortEvent = t.SortableStartEvent = t.SortableEvent = void 0;
            var r,
                o = (r = n(0)) && r.__esModule ? r : {
              default: r
            };

            var i = /*#__PURE__*/function (_o$default5) {
              _inherits(i, _o$default5);

              var _super13 = _createSuper(i);

              function i() {
                _classCallCheck(this, i);

                return _super13.apply(this, arguments);
              }

              _createClass(i, [{
                key: "dragEvent",
                get: function get() {
                  return this.data.dragEvent;
                }
              }]);

              return i;
            }(o.default);

            t.SortableEvent = i, i.type = "sortable";

            var s = /*#__PURE__*/function (_i13) {
              _inherits(s, _i13);

              var _super14 = _createSuper(s);

              function s() {
                _classCallCheck(this, s);

                return _super14.apply(this, arguments);
              }

              _createClass(s, [{
                key: "startIndex",
                get: function get() {
                  return this.data.startIndex;
                }
              }, {
                key: "startContainer",
                get: function get() {
                  return this.data.startContainer;
                }
              }]);

              return s;
            }(i);

            t.SortableStartEvent = s, s.type = "sortable:start", s.cancelable = !0;

            var a = /*#__PURE__*/function (_i14) {
              _inherits(a, _i14);

              var _super15 = _createSuper(a);

              function a() {
                _classCallCheck(this, a);

                return _super15.apply(this, arguments);
              }

              _createClass(a, [{
                key: "currentIndex",
                get: function get() {
                  return this.data.currentIndex;
                }
              }, {
                key: "over",
                get: function get() {
                  return this.data.oldIndex;
                }
              }, {
                key: "overContainer",
                get: function get() {
                  return this.data.newIndex;
                }
              }]);

              return a;
            }(i);

            t.SortableSortEvent = a, a.type = "sortable:sort", a.cancelable = !0;

            var l = /*#__PURE__*/function (_i15) {
              _inherits(l, _i15);

              var _super16 = _createSuper(l);

              function l() {
                _classCallCheck(this, l);

                return _super16.apply(this, arguments);
              }

              _createClass(l, [{
                key: "oldIndex",
                get: function get() {
                  return this.data.oldIndex;
                }
              }, {
                key: "newIndex",
                get: function get() {
                  return this.data.newIndex;
                }
              }, {
                key: "oldContainer",
                get: function get() {
                  return this.data.oldContainer;
                }
              }, {
                key: "newContainer",
                get: function get() {
                  return this.data.newContainer;
                }
              }]);

              return l;
            }(i);

            t.SortableSortedEvent = l, l.type = "sortable:sorted";

            var c = /*#__PURE__*/function (_i16) {
              _inherits(c, _i16);

              var _super17 = _createSuper(c);

              function c() {
                _classCallCheck(this, c);

                return _super17.apply(this, arguments);
              }

              _createClass(c, [{
                key: "oldIndex",
                get: function get() {
                  return this.data.oldIndex;
                }
              }, {
                key: "newIndex",
                get: function get() {
                  return this.data.newIndex;
                }
              }, {
                key: "oldContainer",
                get: function get() {
                  return this.data.oldContainer;
                }
              }, {
                key: "newContainer",
                get: function get() {
                  return this.data.newContainer;
                }
              }]);

              return c;
            }(i);

            t.SortableStopEvent = c, c.type = "sortable:stop";
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = n(9);
            Object.keys(r).forEach(function (e) {
              "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                enumerable: !0,
                get: function get() {
                  return r[e];
                }
              });
            });
            var o,
                i = (o = n(26)) && o.__esModule ? o : {
              default: o
            };
            t.default = i.default;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });

            var r,
                o = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            },
                i = (r = n(5)) && r.__esModule ? r : {
              default: r
            },
                s = n(10);

            var a = Symbol("onDragStart"),
                l = Symbol("onDragOver"),
                c = Symbol("onDragStop"),
                u = {
              "swappabled:swapped": function swappabledSwapped(_ref28) {
                var e = _ref28.dragEvent,
                    t = _ref28.swappedElement;
                return "Swapped ".concat(e.source.textContent.trim() || e.source.id || "swappable element", " with ").concat(t.textContent.trim() || t.id || "swappable element");
              }
            };

            var d = /*#__PURE__*/function (_i$default4) {
              _inherits(d, _i$default4);

              var _super18 = _createSuper(d);

              function d() {
                var _this27;

                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                _classCallCheck(this, d);

                _this27 = _super18.call(this, e, o({}, t, {
                  announcements: o({}, u, t.announcements || {})
                })), _this27.lastOver = null, _this27[a] = _this27[a].bind(_assertThisInitialized(_this27)), _this27[l] = _this27[l].bind(_assertThisInitialized(_this27)), _this27[c] = _this27[c].bind(_assertThisInitialized(_this27)), _this27.on("drag:start", _this27[a]).on("drag:over", _this27[l]).on("drag:stop", _this27[c]);
                return _this27;
              }

              _createClass(d, [{
                key: "destroy",
                value: function destroy() {
                  _get(_getPrototypeOf(d.prototype), "destroy", this).call(this), this.off("drag:start", this._onDragStart).off("drag:over", this._onDragOver).off("drag:stop", this._onDragStop);
                }
              }, {
                key: a,
                value: function value(e) {
                  var t = new s.SwappableStartEvent({
                    dragEvent: e
                  });
                  this.trigger(t), t.canceled() && e.cancel();
                }
              }, {
                key: l,
                value: function value(e) {
                  if (e.over === e.originalSource || e.over === e.source || e.canceled()) return;
                  var t = new s.SwappableSwapEvent({
                    dragEvent: e,
                    over: e.over,
                    overContainer: e.overContainer
                  });
                  if (this.trigger(t), t.canceled()) return;
                  this.lastOver && this.lastOver !== e.over && h(this.lastOver, e.source), this.lastOver === e.over ? this.lastOver = null : this.lastOver = e.over, h(e.source, e.over);
                  var n = new s.SwappableSwappedEvent({
                    dragEvent: e,
                    swappedElement: e.over
                  });
                  this.trigger(n);
                }
              }, {
                key: c,
                value: function value(e) {
                  var t = new s.SwappableStopEvent({
                    dragEvent: e
                  });
                  this.trigger(t), this.lastOver = null;
                }
              }]);

              return d;
            }(i.default);

            function h(e, t) {
              var n = t.parentNode,
                  r = e.parentNode;
              !function (o) {
                var i = document.createElement("div");
                (function (o) {
                  r.insertBefore(o, e), n.insertBefore(e, t), r.insertBefore(t, o);
                })(i), i.parentNode.removeChild(i);
              }();
            }

            t.default = d;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.SwappableStopEvent = t.SwappableSwappedEvent = t.SwappableSwapEvent = t.SwappableStartEvent = t.SwappableEvent = void 0;
            var r,
                o = (r = n(0)) && r.__esModule ? r : {
              default: r
            };

            var i = /*#__PURE__*/function (_o$default6) {
              _inherits(i, _o$default6);

              var _super19 = _createSuper(i);

              function i() {
                _classCallCheck(this, i);

                return _super19.apply(this, arguments);
              }

              _createClass(i, [{
                key: "dragEvent",
                get: function get() {
                  return this.data.dragEvent;
                }
              }]);

              return i;
            }(o.default);

            t.SwappableEvent = i, i.type = "swappable";

            var s = /*#__PURE__*/function (_i17) {
              _inherits(s, _i17);

              var _super20 = _createSuper(s);

              function s() {
                _classCallCheck(this, s);

                return _super20.apply(this, arguments);
              }

              return s;
            }(i);

            t.SwappableStartEvent = s, s.type = "swappable:start", s.cancelable = !0;

            var a = /*#__PURE__*/function (_i18) {
              _inherits(a, _i18);

              var _super21 = _createSuper(a);

              function a() {
                _classCallCheck(this, a);

                return _super21.apply(this, arguments);
              }

              _createClass(a, [{
                key: "over",
                get: function get() {
                  return this.data.over;
                }
              }, {
                key: "overContainer",
                get: function get() {
                  return this.data.overContainer;
                }
              }]);

              return a;
            }(i);

            t.SwappableSwapEvent = a, a.type = "swappable:swap", a.cancelable = !0;

            var l = /*#__PURE__*/function (_i19) {
              _inherits(l, _i19);

              var _super22 = _createSuper(l);

              function l() {
                _classCallCheck(this, l);

                return _super22.apply(this, arguments);
              }

              _createClass(l, [{
                key: "swappedElement",
                get: function get() {
                  return this.data.swappedElement;
                }
              }]);

              return l;
            }(i);

            t.SwappableSwappedEvent = l, l.type = "swappable:swapped";

            var c = /*#__PURE__*/function (_i20) {
              _inherits(c, _i20);

              var _super23 = _createSuper(c);

              function c() {
                _classCallCheck(this, c);

                return _super23.apply(this, arguments);
              }

              return c;
            }(i);

            t.SwappableStopEvent = c, c.type = "swappable:stop";
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = n(10);
            Object.keys(r).forEach(function (e) {
              "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                enumerable: !0,
                get: function get() {
                  return r[e];
                }
              });
            });
            var o,
                i = (o = n(29)) && o.__esModule ? o : {
              default: o
            };
            t.default = i.default;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });

            var r,
                o = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            },
                i = n(2),
                s = (r = n(5)) && r.__esModule ? r : {
              default: r
            },
                a = n(11);

            var l = Symbol("onDragStart"),
                c = Symbol("onDragMove"),
                u = Symbol("onDragStop"),
                d = Symbol("dropInDropZone"),
                h = Symbol("returnToOriginalDropzone"),
                f = Symbol("closestDropzone"),
                p = Symbol("getDropzones"),
                g = {
              "droppable:dropped": function droppableDropped(_ref29) {
                var e = _ref29.dragEvent,
                    t = _ref29.dropzone;
                return "Dropped ".concat(e.source.textContent.trim() || e.source.id || "draggable element", " into ").concat(t.textContent.trim() || t.id || "droppable element");
              },
              "droppable:returned": function droppableReturned(_ref30) {
                var e = _ref30.dragEvent,
                    t = _ref30.dropzone;
                return "Returned ".concat(e.source.textContent.trim() || e.source.id || "draggable element", " from ").concat(t.textContent.trim() || t.id || "droppable element");
              }
            },
                m = {
              "droppable:active": "draggable-dropzone--active",
              "droppable:occupied": "draggable-dropzone--occupied"
            },
                v = {
              dropzone: ".draggable-droppable"
            };

            var y = /*#__PURE__*/function (_s$default) {
              _inherits(y, _s$default);

              var _super24 = _createSuper(y);

              function y() {
                var _this28;

                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                _classCallCheck(this, y);

                _this28 = _super24.call(this, e, o({}, v, t, {
                  classes: o({}, m, t.classes || {}),
                  announcements: o({}, g, t.announcements || {})
                })), _this28.dropzones = null, _this28.lastDropzone = null, _this28.initialDropzone = null, _this28[l] = _this28[l].bind(_assertThisInitialized(_this28)), _this28[c] = _this28[c].bind(_assertThisInitialized(_this28)), _this28[u] = _this28[u].bind(_assertThisInitialized(_this28)), _this28.on("drag:start", _this28[l]).on("drag:move", _this28[c]).on("drag:stop", _this28[u]);
                return _this28;
              }

              _createClass(y, [{
                key: "destroy",
                value: function destroy() {
                  _get(_getPrototypeOf(y.prototype), "destroy", this).call(this), this.off("drag:start", this[l]).off("drag:move", this[c]).off("drag:stop", this[u]);
                }
              }, {
                key: l,
                value: function value(e) {
                  if (e.canceled()) return;
                  this.dropzones = _toConsumableArray(this[p]());
                  var t = (0, i.closest)(e.sensorEvent.target, this.options.dropzone);
                  if (!t) return void e.cancel();
                  var n = new a.DroppableStartEvent({
                    dragEvent: e,
                    dropzone: t
                  });
                  if (this.trigger(n), n.canceled()) e.cancel();else {
                    this.initialDropzone = t;

                    var _iterator10 = _createForOfIteratorHelper(this.dropzones),
                        _step10;

                    try {
                      for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                        var _e17 = _step10.value;
                        _e17.classList.contains(this.getClassNameFor("droppable:occupied")) || _e17.classList.add(this.getClassNameFor("droppable:active"));
                      }
                    } catch (err) {
                      _iterator10.e(err);
                    } finally {
                      _iterator10.f();
                    }
                  }
                }
              }, {
                key: c,
                value: function value(e) {
                  if (e.canceled()) return;
                  var t = this[f](e.sensorEvent.target);
                  t && !t.classList.contains(this.getClassNameFor("droppable:occupied")) && this[d](e, t) ? this.lastDropzone = t : t && t !== this.initialDropzone || !this.lastDropzone || (this[h](e), this.lastDropzone = null);
                }
              }, {
                key: u,
                value: function value(e) {
                  var t = new a.DroppableStopEvent({
                    dragEvent: e,
                    dropzone: this.lastDropzone || this.initialDropzone
                  });
                  this.trigger(t);
                  var n = this.getClassNameFor("droppable:occupied");

                  var _iterator11 = _createForOfIteratorHelper(this.dropzones),
                      _step11;

                  try {
                    for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                      var _e18 = _step11.value;

                      _e18.classList.remove(this.getClassNameFor("droppable:active"));
                    }
                  } catch (err) {
                    _iterator11.e(err);
                  } finally {
                    _iterator11.f();
                  }

                  this.lastDropzone && this.lastDropzone !== this.initialDropzone && this.initialDropzone.classList.remove(n), this.dropzones = null, this.lastDropzone = null, this.initialDropzone = null;
                }
              }, {
                key: d,
                value: function value(e, t) {
                  var n = new a.DroppableDroppedEvent({
                    dragEvent: e,
                    dropzone: t
                  });
                  if (this.trigger(n), n.canceled()) return !1;
                  var r = this.getClassNameFor("droppable:occupied");
                  return this.lastDropzone && this.lastDropzone.classList.remove(r), t.appendChild(e.source), t.classList.add(r), !0;
                }
              }, {
                key: h,
                value: function value(e) {
                  var t = new a.DroppableReturnedEvent({
                    dragEvent: e,
                    dropzone: this.lastDropzone
                  });
                  this.trigger(t), t.canceled() || (this.initialDropzone.appendChild(e.source), this.lastDropzone.classList.remove(this.getClassNameFor("droppable:occupied")));
                }
              }, {
                key: f,
                value: function value(e) {
                  return this.dropzones ? (0, i.closest)(e, this.dropzones) : null;
                }
              }, {
                key: p,
                value: function value() {
                  var e = this.options.dropzone;
                  return "string" == typeof e ? document.querySelectorAll(e) : e instanceof NodeList || e instanceof Array ? e : "function" == typeof e ? e() : [];
                }
              }]);

              return y;
            }(s.default);

            t.default = y;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.DroppableStopEvent = t.DroppableReturnedEvent = t.DroppableDroppedEvent = t.DroppableStartEvent = t.DroppableEvent = void 0;
            var r,
                o = (r = n(0)) && r.__esModule ? r : {
              default: r
            };

            var i = /*#__PURE__*/function (_o$default7) {
              _inherits(i, _o$default7);

              var _super25 = _createSuper(i);

              function i() {
                _classCallCheck(this, i);

                return _super25.apply(this, arguments);
              }

              _createClass(i, [{
                key: "dragEvent",
                get: function get() {
                  return this.data.dragEvent;
                }
              }]);

              return i;
            }(o.default);

            t.DroppableEvent = i, i.type = "droppable";

            var s = /*#__PURE__*/function (_i21) {
              _inherits(s, _i21);

              var _super26 = _createSuper(s);

              function s() {
                _classCallCheck(this, s);

                return _super26.apply(this, arguments);
              }

              _createClass(s, [{
                key: "dropzone",
                get: function get() {
                  return this.data.dropzone;
                }
              }]);

              return s;
            }(i);

            t.DroppableStartEvent = s, s.type = "droppable:start", s.cancelable = !0;

            var a = /*#__PURE__*/function (_i22) {
              _inherits(a, _i22);

              var _super27 = _createSuper(a);

              function a() {
                _classCallCheck(this, a);

                return _super27.apply(this, arguments);
              }

              _createClass(a, [{
                key: "dropzone",
                get: function get() {
                  return this.data.dropzone;
                }
              }]);

              return a;
            }(i);

            t.DroppableDroppedEvent = a, a.type = "droppable:dropped", a.cancelable = !0;

            var l = /*#__PURE__*/function (_i23) {
              _inherits(l, _i23);

              var _super28 = _createSuper(l);

              function l() {
                _classCallCheck(this, l);

                return _super28.apply(this, arguments);
              }

              _createClass(l, [{
                key: "dropzone",
                get: function get() {
                  return this.data.dropzone;
                }
              }]);

              return l;
            }(i);

            t.DroppableReturnedEvent = l, l.type = "droppable:returned", l.cancelable = !0;

            var c = /*#__PURE__*/function (_i24) {
              _inherits(c, _i24);

              var _super29 = _createSuper(c);

              function c() {
                _classCallCheck(this, c);

                return _super29.apply(this, arguments);
              }

              _createClass(c, [{
                key: "dropzone",
                get: function get() {
                  return this.data.dropzone;
                }
              }]);

              return c;
            }(i);

            t.DroppableStopEvent = c, c.type = "droppable:stop", c.cancelable = !0;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = n(11);
            Object.keys(r).forEach(function (e) {
              "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                enumerable: !0,
                get: function get() {
                  return r[e];
                }
              });
            });
            var o,
                i = (o = n(32)) && o.__esModule ? o : {
              default: o
            };
            t.default = i.default;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.default = /*#__PURE__*/function () {
              function _class4() {
                _classCallCheck(this, _class4);

                this.callbacks = {};
              }

              _createClass(_class4, [{
                key: "on",
                value: function on(e) {
                  var _this$callbacks$e;

                  for (var _len6 = arguments.length, t = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
                    t[_key6 - 1] = arguments[_key6];
                  }

                  return this.callbacks[e] || (this.callbacks[e] = []), (_this$callbacks$e = this.callbacks[e]).push.apply(_this$callbacks$e, t), this;
                }
              }, {
                key: "off",
                value: function off(e, t) {
                  if (!this.callbacks[e]) return null;
                  var n = this.callbacks[e].slice(0);

                  for (var _r10 = 0; _r10 < n.length; _r10++) {
                    t === n[_r10] && this.callbacks[e].splice(_r10, 1);
                  }

                  return this;
                }
              }, {
                key: "trigger",
                value: function trigger(e) {
                  if (!this.callbacks[e.type]) return null;

                  var t = _toConsumableArray(this.callbacks[e.type]),
                      n = [];

                  for (var _r11 = t.length - 1; _r11 >= 0; _r11--) {
                    var o = t[_r11];

                    try {
                      o(e);
                    } catch (e) {
                      n.push(e);
                    }
                  }

                  return n.length && console.error("Draggable caught errors while triggering '".concat(e.type, "'"), n), this;
                }
              }]);

              return _class4;
            }();
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r,
                o = (r = n(35)) && r.__esModule ? r : {
              default: r
            };
            t.default = o.default;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.defaultOptions = void 0;

            var r,
                o = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            },
                i = n(2),
                s = n(12),
                a = (r = n(36)) && r.__esModule ? r : {
              default: r
            },
                l = n(6),
                c = n(13),
                u = n(14);

            var d = Symbol("onDragStart"),
                h = Symbol("onDragMove"),
                f = Symbol("onDragStop"),
                p = Symbol("onDragPressure"),
                g = {
              "drag:start": function dragStart(e) {
                return "Picked up ".concat(e.source.textContent.trim() || e.source.id || "draggable element");
              },
              "drag:stop": function dragStop(e) {
                return "Released ".concat(e.source.textContent.trim() || e.source.id || "draggable element");
              }
            },
                m = {
              "container:dragging": "draggable-container--is-dragging",
              "source:dragging": "draggable-source--is-dragging",
              "source:placed": "draggable-source--placed",
              "container:placed": "draggable-container--placed",
              "body:dragging": "draggable--is-dragging",
              "draggable:over": "draggable--over",
              "container:over": "draggable-container--over",
              "source:original": "draggable--original",
              mirror: "draggable-mirror"
            },
                v = t.defaultOptions = {
              draggable: ".draggable-source",
              handle: null,
              delay: 100,
              placedTimeout: 800,
              plugins: [],
              sensors: []
            };

            var y = /*#__PURE__*/function () {
              function y() {
                var _this29 = this;

                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [document.body];
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                _classCallCheck(this, y);

                if (e instanceof NodeList || e instanceof Array) this.containers = _toConsumableArray(e);else {
                  if (!(e instanceof HTMLElement)) throw new Error("Draggable containers are expected to be of type `NodeList`, `HTMLElement[]` or `HTMLElement`");
                  this.containers = [e];
                }
                this.options = o({}, v, t, {
                  classes: o({}, m, t.classes || {}),
                  announcements: o({}, g, t.announcements || {})
                }), this.emitter = new a.default(), this.dragging = !1, this.plugins = [], this.sensors = [], this[d] = this[d].bind(this), this[h] = this[h].bind(this), this[f] = this[f].bind(this), this[p] = this[p].bind(this), document.addEventListener("drag:start", this[d], !0), document.addEventListener("drag:move", this[h], !0), document.addEventListener("drag:stop", this[f], !0), document.addEventListener("drag:pressure", this[p], !0);
                var n = Object.values(y.Plugins).map(function (e) {
                  return e;
                }),
                    r = [l.MouseSensor, l.TouchSensor];
                this.addPlugin.apply(this, _toConsumableArray(n).concat(_toConsumableArray(this.options.plugins))), this.addSensor.apply(this, r.concat(_toConsumableArray(this.options.sensors)));
                var i = new c.DraggableInitializedEvent({
                  draggable: this
                });
                this.on("mirror:created", function (_ref31) {
                  var e = _ref31.mirror;
                  return _this29.mirror = e;
                }), this.on("mirror:destroy", function () {
                  return _this29.mirror = null;
                }), this.trigger(i);
              }

              _createClass(y, [{
                key: "destroy",
                value: function destroy() {
                  document.removeEventListener("drag:start", this[d], !0), document.removeEventListener("drag:move", this[h], !0), document.removeEventListener("drag:stop", this[f], !0), document.removeEventListener("drag:pressure", this[p], !0);
                  var e = new c.DraggableDestroyEvent({
                    draggable: this
                  });
                  this.trigger(e), this.removePlugin.apply(this, _toConsumableArray(this.plugins.map(function (e) {
                    return e.constructor;
                  }))), this.removeSensor.apply(this, _toConsumableArray(this.sensors.map(function (e) {
                    return e.constructor;
                  })));
                }
              }, {
                key: "addPlugin",
                value: function addPlugin() {
                  var _this30 = this;

                  for (var _len7 = arguments.length, e = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
                    e[_key7] = arguments[_key7];
                  }

                  var t = e.map(function (e) {
                    return new e(_this30);
                  });
                  return t.forEach(function (e) {
                    return e.attach();
                  }), this.plugins = [].concat(_toConsumableArray(this.plugins), _toConsumableArray(t)), this;
                }
              }, {
                key: "removePlugin",
                value: function removePlugin() {
                  for (var _len8 = arguments.length, e = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
                    e[_key8] = arguments[_key8];
                  }

                  return this.plugins.filter(function (t) {
                    return e.includes(t.constructor);
                  }).forEach(function (e) {
                    return e.detach();
                  }), this.plugins = this.plugins.filter(function (t) {
                    return !e.includes(t.constructor);
                  }), this;
                }
              }, {
                key: "addSensor",
                value: function addSensor() {
                  var _this31 = this;

                  for (var _len9 = arguments.length, e = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
                    e[_key9] = arguments[_key9];
                  }

                  var t = e.map(function (e) {
                    return new e(_this31.containers, _this31.options);
                  });
                  return t.forEach(function (e) {
                    return e.attach();
                  }), this.sensors = [].concat(_toConsumableArray(this.sensors), _toConsumableArray(t)), this;
                }
              }, {
                key: "removeSensor",
                value: function removeSensor() {
                  for (var _len10 = arguments.length, e = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
                    e[_key10] = arguments[_key10];
                  }

                  return this.sensors.filter(function (t) {
                    return e.includes(t.constructor);
                  }).forEach(function (e) {
                    return e.detach();
                  }), this.sensors = this.sensors.filter(function (t) {
                    return !e.includes(t.constructor);
                  }), this;
                }
              }, {
                key: "addContainer",
                value: function addContainer() {
                  for (var _len11 = arguments.length, e = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
                    e[_key11] = arguments[_key11];
                  }

                  return this.containers = [].concat(_toConsumableArray(this.containers), e), this.sensors.forEach(function (t) {
                    return t.addContainer.apply(t, e);
                  }), this;
                }
              }, {
                key: "removeContainer",
                value: function removeContainer() {
                  for (var _len12 = arguments.length, e = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
                    e[_key12] = arguments[_key12];
                  }

                  return this.containers = this.containers.filter(function (t) {
                    return !e.includes(t);
                  }), this.sensors.forEach(function (t) {
                    return t.removeContainer.apply(t, e);
                  }), this;
                }
              }, {
                key: "on",
                value: function on(e) {
                  var _this$emitter;

                  for (var _len13 = arguments.length, t = new Array(_len13 > 1 ? _len13 - 1 : 0), _key13 = 1; _key13 < _len13; _key13++) {
                    t[_key13 - 1] = arguments[_key13];
                  }

                  return (_this$emitter = this.emitter).on.apply(_this$emitter, [e].concat(t)), this;
                }
              }, {
                key: "off",
                value: function off(e, t) {
                  return this.emitter.off(e, t), this;
                }
              }, {
                key: "trigger",
                value: function trigger(e) {
                  return this.emitter.trigger(e), this;
                }
              }, {
                key: "getClassNameFor",
                value: function getClassNameFor(e) {
                  return this.options.classes[e];
                }
              }, {
                key: "isDragging",
                value: function isDragging() {
                  return Boolean(this.dragging);
                }
              }, {
                key: "getDraggableElements",
                value: function getDraggableElements() {
                  var _this32 = this;

                  return this.containers.reduce(function (e, t) {
                    return [].concat(_toConsumableArray(e), _toConsumableArray(_this32.getDraggableElementsForContainer(t)));
                  }, []);
                }
              }, {
                key: "getDraggableElementsForContainer",
                value: function getDraggableElementsForContainer(e) {
                  var _this33 = this;

                  return _toConsumableArray(e.querySelectorAll(this.options.draggable)).filter(function (e) {
                    return e !== _this33.originalSource && e !== _this33.mirror;
                  });
                }
              }, {
                key: d,
                value: function value(e) {
                  var _this34 = this;

                  var t = b(e),
                      n = t.target,
                      r = t.container;
                  if (!this.containers.includes(r)) return;
                  if (this.options.handle && n && !(0, i.closest)(n, this.options.handle)) return void t.cancel();
                  if (this.originalSource = (0, i.closest)(n, this.options.draggable), this.sourceContainer = r, !this.originalSource) return void t.cancel();
                  this.lastPlacedSource && this.lastPlacedContainer && (clearTimeout(this.placedTimeoutID), this.lastPlacedSource.classList.remove(this.getClassNameFor("source:placed")), this.lastPlacedContainer.classList.remove(this.getClassNameFor("container:placed"))), this.source = this.originalSource.cloneNode(!0), this.originalSource.parentNode.insertBefore(this.source, this.originalSource), this.originalSource.style.display = "none";
                  var s = new u.DragStartEvent({
                    source: this.source,
                    originalSource: this.originalSource,
                    sourceContainer: r,
                    sensorEvent: t
                  });
                  if (this.trigger(s), this.dragging = !s.canceled(), s.canceled()) return this.source.parentNode.removeChild(this.source), void (this.originalSource.style.display = null);
                  this.originalSource.classList.add(this.getClassNameFor("source:original")), this.source.classList.add(this.getClassNameFor("source:dragging")), this.sourceContainer.classList.add(this.getClassNameFor("container:dragging")), document.body.classList.add(this.getClassNameFor("body:dragging")), w(document.body, "none"), requestAnimationFrame(function () {
                    var t = b(e).clone({
                      target: _this34.source
                    });

                    _this34[h](o({}, e, {
                      detail: t
                    }));
                  });
                }
              }, {
                key: h,
                value: function value(e) {
                  if (!this.dragging) return;
                  var t = b(e),
                      n = t.container;
                  var r = t.target;
                  var o = new u.DragMoveEvent({
                    source: this.source,
                    originalSource: this.originalSource,
                    sourceContainer: n,
                    sensorEvent: t
                  });
                  this.trigger(o), o.canceled() && t.cancel(), r = (0, i.closest)(r, this.options.draggable);
                  var s = (0, i.closest)(t.target, this.containers),
                      a = t.overContainer || s,
                      l = this.currentOverContainer && a !== this.currentOverContainer,
                      c = this.currentOver && r !== this.currentOver,
                      d = a && this.currentOverContainer !== a,
                      h = s && r && this.currentOver !== r;

                  if (c) {
                    var _e19 = new u.DragOutEvent({
                      source: this.source,
                      originalSource: this.originalSource,
                      sourceContainer: n,
                      sensorEvent: t,
                      over: this.currentOver
                    });

                    this.currentOver.classList.remove(this.getClassNameFor("draggable:over")), this.currentOver = null, this.trigger(_e19);
                  }

                  if (l) {
                    var _e20 = new u.DragOutContainerEvent({
                      source: this.source,
                      originalSource: this.originalSource,
                      sourceContainer: n,
                      sensorEvent: t,
                      overContainer: this.currentOverContainer
                    });

                    this.currentOverContainer.classList.remove(this.getClassNameFor("container:over")), this.currentOverContainer = null, this.trigger(_e20);
                  }

                  if (d) {
                    a.classList.add(this.getClassNameFor("container:over"));

                    var _e21 = new u.DragOverContainerEvent({
                      source: this.source,
                      originalSource: this.originalSource,
                      sourceContainer: n,
                      sensorEvent: t,
                      overContainer: a
                    });

                    this.currentOverContainer = a, this.trigger(_e21);
                  }

                  if (h) {
                    r.classList.add(this.getClassNameFor("draggable:over"));

                    var _e22 = new u.DragOverEvent({
                      source: this.source,
                      originalSource: this.originalSource,
                      sourceContainer: n,
                      sensorEvent: t,
                      overContainer: a,
                      over: r
                    });

                    this.currentOver = r, this.trigger(_e22);
                  }
                }
              }, {
                key: f,
                value: function value(e) {
                  var _this35 = this;

                  if (!this.dragging) return;
                  this.dragging = !1;
                  var t = new u.DragStopEvent({
                    source: this.source,
                    originalSource: this.originalSource,
                    sensorEvent: e.sensorEvent,
                    sourceContainer: this.sourceContainer
                  });
                  this.trigger(t), this.source.parentNode.insertBefore(this.originalSource, this.source), this.source.parentNode.removeChild(this.source), this.originalSource.style.display = "", this.source.classList.remove(this.getClassNameFor("source:dragging")), this.originalSource.classList.remove(this.getClassNameFor("source:original")), this.originalSource.classList.add(this.getClassNameFor("source:placed")), this.sourceContainer.classList.add(this.getClassNameFor("container:placed")), this.sourceContainer.classList.remove(this.getClassNameFor("container:dragging")), document.body.classList.remove(this.getClassNameFor("body:dragging")), w(document.body, ""), this.currentOver && this.currentOver.classList.remove(this.getClassNameFor("draggable:over")), this.currentOverContainer && this.currentOverContainer.classList.remove(this.getClassNameFor("container:over")), this.lastPlacedSource = this.originalSource, this.lastPlacedContainer = this.sourceContainer, this.placedTimeoutID = setTimeout(function () {
                    _this35.lastPlacedSource && _this35.lastPlacedSource.classList.remove(_this35.getClassNameFor("source:placed")), _this35.lastPlacedContainer && _this35.lastPlacedContainer.classList.remove(_this35.getClassNameFor("container:placed")), _this35.lastPlacedSource = null, _this35.lastPlacedContainer = null;
                  }, this.options.placedTimeout), this.source = null, this.originalSource = null, this.currentOverContainer = null, this.currentOver = null, this.sourceContainer = null;
                }
              }, {
                key: p,
                value: function value(e) {
                  if (!this.dragging) return;
                  var t = b(e),
                      n = this.source || (0, i.closest)(t.originalEvent.target, this.options.draggable),
                      r = new u.DragPressureEvent({
                    sensorEvent: t,
                    source: n,
                    pressure: t.pressure
                  });
                  this.trigger(r);
                }
              }]);

              return y;
            }();

            function b(e) {
              return e.detail;
            }

            function w(e, t) {
              e.style.webkitUserSelect = t, e.style.mozUserSelect = t, e.style.msUserSelect = t, e.style.oUserSelect = t, e.style.userSelect = t;
            }

            t.default = y, y.Plugins = {
              Announcement: s.Announcement,
              Focusable: s.Focusable,
              Mirror: s.Mirror,
              Scrollable: s.Scrollable
            };
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r,
                o = (r = n(4)) && r.__esModule ? r : {
              default: r
            },
                i = n(3);
            var s = Symbol("onMouseForceWillBegin"),
                a = Symbol("onMouseForceDown"),
                l = Symbol("onMouseDown"),
                c = Symbol("onMouseForceChange"),
                u = Symbol("onMouseMove"),
                d = Symbol("onMouseUp"),
                h = Symbol("onMouseForceGlobalChange");

            var f = /*#__PURE__*/function (_o$default8) {
              _inherits(f, _o$default8);

              var _super30 = _createSuper(f);

              function f() {
                var _this36;

                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                _classCallCheck(this, f);

                _this36 = _super30.call(this, e, t), _this36.mightDrag = !1, _this36[s] = _this36[s].bind(_assertThisInitialized(_this36)), _this36[a] = _this36[a].bind(_assertThisInitialized(_this36)), _this36[l] = _this36[l].bind(_assertThisInitialized(_this36)), _this36[c] = _this36[c].bind(_assertThisInitialized(_this36)), _this36[u] = _this36[u].bind(_assertThisInitialized(_this36)), _this36[d] = _this36[d].bind(_assertThisInitialized(_this36));
                return _this36;
              }

              _createClass(f, [{
                key: "attach",
                value: function attach() {
                  var _iterator12 = _createForOfIteratorHelper(this.containers),
                      _step12;

                  try {
                    for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                      var _e23 = _step12.value;
                      _e23.addEventListener("webkitmouseforcewillbegin", this[s], !1), _e23.addEventListener("webkitmouseforcedown", this[a], !1), _e23.addEventListener("mousedown", this[l], !0), _e23.addEventListener("webkitmouseforcechanged", this[c], !1);
                    }
                  } catch (err) {
                    _iterator12.e(err);
                  } finally {
                    _iterator12.f();
                  }

                  document.addEventListener("mousemove", this[u]), document.addEventListener("mouseup", this[d]);
                }
              }, {
                key: "detach",
                value: function detach() {
                  var _iterator13 = _createForOfIteratorHelper(this.containers),
                      _step13;

                  try {
                    for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                      var _e24 = _step13.value;
                      _e24.removeEventListener("webkitmouseforcewillbegin", this[s], !1), _e24.removeEventListener("webkitmouseforcedown", this[a], !1), _e24.removeEventListener("mousedown", this[l], !0), _e24.removeEventListener("webkitmouseforcechanged", this[c], !1);
                    }
                  } catch (err) {
                    _iterator13.e(err);
                  } finally {
                    _iterator13.f();
                  }

                  document.removeEventListener("mousemove", this[u]), document.removeEventListener("mouseup", this[d]);
                }
              }, {
                key: s,
                value: function value(e) {
                  e.preventDefault(), this.mightDrag = !0;
                }
              }, {
                key: a,
                value: function value(e) {
                  if (this.dragging) return;
                  var t = document.elementFromPoint(e.clientX, e.clientY),
                      n = e.currentTarget,
                      r = new i.DragStartSensorEvent({
                    clientX: e.clientX,
                    clientY: e.clientY,
                    target: t,
                    container: n,
                    originalEvent: e
                  });
                  this.trigger(n, r), this.currentContainer = n, this.dragging = !r.canceled(), this.mightDrag = !1;
                }
              }, {
                key: d,
                value: function value(e) {
                  if (!this.dragging) return;
                  var t = new i.DragStopSensorEvent({
                    clientX: e.clientX,
                    clientY: e.clientY,
                    target: null,
                    container: this.currentContainer,
                    originalEvent: e
                  });
                  this.trigger(this.currentContainer, t), this.currentContainer = null, this.dragging = !1, this.mightDrag = !1;
                }
              }, {
                key: l,
                value: function value(e) {
                  this.mightDrag && (e.stopPropagation(), e.stopImmediatePropagation(), e.preventDefault());
                }
              }, {
                key: u,
                value: function value(e) {
                  if (!this.dragging) return;
                  var t = document.elementFromPoint(e.clientX, e.clientY),
                      n = new i.DragMoveSensorEvent({
                    clientX: e.clientX,
                    clientY: e.clientY,
                    target: t,
                    container: this.currentContainer,
                    originalEvent: e
                  });
                  this.trigger(this.currentContainer, n);
                }
              }, {
                key: c,
                value: function value(e) {
                  if (this.dragging) return;
                  var t = e.target,
                      n = e.currentTarget,
                      r = new i.DragPressureSensorEvent({
                    pressure: e.webkitForce,
                    clientX: e.clientX,
                    clientY: e.clientY,
                    target: t,
                    container: n,
                    originalEvent: e
                  });
                  this.trigger(n, r);
                }
              }, {
                key: h,
                value: function value(e) {
                  if (!this.dragging) return;
                  var t = e.target,
                      n = new i.DragPressureSensorEvent({
                    pressure: e.webkitForce,
                    clientX: e.clientX,
                    clientY: e.clientY,
                    target: t,
                    container: this.currentContainer,
                    originalEvent: e
                  });
                  this.trigger(this.currentContainer, n);
                }
              }]);

              return f;
            }(o.default);

            t.default = f;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r,
                o = (r = n(38)) && r.__esModule ? r : {
              default: r
            };
            t.default = o.default;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r,
                o = n(2),
                i = (r = n(4)) && r.__esModule ? r : {
              default: r
            },
                s = n(3);
            var a = Symbol("onMouseDown"),
                l = Symbol("onMouseUp"),
                c = Symbol("onDragStart"),
                u = Symbol("onDragOver"),
                d = Symbol("onDragEnd"),
                h = Symbol("onDrop"),
                f = Symbol("reset");

            var p = /*#__PURE__*/function (_i$default5) {
              _inherits(p, _i$default5);

              var _super31 = _createSuper(p);

              function p() {
                var _this37;

                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                _classCallCheck(this, p);

                _this37 = _super31.call(this, e, t), _this37.mouseDownTimeout = null, _this37.draggableElement = null, _this37.nativeDraggableElement = null, _this37[a] = _this37[a].bind(_assertThisInitialized(_this37)), _this37[l] = _this37[l].bind(_assertThisInitialized(_this37)), _this37[c] = _this37[c].bind(_assertThisInitialized(_this37)), _this37[u] = _this37[u].bind(_assertThisInitialized(_this37)), _this37[d] = _this37[d].bind(_assertThisInitialized(_this37)), _this37[h] = _this37[h].bind(_assertThisInitialized(_this37));
                return _this37;
              }

              _createClass(p, [{
                key: "attach",
                value: function attach() {
                  document.addEventListener("mousedown", this[a], !0);
                }
              }, {
                key: "detach",
                value: function detach() {
                  document.removeEventListener("mousedown", this[a], !0);
                }
              }, {
                key: c,
                value: function value(e) {
                  var _this38 = this;

                  e.dataTransfer.setData("text", ""), e.dataTransfer.effectAllowed = this.options.type;
                  var t = document.elementFromPoint(e.clientX, e.clientY);
                  if (this.currentContainer = (0, o.closest)(e.target, this.containers), !this.currentContainer) return;
                  var n = new s.DragStartSensorEvent({
                    clientX: e.clientX,
                    clientY: e.clientY,
                    target: t,
                    container: this.currentContainer,
                    originalEvent: e
                  });
                  setTimeout(function () {
                    _this38.trigger(_this38.currentContainer, n), n.canceled() ? _this38.dragging = !1 : _this38.dragging = !0;
                  }, 0);
                }
              }, {
                key: u,
                value: function value(e) {
                  if (!this.dragging) return;
                  var t = document.elementFromPoint(e.clientX, e.clientY),
                      n = this.currentContainer,
                      r = new s.DragMoveSensorEvent({
                    clientX: e.clientX,
                    clientY: e.clientY,
                    target: t,
                    container: n,
                    originalEvent: e
                  });
                  this.trigger(n, r), r.canceled() || (e.preventDefault(), e.dataTransfer.dropEffect = this.options.type);
                }
              }, {
                key: d,
                value: function value(e) {
                  if (!this.dragging) return;
                  document.removeEventListener("mouseup", this[l], !0);
                  var t = document.elementFromPoint(e.clientX, e.clientY),
                      n = this.currentContainer,
                      r = new s.DragStopSensorEvent({
                    clientX: e.clientX,
                    clientY: e.clientY,
                    target: t,
                    container: n,
                    originalEvent: e
                  });
                  this.trigger(n, r), this.dragging = !1, this[f]();
                }
              }, {
                key: h,
                value: function value(e) {
                  e.preventDefault();
                }
              }, {
                key: a,
                value: function value(e) {
                  var _this39 = this;

                  if (e.target && (e.target.form || e.target.contenteditable)) return;
                  var t = (0, o.closest)(e.target, function (e) {
                    return e.draggable;
                  });
                  t && (t.draggable = !1, this.nativeDraggableElement = t), document.addEventListener("mouseup", this[l], !0), document.addEventListener("dragstart", this[c], !1), document.addEventListener("dragover", this[u], !1), document.addEventListener("dragend", this[d], !1), document.addEventListener("drop", this[h], !1);
                  var n = (0, o.closest)(e.target, this.options.draggable);
                  n && (this.mouseDownTimeout = setTimeout(function () {
                    n.draggable = !0, _this39.draggableElement = n;
                  }, this.options.delay));
                }
              }, {
                key: l,
                value: function value() {
                  this[f]();
                }
              }, {
                key: f,
                value: function value() {
                  clearTimeout(this.mouseDownTimeout), document.removeEventListener("mouseup", this[l], !0), document.removeEventListener("dragstart", this[c], !1), document.removeEventListener("dragover", this[u], !1), document.removeEventListener("dragend", this[d], !1), document.removeEventListener("drop", this[h], !1), this.nativeDraggableElement && (this.nativeDraggableElement.draggable = !0, this.nativeDraggableElement = null), this.draggableElement && (this.draggableElement.draggable = !1, this.draggableElement = null);
                }
              }]);

              return p;
            }(i.default);

            t.default = p;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r,
                o = (r = n(40)) && r.__esModule ? r : {
              default: r
            };
            t.default = o.default;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r,
                o = n(2),
                i = (r = n(4)) && r.__esModule ? r : {
              default: r
            },
                s = n(3);
            var a = Symbol("onTouchStart"),
                l = Symbol("onTouchHold"),
                c = Symbol("onTouchEnd"),
                u = Symbol("onTouchMove");
            var d = !1;
            window.addEventListener("touchmove", function (e) {
              d && e.preventDefault();
            }, {
              passive: !1
            });

            var h = /*#__PURE__*/function (_i$default6) {
              _inherits(h, _i$default6);

              var _super32 = _createSuper(h);

              function h() {
                var _this40;

                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                _classCallCheck(this, h);

                _this40 = _super32.call(this, e, t), _this40.currentScrollableParent = null, _this40.tapTimeout = null, _this40.touchMoved = !1, _this40[a] = _this40[a].bind(_assertThisInitialized(_this40)), _this40[l] = _this40[l].bind(_assertThisInitialized(_this40)), _this40[c] = _this40[c].bind(_assertThisInitialized(_this40)), _this40[u] = _this40[u].bind(_assertThisInitialized(_this40));
                return _this40;
              }

              _createClass(h, [{
                key: "attach",
                value: function attach() {
                  document.addEventListener("touchstart", this[a]);
                }
              }, {
                key: "detach",
                value: function detach() {
                  document.removeEventListener("touchstart", this[a]);
                }
              }, {
                key: a,
                value: function value(e) {
                  var t = (0, o.closest)(e.target, this.containers);
                  t && (document.addEventListener("touchmove", this[u]), document.addEventListener("touchend", this[c]), document.addEventListener("touchcancel", this[c]), t.addEventListener("contextmenu", f), this.currentContainer = t, this.tapTimeout = setTimeout(this[l](e, t), this.options.delay));
                }
              }, {
                key: l,
                value: function value(e, t) {
                  var _this41 = this;

                  return function () {
                    if (_this41.touchMoved) return;
                    var n = e.touches[0] || e.changedTouches[0],
                        r = e.target,
                        o = new s.DragStartSensorEvent({
                      clientX: n.pageX,
                      clientY: n.pageY,
                      target: r,
                      container: t,
                      originalEvent: e
                    });
                    _this41.trigger(t, o), _this41.dragging = !o.canceled(), d = _this41.dragging;
                  };
                }
              }, {
                key: u,
                value: function value(e) {
                  if (this.touchMoved = !0, !this.dragging) return;
                  var t = e.touches[0] || e.changedTouches[0],
                      n = document.elementFromPoint(t.pageX - window.scrollX, t.pageY - window.scrollY),
                      r = new s.DragMoveSensorEvent({
                    clientX: t.pageX,
                    clientY: t.pageY,
                    target: n,
                    container: this.currentContainer,
                    originalEvent: e
                  });
                  this.trigger(this.currentContainer, r);
                }
              }, {
                key: c,
                value: function value(e) {
                  if (this.touchMoved = !1, d = !1, document.removeEventListener("touchend", this[c]), document.removeEventListener("touchcancel", this[c]), document.removeEventListener("touchmove", this[u]), this.currentContainer && this.currentContainer.removeEventListener("contextmenu", f), clearTimeout(this.tapTimeout), !this.dragging) return;
                  var t = e.touches[0] || e.changedTouches[0],
                      n = document.elementFromPoint(t.pageX - window.scrollX, t.pageY - window.scrollY);
                  e.preventDefault();
                  var r = new s.DragStopSensorEvent({
                    clientX: t.pageX,
                    clientY: t.pageY,
                    target: n,
                    container: this.currentContainer,
                    originalEvent: e
                  });
                  this.trigger(this.currentContainer, r), this.currentContainer = null, this.dragging = !1;
                }
              }]);

              return h;
            }(i.default);

            function f(e) {
              e.preventDefault(), e.stopPropagation();
            }

            t.default = h;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r,
                o = (r = n(42)) && r.__esModule ? r : {
              default: r
            };
            t.default = o.default;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.DragPressureSensorEvent = t.DragStopSensorEvent = t.DragMoveSensorEvent = t.DragStartSensorEvent = t.SensorEvent = void 0;
            var r,
                o = (r = n(0)) && r.__esModule ? r : {
              default: r
            };

            var i = /*#__PURE__*/function (_o$default9) {
              _inherits(i, _o$default9);

              var _super33 = _createSuper(i);

              function i() {
                _classCallCheck(this, i);

                return _super33.apply(this, arguments);
              }

              _createClass(i, [{
                key: "originalEvent",
                get: function get() {
                  return this.data.originalEvent;
                }
              }, {
                key: "clientX",
                get: function get() {
                  return this.data.clientX;
                }
              }, {
                key: "clientY",
                get: function get() {
                  return this.data.clientY;
                }
              }, {
                key: "target",
                get: function get() {
                  return this.data.target;
                }
              }, {
                key: "container",
                get: function get() {
                  return this.data.container;
                }
              }, {
                key: "pressure",
                get: function get() {
                  return this.data.pressure;
                }
              }]);

              return i;
            }(o.default);

            t.SensorEvent = i;

            var s = /*#__PURE__*/function (_i25) {
              _inherits(s, _i25);

              var _super34 = _createSuper(s);

              function s() {
                _classCallCheck(this, s);

                return _super34.apply(this, arguments);
              }

              return s;
            }(i);

            t.DragStartSensorEvent = s, s.type = "drag:start";

            var a = /*#__PURE__*/function (_i26) {
              _inherits(a, _i26);

              var _super35 = _createSuper(a);

              function a() {
                _classCallCheck(this, a);

                return _super35.apply(this, arguments);
              }

              return a;
            }(i);

            t.DragMoveSensorEvent = a, a.type = "drag:move";

            var l = /*#__PURE__*/function (_i27) {
              _inherits(l, _i27);

              var _super36 = _createSuper(l);

              function l() {
                _classCallCheck(this, l);

                return _super36.apply(this, arguments);
              }

              return l;
            }(i);

            t.DragStopSensorEvent = l, l.type = "drag:stop";

            var c = /*#__PURE__*/function (_i28) {
              _inherits(c, _i28);

              var _super37 = _createSuper(c);

              function c() {
                _classCallCheck(this, c);

                return _super37.apply(this, arguments);
              }

              return c;
            }(i);

            t.DragPressureSensorEvent = c, c.type = "drag:pressure";
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r,
                o = n(2),
                i = (r = n(4)) && r.__esModule ? r : {
              default: r
            },
                s = n(3);
            var a = Symbol("onContextMenuWhileDragging"),
                l = Symbol("onMouseDown"),
                c = Symbol("onMouseMove"),
                u = Symbol("onMouseUp");

            var d = /*#__PURE__*/function (_i$default7) {
              _inherits(d, _i$default7);

              var _super38 = _createSuper(d);

              function d() {
                var _this42;

                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                _classCallCheck(this, d);

                _this42 = _super38.call(this, e, t), _this42.mouseDown = !1, _this42.mouseDownTimeout = null, _this42.openedContextMenu = !1, _this42[a] = _this42[a].bind(_assertThisInitialized(_this42)), _this42[l] = _this42[l].bind(_assertThisInitialized(_this42)), _this42[c] = _this42[c].bind(_assertThisInitialized(_this42)), _this42[u] = _this42[u].bind(_assertThisInitialized(_this42));
                return _this42;
              }

              _createClass(d, [{
                key: "attach",
                value: function attach() {
                  document.addEventListener("mousedown", this[l], !0);
                }
              }, {
                key: "detach",
                value: function detach() {
                  document.removeEventListener("mousedown", this[l], !0);
                }
              }, {
                key: l,
                value: function value(e) {
                  var _this43 = this;

                  if (0 !== e.button || e.ctrlKey || e.metaKey) return;
                  document.addEventListener("mouseup", this[u]);
                  var t = document.elementFromPoint(e.clientX, e.clientY),
                      n = (0, o.closest)(t, this.containers);
                  n && (document.addEventListener("dragstart", h), this.mouseDown = !0, clearTimeout(this.mouseDownTimeout), this.mouseDownTimeout = setTimeout(function () {
                    if (!_this43.mouseDown) return;
                    var r = new s.DragStartSensorEvent({
                      clientX: e.clientX,
                      clientY: e.clientY,
                      target: t,
                      container: n,
                      originalEvent: e
                    });
                    _this43.trigger(n, r), _this43.currentContainer = n, _this43.dragging = !r.canceled(), _this43.dragging && (document.addEventListener("contextmenu", _this43[a]), document.addEventListener("mousemove", _this43[c]));
                  }, this.options.delay));
                }
              }, {
                key: c,
                value: function value(e) {
                  if (!this.dragging) return;
                  var t = document.elementFromPoint(e.clientX, e.clientY),
                      n = new s.DragMoveSensorEvent({
                    clientX: e.clientX,
                    clientY: e.clientY,
                    target: t,
                    container: this.currentContainer,
                    originalEvent: e
                  });
                  this.trigger(this.currentContainer, n);
                }
              }, {
                key: u,
                value: function value(e) {
                  if (this.mouseDown = Boolean(this.openedContextMenu), this.openedContextMenu) return void (this.openedContextMenu = !1);
                  if (document.removeEventListener("mouseup", this[u]), document.removeEventListener("dragstart", h), !this.dragging) return;
                  var t = document.elementFromPoint(e.clientX, e.clientY),
                      n = new s.DragStopSensorEvent({
                    clientX: e.clientX,
                    clientY: e.clientY,
                    target: t,
                    container: this.currentContainer,
                    originalEvent: e
                  });
                  this.trigger(this.currentContainer, n), document.removeEventListener("contextmenu", this[a]), document.removeEventListener("mousemove", this[c]), this.currentContainer = null, this.dragging = !1;
                }
              }, {
                key: a,
                value: function value(e) {
                  e.preventDefault(), this.openedContextMenu = !0;
                }
              }]);

              return d;
            }(i.default);

            function h(e) {
              e.preventDefault();
            }

            t.default = d;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r,
                o = (r = n(45)) && r.__esModule ? r : {
              default: r
            };
            t.default = o.default;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });

            var r = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            };

            t.default = /*#__PURE__*/function () {
              function _class5() {
                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                _classCallCheck(this, _class5);

                this.containers = _toConsumableArray(e), this.options = r({}, t), this.dragging = !1, this.currentContainer = null;
              }

              _createClass(_class5, [{
                key: "attach",
                value: function attach() {
                  return this;
                }
              }, {
                key: "detach",
                value: function detach() {
                  return this;
                }
              }, {
                key: "addContainer",
                value: function addContainer() {
                  for (var _len14 = arguments.length, e = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
                    e[_key14] = arguments[_key14];
                  }

                  this.containers = [].concat(_toConsumableArray(this.containers), e);
                }
              }, {
                key: "removeContainer",
                value: function removeContainer() {
                  for (var _len15 = arguments.length, e = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
                    e[_key15] = arguments[_key15];
                  }

                  this.containers = this.containers.filter(function (t) {
                    return !e.includes(t);
                  });
                }
              }, {
                key: "trigger",
                value: function trigger(e, t) {
                  var n = document.createEvent("Event");
                  return n.detail = t, n.initEvent(t.type, !0, !0), e.dispatchEvent(n), this.lastEvent = t, t;
                }
              }]);

              return _class5;
            }();
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.default = function (e) {
              return requestAnimationFrame(function () {
                requestAnimationFrame(e);
              });
            };
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r,
                o = (r = n(48)) && r.__esModule ? r : {
              default: r
            };
            t.default = o.default;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.default = function (e, t) {
              if (!e) return null;
              var n = t,
                  o = t,
                  i = t,
                  s = t,
                  a = Boolean("string" == typeof t),
                  l = Boolean("function" == typeof t),
                  c = Boolean(t instanceof NodeList || t instanceof Array),
                  u = Boolean(t instanceof HTMLElement);
              var d = e;

              do {
                if (d = d.correspondingUseElement || d.correspondingElement || d, (h = d) ? a ? r.call(h, n) : c ? _toConsumableArray(i).includes(h) : u ? s === h : l && o(h) : h) return d;
                d = d.parentNode;
              } while (d && d !== document.body && d !== document);

              var h;
              return null;
            };
            var r = Element.prototype.matches || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r,
                o = (r = n(50)) && r.__esModule ? r : {
              default: r
            };
            t.default = o.default;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.defaultOptions = t.scroll = t.onDragStop = t.onDragMove = t.onDragStart = void 0;

            var r,
                o = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            },
                i = (r = n(1)) && r.__esModule ? r : {
              default: r
            },
                s = n(2);

            var a = t.onDragStart = Symbol("onDragStart"),
                l = t.onDragMove = Symbol("onDragMove"),
                c = t.onDragStop = Symbol("onDragStop"),
                u = t.scroll = Symbol("scroll"),
                d = t.defaultOptions = {
              speed: 6,
              sensitivity: 50,
              scrollableElements: []
            };

            var h = /*#__PURE__*/function (_i$default8) {
              _inherits(h, _i$default8);

              var _super39 = _createSuper(h);

              function h(e) {
                var _this44;

                _classCallCheck(this, h);

                _this44 = _super39.call(this, e), _this44.options = o({}, d, _this44.getOptions()), _this44.currentMousePosition = null, _this44.scrollAnimationFrame = null, _this44.scrollableElement = null, _this44.findScrollableElementFrame = null, _this44[a] = _this44[a].bind(_assertThisInitialized(_this44)), _this44[l] = _this44[l].bind(_assertThisInitialized(_this44)), _this44[c] = _this44[c].bind(_assertThisInitialized(_this44)), _this44[u] = _this44[u].bind(_assertThisInitialized(_this44));
                return _this44;
              }

              _createClass(h, [{
                key: "attach",
                value: function attach() {
                  this.draggable.on("drag:start", this[a]).on("drag:move", this[l]).on("drag:stop", this[c]);
                }
              }, {
                key: "detach",
                value: function detach() {
                  this.draggable.off("drag:start", this[a]).off("drag:move", this[l]).off("drag:stop", this[c]);
                }
              }, {
                key: "getOptions",
                value: function getOptions() {
                  return this.draggable.options.scrollable || {};
                }
              }, {
                key: "getScrollableElement",
                value: function getScrollableElement(e) {
                  return this.hasDefinedScrollableElements() ? (0, s.closest)(e, this.options.scrollableElements) || document.documentElement : function (e) {
                    if (!e) return f();
                    var t = getComputedStyle(e).getPropertyValue("position"),
                        n = "absolute" === t,
                        r = (0, s.closest)(e, function (e) {
                      return (!n || !function (e) {
                        return "static" === getComputedStyle(e).getPropertyValue("position");
                      }(e)) && function (e) {
                        var t = getComputedStyle(e, null),
                            n = t.getPropertyValue("overflow") + t.getPropertyValue("overflow-y") + t.getPropertyValue("overflow-x");
                        return /(auto|scroll)/.test(n);
                      }(e);
                    });
                    return "fixed" !== t && r ? r : f();
                  }(e);
                }
              }, {
                key: "hasDefinedScrollableElements",
                value: function hasDefinedScrollableElements() {
                  return Boolean(0 !== this.options.scrollableElements.length);
                }
              }, {
                key: a,
                value: function value(e) {
                  var _this45 = this;

                  this.findScrollableElementFrame = requestAnimationFrame(function () {
                    _this45.scrollableElement = _this45.getScrollableElement(e.source);
                  });
                }
              }, {
                key: l,
                value: function value(e) {
                  var _this46 = this;

                  if (this.findScrollableElementFrame = requestAnimationFrame(function () {
                    _this46.scrollableElement = _this46.getScrollableElement(e.sensorEvent.target);
                  }), !this.scrollableElement) return;
                  var t = e.sensorEvent,
                      n = {
                    x: 0,
                    y: 0
                  };
                  "ontouchstart" in window && (n.y = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0, n.x = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0), this.currentMousePosition = {
                    clientX: t.clientX - n.x,
                    clientY: t.clientY - n.y
                  }, this.scrollAnimationFrame = requestAnimationFrame(this[u]);
                }
              }, {
                key: c,
                value: function value() {
                  cancelAnimationFrame(this.scrollAnimationFrame), cancelAnimationFrame(this.findScrollableElementFrame), this.scrollableElement = null, this.scrollAnimationFrame = null, this.findScrollableElementFrame = null, this.currentMousePosition = null;
                }
              }, {
                key: u,
                value: function value() {
                  if (!this.scrollableElement || !this.currentMousePosition) return;
                  cancelAnimationFrame(this.scrollAnimationFrame);
                  var _this$options = this.options,
                      e = _this$options.speed,
                      t = _this$options.sensitivity,
                      n = this.scrollableElement.getBoundingClientRect(),
                      r = n.bottom > window.innerHeight,
                      o = n.top < 0 || r,
                      i = f(),
                      s = this.scrollableElement,
                      a = this.currentMousePosition.clientX,
                      l = this.currentMousePosition.clientY;

                  if (s === document.body || s === document.documentElement || o) {
                    var _window = window,
                        _n14 = _window.innerHeight,
                        _r12 = _window.innerWidth;
                    l < t ? i.scrollTop -= e : _n14 - l < t && (i.scrollTop += e), a < t ? i.scrollLeft -= e : _r12 - a < t && (i.scrollLeft += e);
                  } else {
                    var _r13 = s.offsetHeight,
                        _o7 = s.offsetWidth;
                    n.top + _r13 - l < t ? s.scrollTop += e : l - n.top < t && (s.scrollTop -= e), n.left + _o7 - a < t ? s.scrollLeft += e : a - n.left < t && (s.scrollLeft -= e);
                  }

                  this.scrollAnimationFrame = requestAnimationFrame(this[u]);
                }
              }]);

              return h;
            }(i.default);

            function f() {
              return document.scrollingElement || document.documentElement;
            }

            t.default = h;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.defaultOptions = void 0;
            var r,
                o = n(52),
                i = (r = o) && r.__esModule ? r : {
              default: r
            };
            t.default = i.default, t.defaultOptions = o.defaultOptions;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.MirrorDestroyEvent = t.MirrorMoveEvent = t.MirrorAttachedEvent = t.MirrorCreatedEvent = t.MirrorCreateEvent = t.MirrorEvent = void 0;
            var r,
                o = (r = n(0)) && r.__esModule ? r : {
              default: r
            };

            var i = /*#__PURE__*/function (_o$default10) {
              _inherits(i, _o$default10);

              var _super40 = _createSuper(i);

              function i() {
                _classCallCheck(this, i);

                return _super40.apply(this, arguments);
              }

              _createClass(i, [{
                key: "source",
                get: function get() {
                  return this.data.source;
                }
              }, {
                key: "originalSource",
                get: function get() {
                  return this.data.originalSource;
                }
              }, {
                key: "sourceContainer",
                get: function get() {
                  return this.data.sourceContainer;
                }
              }, {
                key: "sensorEvent",
                get: function get() {
                  return this.data.sensorEvent;
                }
              }, {
                key: "dragEvent",
                get: function get() {
                  return this.data.dragEvent;
                }
              }, {
                key: "originalEvent",
                get: function get() {
                  return this.sensorEvent ? this.sensorEvent.originalEvent : null;
                }
              }]);

              return i;
            }(o.default);

            t.MirrorEvent = i;

            var s = /*#__PURE__*/function (_i29) {
              _inherits(s, _i29);

              var _super41 = _createSuper(s);

              function s() {
                _classCallCheck(this, s);

                return _super41.apply(this, arguments);
              }

              return s;
            }(i);

            t.MirrorCreateEvent = s, s.type = "mirror:create";

            var a = /*#__PURE__*/function (_i30) {
              _inherits(a, _i30);

              var _super42 = _createSuper(a);

              function a() {
                _classCallCheck(this, a);

                return _super42.apply(this, arguments);
              }

              _createClass(a, [{
                key: "mirror",
                get: function get() {
                  return this.data.mirror;
                }
              }]);

              return a;
            }(i);

            t.MirrorCreatedEvent = a, a.type = "mirror:created";

            var l = /*#__PURE__*/function (_i31) {
              _inherits(l, _i31);

              var _super43 = _createSuper(l);

              function l() {
                _classCallCheck(this, l);

                return _super43.apply(this, arguments);
              }

              _createClass(l, [{
                key: "mirror",
                get: function get() {
                  return this.data.mirror;
                }
              }]);

              return l;
            }(i);

            t.MirrorAttachedEvent = l, l.type = "mirror:attached";

            var c = /*#__PURE__*/function (_i32) {
              _inherits(c, _i32);

              var _super44 = _createSuper(c);

              function c() {
                _classCallCheck(this, c);

                return _super44.apply(this, arguments);
              }

              _createClass(c, [{
                key: "mirror",
                get: function get() {
                  return this.data.mirror;
                }
              }]);

              return c;
            }(i);

            t.MirrorMoveEvent = c, c.type = "mirror:move", c.cancelable = !0;

            var u = /*#__PURE__*/function (_i33) {
              _inherits(u, _i33);

              var _super45 = _createSuper(u);

              function u() {
                _classCallCheck(this, u);

                return _super45.apply(this, arguments);
              }

              _createClass(u, [{
                key: "mirror",
                get: function get() {
                  return this.data.mirror;
                }
              }]);

              return u;
            }(i);

            t.MirrorDestroyEvent = u, u.type = "mirror:destroy", u.cancelable = !0;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r = n(54);
            Object.keys(r).forEach(function (e) {
              "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                enumerable: !0,
                get: function get() {
                  return r[e];
                }
              });
            });
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.defaultOptions = t.getAppendableContainer = t.onScroll = t.onMirrorMove = t.onMirrorCreated = t.onDragStop = t.onDragMove = t.onDragStart = void 0;

            var r,
                o = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            },
                i = (r = n(1)) && r.__esModule ? r : {
              default: r
            },
                s = n(55);

            function a(e, t) {
              var n = {};

              for (var r in e) {
                t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
              }

              return n;
            }

            var l = t.onDragStart = Symbol("onDragStart"),
                c = t.onDragMove = Symbol("onDragMove"),
                u = t.onDragStop = Symbol("onDragStop"),
                d = t.onMirrorCreated = Symbol("onMirrorCreated"),
                h = t.onMirrorMove = Symbol("onMirrorMove"),
                f = t.onScroll = Symbol("onScroll"),
                p = t.getAppendableContainer = Symbol("getAppendableContainer"),
                g = t.defaultOptions = {
              constrainDimensions: !1,
              xAxis: !0,
              yAxis: !0,
              cursorOffsetX: null,
              cursorOffsetY: null
            };

            var m = /*#__PURE__*/function (_i$default9) {
              _inherits(m, _i$default9);

              var _super46 = _createSuper(m);

              function m(e) {
                var _this47;

                _classCallCheck(this, m);

                _this47 = _super46.call(this, e), _this47.options = o({}, g, _this47.getOptions()), _this47.scrollOffset = {
                  x: 0,
                  y: 0
                }, _this47.initialScrollOffset = {
                  x: window.scrollX,
                  y: window.scrollY
                }, _this47[l] = _this47[l].bind(_assertThisInitialized(_this47)), _this47[c] = _this47[c].bind(_assertThisInitialized(_this47)), _this47[u] = _this47[u].bind(_assertThisInitialized(_this47)), _this47[d] = _this47[d].bind(_assertThisInitialized(_this47)), _this47[h] = _this47[h].bind(_assertThisInitialized(_this47)), _this47[f] = _this47[f].bind(_assertThisInitialized(_this47));
                return _this47;
              }

              _createClass(m, [{
                key: "attach",
                value: function attach() {
                  this.draggable.on("drag:start", this[l]).on("drag:move", this[c]).on("drag:stop", this[u]).on("mirror:created", this[d]).on("mirror:move", this[h]);
                }
              }, {
                key: "detach",
                value: function detach() {
                  this.draggable.off("drag:start", this[l]).off("drag:move", this[c]).off("drag:stop", this[u]).off("mirror:created", this[d]).off("mirror:move", this[h]);
                }
              }, {
                key: "getOptions",
                value: function getOptions() {
                  return this.draggable.options.mirror || {};
                }
              }, {
                key: l,
                value: function value(e) {
                  if (e.canceled()) return;
                  "ontouchstart" in window && document.addEventListener("scroll", this[f], !0), this.initialScrollOffset = {
                    x: window.scrollX,
                    y: window.scrollY
                  };
                  var t = e.source,
                      n = e.originalSource,
                      r = e.sourceContainer,
                      o = e.sensorEvent,
                      i = new s.MirrorCreateEvent({
                    source: t,
                    originalSource: n,
                    sourceContainer: r,
                    sensorEvent: o,
                    dragEvent: e
                  });
                  if (this.draggable.trigger(i), function (e) {
                    return /^drag/.test(e.originalEvent.type);
                  }(o) || i.canceled()) return;
                  var a = this[p](t) || r;
                  this.mirror = t.cloneNode(!0);
                  var l = new s.MirrorCreatedEvent({
                    source: t,
                    originalSource: n,
                    sourceContainer: r,
                    sensorEvent: o,
                    dragEvent: e,
                    mirror: this.mirror
                  }),
                      c = new s.MirrorAttachedEvent({
                    source: t,
                    originalSource: n,
                    sourceContainer: r,
                    sensorEvent: o,
                    dragEvent: e,
                    mirror: this.mirror
                  });
                  this.draggable.trigger(l), a.appendChild(this.mirror), this.draggable.trigger(c);
                }
              }, {
                key: c,
                value: function value(e) {
                  if (!this.mirror || e.canceled()) return;
                  var t = e.source,
                      n = e.originalSource,
                      r = e.sourceContainer,
                      o = e.sensorEvent,
                      i = new s.MirrorMoveEvent({
                    source: t,
                    originalSource: n,
                    sourceContainer: r,
                    sensorEvent: o,
                    dragEvent: e,
                    mirror: this.mirror
                  });
                  this.draggable.trigger(i);
                }
              }, {
                key: u,
                value: function value(e) {
                  if ("ontouchstart" in window && document.removeEventListener("scroll", this[f], !0), this.initialScrollOffset = {
                    x: 0,
                    y: 0
                  }, this.scrollOffset = {
                    x: 0,
                    y: 0
                  }, !this.mirror) return;
                  var t = e.source,
                      n = e.sourceContainer,
                      r = e.sensorEvent,
                      o = new s.MirrorDestroyEvent({
                    source: t,
                    mirror: this.mirror,
                    sourceContainer: n,
                    sensorEvent: r,
                    dragEvent: e
                  });
                  this.draggable.trigger(o), o.canceled() || this.mirror.parentNode.removeChild(this.mirror);
                }
              }, {
                key: f,
                value: function value() {
                  this.scrollOffset = {
                    x: window.scrollX - this.initialScrollOffset.x,
                    y: window.scrollY - this.initialScrollOffset.y
                  };
                }
              }, {
                key: d,
                value: function value(_ref32) {
                  var _this48 = this;

                  var e = _ref32.mirror,
                      t = _ref32.source,
                      n = _ref32.sensorEvent;
                  var r = {
                    mirror: e,
                    source: t,
                    sensorEvent: n,
                    mirrorClass: this.draggable.getClassNameFor("mirror"),
                    scrollOffset: this.scrollOffset,
                    options: this.options
                  };
                  return Promise.resolve(r).then(v).then(y).then(b).then(w).then(E({
                    initial: !0
                  })).then(O).then(function (e) {
                    var t = e.mirrorOffset,
                        n = e.initialX,
                        r = e.initialY,
                        i = a(e, ["mirrorOffset", "initialX", "initialY"]);
                    return _this48.mirrorOffset = t, _this48.initialX = n, _this48.initialY = r, o({
                      mirrorOffset: t,
                      initialX: n,
                      initialY: r
                    }, i);
                  });
                }
              }, {
                key: h,
                value: function value(e) {
                  if (e.canceled()) return null;
                  var t = {
                    mirror: e.mirror,
                    sensorEvent: e.sensorEvent,
                    mirrorOffset: this.mirrorOffset,
                    options: this.options,
                    initialX: this.initialX,
                    initialY: this.initialY,
                    scrollOffset: this.scrollOffset
                  };
                  return Promise.resolve(t).then(E({
                    raf: !0
                  }));
                }
              }, {
                key: p,
                value: function value(e) {
                  var t = this.options.appendTo;
                  return "string" == typeof t ? document.querySelector(t) : t instanceof HTMLElement ? t : "function" == typeof t ? t(e) : e.parentNode;
                }
              }]);

              return m;
            }(i.default);

            function v(e) {
              var t = e.source,
                  n = a(e, ["source"]);
              return _(function (e) {
                var r = t.getBoundingClientRect();
                e(o({
                  source: t,
                  sourceRect: r
                }, n));
              });
            }

            function y(e) {
              var t = e.sensorEvent,
                  n = e.sourceRect,
                  r = e.options,
                  i = a(e, ["sensorEvent", "sourceRect", "options"]);
              return _(function (e) {
                var s = null === r.cursorOffsetY ? t.clientY - n.top : r.cursorOffsetY,
                    a = null === r.cursorOffsetX ? t.clientX - n.left : r.cursorOffsetX;
                e(o({
                  sensorEvent: t,
                  sourceRect: n,
                  mirrorOffset: {
                    top: s,
                    left: a
                  },
                  options: r
                }, i));
              });
            }

            function b(e) {
              var t = e.mirror,
                  n = e.source,
                  r = e.options,
                  i = a(e, ["mirror", "source", "options"]);
              return _(function (e) {
                var s, a;

                if (r.constrainDimensions) {
                  var _e25 = getComputedStyle(n);

                  s = _e25.getPropertyValue("height"), a = _e25.getPropertyValue("width");
                }

                t.style.position = "fixed", t.style.pointerEvents = "none", t.style.top = 0, t.style.left = 0, t.style.margin = 0, r.constrainDimensions && (t.style.height = s, t.style.width = a), e(o({
                  mirror: t,
                  source: n,
                  options: r
                }, i));
              });
            }

            function w(e) {
              var t = e.mirror,
                  n = e.mirrorClass,
                  r = a(e, ["mirror", "mirrorClass"]);
              return _(function (e) {
                t.classList.add(n), e(o({
                  mirror: t,
                  mirrorClass: n
                }, r));
              });
            }

            function O(e) {
              var t = e.mirror,
                  n = a(e, ["mirror"]);
              return _(function (e) {
                t.removeAttribute("id"), delete t.id, e(o({
                  mirror: t
                }, n));
              });
            }

            function E() {
              var _ref33 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                  _ref33$withFrame = _ref33.withFrame,
                  e = _ref33$withFrame === void 0 ? !1 : _ref33$withFrame,
                  _ref33$initial = _ref33.initial,
                  t = _ref33$initial === void 0 ? !1 : _ref33$initial;

              return function (n) {
                var r = n.mirror,
                    i = n.sensorEvent,
                    s = n.mirrorOffset,
                    l = n.initialY,
                    c = n.initialX,
                    u = n.scrollOffset,
                    d = n.options,
                    h = a(n, ["mirror", "sensorEvent", "mirrorOffset", "initialY", "initialX", "scrollOffset", "options"]);
                return _(function (e) {
                  var n = o({
                    mirror: r,
                    sensorEvent: i,
                    mirrorOffset: s,
                    options: d
                  }, h);

                  if (s) {
                    var _e26 = i.clientX - s.left - u.x,
                        _o8 = i.clientY - s.top - u.y;

                    d.xAxis && d.yAxis || t ? r.style.transform = "translate3d(".concat(_e26, "px, ").concat(_o8, "px, 0)") : d.xAxis && !d.yAxis ? r.style.transform = "translate3d(".concat(_e26, "px, ").concat(l, "px, 0)") : d.yAxis && !d.xAxis && (r.style.transform = "translate3d(".concat(c, "px, ").concat(_o8, "px, 0)")), t && (n.initialX = _e26, n.initialY = _o8);
                  }

                  e(n);
                }, {
                  frame: e
                });
              };
            }

            function _(e) {
              var _ref34 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                  _ref34$raf = _ref34.raf,
                  t = _ref34$raf === void 0 ? !1 : _ref34$raf;

              return new Promise(function (n, r) {
                t ? requestAnimationFrame(function () {
                  e(n, r);
                }) : e(n, r);
              });
            }

            t.default = m;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.defaultOptions = void 0;
            var r,
                o = n(56),
                i = (r = o) && r.__esModule ? r : {
              default: r
            };
            t.default = i.default, t.defaultOptions = o.defaultOptions;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });

            var r,
                o = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            },
                i = (r = n(1)) && r.__esModule ? r : {
              default: r
            };

            var s = Symbol("onInitialize"),
                a = Symbol("onDestroy"),
                l = {};

            var c = /*#__PURE__*/function (_i$default10) {
              _inherits(c, _i$default10);

              var _super47 = _createSuper(c);

              function c(e) {
                var _this49;

                _classCallCheck(this, c);

                _this49 = _super47.call(this, e), _this49.options = o({}, l, _this49.getOptions()), _this49[s] = _this49[s].bind(_assertThisInitialized(_this49)), _this49[a] = _this49[a].bind(_assertThisInitialized(_this49));
                return _this49;
              }

              _createClass(c, [{
                key: "attach",
                value: function attach() {
                  this.draggable.on("draggable:initialize", this[s]).on("draggable:destroy", this[a]);
                }
              }, {
                key: "detach",
                value: function detach() {
                  this.draggable.off("draggable:initialize", this[s]).off("draggable:destroy", this[a]);
                }
              }, {
                key: "getOptions",
                value: function getOptions() {
                  return this.draggable.options.focusable || {};
                }
              }, {
                key: "getElements",
                value: function getElements() {
                  return [].concat(_toConsumableArray(this.draggable.containers), _toConsumableArray(this.draggable.getDraggableElements()));
                }
              }, {
                key: s,
                value: function value() {
                  var _this50 = this;

                  requestAnimationFrame(function () {
                    _this50.getElements().forEach(function (e) {
                      return function (e) {
                        Boolean(!e.getAttribute("tabindex") && -1 === e.tabIndex) && (u.push(e), e.tabIndex = 0);
                      }(e);
                    });
                  });
                }
              }, {
                key: a,
                value: function value() {
                  var _this51 = this;

                  requestAnimationFrame(function () {
                    _this51.getElements().forEach(function (e) {
                      return function (e) {
                        var t = u.indexOf(e);
                        -1 !== t && (e.tabIndex = -1, u.splice(t, 1));
                      }(e);
                    });
                  });
                }
              }]);

              return c;
            }(i.default);

            t.default = c;
            var u = [];
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });
            var r,
                o = (r = n(58)) && r.__esModule ? r : {
              default: r
            };
            t.default = o.default;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.default = /*#__PURE__*/function () {
              function _class6(e) {
                _classCallCheck(this, _class6);

                this.draggable = e;
              }

              _createClass(_class6, [{
                key: "attach",
                value: function attach() {
                  throw new Error("Not Implemented");
                }
              }, {
                key: "detach",
                value: function detach() {
                  throw new Error("Not Implemented");
                }
              }]);

              return _class6;
            }();
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.defaultOptions = void 0;

            var r,
                o = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            },
                i = (r = n(1)) && r.__esModule ? r : {
              default: r
            };

            var s = Symbol("onInitialize"),
                a = Symbol("onDestroy"),
                l = Symbol("announceEvent"),
                c = Symbol("announceMessage"),
                u = t.defaultOptions = {
              expire: 7e3
            };

            var d = /*#__PURE__*/function (_i$default11) {
              _inherits(d, _i$default11);

              var _super48 = _createSuper(d);

              function d(e) {
                var _this52;

                _classCallCheck(this, d);

                _this52 = _super48.call(this, e), _this52.options = o({}, u, _this52.getOptions()), _this52.originalTriggerMethod = _this52.draggable.trigger, _this52[s] = _this52[s].bind(_assertThisInitialized(_this52)), _this52[a] = _this52[a].bind(_assertThisInitialized(_this52));
                return _this52;
              }

              _createClass(d, [{
                key: "attach",
                value: function attach() {
                  this.draggable.on("draggable:initialize", this[s]);
                }
              }, {
                key: "detach",
                value: function detach() {
                  this.draggable.off("draggable:destroy", this[a]);
                }
              }, {
                key: "getOptions",
                value: function getOptions() {
                  return this.draggable.options.announcements || {};
                }
              }, {
                key: l,
                value: function value(e) {
                  var t = this.options[e.type];
                  t && "string" == typeof t && this[c](t), t && "function" == typeof t && this[c](t(e));
                }
              }, {
                key: c,
                value: function value(e) {
                  !function (e, _ref35) {
                    var t = _ref35.expire;
                    var n = document.createElement("div");
                    n.textContent = e, h.appendChild(n), setTimeout(function () {
                      h.removeChild(n);
                    }, t);
                  }(e, {
                    expire: this.options.expire
                  });
                }
              }, {
                key: s,
                value: function value() {
                  var _this53 = this;

                  this.draggable.trigger = function (e) {
                    try {
                      _this53[l](e);
                    } finally {
                      _this53.originalTriggerMethod.call(_this53.draggable, e);
                    }
                  };
                }
              }, {
                key: a,
                value: function value() {
                  this.draggable.trigger = this.originalTriggerMethod;
                }
              }]);

              return d;
            }(i.default);

            t.default = d;

            var h = function () {
              var e = document.createElement("div");
              return e.setAttribute("id", "draggable-live-region"), e.setAttribute("aria-relevant", "additions"), e.setAttribute("aria-atomic", "true"), e.setAttribute("aria-live", "assertive"), e.setAttribute("role", "log"), e.style.position = "fixed", e.style.width = "1px", e.style.height = "1px", e.style.top = "-1px", e.style.overflow = "hidden", e;
            }();

            document.addEventListener("DOMContentLoaded", function () {
              document.body.appendChild(h);
            });
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.defaultOptions = void 0;
            var r,
                o = n(61),
                i = (r = o) && r.__esModule ? r : {
              default: r
            };
            t.default = i.default, t.defaultOptions = o.defaultOptions;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.DraggableDestroyEvent = t.DraggableInitializedEvent = t.DraggableEvent = void 0;
            var r,
                o = (r = n(0)) && r.__esModule ? r : {
              default: r
            };

            var i = /*#__PURE__*/function (_o$default11) {
              _inherits(i, _o$default11);

              var _super49 = _createSuper(i);

              function i() {
                _classCallCheck(this, i);

                return _super49.apply(this, arguments);
              }

              _createClass(i, [{
                key: "draggable",
                get: function get() {
                  return this.data.draggable;
                }
              }]);

              return i;
            }(o.default);

            t.DraggableEvent = i, i.type = "draggable";

            var s = /*#__PURE__*/function (_i34) {
              _inherits(s, _i34);

              var _super50 = _createSuper(s);

              function s() {
                _classCallCheck(this, s);

                return _super50.apply(this, arguments);
              }

              return s;
            }(i);

            t.DraggableInitializedEvent = s, s.type = "draggable:initialize";

            var a = /*#__PURE__*/function (_i35) {
              _inherits(a, _i35);

              var _super51 = _createSuper(a);

              function a() {
                _classCallCheck(this, a);

                return _super51.apply(this, arguments);
              }

              return a;
            }(i);

            t.DraggableDestroyEvent = a, a.type = "draggable:destroy";
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            });

            var r = Object.assign || function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];

                for (var r in n) {
                  Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
              }

              return e;
            };

            var o = Symbol("canceled");

            var i = /*#__PURE__*/function () {
              function i(e) {
                _classCallCheck(this, i);

                this[o] = !1, this.data = e;
              }

              _createClass(i, [{
                key: "type",
                get: function get() {
                  return this.constructor.type;
                }
              }, {
                key: "cancelable",
                get: function get() {
                  return this.constructor.cancelable;
                }
              }, {
                key: "cancel",
                value: function cancel() {
                  this[o] = !0;
                }
              }, {
                key: "canceled",
                value: function canceled() {
                  return Boolean(this[o]);
                }
              }, {
                key: "clone",
                value: function clone(e) {
                  return new this.constructor(r({}, this.data, e));
                }
              }]);

              return i;
            }();

            t.default = i, i.type = "event", i.cancelable = !1;
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.DragStopEvent = t.DragPressureEvent = t.DragOutContainerEvent = t.DragOverContainerEvent = t.DragOutEvent = t.DragOverEvent = t.DragMoveEvent = t.DragStartEvent = t.DragEvent = void 0;
            var r,
                o = (r = n(0)) && r.__esModule ? r : {
              default: r
            };

            var i = /*#__PURE__*/function (_o$default12) {
              _inherits(i, _o$default12);

              var _super52 = _createSuper(i);

              function i() {
                _classCallCheck(this, i);

                return _super52.apply(this, arguments);
              }

              _createClass(i, [{
                key: "source",
                get: function get() {
                  return this.data.source;
                }
              }, {
                key: "originalSource",
                get: function get() {
                  return this.data.originalSource;
                }
              }, {
                key: "mirror",
                get: function get() {
                  return this.data.mirror;
                }
              }, {
                key: "sourceContainer",
                get: function get() {
                  return this.data.sourceContainer;
                }
              }, {
                key: "sensorEvent",
                get: function get() {
                  return this.data.sensorEvent;
                }
              }, {
                key: "originalEvent",
                get: function get() {
                  return this.sensorEvent ? this.sensorEvent.originalEvent : null;
                }
              }]);

              return i;
            }(o.default);

            t.DragEvent = i, i.type = "drag";

            var s = /*#__PURE__*/function (_i36) {
              _inherits(s, _i36);

              var _super53 = _createSuper(s);

              function s() {
                _classCallCheck(this, s);

                return _super53.apply(this, arguments);
              }

              return s;
            }(i);

            t.DragStartEvent = s, s.type = "drag:start", s.cancelable = !0;

            var a = /*#__PURE__*/function (_i37) {
              _inherits(a, _i37);

              var _super54 = _createSuper(a);

              function a() {
                _classCallCheck(this, a);

                return _super54.apply(this, arguments);
              }

              return a;
            }(i);

            t.DragMoveEvent = a, a.type = "drag:move";

            var l = /*#__PURE__*/function (_i38) {
              _inherits(l, _i38);

              var _super55 = _createSuper(l);

              function l() {
                _classCallCheck(this, l);

                return _super55.apply(this, arguments);
              }

              _createClass(l, [{
                key: "overContainer",
                get: function get() {
                  return this.data.overContainer;
                }
              }, {
                key: "over",
                get: function get() {
                  return this.data.over;
                }
              }]);

              return l;
            }(i);

            t.DragOverEvent = l, l.type = "drag:over", l.cancelable = !0;

            var c = /*#__PURE__*/function (_i39) {
              _inherits(c, _i39);

              var _super56 = _createSuper(c);

              function c() {
                _classCallCheck(this, c);

                return _super56.apply(this, arguments);
              }

              _createClass(c, [{
                key: "overContainer",
                get: function get() {
                  return this.data.overContainer;
                }
              }, {
                key: "over",
                get: function get() {
                  return this.data.over;
                }
              }]);

              return c;
            }(i);

            t.DragOutEvent = c, c.type = "drag:out";

            var u = /*#__PURE__*/function (_i40) {
              _inherits(u, _i40);

              var _super57 = _createSuper(u);

              function u() {
                _classCallCheck(this, u);

                return _super57.apply(this, arguments);
              }

              _createClass(u, [{
                key: "overContainer",
                get: function get() {
                  return this.data.overContainer;
                }
              }]);

              return u;
            }(i);

            t.DragOverContainerEvent = u, u.type = "drag:over:container";

            var d = /*#__PURE__*/function (_i41) {
              _inherits(d, _i41);

              var _super58 = _createSuper(d);

              function d() {
                _classCallCheck(this, d);

                return _super58.apply(this, arguments);
              }

              _createClass(d, [{
                key: "overContainer",
                get: function get() {
                  return this.data.overContainer;
                }
              }]);

              return d;
            }(i);

            t.DragOutContainerEvent = d, d.type = "drag:out:container";

            var h = /*#__PURE__*/function (_i42) {
              _inherits(h, _i42);

              var _super59 = _createSuper(h);

              function h() {
                _classCallCheck(this, h);

                return _super59.apply(this, arguments);
              }

              _createClass(h, [{
                key: "pressure",
                get: function get() {
                  return this.data.pressure;
                }
              }]);

              return h;
            }(i);

            t.DragPressureEvent = h, h.type = "drag:pressure";

            var f = /*#__PURE__*/function (_i43) {
              _inherits(f, _i43);

              var _super60 = _createSuper(f);

              function f() {
                _classCallCheck(this, f);

                return _super60.apply(this, arguments);
              }

              return f;
            }(i);

            t.DragStopEvent = f, f.type = "drag:stop";
          }, function (e, t, n) {
            "use strict";

            Object.defineProperty(t, "__esModule", {
              value: !0
            }), t.Plugins = t.Sensors = t.Sortable = t.Swappable = t.Droppable = t.Draggable = t.BasePlugin = t.BaseEvent = void 0;
            var r = n(5);
            Object.defineProperty(t, "Draggable", {
              enumerable: !0,
              get: function get() {
                return h(r).default;
              }
            });
            var o = n(34);
            Object.defineProperty(t, "Droppable", {
              enumerable: !0,
              get: function get() {
                return h(o).default;
              }
            });
            var i = n(31);
            Object.defineProperty(t, "Swappable", {
              enumerable: !0,
              get: function get() {
                return h(i).default;
              }
            });
            var s = n(28);
            Object.defineProperty(t, "Sortable", {
              enumerable: !0,
              get: function get() {
                return h(s).default;
              }
            });
            var a = h(n(0)),
                l = h(n(1)),
                c = d(n(6)),
                u = d(n(25));

            function d(e) {
              if (e && e.__esModule) return e;
              var t = {};
              if (null != e) for (var n in e) {
                Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
              }
              return t.default = e, t;
            }

            function h(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }

            t.BaseEvent = a.default, t.BasePlugin = l.default, t.Sensors = c, t.Plugins = u;
          }]);
        }, e.exports = t();
      },
      5158: function _(e) {
        e.exports = function (e) {
          if ("number" != typeof e || isNaN(e)) throw new TypeError("Expected a number, got " + _typeof(e));
          var t = e < 0,
              n = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
          if (t && (e = -e), e < 1) return (t ? "-" : "") + e + " B";
          var r = Math.min(Math.floor(Math.log(e) / Math.log(1024)), n.length - 1);
          e = Number(e / Math.pow(1024, r));
          var o = n[r];
          return e >= 10 || e % 1 == 0 ? (t ? "-" : "") + e.toFixed(0) + " " + o : (t ? "-" : "") + e.toFixed(1) + " " + o;
        };
      },
      9334: function _(e, t, n) {
        "use strict";

        function r(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function o(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function i(e, t) {
          return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, i(e, t);
        }

        function s(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function a(e) {
          return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, a(e);
        }

        n.r(t), n.d(t, {
          default: function _default() {
            return l;
          }
        });

        var l = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && i(e, t);
          }(d, e);
          var t,
              n,
              l,
              c,
              u = (l = d, c = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = a(l);

            if (c) {
              var n = a(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return s(this, e);
          });

          function d() {
            return r(this, d), u.apply(this, arguments);
          }

          return t = d, (n = [{
            key: "remove",
            value: function value() {
              var _this54 = this;

              this.element.classList.add(this.data.get("fadeOutClass")), this.element.addEventListener("transitionend", function () {
                return _this54.element.remove();
              });
            }
          }]) && o(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), d;
        }(n(6599).Qr);
      },
      1906: function _(e, t, n) {
        "use strict";

        function r(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function o(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function i(e, t) {
          return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, i(e, t);
        }

        function s(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function a(e) {
          return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, a(e);
        }

        n.r(t), n.d(t, {
          default: function _default() {
            return l;
          }
        });

        var l = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && i(e, t);
          }(d, e);
          var t,
              n,
              l,
              c,
              u = (l = d, c = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = a(l);

            if (c) {
              var n = a(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return s(this, e);
          });

          function d() {
            return r(this, d), u.apply(this, arguments);
          }

          return t = d, (n = [{
            key: "onSearch",
            value: function value(e) {
              e.target.value || this.hasQuery && this.formTarget.submit();
            }
          }, {
            key: "hasQuery",
            get: function get() {
              return this.element.classList.contains(this.hasQueryClass);
            }
          }, {
            key: "hasQueryClass",
            get: function get() {
              return this.data.get("hasQueryClass");
            }
          }]) && o(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), d;
        }(n(6599).Qr);

        var c, u, d;
        d = ["form", "input"], (u = "targets") in (c = l) ? Object.defineProperty(c, u, {
          value: d,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : c[u] = d;
      },
      1261: function _(e, t, n) {
        "use strict";

        function r(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function o(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function i(e, t) {
          return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, i(e, t);
        }

        function s(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function a(e) {
          return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, a(e);
        }

        n.r(t), n.d(t, {
          default: function _default() {
            return l;
          }
        });

        var l = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && i(e, t);
          }(d, e);
          var t,
              n,
              l,
              c,
              u = (l = d, c = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = a(l);

            if (c) {
              var n = a(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return s(this, e);
          });

          function d() {
            return r(this, d), u.apply(this, arguments);
          }

          return t = d, (n = [{
            key: "deselectAll",
            value: function value() {
              this.attachmentToggleControllers && this.attachmentToggleControllers.forEach(function (e) {
                e.deselect();
              });
            }
          }, {
            key: "getControllerForAttachmentToggle",
            value: function value(e) {
              if (e) return this.application.getControllerForElementAndIdentifier(e, "apparatus--attachments--attachment-selector-component--attachment-toggle-component");
            }
          }, {
            key: "attachmentToggleControllers",
            get: function get() {
              var _this55 = this;

              return this.attachmentToggleTargets.map(function (e) {
                return _this55.getControllerForAttachmentToggle(e);
              }).filter(Boolean);
            }
          }, {
            key: "selectedAttachmentsCount",
            get: function get() {
              return this.toggledAttachments.length;
            }
          }, {
            key: "selectedAttachmentIds",
            get: function get() {
              if (this.toggledAttachments) return this.toggledAttachments.map(function (e) {
                return e.dataset.attachmentId;
              });
            }
          }, {
            key: "toggledAttachments",
            get: function get() {
              return this.attachmentToggleControllers.filter(function (e) {
                return e.isToggled;
              }).map(function (e) {
                return e.element;
              });
            }
          }]) && o(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), d;
        }(n(6599).Qr);

        var c, u, d;
        d = ["attachmentToggle"], (u = "targets") in (c = l) ? Object.defineProperty(c, u, {
          value: d,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : c[u] = d;
      },
      8831: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return f;
          }
        });
        var r = n(6599),
            o = n(7545),
            i = n(8535),
            s = n.n(i);

        function a(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function l(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function c(e, t) {
          return c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, c(e, t);
        }

        function u(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function d(e) {
          return d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, d(e);
        }

        function h(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }

        var f = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && c(e, t);
          }(f, e);
          var t,
              n,
              r,
              i,
              h = (r = f, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = d(r);

            if (i) {
              var n = d(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return u(this, e);
          });

          function f() {
            return a(this, f), h.apply(this, arguments);
          }

          return t = f, (n = [{
            key: "connect",
            value: function value() {
              (0, o.Nr)(this);
            }
          }, {
            key: "search",
            value: function value(e) {
              s().fire(this.formTarget, "submit");
            }
          }]) && l(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), f;
        }(r.Qr);

        h(f, "targets", ["form"]), h(f, "debounces", ["search"]);
      },
      1795: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return h;
          }
        });
        var r = n(6599),
            o = n(7545),
            i = n(1421);

        function s(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function a(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function l(e, t) {
          return l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, l(e, t);
        }

        function c(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function u(e) {
          return u = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, u(e);
        }

        function d(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }

        var h = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && l(e, t);
          }(f, e);
          var t,
              n,
              r,
              d,
              h = (r = f, d = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = u(r);

            if (d) {
              var n = u(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return c(this, e);
          });

          function f() {
            return s(this, f), h.apply(this, arguments);
          }

          return t = f, (n = [{
            key: "connect",
            value: function value() {
              (0, o.I0)(this), (0, i.J)(this);
            }
          }, {
            key: "update",
            value: function value(e) {
              this.replace(e);
            }
          }, {
            key: "updateCounter",
            value: function value() {
              this.hasCounterTarget && (this.counterTarget.textContent = this.selectedAttachmentsCount, this.toggleHasSelectionClass());
            }
          }, {
            key: "updateAttachments",
            value: function value(e) {
              this.deselectAll(), this.replace(e);
            }
          }, {
            key: "deselectAll",
            value: function value() {
              this.inputTargets.forEach(function (e) {
                return e.checked = !1;
              }), this.updateCounter();
            }
          }, {
            key: "select",
            value: function value() {
              this.dispatch("select", {
                attachmentIds: this.selectedAttachmentIds
              }), this.destroy();
            }
          }, {
            key: "cancel",
            value: function value() {
              this.destroy();
            }
          }, {
            key: "destroy",
            value: function value() {
              this.element.parentNode && this.element.parentNode.removeChild(this.element);
            }
          }, {
            key: "updateSelectButtonDisabledState",
            value: function value() {
              this.hasSelectButtonTarget && (this.selectButtonTarget.disabled = !this.hasSelection);
            }
          }, {
            key: "toggleHasSelectionClass",
            value: function value() {
              this.element.classList.toggle(this.hasSelectionClass, this.hasSelection);
            }
          }, {
            key: "selectedAttachmentsCount",
            get: function get() {
              return this.selectedAttachmentInputs.length;
            }
          }, {
            key: "selectedAttachmentIds",
            get: function get() {
              return this.selectedAttachmentInputs.map(function (e) {
                return e.value;
              });
            }
          }, {
            key: "selectedAttachmentInputs",
            get: function get() {
              return this.inputTargets.filter(function (e) {
                return e.checked;
              });
            }
          }, {
            key: "hasSelection",
            get: function get() {
              return this.selectedAttachmentsCount > 0;
            }
          }, {
            key: "hasSelectionClass",
            get: function get() {
              return this.data.get("hasSelectionClass");
            }
          }]) && a(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), f;
        }(r.Qr);

        d(h, "targets", ["attachments", "attachment", "counter", "selectButton", "input"]), d(h, "classes", ["hasSelection"]), d(h, "values", {
          selectedCount: Number,
          loading: Boolean,
          remoteResponseTarget: String
        });
      },
      7057: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return m;
          }
        });
        var r = n(6599),
            o = n(7545),
            i = n(1421),
            s = n(1668);

        function a(e) {
          var t = e.parentNode,
              n = e.cloneNode(!0),
              r = t.insertBefore(n, e);
          return r.style.transition = "transform var(--swap-timing-function) var(--swap-duration)", r.style.boxSizing = "border-box", r.style.position = "absolute", r.style.opacity = 1, r.style.width = "".concat(e.offsetWidth, "px"), r.style.height = "".concat(e.offsetHeight, "px"), r.style.top = "".concat(e.offsetTop, "px"), r.style.left = "".concat(e.offsetLeft, "px"), r.style.zIndex = "9999999", r;
        }

        function l(e, t) {
          e.removeEventListener("transitionend", l), t();
        }

        function c(e, t) {
          return new Promise(function (n) {
            e.addEventListener("transitionend", function (t) {
              return l(e, n);
            }, !1), e.style.transform = "translateY(".concat(t, "px)");
          });
        }

        var u = function u(e, t) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
          var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "ease-in-out";
          if (null != e && null != t) return new Promise(function (o) {
            !function (e, t, n, r) {
              [e, t].forEach(function (e) {
                e.classList.add("swapped"), e.style.opacity = 0;
              }), function (e, t, n) {
                e.style.position = "relative", e.style.setProperty("--swap-duration", "".concat(t, "ms")), e.style.setProperty("--swap-timing-function", n);
              }(e.parentNode, n, r);
            }(e, t, n, r);

            var i = function (e, t) {
              var n = e.getBoundingClientRect(),
                  r = t.getBoundingClientRect();
              return Math.hypot(n.left - r.left, n.top - r.top);
            }(e, t);

            var s, l;
            "down" === function (e, t) {
              return e.offsetTop < t.offsetTop ? "down" : "up";
            }(e, t) ? (s = i + t.offsetHeight - e.offsetHeight, l = -i) : (s = -i, l = i + e.offsetHeight - t.offsetHeight);
            var u = a(e),
                d = a(t),
                h = c(u, s),
                f = c(d, l);
            Promise.all([h, f]).then(function () {
              !function (e, t, n, r) {
                e.parentNode.insertBefore(e, r), e.parentNode.insertBefore(n, t), r.remove(), t.remove(), [e, n].forEach(function (e) {
                  e.classList.remove("swapped"), e.style.opacity = 1;
                });
              }(e, u, t, d), o();
            });
          });
        };

        function d(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function h(e, t) {
          return h = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, h(e, t);
        }

        function f(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return p(e);
        }

        function p(e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }

        function g(e) {
          return g = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, g(e);
        }

        var m = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && h(e, t);
          }(c, e);
          var t,
              n,
              r,
              a,
              l = (r = c, a = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = g(r);

            if (a) {
              var n = g(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return f(this, e);
          });

          function c() {
            var t, n, r, o;

            for (var _len16 = arguments.length, e = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
              e[_key16] = arguments[_key16];
            }

            return function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, c), o = ".Apparatus-Blocks-Editor", (r = "editorSelector") in (n = p(t = l.call.apply(l, [this].concat(e)))) ? Object.defineProperty(n, r, {
              value: o,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : n[r] = o, t;
          }

          return t = c, (n = [{
            key: "connect",
            value: function value() {
              (0, i.J)(this), (0, o.I0)(this, {
                element: this.element.parentElement,
                eventPrefix: "apparatus:block"
              });
            }
          }, {
            key: "onSuccess",
            value: function value(e) {
              var _this56 = this;

              this.parseRemoteResponse(e, function (e) {
                return _this56._update(e);
              });
            }
          }, {
            key: "onError",
            value: function value(e) {
              var _this57 = this;

              var _e$detail = _slicedToArray(e.detail, 3),
                  t = _e$detail[0],
                  n = _e$detail[1],
                  r = _e$detail[2];

              422 == r.status ? this.parseRemoteResponse(e, function (e) {
                _this57._update(e);
              }) : console.warn("Something went wrong!", e);
            }
          }, {
            key: "destroy",
            value: function value() {
              var _this58 = this;

              var e = this.composer;
              (0, s.C)(e).then(function () {
                return e.remove();
              }), (0, s.C)(this.element).then(function () {
                _this58.element.remove(), _this58.dispatch("destroy");
              });
            }
          }, {
            key: "moveUp",
            value: function value() {
              var _this59 = this;

              this.previousEditor && u(this.element, this.previousEditor).then(function () {
                return _this59.dispatch("move", {
                  block: _this59.element,
                  direction: "up"
                });
              });
            }
          }, {
            key: "moveDown",
            value: function value() {
              var _this60 = this;

              this.nextEditor && u(this.element, this.nextEditor).then(function () {
                return _this60.dispatch("move", {
                  block: _this60.element,
                  direction: "down"
                });
              });
            }
          }, {
            key: "_update",
            value: function value(e) {
              this.element.replaceWith(e), this.dispatch("update");
            }
          }, {
            key: "composer",
            get: function get() {
              return this.element.previousElementSibling;
            }
          }, {
            key: "previousEditor",
            get: function get() {
              return function (e, t) {
                var n = e.previousElementSibling;
                if (!t) return n;

                for (; n;) {
                  if (n.matches(t)) return n;
                  n = n.previousElementSibling;
                }
              }(this.element, this.editorSelector);
            }
          }, {
            key: "nextEditor",
            get: function get() {
              return function (e, t) {
                var n = e.nextElementSibling;
                if (!t) return n;

                for (; n;) {
                  if (n.matches(t)) return n;
                  n = n.nextElementSibling;
                }
              }(this.element, this.editorSelector);
            }
          }]) && d(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), c;
        }(r.Qr);
      },
      7823: function _(e, t, n) {
        "use strict";

        function r(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function o(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function i(e, t) {
          return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, i(e, t);
        }

        function s(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function a(e) {
          return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, a(e);
        }

        n.r(t), n.d(t, {
          default: function _default() {
            return l;
          }
        });

        var l = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && i(e, t);
          }(d, e);
          var t,
              n,
              l,
              c,
              u = (l = d, c = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = a(l);

            if (c) {
              var n = a(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return s(this, e);
          });

          function d() {
            return r(this, d), u.apply(this, arguments);
          }

          return t = d, (n = [{
            key: "addFrame",
            value: function value() {
              if (this.turboFrame) return;
              var e = document.createElement("turbo-frame");
              e.id = "dialog", document.body.appendChild(e);
            }
          }, {
            key: "removeFrame",
            value: function value() {
              this.turboFrame && this.turboFrame.parentNode.removeChild(this.turboFrame);
            }
          }, {
            key: "turboFrame",
            get: function get() {
              return document.getElementById("dialog");
            }
          }]) && o(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), d;
        }(n(6599).Qr);
      },
      2365: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return d;
          }
        });
        var r = n(6599),
            o = n(9404);

        function i(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function s(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function a(e, t) {
          return a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, a(e, t);
        }

        function l(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function c(e) {
          return c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, c(e);
        }

        function u(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }

        var d = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && a(e, t);
          }(h, e);
          var t,
              n,
              r,
              u,
              d = (r = h, u = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = c(r);

            if (u) {
              var n = c(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return l(this, e);
          });

          function h() {
            return i(this, h), d.apply(this, arguments);
          }

          return t = h, (n = [{
            key: "connect",
            value: function value() {
              this.startRefreshing();
            }
          }, {
            key: "disconnect",
            value: function value() {
              this.stopRefreshing();
            }
          }, {
            key: "startRefreshing",
            value: function value() {
              var _this61 = this;

              this.refreshTimer = setInterval(function () {
                _this61.touch();
              }, 5e3);
            }
          }, {
            key: "stopRefreshing",
            value: function value() {
              this.refreshTimer && clearInterval(this.refreshTimer);
            }
          }, {
            key: "touch",
            value: function value() {
              (0, o.r$)(this.touchPathValue);
            }
          }, {
            key: "leavingPage",
            value: function value(e) {
              this.hasEditingBlocks && ("turbo:before-visit" == e.type ? window.confirm("There are unsaved changes, they will be lost if you leave the page.") || e.preventDefault() : this._isCancelEvent(e) || (e.preventDefault(), e.returnValue = ""));
            }
          }, {
            key: "appendBlockComposer",
            value: function value(e) {
              var t = this.blockComposerTemplateTarget.content.cloneNode(!0);
              e.target.nextSibling.after(t);
            }
          }, {
            key: "updateBlockPositions",
            value: function value() {
              this.blockIds && this.hasUpdateBlockPositionsPathValue && fetch(this.updateBlockPositionsPathValue, {
                method: "post",
                body: JSON.stringify({
                  blocks: this.blockIds
                }),
                headers: {
                  "Content-Type": "application/json",
                  "X-CSRF-Token": this.csrfToken
                },
                credentials: "same-origin"
              });
            }
          }, {
            key: "_isCancelEvent",
            value: function value(e) {
              return e.srcElement.activeElement.classList.contains("cancel_page_edit");
            }
          }, {
            key: "blockIds",
            get: function get() {
              return this.blockEditorTargets.map(function (e) {
                return e.dataset.blockId;
              });
            }
          }, {
            key: "hasEditingBlocks",
            get: function get() {
              var _this62 = this;

              return this.blockEditorTargets.some(function (e) {
                return e.classList.contains(_this62.data.get("blockEditorFormClass"));
              });
            }
          }, {
            key: "csrfToken",
            get: function get() {
              if (document.querySelector("meta[name='csrf-token']")) return document.querySelector("meta[name='csrf-token']").content;
            }
          }]) && s(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), h;
        }(r.Qr);

        u(d, "targets", ["blockEditor", "blockComposerTemplate"]), u(d, "values", {
          touchPath: String,
          updateBlockPositionsPath: String
        });
      },
      2359: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return d;
          }
        });
        var r = n(6599),
            o = n(7545),
            i = n(1421);

        function s(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function a(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function l(e, t) {
          return l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, l(e, t);
        }

        function c(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function u(e) {
          return u = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, u(e);
        }

        var d = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && l(e, t);
          }(f, e);
          var t,
              n,
              r,
              d,
              h = (r = f, d = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = u(r);

            if (d) {
              var n = u(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return c(this, e);
          });

          function f() {
            return s(this, f), h.apply(this, arguments);
          }

          return t = f, (n = [{
            key: "connect",
            value: function value() {
              (0, i.J)(this), (0, o.I0)(this, {
                eventPrefix: "apparatus:block"
              });
            }
          }, {
            key: "close",
            value: function value() {
              this.open = !1;
            }
          }, {
            key: "addBlock",
            value: function value(e) {
              var _this63 = this;

              this.parseRemoteResponse(e, function (e) {
                _this63.element.after(e), _this63.dispatch("create");
              });
            }
          }, {
            key: "open",
            get: function get() {
              return this.element.open;
            },
            set: function set(e) {
              this.element.open = e;
            }
          }]) && a(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), f;
        }(r.Qr);
      },
      6963: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return f;
          }
        });
        var r = n(6599),
            o = n(1421),
            i = n(8535),
            s = n.n(i);

        function a(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function l(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function c(e, t) {
          return c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, c(e, t);
        }

        function u(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function d(e) {
          return d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, d(e);
        }

        function h(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }

        var f = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && c(e, t);
          }(f, e);
          var t,
              n,
              r,
              i,
              h = (r = f, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = d(r);

            if (i) {
              var n = d(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return u(this, e);
          });

          function f() {
            return a(this, f), h.apply(this, arguments);
          }

          return t = f, (n = [{
            key: "initialize",
            value: function value() {
              this.loading = !1, (0, o.J)(this);
            }
          }, {
            key: "connect",
            value: function value() {
              var _this64 = this;

              this.hasPaginationTarget && (this.intersectionObserver = new IntersectionObserver(function (e, t) {
                e.forEach(function (e) {
                  e.intersectionRatio > 0 && _this64.loadMore();
                });
              }, {
                root: this.scrollable,
                rootMargin: "0px",
                threshold: 1
              }), this.intersectionObserver.observe(this.paginationTarget));
            }
          }, {
            key: "loadMore",
            value: function value() {
              var _this65 = this;

              this.loading || this.nextPageUrl && (this.loading = !0, s().ajax({
                type: "GET",
                url: this.nextPageUrl,
                success: function success(e) {
                  var t = e.querySelector("[data-apparatus--infinite-scroll-target='content']"),
                      n = e.querySelector("[data-apparatus--infinite-scroll-target='pagination']");
                  _this65.contentTarget.insertAdjacentHTML("beforeend", t.innerHTML), _this65.paginationTarget.innerHTML = n.innerHTML, _this65.loading = !1;
                }
              }));
            }
          }, {
            key: "nextPageUrl",
            get: function get() {
              if (this.nextPageLink) return this.nextPageLink.href;
            }
          }, {
            key: "nextPageLink",
            get: function get() {
              return this.paginationTarget.querySelector("a[rel='next']");
            }
          }, {
            key: "scrollable",
            get: function get() {
              if (this.hasScrollableSelectorValue) return document.querySelector(this.scrollableSelectorValue);
            }
          }]) && l(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), f;
        }(r.Qr);

        h(f, "targets", ["content", "pagination"]), h(f, "values", {
          scrollableSelector: String
        });
      },
      4929: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return h;
          }
        });
        var r = n(6599),
            o = n(7545),
            i = n(8535),
            s = n.n(i);

        function a(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function l(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function c(e, t) {
          return c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, c(e, t);
        }

        function u(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function d(e) {
          return d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, d(e);
        }

        var h = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && c(e, t);
          }(f, e);
          var t,
              n,
              r,
              i,
              h = (r = f, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = d(r);

            if (i) {
              var n = d(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return u(this, e);
          });

          function f() {
            return a(this, f), h.apply(this, arguments);
          }

          return t = f, (n = [{
            key: "connect",
            value: function value() {
              (0, o.I0)(this, {
                eventPrefix: "apparatus:page"
              });
            }
          }, {
            key: "submit",
            value: function value() {
              s().fire(this.formTarget, "submit");
            }
          }, {
            key: "toggled",
            value: function value() {
              this.dispatch(this.visibility);
            }
          }, {
            key: "visibility",
            get: function get() {
              return this.private ? "private" : "public";
            }
          }, {
            key: "private",
            get: function get() {
              return "private" === this.data.get("onState") && this.checkboxTarget.checked;
            }
          }, {
            key: "public",
            get: function get() {
              return "public" === this.data.get("onState") && this.checkboxTarget.checked;
            }
          }]) && l(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), f;
        }(r.Qr);

        var f, p, g;
        g = ["form", "checkbox"], (p = "targets") in (f = h) ? Object.defineProperty(f, p, {
          value: g,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : f[p] = g;
      },
      7142: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return O;
          }
        });
        var r,
            o = n(6599),
            i = n(8535),
            s = n.n(i),
            a = "undefined" == typeof document ? void 0 : document,
            l = !!a && "content" in a.createElement("template"),
            c = !!a && a.createRange && "createContextualFragment" in a.createRange();

        function u(e, t) {
          var n,
              r,
              o = e.nodeName,
              i = t.nodeName;
          return o === i || (n = o.charCodeAt(0), r = i.charCodeAt(0), n <= 90 && r >= 97 ? o === i.toUpperCase() : r <= 90 && n >= 97 && i === o.toUpperCase());
        }

        function d(e, t, n) {
          e[n] !== t[n] && (e[n] = t[n], e[n] ? e.setAttribute(n, "") : e.removeAttribute(n));
        }

        var h = {
          OPTION: function OPTION(e, t) {
            var n = e.parentNode;

            if (n) {
              var r = n.nodeName.toUpperCase();
              "OPTGROUP" === r && (r = (n = n.parentNode) && n.nodeName.toUpperCase()), "SELECT" !== r || n.hasAttribute("multiple") || (e.hasAttribute("selected") && !t.selected && (e.setAttribute("selected", "selected"), e.removeAttribute("selected")), n.selectedIndex = -1);
            }

            d(e, t, "selected");
          },
          INPUT: function INPUT(e, t) {
            d(e, t, "checked"), d(e, t, "disabled"), e.value !== t.value && (e.value = t.value), t.hasAttribute("value") || e.removeAttribute("value");
          },
          TEXTAREA: function TEXTAREA(e, t) {
            var n = t.value;
            e.value !== n && (e.value = n);
            var r = e.firstChild;

            if (r) {
              var o = r.nodeValue;
              if (o == n || !n && o == e.placeholder) return;
              r.nodeValue = n;
            }
          },
          SELECT: function SELECT(e, t) {
            if (!t.hasAttribute("multiple")) {
              for (var n, r, o = -1, i = 0, s = e.firstChild; s;) {
                if ("OPTGROUP" === (r = s.nodeName && s.nodeName.toUpperCase())) s = (n = s).firstChild;else {
                  if ("OPTION" === r) {
                    if (s.hasAttribute("selected")) {
                      o = i;
                      break;
                    }

                    i++;
                  }

                  !(s = s.nextSibling) && n && (s = n.nextSibling, n = null);
                }
              }

              e.selectedIndex = o;
            }
          }
        };

        function f() {}

        function p(e) {
          if (e) return e.getAttribute && e.getAttribute("id") || e.id;
        }

        var g = function g(e, t, n) {
          if (n || (n = {}), "string" == typeof t) if ("#document" === e.nodeName || "HTML" === e.nodeName || "BODY" === e.nodeName) {
            var o = t;
            (t = a.createElement("html")).innerHTML = o;
          } else i = (i = t).trim(), t = l ? function (e) {
            var t = a.createElement("template");
            return t.innerHTML = e, t.content.childNodes[0];
          }(i) : c ? function (e) {
            return r || (r = a.createRange()).selectNode(a.body), r.createContextualFragment(e).childNodes[0];
          }(i) : function (e) {
            var t = a.createElement("body");
            return t.innerHTML = e, t.childNodes[0];
          }(i);
          var i,
              s = n.getNodeKey || p,
              d = n.onBeforeNodeAdded || f,
              g = n.onNodeAdded || f,
              m = n.onBeforeElUpdated || f,
              v = n.onElUpdated || f,
              y = n.onBeforeNodeDiscarded || f,
              b = n.onNodeDiscarded || f,
              w = n.onBeforeElChildrenUpdated || f,
              O = !0 === n.childrenOnly,
              E = Object.create(null),
              _ = [];

          function S(e) {
            _.push(e);
          }

          function x(e, t) {
            if (1 === e.nodeType) for (var n = e.firstChild; n;) {
              var r = void 0;
              t && (r = s(n)) ? S(r) : (b(n), n.firstChild && x(n, t)), n = n.nextSibling;
            }
          }

          function C(e, t, n) {
            !1 !== y(e) && (t && t.removeChild(e), b(e), x(e, n));
          }

          function k(e) {
            g(e);

            for (var t = e.firstChild; t;) {
              var n = t.nextSibling,
                  r = s(t);

              if (r) {
                var o = E[r];
                o && u(t, o) ? (t.parentNode.replaceChild(o, t), P(o, t)) : k(t);
              } else k(t);

              t = n;
            }
          }

          function P(e, t, n) {
            var r = s(t);

            if (r && delete E[r], !n) {
              if (!1 === m(e, t)) return;
              if (function (e, t) {
                var n,
                    r,
                    o,
                    i,
                    s = t.attributes;

                if (11 !== t.nodeType && 11 !== e.nodeType) {
                  for (var a = s.length - 1; a >= 0; a--) {
                    r = (n = s[a]).name, o = n.namespaceURI, i = n.value, o ? (r = n.localName || r, e.getAttributeNS(o, r) !== i && ("xmlns" === n.prefix && (r = n.name), e.setAttributeNS(o, r, i))) : e.getAttribute(r) !== i && e.setAttribute(r, i);
                  }

                  for (var l = e.attributes, c = l.length - 1; c >= 0; c--) {
                    r = (n = l[c]).name, (o = n.namespaceURI) ? (r = n.localName || r, t.hasAttributeNS(o, r) || e.removeAttributeNS(o, r)) : t.hasAttribute(r) || e.removeAttribute(r);
                  }
                }
              }(e, t), v(e), !1 === w(e, t)) return;
            }

            "TEXTAREA" !== e.nodeName ? function (e, t) {
              var n,
                  r,
                  o,
                  i,
                  l,
                  c = t.firstChild,
                  f = e.firstChild;

              e: for (; c;) {
                for (i = c.nextSibling, n = s(c); f;) {
                  if (o = f.nextSibling, c.isSameNode && c.isSameNode(f)) {
                    c = i, f = o;
                    continue e;
                  }

                  r = s(f);
                  var p = f.nodeType,
                      g = void 0;

                  if (p === c.nodeType && (1 === p ? (n ? n !== r && ((l = E[n]) ? o === l ? g = !1 : (e.insertBefore(l, f), r ? S(r) : C(f, e, !0), f = l) : g = !1) : r && (g = !1), (g = !1 !== g && u(f, c)) && P(f, c)) : 3 !== p && 8 != p || (g = !0, f.nodeValue !== c.nodeValue && (f.nodeValue = c.nodeValue))), g) {
                    c = i, f = o;
                    continue e;
                  }

                  r ? S(r) : C(f, e, !0), f = o;
                }

                if (n && (l = E[n]) && u(l, c)) e.appendChild(l), P(l, c);else {
                  var m = d(c);
                  !1 !== m && (m && (c = m), c.actualize && (c = c.actualize(e.ownerDocument || a)), e.appendChild(c), k(c));
                }
                c = i, f = o;
              }

              !function (e, t, n) {
                for (; t;) {
                  var r = t.nextSibling;
                  (n = s(t)) ? S(n) : C(t, e, !0), t = r;
                }
              }(e, f, r);
              var v = h[e.nodeName];
              v && v(e, t);
            }(e, t) : h.TEXTAREA(e, t);
          }

          !function e(t) {
            if (1 === t.nodeType || 11 === t.nodeType) for (var n = t.firstChild; n;) {
              var r = s(n);
              r && (E[r] = n), e(n), n = n.nextSibling;
            }
          }(e);
          var j,
              T,
              D = e,
              M = D.nodeType,
              A = t.nodeType;
          if (!O) if (1 === M) 1 === A ? u(e, t) || (b(e), D = function (e, t) {
            for (var n = e.firstChild; n;) {
              var r = n.nextSibling;
              t.appendChild(n), n = r;
            }

            return t;
          }(e, (j = t.nodeName, (T = t.namespaceURI) && "http://www.w3.org/1999/xhtml" !== T ? a.createElementNS(T, j) : a.createElement(j)))) : D = t;else if (3 === M || 8 === M) {
            if (A === M) return D.nodeValue !== t.nodeValue && (D.nodeValue = t.nodeValue), D;
            D = t;
          }
          if (D === t) b(e);else {
            if (t.isSameNode && t.isSameNode(D)) return;
            if (P(D, t, O), _) for (var F = 0, L = _.length; F < L; F++) {
              var I = E[_[F]];
              I && C(I, I.parentNode, !1);
            }
          }
          return !O && D !== e && e.parentNode && (D.actualize && (D = D.actualize(e.ownerDocument || a)), e.parentNode.replaceChild(D, e)), D;
        };

        function m(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function v(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function y(e, t) {
          return y = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, y(e, t);
        }

        function b(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function w(e) {
          return w = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, w(e);
        }

        var O = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && y(e, t);
          }(a, e);
          var t,
              n,
              r,
              o,
              i = (r = a, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = w(r);

            if (o) {
              var n = w(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return b(this, e);
          });

          function a() {
            return m(this, a), i.apply(this, arguments);
          }

          return t = a, (n = [{
            key: "refresh",
            value: function value() {
              var _this66 = this;

              s().ajax({
                type: "GET",
                dataType: "html",
                url: this.url,
                success: function success(e) {
                  _this66._update(e.body.firstChild.innerHTML);
                }
              });
            }
          }, {
            key: "url",
            get: function get() {
              return this.data.get("url");
            }
          }, {
            key: "_update",
            value: function value(e) {
              g(this.element, e, {
                onBeforeElUpdated: function onBeforeElUpdated(e, t) {
                  return !e.isEqualNode(t);
                }
              });
            }
          }]) && v(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), a;
        }(o.Qr);
      },
      8307: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return N;
          }
        });
        var r = n(6599),
            o = n(7545),
            i = window.CustomEvent;

        function s(e, t) {
          var n = "on" + t.type.toLowerCase();
          return "function" == typeof e[n] && e[n](t), e.dispatchEvent(t);
        }

        function a(e) {
          for (; e;) {
            if ("dialog" === e.localName) return e;
            e = e.parentElement ? e.parentElement : e.parentNode ? e.parentNode.host : null;
          }

          return null;
        }

        function l(e) {
          for (; e && e.shadowRoot && e.shadowRoot.activeElement;) {
            e = e.shadowRoot.activeElement;
          }

          e && e.blur && e !== document.body && e.blur();
        }

        function c(e, t) {
          for (var n = 0; n < e.length; ++n) {
            if (e[n] === t) return !0;
          }

          return !1;
        }

        function u(e) {
          return !(!e || !e.hasAttribute("method")) && "dialog" === e.getAttribute("method").toLowerCase();
        }

        function d(e) {
          var t = ["button", "input", "keygen", "select", "textarea"].map(function (e) {
            return e + ":not([disabled])";
          });
          t.push('[tabindex]:not([disabled]):not([tabindex=""])');
          var n = e.querySelector(t.join(", "));
          if (!n && "attachShadow" in Element.prototype) for (var r = e.querySelectorAll("*"), o = 0; o < r.length && !(r[o].tagName && r[o].shadowRoot && (n = d(r[o].shadowRoot))); o++) {
            ;
          }
          return n;
        }

        function h(e) {
          return e.isConnected || document.body.contains(e);
        }

        function f(e) {
          if (e.submitter) return e.submitter;
          var t = e.target;
          if (!(t instanceof HTMLFormElement)) return null;
          var n = m.formSubmitter;

          if (!n) {
            var r = e.target;
            n = ("getRootNode" in r && r.getRootNode() || document).activeElement;
          }

          return n && n.form === t ? n : null;
        }

        function p(e) {
          if (!e.defaultPrevented) {
            var t = e.target,
                n = m.imagemapUseValue,
                r = f(e);
            null === n && r && (n = r.value);
            var o = a(t);
            o && "dialog" === (r && r.getAttribute("formmethod") || t.getAttribute("method")) && (e.preventDefault(), null != n ? o.close(n) : o.close());
          }
        }

        function g(e) {
          if (this.dialog_ = e, this.replacedStyleTop_ = !1, this.openAsModal_ = !1, e.hasAttribute("role") || e.setAttribute("role", "dialog"), e.show = this.show.bind(this), e.showModal = this.showModal.bind(this), e.close = this.close.bind(this), e.addEventListener("submit", p, !1), "returnValue" in e || (e.returnValue = ""), "MutationObserver" in window) new MutationObserver(this.maybeHideModal.bind(this)).observe(e, {
            attributes: !0,
            attributeFilter: ["open"]
          });else {
            var t,
                n = !1,
                r = function () {
              n ? this.downgradeModal() : this.maybeHideModal(), n = !1;
            }.bind(this),
                o = function o(_o9) {
              if (_o9.target === e) {
                var i = "DOMNodeRemoved";
                n |= _o9.type.substr(0, i.length) === i, window.clearTimeout(t), t = window.setTimeout(r, 0);
              }
            };

            ["DOMAttrModified", "DOMNodeRemoved", "DOMNodeRemovedFromDocument"].forEach(function (t) {
              e.addEventListener(t, o);
            });
          }
          Object.defineProperty(e, "open", {
            set: this.setOpen.bind(this),
            get: e.hasAttribute.bind(e, "open")
          }), this.backdrop_ = document.createElement("div"), this.backdrop_.className = "backdrop", this.backdrop_.addEventListener("mouseup", this.backdropMouseEvent_.bind(this)), this.backdrop_.addEventListener("mousedown", this.backdropMouseEvent_.bind(this)), this.backdrop_.addEventListener("click", this.backdropMouseEvent_.bind(this));
        }

        i && "object" != _typeof(i) || ((i = function i(e, t) {
          t = t || {};
          var n = document.createEvent("CustomEvent");
          return n.initCustomEvent(e, !!t.bubbles, !!t.cancelable, t.detail || null), n;
        }).prototype = window.Event.prototype), g.prototype = {
          get dialog() {
            return this.dialog_;
          },

          maybeHideModal: function maybeHideModal() {
            this.dialog_.hasAttribute("open") && h(this.dialog_) || this.downgradeModal();
          },
          downgradeModal: function downgradeModal() {
            this.openAsModal_ && (this.openAsModal_ = !1, this.dialog_.style.zIndex = "", this.replacedStyleTop_ && (this.dialog_.style.top = "", this.replacedStyleTop_ = !1), this.backdrop_.parentNode && this.backdrop_.parentNode.removeChild(this.backdrop_), m.dm.removeDialog(this));
          },
          setOpen: function setOpen(e) {
            e ? this.dialog_.hasAttribute("open") || this.dialog_.setAttribute("open", "") : (this.dialog_.removeAttribute("open"), this.maybeHideModal());
          },
          backdropMouseEvent_: function backdropMouseEvent_(e) {
            if (this.dialog_.hasAttribute("tabindex")) this.dialog_.focus();else {
              var t = document.createElement("div");
              this.dialog_.insertBefore(t, this.dialog_.firstChild), t.tabIndex = -1, t.focus(), this.dialog_.removeChild(t);
            }
            var n = document.createEvent("MouseEvents");
            n.initMouseEvent(e.type, e.bubbles, e.cancelable, window, e.detail, e.screenX, e.screenY, e.clientX, e.clientY, e.ctrlKey, e.altKey, e.shiftKey, e.metaKey, e.button, e.relatedTarget), this.dialog_.dispatchEvent(n), e.stopPropagation();
          },
          focus_: function focus_() {
            var e = this.dialog_.querySelector("[autofocus]:not([disabled])");
            !e && this.dialog_.tabIndex >= 0 && (e = this.dialog_), e || (e = d(this.dialog_)), l(document.activeElement), e && e.focus();
          },
          updateZIndex: function updateZIndex(e, t) {
            if (e < t) throw new Error("dialogZ should never be < backdropZ");
            this.dialog_.style.zIndex = e, this.backdrop_.style.zIndex = t;
          },
          show: function show() {
            this.dialog_.open || (this.setOpen(!0), this.focus_());
          },
          showModal: function showModal() {
            if (this.dialog_.hasAttribute("open")) throw new Error("Failed to execute 'showModal' on dialog: The element is already open, and therefore cannot be opened modally.");
            if (!h(this.dialog_)) throw new Error("Failed to execute 'showModal' on dialog: The element is not in a Document.");
            if (!m.dm.pushDialog(this)) throw new Error("Failed to execute 'showModal' on dialog: There are too many open modal dialogs.");
            (function (e) {
              for (; e && e !== document.body;) {
                var t = window.getComputedStyle(e),
                    n = function n(e, _n15) {
                  return !(void 0 === t[e] || t[e] === _n15);
                };

                if (t.opacity < 1 || n("zIndex", "auto") || n("transform", "none") || n("mixBlendMode", "normal") || n("filter", "none") || n("perspective", "none") || "isolate" === t.isolation || "fixed" === t.position || "touch" === t.webkitOverflowScrolling) return !0;
                e = e.parentElement;
              }

              return !1;
            })(this.dialog_.parentElement) && console.warn("A dialog is being shown inside a stacking context. This may cause it to be unusable. For more information, see this link: https://github.com/GoogleChrome/dialog-polyfill/#stacking-context"), this.setOpen(!0), this.openAsModal_ = !0, m.needsCentering(this.dialog_) ? (m.reposition(this.dialog_), this.replacedStyleTop_ = !0) : this.replacedStyleTop_ = !1, this.dialog_.parentNode.insertBefore(this.backdrop_, this.dialog_.nextSibling), this.focus_();
          },
          close: function close(e) {
            if (!this.dialog_.hasAttribute("open")) throw new Error("Failed to execute 'close' on dialog: The element does not have an 'open' attribute, and therefore cannot be closed.");
            this.setOpen(!1), void 0 !== e && (this.dialog_.returnValue = e);
            var t = new i("close", {
              bubbles: !1,
              cancelable: !1
            });
            s(this.dialog_, t);
          }
        };
        var m = {
          reposition: function reposition(e) {
            var t = document.body.scrollTop || document.documentElement.scrollTop,
                n = t + (window.innerHeight - e.offsetHeight) / 2;
            e.style.top = Math.max(t, n) + "px";
          },
          isInlinePositionSetByStylesheet: function isInlinePositionSetByStylesheet(e) {
            for (var t = 0; t < document.styleSheets.length; ++t) {
              var n = document.styleSheets[t],
                  r = null;

              try {
                r = n.cssRules;
              } catch (e) {}

              if (r) for (var o = 0; o < r.length; ++o) {
                var i = r[o],
                    s = null;

                try {
                  s = document.querySelectorAll(i.selectorText);
                } catch (e) {}

                if (s && c(s, e)) {
                  var a = i.style.getPropertyValue("top"),
                      l = i.style.getPropertyValue("bottom");
                  if (a && "auto" !== a || l && "auto" !== l) return !0;
                }
              }
            }

            return !1;
          },
          needsCentering: function needsCentering(e) {
            return !("absolute" !== window.getComputedStyle(e).position || "auto" !== e.style.top && "" !== e.style.top || "auto" !== e.style.bottom && "" !== e.style.bottom || m.isInlinePositionSetByStylesheet(e));
          },
          forceRegisterDialog: function forceRegisterDialog(e) {
            if ((window.HTMLDialogElement || e.showModal) && console.warn("This browser already supports <dialog>, the polyfill may not work correctly", e), "dialog" !== e.localName) throw new Error("Failed to register dialog: The element is not a dialog.");
            new g(e);
          },
          registerDialog: function registerDialog(e) {
            e.showModal || m.forceRegisterDialog(e);
          },
          DialogManager: function DialogManager() {
            this.pendingDialogStack = [];
            var e = this.checkDOM_.bind(this);
            this.overlay = document.createElement("div"), this.overlay.className = "_dialog_overlay", this.overlay.addEventListener("click", function (t) {
              this.forwardTab_ = void 0, t.stopPropagation(), e([]);
            }.bind(this)), this.handleKey_ = this.handleKey_.bind(this), this.handleFocus_ = this.handleFocus_.bind(this), this.zIndexLow_ = 1e5, this.zIndexHigh_ = 100150, this.forwardTab_ = void 0, "MutationObserver" in window && (this.mo_ = new MutationObserver(function (t) {
              var n = [];
              t.forEach(function (e) {
                for (var t, r = 0; t = e.removedNodes[r]; ++r) {
                  t instanceof Element && ("dialog" === t.localName && n.push(t), n = n.concat(t.querySelectorAll("dialog")));
                }
              }), n.length && e(n);
            }));
          }
        };

        if (m.DialogManager.prototype.blockDocument = function () {
          document.documentElement.addEventListener("focus", this.handleFocus_, !0), document.addEventListener("keydown", this.handleKey_), this.mo_ && this.mo_.observe(document, {
            childList: !0,
            subtree: !0
          });
        }, m.DialogManager.prototype.unblockDocument = function () {
          document.documentElement.removeEventListener("focus", this.handleFocus_, !0), document.removeEventListener("keydown", this.handleKey_), this.mo_ && this.mo_.disconnect();
        }, m.DialogManager.prototype.updateStacking = function () {
          for (var e, t = this.zIndexHigh_, n = 0; e = this.pendingDialogStack[n]; ++n) {
            e.updateZIndex(--t, --t), 0 === n && (this.overlay.style.zIndex = --t);
          }

          var r = this.pendingDialogStack[0];
          r ? (r.dialog.parentNode || document.body).appendChild(this.overlay) : this.overlay.parentNode && this.overlay.parentNode.removeChild(this.overlay);
        }, m.DialogManager.prototype.containedByTopDialog_ = function (e) {
          for (; e = a(e);) {
            for (var t, n = 0; t = this.pendingDialogStack[n]; ++n) {
              if (t.dialog === e) return 0 === n;
            }

            e = e.parentElement;
          }

          return !1;
        }, m.DialogManager.prototype.handleFocus_ = function (e) {
          var t = e.composedPath ? e.composedPath()[0] : e.target;

          if (!this.containedByTopDialog_(t) && document.activeElement !== document.documentElement && (e.preventDefault(), e.stopPropagation(), l(t), void 0 !== this.forwardTab_)) {
            var n = this.pendingDialogStack[0];
            return n.dialog.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_PRECEDING && (this.forwardTab_ ? n.focus_() : t !== document.documentElement && document.documentElement.focus()), !1;
          }
        }, m.DialogManager.prototype.handleKey_ = function (e) {
          if (this.forwardTab_ = void 0, 27 === e.keyCode) {
            e.preventDefault(), e.stopPropagation();
            var t = new i("cancel", {
              bubbles: !1,
              cancelable: !0
            }),
                n = this.pendingDialogStack[0];
            n && s(n.dialog, t) && n.dialog.close();
          } else 9 === e.keyCode && (this.forwardTab_ = !e.shiftKey);
        }, m.DialogManager.prototype.checkDOM_ = function (e) {
          this.pendingDialogStack.slice().forEach(function (t) {
            -1 !== e.indexOf(t.dialog) ? t.downgradeModal() : t.maybeHideModal();
          });
        }, m.DialogManager.prototype.pushDialog = function (e) {
          var t = (this.zIndexHigh_ - this.zIndexLow_) / 2 - 1;
          return !(this.pendingDialogStack.length >= t || (1 === this.pendingDialogStack.unshift(e) && this.blockDocument(), this.updateStacking(), 0));
        }, m.DialogManager.prototype.removeDialog = function (e) {
          var t = this.pendingDialogStack.indexOf(e);
          -1 !== t && (this.pendingDialogStack.splice(t, 1), 0 === this.pendingDialogStack.length && this.unblockDocument(), this.updateStacking());
        }, m.dm = new m.DialogManager(), m.formSubmitter = null, m.imagemapUseValue = null, void 0 === window.HTMLDialogElement) {
          var v = document.createElement("form");

          if (v.setAttribute("method", "dialog"), "dialog" !== v.method) {
            var y = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, "method");

            if (y) {
              var b = y.get;

              y.get = function () {
                return u(this) ? "dialog" : b.call(this);
              };

              var w = y.set;
              y.set = function (e) {
                return "string" == typeof e && "dialog" === e.toLowerCase() ? this.setAttribute("method", e) : w.call(this, e);
              }, Object.defineProperty(HTMLFormElement.prototype, "method", y);
            }
          }

          document.addEventListener("click", function (e) {
            if (m.formSubmitter = null, m.imagemapUseValue = null, !e.defaultPrevented) {
              var t = e.target;

              if ("composedPath" in e && (t = e.composedPath().shift() || t), t && u(t.form)) {
                if (!("submit" === t.type && ["button", "input"].indexOf(t.localName) > -1)) {
                  if ("input" !== t.localName || "image" !== t.type) return;
                  m.imagemapUseValue = e.offsetX + "," + e.offsetY;
                }

                a(t) && (m.formSubmitter = t);
              }
            }
          }, !1), document.addEventListener("submit", function (e) {
            var t = e.target;

            if (!a(t)) {
              var n = f(e);
              "dialog" === (n && n.getAttribute("formmethod") || t.getAttribute("method")) && e.preventDefault();
            }
          });
          var O = HTMLFormElement.prototype.submit;

          HTMLFormElement.prototype.submit = function () {
            if (!u(this)) return O.call(this);
            var e = a(this);
            e && e.close();
          };
        }

        var E = m,
            _ = !1;

        if ("undefined" != typeof window) {
          var S = {
            get passive() {
              _ = !0;
            }

          };
          window.addEventListener("testPassive", null, S), window.removeEventListener("testPassive", null, S);
        }

        var x = "undefined" != typeof window && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || "MacIntel" === window.navigator.platform && window.navigator.maxTouchPoints > 1),
            C = [],
            k = !1,
            P = -1,
            j = void 0,
            T = void 0,
            D = function D(e) {
          return C.some(function (t) {
            return !(!t.options.allowTouchMove || !t.options.allowTouchMove(e));
          });
        },
            M = function M(e) {
          var t = e || window.event;
          return !!D(t.target) || t.touches.length > 1 || (t.preventDefault && t.preventDefault(), !1);
        };

        function A(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function F(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function L(e, t) {
          return L = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, L(e, t);
        }

        function I(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function R(e) {
          return R = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, R(e);
        }

        var N = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && L(e, t);
          }(a, e);
          var t,
              n,
              r,
              i,
              s = (r = a, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = R(r);

            if (i) {
              var n = R(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return I(this, e);
          });

          function a() {
            return A(this, a), s.apply(this, arguments);
          }

          return t = a, (n = [{
            key: "connect",
            value: function value() {
              E.registerDialog(this.element), (0, o.I0)(this, {
                eventPrefix: "apparatus:dialog"
              }), (0, o.O8)(this), this.openValue && this.open();
            }
          }, {
            key: "open",
            value: function value() {
              this.element.showModal(), function (e, t) {
                if (e) {
                  if (!C.some(function (t) {
                    return t.targetElement === e;
                  })) {
                    var n = {
                      targetElement: e,
                      options: t || {}
                    };
                    C = [].concat(function (e) {
                      if (Array.isArray(e)) {
                        for (var t = 0, n = Array(e.length); t < e.length; t++) {
                          n[t] = e[t];
                        }

                        return n;
                      }

                      return Array.from(e);
                    }(C), [n]), x ? (e.ontouchstart = function (e) {
                      1 === e.targetTouches.length && (P = e.targetTouches[0].clientY);
                    }, e.ontouchmove = function (t) {
                      1 === t.targetTouches.length && function (e, t) {
                        var n = e.targetTouches[0].clientY - P;
                        !D(e.target) && (t && 0 === t.scrollTop && n > 0 || function (e) {
                          return !!e && e.scrollHeight - e.scrollTop <= e.clientHeight;
                        }(t) && n < 0 ? M(e) : e.stopPropagation());
                      }(t, e);
                    }, k || (document.addEventListener("touchmove", M, _ ? {
                      passive: !1
                    } : void 0), k = !0)) : function (e) {
                      if (void 0 === T) {
                        var t = !!e && !0 === e.reserveScrollBarGap,
                            n = window.innerWidth - document.documentElement.clientWidth;
                        t && n > 0 && (T = document.body.style.paddingRight, document.body.style.paddingRight = n + "px");
                      }

                      void 0 === j && (j = document.body.style.overflow, document.body.style.overflow = "hidden");
                    }(t);
                  }
                } else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
              }(this.element);
            }
          }, {
            key: "close",
            value: function value(e) {
              var t;
              e.preventDefault(), this.element.close(), (t = this.element) ? (C = C.filter(function (e) {
                return e.targetElement !== t;
              }), x ? (t.ontouchstart = null, t.ontouchmove = null, k && 0 === C.length && (document.removeEventListener("touchmove", M, _ ? {
                passive: !1
              } : void 0), k = !1)) : C.length || (void 0 !== T && (document.body.style.paddingRight = T, T = void 0), void 0 !== j && (document.body.style.overflow = j, j = void 0))) : console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices."), this.dispatch("close"), this.removeValue && this.remove();
            }
          }, {
            key: "onSubmitEnd",
            value: function value(e) {
              e.detail.success && (this.close(e), this.reloadPageValue && window.location.reload());
            }
          }, {
            key: "remove",
            value: function value() {
              this.element.parentNode.removeChild(this.element);
            }
          }]) && F(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), a;
        }(r.Qr);

        var B, $, H;
        B = N, $ = "values", H = {
          open: Boolean,
          remove: Boolean,
          reloadPage: Boolean
        }, $ in B ? Object.defineProperty(B, $, {
          value: H,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : B[$] = H;
      },
      53: function _(e, t, n) {
        "use strict";

        function r(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function o(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function i(e, t) {
          return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, i(e, t);
        }

        function s(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function a(e) {
          return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, a(e);
        }

        n.r(t), n.d(t, {
          default: function _default() {
            return l;
          }
        });

        var l = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && i(e, t);
          }(d, e);
          var t,
              n,
              l,
              c,
              u = (l = d, c = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = a(l);

            if (c) {
              var n = a(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return s(this, e);
          });

          function d() {
            return r(this, d), u.apply(this, arguments);
          }

          return t = d, (n = [{
            key: "open",
            value: function value() {
              this.element.open = !0;
            }
          }, {
            key: "close",
            value: function value() {
              this.element.open = !1;
            }
          }]) && o(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), d;
        }(n(6599).Qr);
      },
      5191: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return u;
          }
        });
        var r = n(6599),
            o = n(1668);

        function i(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function s(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function a(e, t) {
          return a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, a(e, t);
        }

        function l(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function c(e) {
          return c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, c(e);
        }

        var u = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && a(e, t);
          }(h, e);
          var t,
              n,
              r,
              u,
              d = (r = h, u = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = c(r);

            if (u) {
              var n = c(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return l(this, e);
          });

          function h() {
            return i(this, h), d.apply(this, arguments);
          }

          return t = h, (n = [{
            key: "close",
            value: function value() {
              var _this67 = this;

              (0, o.C)(this.element).then(function () {
                return _this67.element.remove();
              });
            }
          }]) && s(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), h;
        }(r.Qr);
      },
      2763: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return d;
          }
        });
        var r = n(6599),
            o = n(1421);

        function i(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function s(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function a(e, t) {
          return a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, a(e, t);
        }

        function l(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function c(e) {
          return c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, c(e);
        }

        function u(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }

        var d = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && a(e, t);
          }(h, e);
          var t,
              n,
              r,
              u,
              d = (r = h, u = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = c(r);

            if (u) {
              var n = c(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return l(this, e);
          });

          function h() {
            return i(this, h), d.apply(this, arguments);
          }

          return t = h, (n = [{
            key: "connect",
            value: function value() {
              (0, o.J)(this);
            }
          }, {
            key: "toggle",
            value: function value() {
              this.expandedValue = !this.expandedValue;
            }
          }, {
            key: "load",
            value: function value(e) {
              console.log(e), e.stopPropagation(), this.append(e), this.expandedValue = !0, this.loadedValue = !0;
            }
          }, {
            key: "loadedValueChanged",
            value: function value() {
              this.element.classList.toggle(this.loadedClass, this.loadedValue);
            }
          }, {
            key: "expandedValueChanged",
            value: function value() {
              this.expandedValue ? this.ariaExpanded = "true" : this.ariaExpanded = "false";
            }
          }, {
            key: "ariaExpanded",
            set: function set(e) {
              this.element.setAttribute("aria-expanded", e);
            }
          }]) && s(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), h;
        }(r.Qr);

        u(d, "values", {
          expanded: Boolean,
          loaded: Boolean
        }), u(d, "classes", ["loaded"]);
      },
      476: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return h;
          }
        });
        var r = n(6599),
            o = n(8535),
            i = n.n(o);

        function s(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function a(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function l(e, t) {
          return l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, l(e, t);
        }

        function c(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function u(e) {
          return u = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, u(e);
        }

        function d(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }

        var h = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && l(e, t);
          }(h, e);
          var t,
              n,
              r,
              o,
              d = (r = h, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = u(r);

            if (o) {
              var n = u(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return c(this, e);
          });

          function h() {
            return s(this, h), d.apply(this, arguments);
          }

          return t = h, (n = [{
            key: "connect",
            value: function value() {
              this.toggleHasQueryClass();
            }
          }, {
            key: "toggleHasQueryClass",
            value: function value() {
              this.element.classList.toggle(this.hasQueryClass, this.hasQuery);
            }
          }, {
            key: "clear",
            value: function value() {
              this.inputTarget.value = "", this.toggleHasQueryClass();
            }
          }, {
            key: "reset",
            value: function value() {
              this.clear(), i().fire(this.formTarget, "submit");
            }
          }, {
            key: "hasQuery",
            get: function get() {
              return "" != this.inputTarget.value;
            }
          }]) && a(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), h;
        }(r.Qr);

        d(h, "targets", ["form", "input", "resetButton"]), d(h, "classes", ["hasQuery"]);
      },
      5027: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return u;
          }
        });
        var r = n(6599),
            o = n(1668);

        function i(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function s(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function a(e, t) {
          return a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, a(e, t);
        }

        function l(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function c(e) {
          return c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, c(e);
        }

        var u = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && a(e, t);
          }(h, e);
          var t,
              n,
              r,
              u,
              d = (r = h, u = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = c(r);

            if (u) {
              var n = c(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return l(this, e);
          });

          function h() {
            return i(this, h), d.apply(this, arguments);
          }

          return t = h, (n = [{
            key: "close",
            value: function value() {
              var _this68 = this;

              (0, o.C)(this.element).then(function () {
                return _this68.element.remove();
              });
            }
          }]) && s(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), h;
        }(r.Qr);
      },
      7504: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return d;
          }
        });
        var r = n(6599),
            o = n(8535),
            i = n.n(o);

        function s(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function a(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function l(e, t) {
          return l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, l(e, t);
        }

        function c(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function u(e) {
          return u = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, u(e);
        }

        var d = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && l(e, t);
          }(h, e);
          var t,
              n,
              r,
              o,
              d = (r = h, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = u(r);

            if (o) {
              var n = u(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return c(this, e);
          });

          function h() {
            return s(this, h), d.apply(this, arguments);
          }

          return t = h, (n = [{
            key: "onDragenter",
            value: function value(e) {
              this.isFiltered || (e.preventDefault(), e.stopPropagation(), this.highlight());
            }
          }, {
            key: "onDragover",
            value: function value(e) {
              this.isFiltered || (e.preventDefault(), e.stopPropagation(), this.highlight());
            }
          }, {
            key: "onDragleave",
            value: function value(e) {
              this.isFiltered || (e.preventDefault(), e.stopPropagation(), this.unhighlight());
            }
          }, {
            key: "onDrop",
            value: function value(e) {
              if (this.isFiltered) return;
              e.preventDefault(), e.stopPropagation(), this.unhighlight();
              var t = e.dataTransfer.files;
              this.handleDroppedFiles(t);
            }
          }, {
            key: "highlight",
            value: function value() {
              this.element.classList.add(this.highlightClass);
            }
          }, {
            key: "unhighlight",
            value: function value() {
              this.element.classList.remove(this.highlightClass);
            }
          }, {
            key: "handleDroppedFiles",
            value: function value(e) {
              var _this69 = this;

              _toConsumableArray(e).forEach(function (e) {
                return _this69.handleDroppedFile(e);
              });
            }
          }, {
            key: "handleDroppedFile",
            value: function value(e) {
              var _this70 = this;

              var t = new FormData(this.uploadFormTarget);
              t.append("apparatus_attachment[file]", e), fetch(this.uploadFormTarget.action, {
                method: "post",
                body: t,
                headers: {
                  "X-CSRF-Token": i().csrfToken()
                },
                credentials: "same-origin"
              }).then(function (e) {
                return e.text();
              }).then(function (e) {
                return _this70.addAttachment(e);
              });
            }
          }, {
            key: "uploadFile",
            value: function value(e) {
              i().fire(e.target.form, "submit"), e.target.value = "";
            }
          }, {
            key: "onUploadAttachment",
            value: function value(e) {
              var _e$detail2 = _slicedToArray(e.detail, 3),
                  t = _e$detail2[0],
                  n = _e$detail2[1],
                  r = _e$detail2[2];

              this.addAttachment(r.response);
            }
          }, {
            key: "addAttachment",
            value: function value(e) {
              var t = new DOMParser().parseFromString(e, "text/html");
              this.attachmentsTarget.prepend(t.body.children[0]);
            }
          }, {
            key: "updateAttachment",
            value: function value(e) {}
          }, {
            key: "isFiltered",
            get: function get() {
              return "true" === this.data.get("filtered");
            }
          }, {
            key: "filteredClass",
            get: function get() {
              return this.data.get("filteredClass");
            }
          }, {
            key: "highlightClass",
            get: function get() {
              return this.data.get("highlightClass");
            }
          }, {
            key: "queriedClass",
            get: function get() {
              return this.data.get("queriedClass");
            }
          }]) && a(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), h;
        }(r.Qr);

        var h, f, p;
        p = ["attachments", "uploadForm"], (f = "targets") in (h = d) ? Object.defineProperty(h, f, {
          value: p,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : h[f] = p;
      },
      9799: function _(e, t, n) {
        "use strict";

        function r(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function o(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function i(e, t) {
          return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, i(e, t);
        }

        function s(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function a(e) {
          return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, a(e);
        }

        n.r(t), n.d(t, {
          default: function _default() {
            return l;
          }
        });

        var l = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && i(e, t);
          }(d, e);
          var t,
              n,
              l,
              c,
              u = (l = d, c = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = a(l);

            if (c) {
              var n = a(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return s(this, e);
          });

          function d() {
            return r(this, d), u.apply(this, arguments);
          }

          return t = d, (n = [{
            key: "removeAttachment",
            value: function value(e) {
              e.stopPropagation(), e.target.closest(".AttachmentUploader-Attachment").remove();
            }
          }]) && o(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), d;
        }(n(6599).Qr);
      },
      2595: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return O;
          }
        });
        var r = n(6599),
            o = n(1421),
            i = n(7841),
            s = n.n(i),
            a = n(2868),
            l = n.n(a),
            c = n(3993),
            u = n.n(c),
            d = n(5117),
            h = n.n(d),
            f = n(8978),
            p = n.n(f);

        function g(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function m(e, t) {
          return m = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, m(e, t);
        }

        function v(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return y(e);
        }

        function y(e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }

        function b(e) {
          return b = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, b(e);
        }

        function w(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }

        var O = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && m(e, t);
          }(c, e);
          var t,
              n,
              r,
              i,
              a = (r = c, i = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = b(r);

            if (i) {
              var n = b(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return v(this, e);
          });

          function c() {
            var t;

            for (var _len17 = arguments.length, e = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
              e[_key17] = arguments[_key17];
            }

            return function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, c), w(y(t = a.call.apply(a, [this].concat(e))), "defaults", {
              fieldName: "attachment[file]"
            }), t;
          }

          return t = c, (n = [{
            key: "connect",
            value: function value() {
              var _this71 = this;

              (0, o.J)(this, {
                target: document.body
              }), this.uppy = new (s())({
                autoProceed: !0,
                meta: this.metaValue,
                restrictions: {
                  allowedFileTypes: this.allowedFileTypesValue,
                  maxNumberOfFiles: this.maxNumberOfFiles,
                  allowMultipleUploads: !0
                },
                onBeforeFileAdded: function onBeforeFileAdded(e, t) {
                  return _this71._resetFilesObj(t);
                }
              }).use(u(), {
                target: this.uploaderTarget,
                locale: {
                  strings: {
                    chooseFiles: this.promptValue,
                    chooseFile: this.promptValue
                  }
                }
              }).use(l(), {
                target: this.element
              }).use(h(), {
                target: this.progressBarTarget,
                fixed: !1,
                hideAfterFinish: !0
              }).use(p(), {
                endpoint: this.endpointValue,
                formData: !0,
                fieldName: "attachment[file]",
                headers: this.headers
              }), this.uppy.on("upload-success", function (e, t) {
                _this71._append(t.body.html);
              }), this.uppy.on("upload-error", function (e, t, n) {
                _this71._append(n.body.html);
              });
            }
          }, {
            key: "onSelectAttachments",
            value: function value(e) {
              this.selectorOpenValue && (this._fetchAttachments(e.detail.attachmentIds), this.selectorOpenValue = !1);
            }
          }, {
            key: "onAjaxSuccess",
            value: function value(e) {
              this.selectorOpenValue && (e.stopPropagation(), this.append(e));
            }
          }, {
            key: "openSelector",
            value: function value() {
              this.selectorOpenValue = !0;
            }
          }, {
            key: "_fetchAttachments",
            value: function value(e) {
              var _this72 = this;

              _toConsumableArray(e).forEach(function (e) {
                return _this72._fetchAttachment(e);
              });
            }
          }, {
            key: "_fetchAttachment",
            value: function value(e) {
              var _this73 = this;

              fetch("".concat(this.endpointValue, "/").concat(e, "?") + new URLSearchParams(this.metaValue)).then(function (e) {
                return e.text();
              }).then(function (e) {
                return JSON.parse(e);
              }).then(function (e) {
                return new DOMParser().parseFromString(e.html, "text/html");
              }).then(function (e) {
                return _this73._addAttachments(e.body.children);
              });
            }
          }, {
            key: "_addAttachments",
            value: function value(e) {
              this.multipleValue ? this._appendAttachments(e) : this._replaceAttachment(e);
            }
          }, {
            key: "_appendAttachments",
            value: function value(e) {
              var _this74 = this;

              _toConsumableArray(e).forEach(function (e) {
                return _this74.listTarget.append(e);
              });
            }
          }, {
            key: "_replaceAttachment",
            value: function value(e) {
              this.listTarget.firstChild ? this.listTarget.firstChild.replaceWith(e[0]) : this._appendAttachments(e);
            }
          }, {
            key: "_append",
            value: function value(e) {
              this.listTarget.append(this._documentFragment(e));
            }
          }, {
            key: "_documentFragment",
            value: function value(e) {
              var t = document.createElement("template");
              return t.innerHTML = e, t.content;
            }
          }, {
            key: "_resetFilesObj",
            value: function value(e) {
              this.multipleValue || Object.keys(e).forEach(function (t) {
                delete e[t];
              });
            }
          }, {
            key: "meta",
            get: function get() {
              return {
                "attachment_parent[class]": this.attachmentParentValue.class,
                "attachment_parent[name]": this.attachmentParentValue.name,
                "attachment_relation[name]": this.attachmentRelationValue.name,
                "attachment_relation[type]": this.attachmentRelationValue.type
              };
            }
          }, {
            key: "csrfToken",
            get: function get() {
              if (document.querySelector("meta[name='csrf-token']")) return document.querySelector("meta[name='csrf-token']").content;
            }
          }, {
            key: "fieldName",
            get: function get() {
              return this.fieldNameValue || this.defaults.fieldName;
            }
          }, {
            key: "maxNumberOfFiles",
            get: function get() {
              if (!this.multipleValue) return 1;
            }
          }, {
            key: "headers",
            get: function get() {
              if (this.csrfToken) return {
                "X-CSRF-Token": this.csrfToken
              };
            }
          }]) && g(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), c;
        }(r.Qr);

        w(O, "values", {
          endpoint: String,
          fieldName: String,
          maxNumberOfFiles: Number,
          meta: Object,
          selectorOpen: Boolean,
          multiple: Boolean,
          allowedFileTypes: Array,
          attachmentParent: Object,
          attachmentRelation: Object,
          prompt: String
        }), w(O, "targets", ["uploader", "list", "progressBar"]);
      },
      941: function _(e, t, n) {
        "use strict";

        function r(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function o(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function i(e, t) {
          return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, i(e, t);
        }

        function s(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function a(e) {
          return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, a(e);
        }

        n.r(t), n.d(t, {
          default: function _default() {
            return l;
          }
        });

        var l = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && i(e, t);
          }(d, e);
          var t,
              n,
              l,
              c,
              u = (l = d, c = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = a(l);

            if (c) {
              var n = a(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return s(this, e);
          });

          function d() {
            return r(this, d), u.apply(this, arguments);
          }

          return t = d, (n = [{
            key: "connect",
            value: function value() {
              this._setupDummy(), this.resize();
            }
          }, {
            key: "resize",
            value: function value() {
              this.dummyContent = this.inputTarget.value, this.inputTarget.style.inlineSize = null, this.inputTarget.style.width = "".concat(this.dummyWidth, "px");
            }
          }, {
            key: "_setupDummy",
            value: function value() {
              this.transferComputedStyle(this.inputTarget, this.dummyTarget), this.dummyTarget.style.width = null, this.dummyTarget.style.inlineSize = null, this.dummyTarget.style.position = "absolute", this.dummyTarget.style.visibility = "hidden", this.dummyTarget.pointerEvents = "none";
            }
          }, {
            key: "transferComputedStyle",
            value: function value(e, t) {
              var n,
                  r = window.getComputedStyle(e);

              for (n = 0; n < r.length; n++) {
                var o = r[n] + "";
                t.style[o] = r[o];
              }
            }
          }, {
            key: "dummyWidth",
            get: function get() {
              return Math.ceil(this.dummyTarget.offsetWidth);
            }
          }, {
            key: "hasChanged",
            get: function get() {
              return this.inputTarget.value != this.data.get("originalValue");
            }
          }, {
            key: "dummyContent",
            set: function set(e) {
              this.dummyTarget.textContent = e;
            }
          }]) && o(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), d;
        }(n(6599).Qr);

        var c, u, d;
        d = ["input", "dummy"], (u = "targets") in (c = l) ? Object.defineProperty(c, u, {
          value: d,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : c[u] = d;
      },
      623: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return v;
          }
        });

        var r,
            o,
            i = n(6599),
            s = "function" == typeof Map ? new Map() : (r = [], o = [], {
          has: function has(e) {
            return r.indexOf(e) > -1;
          },
          get: function get(e) {
            return o[r.indexOf(e)];
          },
          set: function set(e, t) {
            -1 === r.indexOf(e) && (r.push(e), o.push(t));
          },
          delete: function _delete(e) {
            var t = r.indexOf(e);
            t > -1 && (r.splice(t, 1), o.splice(t, 1));
          }
        }),
            a = function a(e) {
          return new Event(e, {
            bubbles: !0
          });
        };

        try {
          new Event("test");
        } catch (r) {
          a = function a(e) {
            var t = document.createEvent("Event");
            return t.initEvent(e, !0, !1), t;
          };
        }

        function l(e) {
          var t = s.get(e);
          t && t.destroy();
        }

        function c(e) {
          var t = s.get(e);
          t && t.update();
        }

        var u = null;
        "undefined" == typeof window || "function" != typeof window.getComputedStyle ? ((u = function u(e) {
          return e;
        }).destroy = function (e) {
          return e;
        }, u.update = function (e) {
          return e;
        }) : ((u = function u(e, t) {
          return e && Array.prototype.forEach.call(e.length ? e : [e], function (e) {
            return function (e) {
              if (e && e.nodeName && "TEXTAREA" === e.nodeName && !s.has(e)) {
                var t,
                    n = null,
                    r = null,
                    o = null,
                    i = function i() {
                  e.clientWidth !== r && d();
                },
                    l = function (t) {
                  window.removeEventListener("resize", i, !1), e.removeEventListener("input", d, !1), e.removeEventListener("keyup", d, !1), e.removeEventListener("autosize:destroy", l, !1), e.removeEventListener("autosize:update", d, !1), Object.keys(t).forEach(function (n) {
                    e.style[n] = t[n];
                  }), s.delete(e);
                }.bind(e, {
                  height: e.style.height,
                  resize: e.style.resize,
                  overflowY: e.style.overflowY,
                  overflowX: e.style.overflowX,
                  wordWrap: e.style.wordWrap
                });

                e.addEventListener("autosize:destroy", l, !1), "onpropertychange" in e && "oninput" in e && e.addEventListener("keyup", d, !1), window.addEventListener("resize", i, !1), e.addEventListener("input", d, !1), e.addEventListener("autosize:update", d, !1), e.style.overflowX = "hidden", e.style.wordWrap = "break-word", s.set(e, {
                  destroy: l,
                  update: d
                }), "vertical" === (t = window.getComputedStyle(e, null)).resize ? e.style.resize = "none" : "both" === t.resize && (e.style.resize = "horizontal"), n = "content-box" === t.boxSizing ? -(parseFloat(t.paddingTop) + parseFloat(t.paddingBottom)) : parseFloat(t.borderTopWidth) + parseFloat(t.borderBottomWidth), isNaN(n) && (n = 0), d();
              }

              function c(t) {
                var n = e.style.width;
                e.style.width = "0px", e.style.width = n, e.style.overflowY = t;
              }

              function u() {
                if (0 !== e.scrollHeight) {
                  var t = function (e) {
                    for (var t = []; e && e.parentNode && e.parentNode instanceof Element;) {
                      e.parentNode.scrollTop && t.push({
                        node: e.parentNode,
                        scrollTop: e.parentNode.scrollTop
                      }), e = e.parentNode;
                    }

                    return t;
                  }(e),
                      o = document.documentElement && document.documentElement.scrollTop;

                  e.style.height = "", e.style.height = e.scrollHeight + n + "px", r = e.clientWidth, t.forEach(function (e) {
                    e.node.scrollTop = e.scrollTop;
                  }), o && (document.documentElement.scrollTop = o);
                }
              }

              function d() {
                u();
                var t = Math.round(parseFloat(e.style.height)),
                    n = window.getComputedStyle(e, null),
                    r = "content-box" === n.boxSizing ? Math.round(parseFloat(n.height)) : e.offsetHeight;

                if (r < t ? "hidden" === n.overflowY && (c("scroll"), u(), r = "content-box" === n.boxSizing ? Math.round(parseFloat(window.getComputedStyle(e, null).height)) : e.offsetHeight) : "hidden" !== n.overflowY && (c("hidden"), u(), r = "content-box" === n.boxSizing ? Math.round(parseFloat(window.getComputedStyle(e, null).height)) : e.offsetHeight), o !== r) {
                  o = r;
                  var i = a("autosize:resized");

                  try {
                    e.dispatchEvent(i);
                  } catch (e) {}
                }
              }
            }(e);
          }), e;
        }).destroy = function (e) {
          return e && Array.prototype.forEach.call(e.length ? e : [e], l), e;
        }, u.update = function (e) {
          return e && Array.prototype.forEach.call(e.length ? e : [e], c), e;
        });
        var d = u;

        function h(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function f(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function p(e, t) {
          return p = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, p(e, t);
        }

        function g(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function m(e) {
          return m = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, m(e);
        }

        var v = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && p(e, t);
          }(s, e);
          var t,
              n,
              r,
              o,
              i = (r = s, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = m(r);

            if (o) {
              var n = m(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return g(this, e);
          });

          function s() {
            return h(this, s), i.apply(this, arguments);
          }

          return t = s, (n = [{
            key: "connect",
            value: function value() {
              d(this.element);
            }
          }]) && f(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), s;
        }(i.Qr);
      },
      2427: function _(e, t, n) {
        "use strict";

        function r(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function o(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function i(e, t) {
          return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, i(e, t);
        }

        function s(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function a(e) {
          return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, a(e);
        }

        n.r(t), n.d(t, {
          default: function _default() {
            return l;
          }
        });

        var l = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && i(e, t);
          }(d, e);
          var t,
              n,
              l,
              c,
              u = (l = d, c = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = a(l);

            if (c) {
              var n = a(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return s(this, e);
          });

          function d() {
            return r(this, d), u.apply(this, arguments);
          }

          return t = d, (n = [{
            key: "onSuccess",
            value: function value(e) {
              this.blockController.destroy();
            }
          }, {
            key: "onError",
            value: function value(e) {
              console.log(e);
            }
          }, {
            key: "blockController",
            get: function get() {
              var e = this.element.closest(".block");
              return this.application.getControllerForElementAndIdentifier(e, "block");
            }
          }]) && o(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), d;
        }(n(6599).Qr);
      },
      3012: function _(e, t, n) {
        "use strict";

        function r(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function o(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function i(e, t) {
          return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, i(e, t);
        }

        function s(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function a(e) {
          return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, a(e);
        }

        n.r(t), n.d(t, {
          default: function _default() {
            return l;
          }
        });

        var l = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && i(e, t);
          }(d, e);
          var t,
              n,
              l,
              c,
              u = (l = d, c = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = a(l);

            if (c) {
              var n = a(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return s(this, e);
          });

          function d() {
            return r(this, d), u.apply(this, arguments);
          }

          return t = d, (n = [{
            key: "onSuccess",
            value: function value(e) {
              var _e$detail3 = _slicedToArray(e.detail, 3),
                  t = _e$detail3[0],
                  n = _e$detail3[1],
                  r = _e$detail3[2];

              this.blockEditorController.update(r.response);
            }
          }, {
            key: "blockEditorController",
            get: function get() {
              var e = this.element.closest(".block__editor");
              return this.application.getControllerForElementAndIdentifier(e, "block--editor");
            }
          }]) && o(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), d;
        }(n(6599).Qr);
      },
      2207: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return f;
          }
        });
        var r = n(6599),
            o = n(4183),
            i = n.n(o),
            s = n(8535),
            a = n.n(s);

        function l(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function c(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function u(e, t) {
          return u = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, u(e, t);
        }

        function d(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function h(e) {
          return h = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, h(e);
        }

        var f = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && u(e, t);
          }(f, e);
          var t,
              n,
              r,
              o,
              s = (r = f, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = h(r);

            if (o) {
              var n = h(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return d(this, e);
          });

          function f() {
            return l(this, f), s.apply(this, arguments);
          }

          return t = f, (n = [{
            key: "connect",
            value: function value() {
              var _this75 = this;

              this.tomSelect = new (i())(this.element, {
                sortField: function sortField() {
                  return 1;
                },
                render: {
                  option: function option(e, t) {
                    var n = _this75.descriptionFor(e.value);

                    return "\n            <div>\n              <div class=\"type\">".concat(t(e.text), "</div>\n              <div class=\"description\">").concat(t(n), "</div>\n            </div>\n          ");
                  }
                }
              });
            }
          }, {
            key: "submit",
            value: function value() {
              this.isEmpty || (a().fire(this.element.form, "submit"), this.tomSelect.clear(!0));
            }
          }, {
            key: "descriptionFor",
            value: function value(e) {
              return this.descriptionsValue.find(function (t) {
                return e === t.type;
              }).description;
            }
          }, {
            key: "isEmpty",
            get: function get() {
              return "" === this.element.value;
            }
          }]) && c(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), f;
        }(r.Qr);

        var p, g, m;
        p = f, g = "values", m = {
          descriptions: Array
        }, g in p ? Object.defineProperty(p, g, {
          value: m,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : p[g] = m;
      },
      302: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return fe;
          }
        });

        var r = ["onChange", "onClose", "onDayCreate", "onDestroy", "onKeyDown", "onMonthChange", "onOpen", "onParseConfig", "onReady", "onValueUpdate", "onYearChange", "onPreCalendarPosition"],
            o = {
          _disable: [],
          allowInput: !1,
          allowInvalidPreload: !1,
          altFormat: "F j, Y",
          altInput: !1,
          altInputClass: "form-control input",
          animate: "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && -1 === window.navigator.userAgent.indexOf("MSIE"),
          ariaDateFormat: "F j, Y",
          autoFillDefaultTime: !0,
          clickOpens: !0,
          closeOnSelect: !0,
          conjunction: ", ",
          dateFormat: "Y-m-d",
          defaultHour: 12,
          defaultMinute: 0,
          defaultSeconds: 0,
          disable: [],
          disableMobile: !1,
          enableSeconds: !1,
          enableTime: !1,
          errorHandler: function errorHandler(e) {
            return "undefined" != typeof console && console.warn(e);
          },
          getWeek: function getWeek(e) {
            var t = new Date(e.getTime());
            t.setHours(0, 0, 0, 0), t.setDate(t.getDate() + 3 - (t.getDay() + 6) % 7);
            var n = new Date(t.getFullYear(), 0, 4);
            return 1 + Math.round(((t.getTime() - n.getTime()) / 864e5 - 3 + (n.getDay() + 6) % 7) / 7);
          },
          hourIncrement: 1,
          ignoredFocusElements: [],
          inline: !1,
          locale: "default",
          minuteIncrement: 5,
          mode: "single",
          monthSelectorType: "dropdown",
          nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
          noCalendar: !1,
          now: new Date(),
          onChange: [],
          onClose: [],
          onDayCreate: [],
          onDestroy: [],
          onKeyDown: [],
          onMonthChange: [],
          onOpen: [],
          onParseConfig: [],
          onReady: [],
          onValueUpdate: [],
          onYearChange: [],
          onPreCalendarPosition: [],
          plugins: [],
          position: "auto",
          positionElement: void 0,
          prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
          shorthandCurrentMonth: !1,
          showMonths: 1,
          static: !1,
          time_24hr: !1,
          weekNumbers: !1,
          wrap: !1
        },
            i = {
          weekdays: {
            shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
          },
          months: {
            shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
          },
          daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
          firstDayOfWeek: 0,
          ordinal: function ordinal(e) {
            var t = e % 100;
            if (t > 3 && t < 21) return "th";

            switch (t % 10) {
              case 1:
                return "st";

              case 2:
                return "nd";

              case 3:
                return "rd";

              default:
                return "th";
            }
          },
          rangeSeparator: " to ",
          weekAbbreviation: "Wk",
          scrollTitle: "Scroll to increment",
          toggleTitle: "Click to toggle",
          amPM: ["AM", "PM"],
          yearAriaLabel: "Year",
          monthAriaLabel: "Month",
          hourAriaLabel: "Hour",
          minuteAriaLabel: "Minute",
          time_24hr: !1
        },
            s = i,
            a = function a(e, t) {
          return void 0 === t && (t = 2), ("000" + e).slice(-1 * t);
        },
            l = function l(e) {
          return !0 === e ? 1 : 0;
        };

        function c(e, t) {
          var n;
          return function () {
            var r = this,
                o = arguments;
            clearTimeout(n), n = setTimeout(function () {
              return e.apply(r, o);
            }, t);
          };
        }

        var u = function u(e) {
          return e instanceof Array ? e : [e];
        };

        function d(e, t, n) {
          if (!0 === n) return e.classList.add(t);
          e.classList.remove(t);
        }

        function h(e, t, n) {
          var r = window.document.createElement(e);
          return t = t || "", n = n || "", r.className = t, void 0 !== n && (r.textContent = n), r;
        }

        function f(e) {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }
        }

        function p(e, t) {
          return t(e) ? e : e.parentNode ? p(e.parentNode, t) : void 0;
        }

        function g(e, t) {
          var n = h("div", "numInputWrapper"),
              r = h("input", "numInput " + e),
              o = h("span", "arrowUp"),
              i = h("span", "arrowDown");
          if (-1 === navigator.userAgent.indexOf("MSIE 9.0") ? r.type = "number" : (r.type = "text", r.pattern = "\\d*"), void 0 !== t) for (var s in t) {
            r.setAttribute(s, t[s]);
          }
          return n.appendChild(r), n.appendChild(o), n.appendChild(i), n;
        }

        function m(e) {
          try {
            return "function" == typeof e.composedPath ? e.composedPath()[0] : e.target;
          } catch (t) {
            return e.target;
          }
        }

        var v = function v() {},
            y = function y(e, t, n) {
          return n.months[t ? "shorthand" : "longhand"][e];
        },
            b = {
          D: v,
          F: function F(e, t, n) {
            e.setMonth(n.months.longhand.indexOf(t));
          },
          G: function G(e, t) {
            e.setHours((e.getHours() >= 12 ? 12 : 0) + parseFloat(t));
          },
          H: function H(e, t) {
            e.setHours(parseFloat(t));
          },
          J: function J(e, t) {
            e.setDate(parseFloat(t));
          },
          K: function K(e, t, n) {
            e.setHours(e.getHours() % 12 + 12 * l(new RegExp(n.amPM[1], "i").test(t)));
          },
          M: function M(e, t, n) {
            e.setMonth(n.months.shorthand.indexOf(t));
          },
          S: function S(e, t) {
            e.setSeconds(parseFloat(t));
          },
          U: function U(e, t) {
            return new Date(1e3 * parseFloat(t));
          },
          W: function W(e, t, n) {
            var r = parseInt(t),
                o = new Date(e.getFullYear(), 0, 2 + 7 * (r - 1), 0, 0, 0, 0);
            return o.setDate(o.getDate() - o.getDay() + n.firstDayOfWeek), o;
          },
          Y: function Y(e, t) {
            e.setFullYear(parseFloat(t));
          },
          Z: function Z(e, t) {
            return new Date(t);
          },
          d: function d(e, t) {
            e.setDate(parseFloat(t));
          },
          h: function h(e, t) {
            e.setHours((e.getHours() >= 12 ? 12 : 0) + parseFloat(t));
          },
          i: function i(e, t) {
            e.setMinutes(parseFloat(t));
          },
          j: function j(e, t) {
            e.setDate(parseFloat(t));
          },
          l: v,
          m: function m(e, t) {
            e.setMonth(parseFloat(t) - 1);
          },
          n: function n(e, t) {
            e.setMonth(parseFloat(t) - 1);
          },
          s: function s(e, t) {
            e.setSeconds(parseFloat(t));
          },
          u: function u(e, t) {
            return new Date(parseFloat(t));
          },
          w: v,
          y: function y(e, t) {
            e.setFullYear(2e3 + parseFloat(t));
          }
        },
            w = {
          D: "",
          F: "",
          G: "(\\d\\d|\\d)",
          H: "(\\d\\d|\\d)",
          J: "(\\d\\d|\\d)\\w+",
          K: "",
          M: "",
          S: "(\\d\\d|\\d)",
          U: "(.+)",
          W: "(\\d\\d|\\d)",
          Y: "(\\d{4})",
          Z: "(.+)",
          d: "(\\d\\d|\\d)",
          h: "(\\d\\d|\\d)",
          i: "(\\d\\d|\\d)",
          j: "(\\d\\d|\\d)",
          l: "",
          m: "(\\d\\d|\\d)",
          n: "(\\d\\d|\\d)",
          s: "(\\d\\d|\\d)",
          u: "(.+)",
          w: "(\\d\\d|\\d)",
          y: "(\\d{2})"
        },
            O = {
          Z: function Z(e) {
            return e.toISOString();
          },
          D: function D(e, t, n) {
            return t.weekdays.shorthand[O.w(e, t, n)];
          },
          F: function F(e, t, n) {
            return y(O.n(e, t, n) - 1, !1, t);
          },
          G: function G(e, t, n) {
            return a(O.h(e, t, n));
          },
          H: function H(e) {
            return a(e.getHours());
          },
          J: function J(e, t) {
            return void 0 !== t.ordinal ? e.getDate() + t.ordinal(e.getDate()) : e.getDate();
          },
          K: function K(e, t) {
            return t.amPM[l(e.getHours() > 11)];
          },
          M: function M(e, t) {
            return y(e.getMonth(), !0, t);
          },
          S: function S(e) {
            return a(e.getSeconds());
          },
          U: function U(e) {
            return e.getTime() / 1e3;
          },
          W: function W(e, t, n) {
            return n.getWeek(e);
          },
          Y: function Y(e) {
            return a(e.getFullYear(), 4);
          },
          d: function d(e) {
            return a(e.getDate());
          },
          h: function h(e) {
            return e.getHours() % 12 ? e.getHours() % 12 : 12;
          },
          i: function i(e) {
            return a(e.getMinutes());
          },
          j: function j(e) {
            return e.getDate();
          },
          l: function l(e, t) {
            return t.weekdays.longhand[e.getDay()];
          },
          m: function m(e) {
            return a(e.getMonth() + 1);
          },
          n: function n(e) {
            return e.getMonth() + 1;
          },
          s: function s(e) {
            return e.getSeconds();
          },
          u: function u(e) {
            return e.getTime();
          },
          w: function w(e) {
            return e.getDay();
          },
          y: function y(e) {
            return String(e.getFullYear()).substring(2);
          }
        },
            E = function E(e) {
          var t = e.config,
              n = void 0 === t ? o : t,
              r = e.l10n,
              s = void 0 === r ? i : r,
              a = e.isMobile,
              l = void 0 !== a && a;
          return function (e, t, r) {
            var o = r || s;
            return void 0 === n.formatDate || l ? t.split("").map(function (t, r, i) {
              return O[t] && "\\" !== i[r - 1] ? O[t](e, o, n) : "\\" !== t ? t : "";
            }).join("") : n.formatDate(e, t, o);
          };
        },
            _ = function _(e) {
          var t = e.config,
              n = void 0 === t ? o : t,
              r = e.l10n,
              s = void 0 === r ? i : r;
          return function (e, t, r, i) {
            if (0 === e || e) {
              var a,
                  l = i || s,
                  c = e;
              if (e instanceof Date) a = new Date(e.getTime());else if ("string" != typeof e && void 0 !== e.toFixed) a = new Date(e);else if ("string" == typeof e) {
                var u = t || (n || o).dateFormat,
                    d = String(e).trim();
                if ("today" === d) a = new Date(), r = !0;else if (n && n.parseDate) a = n.parseDate(e, u);else if (/Z$/.test(d) || /GMT$/.test(d)) a = new Date(e);else {
                  for (var h = void 0, f = [], p = 0, g = 0, m = ""; p < u.length; p++) {
                    var v = u[p],
                        y = "\\" === v,
                        O = "\\" === u[p - 1] || y;

                    if (w[v] && !O) {
                      m += w[v];
                      var E = new RegExp(m).exec(e);
                      E && (h = !0) && f["Y" !== v ? "push" : "unshift"]({
                        fn: b[v],
                        val: E[++g]
                      });
                    } else y || (m += ".");
                  }

                  a = n && n.noCalendar ? new Date(new Date().setHours(0, 0, 0, 0)) : new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0), f.forEach(function (e) {
                    var t = e.fn,
                        n = e.val;
                    return a = t(a, n, l) || a;
                  }), a = h ? a : void 0;
                }
              }
              if (a instanceof Date && !isNaN(a.getTime())) return !0 === r && a.setHours(0, 0, 0, 0), a;
              n.errorHandler(new Error("Invalid date provided: " + c));
            }
          };
        };

        function S(e, t, n) {
          return void 0 === n && (n = !0), !1 !== n ? new Date(e.getTime()).setHours(0, 0, 0, 0) - new Date(t.getTime()).setHours(0, 0, 0, 0) : e.getTime() - t.getTime();
        }

        var x = function x(e, t, n) {
          return 3600 * e + 60 * t + n;
        };

        function C(e) {
          var t = e.defaultHour,
              n = e.defaultMinute,
              r = e.defaultSeconds;

          if (void 0 !== e.minDate) {
            var o = e.minDate.getHours(),
                i = e.minDate.getMinutes(),
                s = e.minDate.getSeconds();
            t < o && (t = o), t === o && n < i && (n = i), t === o && n === i && r < s && (r = e.minDate.getSeconds());
          }

          if (void 0 !== e.maxDate) {
            var a = e.maxDate.getHours(),
                l = e.maxDate.getMinutes();
            (t = Math.min(t, a)) === a && (n = Math.min(l, n)), t === a && n === l && (r = e.maxDate.getSeconds());
          }

          return {
            hours: t,
            minutes: n,
            seconds: r
          };
        }

        n(1895);

        var _k = function k() {
          return _k = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) {
              for (var o in t = arguments[n]) {
                Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              }
            }

            return e;
          }, _k.apply(this, arguments);
        },
            P = function P() {
          for (var e = 0, t = 0, n = arguments.length; t < n; t++) {
            e += arguments[t].length;
          }

          var r = Array(e),
              o = 0;

          for (t = 0; t < n; t++) {
            for (var i = arguments[t], s = 0, a = i.length; s < a; s++, o++) {
              r[o] = i[s];
            }
          }

          return r;
        };

        function j(e, t) {
          var n = {
            config: _k(_k({}, o), D.defaultConfig),
            l10n: s
          };

          function i() {
            var e;
            return (null === (e = n.calendarContainer) || void 0 === e ? void 0 : e.getRootNode()).activeElement || document.activeElement;
          }

          function v(e) {
            return e.bind(n);
          }

          function b() {
            var e = n.config;
            !1 === e.weekNumbers && 1 === e.showMonths || !0 !== e.noCalendar && window.requestAnimationFrame(function () {
              if (void 0 !== n.calendarContainer && (n.calendarContainer.style.visibility = "hidden", n.calendarContainer.style.display = "block"), void 0 !== n.daysContainer) {
                var t = (n.days.offsetWidth + 1) * e.showMonths;
                n.daysContainer.style.width = t + "px", n.calendarContainer.style.width = t + (void 0 !== n.weekWrapper ? n.weekWrapper.offsetWidth : 0) + "px", n.calendarContainer.style.removeProperty("visibility"), n.calendarContainer.style.removeProperty("display");
              }
            });
          }

          function O(e) {
            if (0 === n.selectedDates.length) {
              var t = void 0 === n.config.minDate || S(new Date(), n.config.minDate) >= 0 ? new Date() : new Date(n.config.minDate.getTime()),
                  r = C(n.config);
              t.setHours(r.hours, r.minutes, r.seconds, t.getMilliseconds()), n.selectedDates = [t], n.latestSelectedDateObj = t;
            }

            void 0 !== e && "blur" !== e.type && function (e) {
              e.preventDefault();
              var t = "keydown" === e.type,
                  r = m(e),
                  o = r;
              void 0 !== n.amPM && r === n.amPM && (n.amPM.textContent = n.l10n.amPM[l(n.amPM.textContent === n.l10n.amPM[0])]);
              var i = parseFloat(o.getAttribute("min")),
                  s = parseFloat(o.getAttribute("max")),
                  c = parseFloat(o.getAttribute("step")),
                  u = parseInt(o.value, 10),
                  d = u + c * (e.delta || (t ? 38 === e.which ? 1 : -1 : 0));

              if (void 0 !== o.value && 2 === o.value.length) {
                var h = o === n.hourElement,
                    f = o === n.minuteElement;
                d < i ? (d = s + d + l(!h) + (l(h) && l(!n.amPM)), f && N(void 0, -1, n.hourElement)) : d > s && (d = o === n.hourElement ? d - s - l(!n.amPM) : i, f && N(void 0, 1, n.hourElement)), n.amPM && h && (1 === c ? d + u === 23 : Math.abs(d - u) > c) && (n.amPM.textContent = n.l10n.amPM[l(n.amPM.textContent === n.l10n.amPM[0])]), o.value = a(d);
              }
            }(e);
            var o = n._input.value;
            j(), Ee(), n._input.value !== o && n._debouncedChange();
          }

          function j() {
            if (void 0 !== n.hourElement && void 0 !== n.minuteElement) {
              var e,
                  t,
                  r = (parseInt(n.hourElement.value.slice(-2), 10) || 0) % 24,
                  o = (parseInt(n.minuteElement.value, 10) || 0) % 60,
                  i = void 0 !== n.secondElement ? (parseInt(n.secondElement.value, 10) || 0) % 60 : 0;
              void 0 !== n.amPM && (e = r, t = n.amPM.textContent, r = e % 12 + 12 * l(t === n.l10n.amPM[1]));
              var s = void 0 !== n.config.minTime || n.config.minDate && n.minDateHasTime && n.latestSelectedDateObj && 0 === S(n.latestSelectedDateObj, n.config.minDate, !0),
                  a = void 0 !== n.config.maxTime || n.config.maxDate && n.maxDateHasTime && n.latestSelectedDateObj && 0 === S(n.latestSelectedDateObj, n.config.maxDate, !0);

              if (void 0 !== n.config.maxTime && void 0 !== n.config.minTime && n.config.minTime > n.config.maxTime) {
                var c = x(n.config.minTime.getHours(), n.config.minTime.getMinutes(), n.config.minTime.getSeconds()),
                    u = x(n.config.maxTime.getHours(), n.config.maxTime.getMinutes(), n.config.maxTime.getSeconds()),
                    d = x(r, o, i);

                if (d > u && d < c) {
                  var h = function (e) {
                    var t = Math.floor(e / 3600),
                        n = (e - 3600 * t) / 60;
                    return [t, n, e - 3600 * t - 60 * n];
                  }(c);

                  r = h[0], o = h[1], i = h[2];
                }
              } else {
                if (a) {
                  var f = void 0 !== n.config.maxTime ? n.config.maxTime : n.config.maxDate;
                  (r = Math.min(r, f.getHours())) === f.getHours() && (o = Math.min(o, f.getMinutes())), o === f.getMinutes() && (i = Math.min(i, f.getSeconds()));
                }

                if (s) {
                  var p = void 0 !== n.config.minTime ? n.config.minTime : n.config.minDate;
                  (r = Math.max(r, p.getHours())) === p.getHours() && o < p.getMinutes() && (o = p.getMinutes()), o === p.getMinutes() && (i = Math.max(i, p.getSeconds()));
                }
              }

              M(r, o, i);
            }
          }

          function T(e) {
            var t = e || n.latestSelectedDateObj;
            t && t instanceof Date && M(t.getHours(), t.getMinutes(), t.getSeconds());
          }

          function M(e, t, r) {
            void 0 !== n.latestSelectedDateObj && n.latestSelectedDateObj.setHours(e % 24, t, r || 0, 0), n.hourElement && n.minuteElement && !n.isMobile && (n.hourElement.value = a(n.config.time_24hr ? e : (12 + e) % 12 + 12 * l(e % 12 == 0)), n.minuteElement.value = a(t), void 0 !== n.amPM && (n.amPM.textContent = n.l10n.amPM[l(e >= 12)]), void 0 !== n.secondElement && (n.secondElement.value = a(r)));
          }

          function A(e) {
            var t = m(e),
                n = parseInt(t.value) + (e.delta || 0);
            (n / 1e3 > 1 || "Enter" === e.key && !/[^\d]/.test(n.toString())) && Z(n);
          }

          function F(e, t, r, o) {
            return t instanceof Array ? t.forEach(function (t) {
              return F(e, t, r, o);
            }) : e instanceof Array ? e.forEach(function (e) {
              return F(e, t, r, o);
            }) : (e.addEventListener(t, r, o), void n._handlers.push({
              remove: function remove() {
                return e.removeEventListener(t, r, o);
              }
            }));
          }

          function L() {
            ve("onChange");
          }

          function I(e, t) {
            var r = void 0 !== e ? n.parseDate(e) : n.latestSelectedDateObj || (n.config.minDate && n.config.minDate > n.now ? n.config.minDate : n.config.maxDate && n.config.maxDate < n.now ? n.config.maxDate : n.now),
                o = n.currentYear,
                i = n.currentMonth;

            try {
              void 0 !== r && (n.currentYear = r.getFullYear(), n.currentMonth = r.getMonth());
            } catch (e) {
              e.message = "Invalid date supplied: " + r, n.config.errorHandler(e);
            }

            t && n.currentYear !== o && (ve("onYearChange"), q()), !t || n.currentYear === o && n.currentMonth === i || ve("onMonthChange"), n.redraw();
          }

          function R(e) {
            var t = m(e);
            ~t.className.indexOf("arrow") && N(e, t.classList.contains("arrowUp") ? 1 : -1);
          }

          function N(e, t, n) {
            var r = e && m(e),
                o = n || r && r.parentNode && r.parentNode.firstChild,
                i = ye("increment");
            i.delta = t, o && o.dispatchEvent(i);
          }

          function B(e, t, r, o) {
            var i = ee(t, !0),
                s = h("span", e, t.getDate().toString());
            return s.dateObj = t, s.$i = o, s.setAttribute("aria-label", n.formatDate(t, n.config.ariaDateFormat)), -1 === e.indexOf("hidden") && 0 === S(t, n.now) && (n.todayDateElem = s, s.classList.add("today"), s.setAttribute("aria-current", "date")), i ? (s.tabIndex = -1, be(t) && (s.classList.add("selected"), n.selectedDateElem = s, "range" === n.config.mode && (d(s, "startRange", n.selectedDates[0] && 0 === S(t, n.selectedDates[0], !0)), d(s, "endRange", n.selectedDates[1] && 0 === S(t, n.selectedDates[1], !0)), "nextMonthDay" === e && s.classList.add("inRange")))) : s.classList.add("flatpickr-disabled"), "range" === n.config.mode && function (e) {
              return !("range" !== n.config.mode || n.selectedDates.length < 2) && S(e, n.selectedDates[0]) >= 0 && S(e, n.selectedDates[1]) <= 0;
            }(t) && !be(t) && s.classList.add("inRange"), n.weekNumbers && 1 === n.config.showMonths && "prevMonthDay" !== e && o % 7 == 6 && n.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + n.config.getWeek(t) + "</span>"), ve("onDayCreate", s), s;
          }

          function $(e) {
            e.focus(), "range" === n.config.mode && oe(e);
          }

          function H(e) {
            for (var t = e > 0 ? 0 : n.config.showMonths - 1, r = e > 0 ? n.config.showMonths : -1, o = t; o != r; o += e) {
              for (var i = n.daysContainer.children[o], s = e > 0 ? 0 : i.children.length - 1, a = e > 0 ? i.children.length : -1, l = s; l != a; l += e) {
                var c = i.children[l];
                if (-1 === c.className.indexOf("hidden") && ee(c.dateObj)) return c;
              }
            }
          }

          function U(e, t) {
            var r = i(),
                o = te(r || document.body),
                s = void 0 !== e ? e : o ? r : void 0 !== n.selectedDateElem && te(n.selectedDateElem) ? n.selectedDateElem : void 0 !== n.todayDateElem && te(n.todayDateElem) ? n.todayDateElem : H(t > 0 ? 1 : -1);
            void 0 === s ? n._input.focus() : o ? function (e, t) {
              for (var r = -1 === e.className.indexOf("Month") ? e.dateObj.getMonth() : n.currentMonth, o = t > 0 ? n.config.showMonths : -1, i = t > 0 ? 1 : -1, s = r - n.currentMonth; s != o; s += i) {
                for (var a = n.daysContainer.children[s], l = r - n.currentMonth === s ? e.$i + t : t < 0 ? a.children.length - 1 : 0, c = a.children.length, u = l; u >= 0 && u < c && u != (t > 0 ? c : -1); u += i) {
                  var d = a.children[u];
                  if (-1 === d.className.indexOf("hidden") && ee(d.dateObj) && Math.abs(e.$i - u) >= Math.abs(t)) return $(d);
                }
              }

              n.changeMonth(i), U(H(i), 0);
            }(s, t) : $(s);
          }

          function z(e, t) {
            for (var r = (new Date(e, t, 1).getDay() - n.l10n.firstDayOfWeek + 7) % 7, o = n.utils.getDaysInMonth((t - 1 + 12) % 12, e), i = n.utils.getDaysInMonth(t, e), s = window.document.createDocumentFragment(), a = n.config.showMonths > 1, l = a ? "prevMonthDay hidden" : "prevMonthDay", c = a ? "nextMonthDay hidden" : "nextMonthDay", u = o + 1 - r, d = 0; u <= o; u++, d++) {
              s.appendChild(B("flatpickr-day " + l, new Date(e, t - 1, u), 0, d));
            }

            for (u = 1; u <= i; u++, d++) {
              s.appendChild(B("flatpickr-day", new Date(e, t, u), 0, d));
            }

            for (var f = i + 1; f <= 42 - r && (1 === n.config.showMonths || d % 7 != 0); f++, d++) {
              s.appendChild(B("flatpickr-day " + c, new Date(e, t + 1, f % i), 0, d));
            }

            var p = h("div", "dayContainer");
            return p.appendChild(s), p;
          }

          function Y() {
            if (void 0 !== n.daysContainer) {
              f(n.daysContainer), n.weekNumbers && f(n.weekNumbers);

              for (var e = document.createDocumentFragment(), t = 0; t < n.config.showMonths; t++) {
                var r = new Date(n.currentYear, n.currentMonth, 1);
                r.setMonth(n.currentMonth + t), e.appendChild(z(r.getFullYear(), r.getMonth()));
              }

              n.daysContainer.appendChild(e), n.days = n.daysContainer.firstChild, "range" === n.config.mode && 1 === n.selectedDates.length && oe();
            }
          }

          function q() {
            if (!(n.config.showMonths > 1 || "dropdown" !== n.config.monthSelectorType)) {
              var e = function e(_e27) {
                return !(void 0 !== n.config.minDate && n.currentYear === n.config.minDate.getFullYear() && _e27 < n.config.minDate.getMonth() || void 0 !== n.config.maxDate && n.currentYear === n.config.maxDate.getFullYear() && _e27 > n.config.maxDate.getMonth());
              };

              n.monthsDropdownContainer.tabIndex = -1, n.monthsDropdownContainer.innerHTML = "";

              for (var t = 0; t < 12; t++) {
                if (e(t)) {
                  var r = h("option", "flatpickr-monthDropdown-month");
                  r.value = new Date(n.currentYear, t).getMonth().toString(), r.textContent = y(t, n.config.shorthandCurrentMonth, n.l10n), r.tabIndex = -1, n.currentMonth === t && (r.selected = !0), n.monthsDropdownContainer.appendChild(r);
                }
              }
            }
          }

          function V() {
            var e,
                t = h("div", "flatpickr-month"),
                r = window.document.createDocumentFragment();
            n.config.showMonths > 1 || "static" === n.config.monthSelectorType ? e = h("span", "cur-month") : (n.monthsDropdownContainer = h("select", "flatpickr-monthDropdown-months"), n.monthsDropdownContainer.setAttribute("aria-label", n.l10n.monthAriaLabel), F(n.monthsDropdownContainer, "change", function (e) {
              var t = m(e),
                  r = parseInt(t.value, 10);
              n.changeMonth(r - n.currentMonth), ve("onMonthChange");
            }), q(), e = n.monthsDropdownContainer);
            var o = g("cur-year", {
              tabindex: "-1"
            }),
                i = o.getElementsByTagName("input")[0];
            i.setAttribute("aria-label", n.l10n.yearAriaLabel), n.config.minDate && i.setAttribute("min", n.config.minDate.getFullYear().toString()), n.config.maxDate && (i.setAttribute("max", n.config.maxDate.getFullYear().toString()), i.disabled = !!n.config.minDate && n.config.minDate.getFullYear() === n.config.maxDate.getFullYear());
            var s = h("div", "flatpickr-current-month");
            return s.appendChild(e), s.appendChild(o), r.appendChild(s), t.appendChild(r), {
              container: t,
              yearElement: i,
              monthElement: e
            };
          }

          function W() {
            f(n.monthNav), n.monthNav.appendChild(n.prevMonthNav), n.config.showMonths && (n.yearElements = [], n.monthElements = []);

            for (var e = n.config.showMonths; e--;) {
              var t = V();
              n.yearElements.push(t.yearElement), n.monthElements.push(t.monthElement), n.monthNav.appendChild(t.container);
            }

            n.monthNav.appendChild(n.nextMonthNav);
          }

          function K() {
            n.weekdayContainer ? f(n.weekdayContainer) : n.weekdayContainer = h("div", "flatpickr-weekdays");

            for (var e = n.config.showMonths; e--;) {
              var t = h("div", "flatpickr-weekdaycontainer");
              n.weekdayContainer.appendChild(t);
            }

            return X(), n.weekdayContainer;
          }

          function X() {
            if (n.weekdayContainer) {
              var e = n.l10n.firstDayOfWeek,
                  t = P(n.l10n.weekdays.shorthand);
              e > 0 && e < t.length && (t = P(t.splice(e, t.length), t.splice(0, e)));

              for (var r = n.config.showMonths; r--;) {
                n.weekdayContainer.children[r].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + t.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
              }
            }
          }

          function Q(e, t) {
            void 0 === t && (t = !0);
            var r = t ? e : e - n.currentMonth;
            r < 0 && !0 === n._hidePrevMonthArrow || r > 0 && !0 === n._hideNextMonthArrow || (n.currentMonth += r, (n.currentMonth < 0 || n.currentMonth > 11) && (n.currentYear += n.currentMonth > 11 ? 1 : -1, n.currentMonth = (n.currentMonth + 12) % 12, ve("onYearChange"), q()), Y(), ve("onMonthChange"), we());
          }

          function G(e) {
            return n.calendarContainer.contains(e);
          }

          function J(e) {
            if (n.isOpen && !n.config.inline) {
              var t = m(e),
                  r = G(t),
                  o = !(t === n.input || t === n.altInput || n.element.contains(t) || e.path && e.path.indexOf && (~e.path.indexOf(n.input) || ~e.path.indexOf(n.altInput)) || r || G(e.relatedTarget)),
                  i = !n.config.ignoredFocusElements.some(function (e) {
                return e.contains(t);
              });
              o && i && (n.config.allowInput && n.setDate(n._input.value, !1, n.config.altInput ? n.config.altFormat : n.config.dateFormat), void 0 !== n.timeContainer && void 0 !== n.minuteElement && void 0 !== n.hourElement && "" !== n.input.value && void 0 !== n.input.value && O(), n.close(), n.config && "range" === n.config.mode && 1 === n.selectedDates.length && n.clear(!1));
            }
          }

          function Z(e) {
            if (!(!e || n.config.minDate && e < n.config.minDate.getFullYear() || n.config.maxDate && e > n.config.maxDate.getFullYear())) {
              var t = e,
                  r = n.currentYear !== t;
              n.currentYear = t || n.currentYear, n.config.maxDate && n.currentYear === n.config.maxDate.getFullYear() ? n.currentMonth = Math.min(n.config.maxDate.getMonth(), n.currentMonth) : n.config.minDate && n.currentYear === n.config.minDate.getFullYear() && (n.currentMonth = Math.max(n.config.minDate.getMonth(), n.currentMonth)), r && (n.redraw(), ve("onYearChange"), q());
            }
          }

          function ee(e, t) {
            var r;
            void 0 === t && (t = !0);
            var o = n.parseDate(e, void 0, t);
            if (n.config.minDate && o && S(o, n.config.minDate, void 0 !== t ? t : !n.minDateHasTime) < 0 || n.config.maxDate && o && S(o, n.config.maxDate, void 0 !== t ? t : !n.maxDateHasTime) > 0) return !1;
            if (!n.config.enable && 0 === n.config.disable.length) return !0;
            if (void 0 === o) return !1;

            for (var i = !!n.config.enable, s = null !== (r = n.config.enable) && void 0 !== r ? r : n.config.disable, a = 0, l = void 0; a < s.length; a++) {
              if ("function" == typeof (l = s[a]) && l(o)) return i;
              if (l instanceof Date && void 0 !== o && l.getTime() === o.getTime()) return i;

              if ("string" == typeof l) {
                var c = n.parseDate(l, void 0, !0);
                return c && c.getTime() === o.getTime() ? i : !i;
              }

              if ("object" == _typeof(l) && void 0 !== o && l.from && l.to && o.getTime() >= l.from.getTime() && o.getTime() <= l.to.getTime()) return i;
            }

            return !i;
          }

          function te(e) {
            return void 0 !== n.daysContainer && -1 === e.className.indexOf("hidden") && -1 === e.className.indexOf("flatpickr-disabled") && n.daysContainer.contains(e);
          }

          function ne(e) {
            var t = e.target === n._input,
                r = n._input.value.trimEnd() !== Oe();
            !t || !r || e.relatedTarget && G(e.relatedTarget) || n.setDate(n._input.value, !0, e.target === n.altInput ? n.config.altFormat : n.config.dateFormat);
          }

          function re(t) {
            var r = m(t),
                o = n.config.wrap ? e.contains(r) : r === n._input,
                s = n.config.allowInput,
                a = n.isOpen && (!s || !o),
                l = n.config.inline && o && !s;

            if (13 === t.keyCode && o) {
              if (s) return n.setDate(n._input.value, !0, r === n.altInput ? n.config.altFormat : n.config.dateFormat), n.close(), r.blur();
              n.open();
            } else if (G(r) || a || l) {
              var c = !!n.timeContainer && n.timeContainer.contains(r);

              switch (t.keyCode) {
                case 13:
                  c ? (t.preventDefault(), O(), de()) : he(t);
                  break;

                case 27:
                  t.preventDefault(), de();
                  break;

                case 8:
                case 46:
                  o && !n.config.allowInput && (t.preventDefault(), n.clear());
                  break;

                case 37:
                case 39:
                  if (c || o) n.hourElement && n.hourElement.focus();else {
                    t.preventDefault();
                    var u = i();

                    if (void 0 !== n.daysContainer && (!1 === s || u && te(u))) {
                      var d = 39 === t.keyCode ? 1 : -1;
                      t.ctrlKey ? (t.stopPropagation(), Q(d), U(H(1), 0)) : U(void 0, d);
                    }
                  }
                  break;

                case 38:
                case 40:
                  t.preventDefault();
                  var h = 40 === t.keyCode ? 1 : -1;
                  n.daysContainer && void 0 !== r.$i || r === n.input || r === n.altInput ? t.ctrlKey ? (t.stopPropagation(), Z(n.currentYear - h), U(H(1), 0)) : c || U(void 0, 7 * h) : r === n.currentYearElement ? Z(n.currentYear - h) : n.config.enableTime && (!c && n.hourElement && n.hourElement.focus(), O(t), n._debouncedChange());
                  break;

                case 9:
                  if (c) {
                    var f = [n.hourElement, n.minuteElement, n.secondElement, n.amPM].concat(n.pluginElements).filter(function (e) {
                      return e;
                    }),
                        p = f.indexOf(r);

                    if (-1 !== p) {
                      var g = f[p + (t.shiftKey ? -1 : 1)];
                      t.preventDefault(), (g || n._input).focus();
                    }
                  } else !n.config.noCalendar && n.daysContainer && n.daysContainer.contains(r) && t.shiftKey && (t.preventDefault(), n._input.focus());

              }
            }

            if (void 0 !== n.amPM && r === n.amPM) switch (t.key) {
              case n.l10n.amPM[0].charAt(0):
              case n.l10n.amPM[0].charAt(0).toLowerCase():
                n.amPM.textContent = n.l10n.amPM[0], j(), Ee();
                break;

              case n.l10n.amPM[1].charAt(0):
              case n.l10n.amPM[1].charAt(0).toLowerCase():
                n.amPM.textContent = n.l10n.amPM[1], j(), Ee();
            }
            (o || G(r)) && ve("onKeyDown", t);
          }

          function oe(e, t) {
            if (void 0 === t && (t = "flatpickr-day"), 1 === n.selectedDates.length && (!e || e.classList.contains(t) && !e.classList.contains("flatpickr-disabled"))) {
              for (var r = e ? e.dateObj.getTime() : n.days.firstElementChild.dateObj.getTime(), o = n.parseDate(n.selectedDates[0], void 0, !0).getTime(), i = Math.min(r, n.selectedDates[0].getTime()), s = Math.max(r, n.selectedDates[0].getTime()), a = !1, l = 0, c = 0, u = i; u < s; u += 864e5) {
                ee(new Date(u), !0) || (a = a || u > i && u < s, u < o && (!l || u > l) ? l = u : u > o && (!c || u < c) && (c = u));
              }

              Array.from(n.rContainer.querySelectorAll("*:nth-child(-n+" + n.config.showMonths + ") > ." + t)).forEach(function (t) {
                var i,
                    s,
                    u,
                    d = t.dateObj.getTime(),
                    h = l > 0 && d < l || c > 0 && d > c;
                if (h) return t.classList.add("notAllowed"), void ["inRange", "startRange", "endRange"].forEach(function (e) {
                  t.classList.remove(e);
                });
                a && !h || (["startRange", "inRange", "endRange", "notAllowed"].forEach(function (e) {
                  t.classList.remove(e);
                }), void 0 !== e && (e.classList.add(r <= n.selectedDates[0].getTime() ? "startRange" : "endRange"), o < r && d === o ? t.classList.add("startRange") : o > r && d === o && t.classList.add("endRange"), d >= l && (0 === c || d <= c) && (s = o, u = r, (i = d) > Math.min(s, u) && i < Math.max(s, u)) && t.classList.add("inRange")));
              });
            }
          }

          function ie() {
            !n.isOpen || n.config.static || n.config.inline || ce();
          }

          function se(e) {
            return function (t) {
              var r = n.config["_" + e + "Date"] = n.parseDate(t, n.config.dateFormat),
                  o = n.config["_" + ("min" === e ? "max" : "min") + "Date"];
              void 0 !== r && (n["min" === e ? "minDateHasTime" : "maxDateHasTime"] = r.getHours() > 0 || r.getMinutes() > 0 || r.getSeconds() > 0), n.selectedDates && (n.selectedDates = n.selectedDates.filter(function (e) {
                return ee(e);
              }), n.selectedDates.length || "min" !== e || T(r), Ee()), n.daysContainer && (ue(), void 0 !== r ? n.currentYearElement[e] = r.getFullYear().toString() : n.currentYearElement.removeAttribute(e), n.currentYearElement.disabled = !!o && void 0 !== r && o.getFullYear() === r.getFullYear());
            };
          }

          function ae() {
            return n.config.wrap ? e.querySelector("[data-input]") : e;
          }

          function le() {
            "object" != _typeof(n.config.locale) && void 0 === D.l10ns[n.config.locale] && n.config.errorHandler(new Error("flatpickr: invalid locale " + n.config.locale)), n.l10n = _k(_k({}, D.l10ns.default), "object" == _typeof(n.config.locale) ? n.config.locale : "default" !== n.config.locale ? D.l10ns[n.config.locale] : void 0), w.D = "(" + n.l10n.weekdays.shorthand.join("|") + ")", w.l = "(" + n.l10n.weekdays.longhand.join("|") + ")", w.M = "(" + n.l10n.months.shorthand.join("|") + ")", w.F = "(" + n.l10n.months.longhand.join("|") + ")", w.K = "(" + n.l10n.amPM[0] + "|" + n.l10n.amPM[1] + "|" + n.l10n.amPM[0].toLowerCase() + "|" + n.l10n.amPM[1].toLowerCase() + ")", void 0 === _k(_k({}, t), JSON.parse(JSON.stringify(e.dataset || {}))).time_24hr && void 0 === D.defaultConfig.time_24hr && (n.config.time_24hr = n.l10n.time_24hr), n.formatDate = E(n), n.parseDate = _({
              config: n.config,
              l10n: n.l10n
            });
          }

          function ce(e) {
            if ("function" != typeof n.config.position) {
              if (void 0 !== n.calendarContainer) {
                ve("onPreCalendarPosition");
                var t = e || n._positionElement,
                    r = Array.prototype.reduce.call(n.calendarContainer.children, function (e, t) {
                  return e + t.offsetHeight;
                }, 0),
                    o = n.calendarContainer.offsetWidth,
                    i = n.config.position.split(" "),
                    s = i[0],
                    a = i.length > 1 ? i[1] : null,
                    l = t.getBoundingClientRect(),
                    c = window.innerHeight - l.bottom,
                    u = "above" === s || "below" !== s && c < r && l.top > r,
                    h = window.pageYOffset + l.top + (u ? -r - 2 : t.offsetHeight + 2);

                if (d(n.calendarContainer, "arrowTop", !u), d(n.calendarContainer, "arrowBottom", u), !n.config.inline) {
                  var f = window.pageXOffset + l.left,
                      p = !1,
                      g = !1;
                  "center" === a ? (f -= (o - l.width) / 2, p = !0) : "right" === a && (f -= o - l.width, g = !0), d(n.calendarContainer, "arrowLeft", !p && !g), d(n.calendarContainer, "arrowCenter", p), d(n.calendarContainer, "arrowRight", g);
                  var m = window.document.body.offsetWidth - (window.pageXOffset + l.right),
                      v = f + o > window.document.body.offsetWidth,
                      y = m + o > window.document.body.offsetWidth;
                  if (d(n.calendarContainer, "rightMost", v), !n.config.static) if (n.calendarContainer.style.top = h + "px", v) {
                    if (y) {
                      var b = function () {
                        for (var e = null, t = 0; t < document.styleSheets.length; t++) {
                          var n = document.styleSheets[t];

                          if (n.cssRules) {
                            try {
                              n.cssRules;
                            } catch (e) {
                              continue;
                            }

                            e = n;
                            break;
                          }
                        }

                        return null != e ? e : (r = document.createElement("style"), document.head.appendChild(r), r.sheet);
                        var r;
                      }();

                      if (void 0 === b) return;

                      var w = window.document.body.offsetWidth,
                          O = Math.max(0, w / 2 - o / 2),
                          E = b.cssRules.length,
                          _ = "{left:" + l.left + "px;right:auto;}";

                      d(n.calendarContainer, "rightMost", !1), d(n.calendarContainer, "centerMost", !0), b.insertRule(".flatpickr-calendar.centerMost:before,.flatpickr-calendar.centerMost:after" + _, E), n.calendarContainer.style.left = O + "px", n.calendarContainer.style.right = "auto";
                    } else n.calendarContainer.style.left = "auto", n.calendarContainer.style.right = m + "px";
                  } else n.calendarContainer.style.left = f + "px", n.calendarContainer.style.right = "auto";
                }
              }
            } else n.config.position(n, e);
          }

          function ue() {
            n.config.noCalendar || n.isMobile || (q(), we(), Y());
          }

          function de() {
            n._input.focus(), -1 !== window.navigator.userAgent.indexOf("MSIE") || void 0 !== navigator.msMaxTouchPoints ? setTimeout(n.close, 0) : n.close();
          }

          function he(e) {
            e.preventDefault(), e.stopPropagation();
            var t = p(m(e), function (e) {
              return e.classList && e.classList.contains("flatpickr-day") && !e.classList.contains("flatpickr-disabled") && !e.classList.contains("notAllowed");
            });

            if (void 0 !== t) {
              var r = t,
                  o = n.latestSelectedDateObj = new Date(r.dateObj.getTime()),
                  i = (o.getMonth() < n.currentMonth || o.getMonth() > n.currentMonth + n.config.showMonths - 1) && "range" !== n.config.mode;
              if (n.selectedDateElem = r, "single" === n.config.mode) n.selectedDates = [o];else if ("multiple" === n.config.mode) {
                var s = be(o);
                s ? n.selectedDates.splice(parseInt(s), 1) : n.selectedDates.push(o);
              } else "range" === n.config.mode && (2 === n.selectedDates.length && n.clear(!1, !1), n.latestSelectedDateObj = o, n.selectedDates.push(o), 0 !== S(o, n.selectedDates[0], !0) && n.selectedDates.sort(function (e, t) {
                return e.getTime() - t.getTime();
              }));

              if (j(), i) {
                var a = n.currentYear !== o.getFullYear();
                n.currentYear = o.getFullYear(), n.currentMonth = o.getMonth(), a && (ve("onYearChange"), q()), ve("onMonthChange");
              }

              if (we(), Y(), Ee(), i || "range" === n.config.mode || 1 !== n.config.showMonths ? void 0 !== n.selectedDateElem && void 0 === n.hourElement && n.selectedDateElem && n.selectedDateElem.focus() : $(r), void 0 !== n.hourElement && void 0 !== n.hourElement && n.hourElement.focus(), n.config.closeOnSelect) {
                var l = "single" === n.config.mode && !n.config.enableTime,
                    c = "range" === n.config.mode && 2 === n.selectedDates.length && !n.config.enableTime;
                (l || c) && de();
              }

              L();
            }
          }

          n.parseDate = _({
            config: n.config,
            l10n: n.l10n
          }), n._handlers = [], n.pluginElements = [], n.loadedPlugins = [], n._bind = F, n._setHoursFromDate = T, n._positionCalendar = ce, n.changeMonth = Q, n.changeYear = Z, n.clear = function (e, t) {
            if (void 0 === e && (e = !0), void 0 === t && (t = !0), n.input.value = "", void 0 !== n.altInput && (n.altInput.value = ""), void 0 !== n.mobileInput && (n.mobileInput.value = ""), n.selectedDates = [], n.latestSelectedDateObj = void 0, !0 === t && (n.currentYear = n._initialDate.getFullYear(), n.currentMonth = n._initialDate.getMonth()), !0 === n.config.enableTime) {
              var r = C(n.config);
              M(r.hours, r.minutes, r.seconds);
            }

            n.redraw(), e && ve("onChange");
          }, n.close = function () {
            n.isOpen = !1, n.isMobile || (void 0 !== n.calendarContainer && n.calendarContainer.classList.remove("open"), void 0 !== n._input && n._input.classList.remove("active")), ve("onClose");
          }, n.onMouseOver = oe, n._createElement = h, n.createDay = B, n.destroy = function () {
            void 0 !== n.config && ve("onDestroy");

            for (var e = n._handlers.length; e--;) {
              n._handlers[e].remove();
            }

            if (n._handlers = [], n.mobileInput) n.mobileInput.parentNode && n.mobileInput.parentNode.removeChild(n.mobileInput), n.mobileInput = void 0;else if (n.calendarContainer && n.calendarContainer.parentNode) if (n.config.static && n.calendarContainer.parentNode) {
              var t = n.calendarContainer.parentNode;

              if (t.lastChild && t.removeChild(t.lastChild), t.parentNode) {
                for (; t.firstChild;) {
                  t.parentNode.insertBefore(t.firstChild, t);
                }

                t.parentNode.removeChild(t);
              }
            } else n.calendarContainer.parentNode.removeChild(n.calendarContainer);
            n.altInput && (n.input.type = "text", n.altInput.parentNode && n.altInput.parentNode.removeChild(n.altInput), delete n.altInput), n.input && (n.input.type = n.input._type, n.input.classList.remove("flatpickr-input"), n.input.removeAttribute("readonly")), ["_showTimeInput", "latestSelectedDateObj", "_hideNextMonthArrow", "_hidePrevMonthArrow", "__hideNextMonthArrow", "__hidePrevMonthArrow", "isMobile", "isOpen", "selectedDateElem", "minDateHasTime", "maxDateHasTime", "days", "daysContainer", "_input", "_positionElement", "innerContainer", "rContainer", "monthNav", "todayDateElem", "calendarContainer", "weekdayContainer", "prevMonthNav", "nextMonthNav", "monthsDropdownContainer", "currentMonthElement", "currentYearElement", "navigationCurrentMonth", "selectedDateElem", "config"].forEach(function (e) {
              try {
                delete n[e];
              } catch (e) {}
            });
          }, n.isEnabled = ee, n.jumpToDate = I, n.updateValue = Ee, n.open = function (e, t) {
            if (void 0 === t && (t = n._positionElement), !0 === n.isMobile) {
              if (e) {
                e.preventDefault();
                var r = m(e);
                r && r.blur();
              }

              return void 0 !== n.mobileInput && (n.mobileInput.focus(), n.mobileInput.click()), void ve("onOpen");
            }

            if (!n._input.disabled && !n.config.inline) {
              var o = n.isOpen;
              n.isOpen = !0, o || (n.calendarContainer.classList.add("open"), n._input.classList.add("active"), ve("onOpen"), ce(t)), !0 === n.config.enableTime && !0 === n.config.noCalendar && (!1 !== n.config.allowInput || void 0 !== e && n.timeContainer.contains(e.relatedTarget) || setTimeout(function () {
                return n.hourElement.select();
              }, 50));
            }
          }, n.redraw = ue, n.set = function (e, t) {
            if (null !== e && "object" == _typeof(e)) for (var o in Object.assign(n.config, e), e) {
              void 0 !== fe[o] && fe[o].forEach(function (e) {
                return e();
              });
            } else n.config[e] = t, void 0 !== fe[e] ? fe[e].forEach(function (e) {
              return e();
            }) : r.indexOf(e) > -1 && (n.config[e] = u(t));
            n.redraw(), Ee(!0);
          }, n.setDate = function (e, t, r) {
            if (void 0 === t && (t = !1), void 0 === r && (r = n.config.dateFormat), 0 !== e && !e || e instanceof Array && 0 === e.length) return n.clear(t);
            pe(e, r), n.latestSelectedDateObj = n.selectedDates[n.selectedDates.length - 1], n.redraw(), I(void 0, t), T(), 0 === n.selectedDates.length && n.clear(!1), Ee(t), t && ve("onChange");
          }, n.toggle = function (e) {
            if (!0 === n.isOpen) return n.close();
            n.open(e);
          };
          var fe = {
            locale: [le, X],
            showMonths: [W, b, K],
            minDate: [I],
            maxDate: [I],
            positionElement: [me],
            clickOpens: [function () {
              !0 === n.config.clickOpens ? (F(n._input, "focus", n.open), F(n._input, "click", n.open)) : (n._input.removeEventListener("focus", n.open), n._input.removeEventListener("click", n.open));
            }]
          };

          function pe(e, t) {
            var r = [];
            if (e instanceof Array) r = e.map(function (e) {
              return n.parseDate(e, t);
            });else if (e instanceof Date || "number" == typeof e) r = [n.parseDate(e, t)];else if ("string" == typeof e) switch (n.config.mode) {
              case "single":
              case "time":
                r = [n.parseDate(e, t)];
                break;

              case "multiple":
                r = e.split(n.config.conjunction).map(function (e) {
                  return n.parseDate(e, t);
                });
                break;

              case "range":
                r = e.split(n.l10n.rangeSeparator).map(function (e) {
                  return n.parseDate(e, t);
                });
            } else n.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(e)));
            n.selectedDates = n.config.allowInvalidPreload ? r : r.filter(function (e) {
              return e instanceof Date && ee(e, !1);
            }), "range" === n.config.mode && n.selectedDates.sort(function (e, t) {
              return e.getTime() - t.getTime();
            });
          }

          function ge(e) {
            return e.slice().map(function (e) {
              return "string" == typeof e || "number" == typeof e || e instanceof Date ? n.parseDate(e, void 0, !0) : e && "object" == _typeof(e) && e.from && e.to ? {
                from: n.parseDate(e.from, void 0),
                to: n.parseDate(e.to, void 0)
              } : e;
            }).filter(function (e) {
              return e;
            });
          }

          function me() {
            n._positionElement = n.config.positionElement || n._input;
          }

          function ve(e, t) {
            if (void 0 !== n.config) {
              var r = n.config[e];
              if (void 0 !== r && r.length > 0) for (var o = 0; r[o] && o < r.length; o++) {
                r[o](n.selectedDates, n.input.value, n, t);
              }
              "onChange" === e && (n.input.dispatchEvent(ye("change")), n.input.dispatchEvent(ye("input")));
            }
          }

          function ye(e) {
            var t = document.createEvent("Event");
            return t.initEvent(e, !0, !0), t;
          }

          function be(e) {
            for (var t = 0; t < n.selectedDates.length; t++) {
              var r = n.selectedDates[t];
              if (r instanceof Date && 0 === S(r, e)) return "" + t;
            }

            return !1;
          }

          function we() {
            n.config.noCalendar || n.isMobile || !n.monthNav || (n.yearElements.forEach(function (e, t) {
              var r = new Date(n.currentYear, n.currentMonth, 1);
              r.setMonth(n.currentMonth + t), n.config.showMonths > 1 || "static" === n.config.monthSelectorType ? n.monthElements[t].textContent = y(r.getMonth(), n.config.shorthandCurrentMonth, n.l10n) + " " : n.monthsDropdownContainer.value = r.getMonth().toString(), e.value = r.getFullYear().toString();
            }), n._hidePrevMonthArrow = void 0 !== n.config.minDate && (n.currentYear === n.config.minDate.getFullYear() ? n.currentMonth <= n.config.minDate.getMonth() : n.currentYear < n.config.minDate.getFullYear()), n._hideNextMonthArrow = void 0 !== n.config.maxDate && (n.currentYear === n.config.maxDate.getFullYear() ? n.currentMonth + 1 > n.config.maxDate.getMonth() : n.currentYear > n.config.maxDate.getFullYear()));
          }

          function Oe(e) {
            var t = e || (n.config.altInput ? n.config.altFormat : n.config.dateFormat);
            return n.selectedDates.map(function (e) {
              return n.formatDate(e, t);
            }).filter(function (e, t, r) {
              return "range" !== n.config.mode || n.config.enableTime || r.indexOf(e) === t;
            }).join("range" !== n.config.mode ? n.config.conjunction : n.l10n.rangeSeparator);
          }

          function Ee(e) {
            void 0 === e && (e = !0), void 0 !== n.mobileInput && n.mobileFormatStr && (n.mobileInput.value = void 0 !== n.latestSelectedDateObj ? n.formatDate(n.latestSelectedDateObj, n.mobileFormatStr) : ""), n.input.value = Oe(n.config.dateFormat), void 0 !== n.altInput && (n.altInput.value = Oe(n.config.altFormat)), !1 !== e && ve("onValueUpdate");
          }

          function _e(e) {
            var t = m(e),
                r = n.prevMonthNav.contains(t),
                o = n.nextMonthNav.contains(t);
            r || o ? Q(r ? -1 : 1) : n.yearElements.indexOf(t) >= 0 ? t.select() : t.classList.contains("arrowUp") ? n.changeYear(n.currentYear + 1) : t.classList.contains("arrowDown") && n.changeYear(n.currentYear - 1);
          }

          return function () {
            n.element = n.input = e, n.isOpen = !1, function () {
              var i = ["wrap", "weekNumbers", "allowInput", "allowInvalidPreload", "clickOpens", "time_24hr", "enableTime", "noCalendar", "altInput", "shorthandCurrentMonth", "inline", "static", "enableSeconds", "disableMobile"],
                  s = _k(_k({}, JSON.parse(JSON.stringify(e.dataset || {}))), t),
                  a = {};

              n.config.parseDate = s.parseDate, n.config.formatDate = s.formatDate, Object.defineProperty(n.config, "enable", {
                get: function get() {
                  return n.config._enable;
                },
                set: function set(e) {
                  n.config._enable = ge(e);
                }
              }), Object.defineProperty(n.config, "disable", {
                get: function get() {
                  return n.config._disable;
                },
                set: function set(e) {
                  n.config._disable = ge(e);
                }
              });
              var l = "time" === s.mode;

              if (!s.dateFormat && (s.enableTime || l)) {
                var c = D.defaultConfig.dateFormat || o.dateFormat;
                a.dateFormat = s.noCalendar || l ? "H:i" + (s.enableSeconds ? ":S" : "") : c + " H:i" + (s.enableSeconds ? ":S" : "");
              }

              if (s.altInput && (s.enableTime || l) && !s.altFormat) {
                var d = D.defaultConfig.altFormat || o.altFormat;
                a.altFormat = s.noCalendar || l ? "h:i" + (s.enableSeconds ? ":S K" : " K") : d + " h:i" + (s.enableSeconds ? ":S" : "") + " K";
              }

              Object.defineProperty(n.config, "minDate", {
                get: function get() {
                  return n.config._minDate;
                },
                set: se("min")
              }), Object.defineProperty(n.config, "maxDate", {
                get: function get() {
                  return n.config._maxDate;
                },
                set: se("max")
              });

              var h = function h(e) {
                return function (t) {
                  n.config["min" === e ? "_minTime" : "_maxTime"] = n.parseDate(t, "H:i:S");
                };
              };

              Object.defineProperty(n.config, "minTime", {
                get: function get() {
                  return n.config._minTime;
                },
                set: h("min")
              }), Object.defineProperty(n.config, "maxTime", {
                get: function get() {
                  return n.config._maxTime;
                },
                set: h("max")
              }), "time" === s.mode && (n.config.noCalendar = !0, n.config.enableTime = !0), Object.assign(n.config, a, s);

              for (var f = 0; f < i.length; f++) {
                n.config[i[f]] = !0 === n.config[i[f]] || "true" === n.config[i[f]];
              }

              for (r.filter(function (e) {
                return void 0 !== n.config[e];
              }).forEach(function (e) {
                n.config[e] = u(n.config[e] || []).map(v);
              }), n.isMobile = !n.config.disableMobile && !n.config.inline && "single" === n.config.mode && !n.config.disable.length && !n.config.enable && !n.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), f = 0; f < n.config.plugins.length; f++) {
                var p = n.config.plugins[f](n) || {};

                for (var g in p) {
                  r.indexOf(g) > -1 ? n.config[g] = u(p[g]).map(v).concat(n.config[g]) : void 0 === s[g] && (n.config[g] = p[g]);
                }
              }

              s.altInputClass || (n.config.altInputClass = ae().className + " " + n.config.altInputClass), ve("onParseConfig");
            }(), le(), n.input = ae(), n.input ? (n.input._type = n.input.type, n.input.type = "text", n.input.classList.add("flatpickr-input"), n._input = n.input, n.config.altInput && (n.altInput = h(n.input.nodeName, n.config.altInputClass), n._input = n.altInput, n.altInput.placeholder = n.input.placeholder, n.altInput.disabled = n.input.disabled, n.altInput.required = n.input.required, n.altInput.tabIndex = n.input.tabIndex, n.altInput.type = "text", n.input.setAttribute("type", "hidden"), !n.config.static && n.input.parentNode && n.input.parentNode.insertBefore(n.altInput, n.input.nextSibling)), n.config.allowInput || n._input.setAttribute("readonly", "readonly"), me()) : n.config.errorHandler(new Error("Invalid input element specified")), function () {
              n.selectedDates = [], n.now = n.parseDate(n.config.now) || new Date();
              var e = n.config.defaultDate || ("INPUT" !== n.input.nodeName && "TEXTAREA" !== n.input.nodeName || !n.input.placeholder || n.input.value !== n.input.placeholder ? n.input.value : null);
              e && pe(e, n.config.dateFormat), n._initialDate = n.selectedDates.length > 0 ? n.selectedDates[0] : n.config.minDate && n.config.minDate.getTime() > n.now.getTime() ? n.config.minDate : n.config.maxDate && n.config.maxDate.getTime() < n.now.getTime() ? n.config.maxDate : n.now, n.currentYear = n._initialDate.getFullYear(), n.currentMonth = n._initialDate.getMonth(), n.selectedDates.length > 0 && (n.latestSelectedDateObj = n.selectedDates[0]), void 0 !== n.config.minTime && (n.config.minTime = n.parseDate(n.config.minTime, "H:i")), void 0 !== n.config.maxTime && (n.config.maxTime = n.parseDate(n.config.maxTime, "H:i")), n.minDateHasTime = !!n.config.minDate && (n.config.minDate.getHours() > 0 || n.config.minDate.getMinutes() > 0 || n.config.minDate.getSeconds() > 0), n.maxDateHasTime = !!n.config.maxDate && (n.config.maxDate.getHours() > 0 || n.config.maxDate.getMinutes() > 0 || n.config.maxDate.getSeconds() > 0);
            }(), n.utils = {
              getDaysInMonth: function getDaysInMonth(e, t) {
                return void 0 === e && (e = n.currentMonth), void 0 === t && (t = n.currentYear), 1 === e && (t % 4 == 0 && t % 100 != 0 || t % 400 == 0) ? 29 : n.l10n.daysInMonth[e];
              }
            }, n.isMobile || function () {
              var e = window.document.createDocumentFragment();

              if (n.calendarContainer = h("div", "flatpickr-calendar"), n.calendarContainer.tabIndex = -1, !n.config.noCalendar) {
                if (e.appendChild((n.monthNav = h("div", "flatpickr-months"), n.yearElements = [], n.monthElements = [], n.prevMonthNav = h("span", "flatpickr-prev-month"), n.prevMonthNav.innerHTML = n.config.prevArrow, n.nextMonthNav = h("span", "flatpickr-next-month"), n.nextMonthNav.innerHTML = n.config.nextArrow, W(), Object.defineProperty(n, "_hidePrevMonthArrow", {
                  get: function get() {
                    return n.__hidePrevMonthArrow;
                  },
                  set: function set(e) {
                    n.__hidePrevMonthArrow !== e && (d(n.prevMonthNav, "flatpickr-disabled", e), n.__hidePrevMonthArrow = e);
                  }
                }), Object.defineProperty(n, "_hideNextMonthArrow", {
                  get: function get() {
                    return n.__hideNextMonthArrow;
                  },
                  set: function set(e) {
                    n.__hideNextMonthArrow !== e && (d(n.nextMonthNav, "flatpickr-disabled", e), n.__hideNextMonthArrow = e);
                  }
                }), n.currentYearElement = n.yearElements[0], we(), n.monthNav)), n.innerContainer = h("div", "flatpickr-innerContainer"), n.config.weekNumbers) {
                  var t = function () {
                    n.calendarContainer.classList.add("hasWeeks");
                    var e = h("div", "flatpickr-weekwrapper");
                    e.appendChild(h("span", "flatpickr-weekday", n.l10n.weekAbbreviation));
                    var t = h("div", "flatpickr-weeks");
                    return e.appendChild(t), {
                      weekWrapper: e,
                      weekNumbers: t
                    };
                  }(),
                      r = t.weekWrapper,
                      o = t.weekNumbers;

                  n.innerContainer.appendChild(r), n.weekNumbers = o, n.weekWrapper = r;
                }

                n.rContainer = h("div", "flatpickr-rContainer"), n.rContainer.appendChild(K()), n.daysContainer || (n.daysContainer = h("div", "flatpickr-days"), n.daysContainer.tabIndex = -1), Y(), n.rContainer.appendChild(n.daysContainer), n.innerContainer.appendChild(n.rContainer), e.appendChild(n.innerContainer);
              }

              n.config.enableTime && e.appendChild(function () {
                n.calendarContainer.classList.add("hasTime"), n.config.noCalendar && n.calendarContainer.classList.add("noCalendar");
                var e = C(n.config);
                n.timeContainer = h("div", "flatpickr-time"), n.timeContainer.tabIndex = -1;
                var t = h("span", "flatpickr-time-separator", ":"),
                    r = g("flatpickr-hour", {
                  "aria-label": n.l10n.hourAriaLabel
                });
                n.hourElement = r.getElementsByTagName("input")[0];
                var o = g("flatpickr-minute", {
                  "aria-label": n.l10n.minuteAriaLabel
                });

                if (n.minuteElement = o.getElementsByTagName("input")[0], n.hourElement.tabIndex = n.minuteElement.tabIndex = -1, n.hourElement.value = a(n.latestSelectedDateObj ? n.latestSelectedDateObj.getHours() : n.config.time_24hr ? e.hours : function (e) {
                  switch (e % 24) {
                    case 0:
                    case 12:
                      return 12;

                    default:
                      return e % 12;
                  }
                }(e.hours)), n.minuteElement.value = a(n.latestSelectedDateObj ? n.latestSelectedDateObj.getMinutes() : e.minutes), n.hourElement.setAttribute("step", n.config.hourIncrement.toString()), n.minuteElement.setAttribute("step", n.config.minuteIncrement.toString()), n.hourElement.setAttribute("min", n.config.time_24hr ? "0" : "1"), n.hourElement.setAttribute("max", n.config.time_24hr ? "23" : "12"), n.hourElement.setAttribute("maxlength", "2"), n.minuteElement.setAttribute("min", "0"), n.minuteElement.setAttribute("max", "59"), n.minuteElement.setAttribute("maxlength", "2"), n.timeContainer.appendChild(r), n.timeContainer.appendChild(t), n.timeContainer.appendChild(o), n.config.time_24hr && n.timeContainer.classList.add("time24hr"), n.config.enableSeconds) {
                  n.timeContainer.classList.add("hasSeconds");
                  var i = g("flatpickr-second");
                  n.secondElement = i.getElementsByTagName("input")[0], n.secondElement.value = a(n.latestSelectedDateObj ? n.latestSelectedDateObj.getSeconds() : e.seconds), n.secondElement.setAttribute("step", n.minuteElement.getAttribute("step")), n.secondElement.setAttribute("min", "0"), n.secondElement.setAttribute("max", "59"), n.secondElement.setAttribute("maxlength", "2"), n.timeContainer.appendChild(h("span", "flatpickr-time-separator", ":")), n.timeContainer.appendChild(i);
                }

                return n.config.time_24hr || (n.amPM = h("span", "flatpickr-am-pm", n.l10n.amPM[l((n.latestSelectedDateObj ? n.hourElement.value : n.config.defaultHour) > 11)]), n.amPM.title = n.l10n.toggleTitle, n.amPM.tabIndex = -1, n.timeContainer.appendChild(n.amPM)), n.timeContainer;
              }()), d(n.calendarContainer, "rangeMode", "range" === n.config.mode), d(n.calendarContainer, "animate", !0 === n.config.animate), d(n.calendarContainer, "multiMonth", n.config.showMonths > 1), n.calendarContainer.appendChild(e);
              var i = void 0 !== n.config.appendTo && void 0 !== n.config.appendTo.nodeType;

              if ((n.config.inline || n.config.static) && (n.calendarContainer.classList.add(n.config.inline ? "inline" : "static"), n.config.inline && (!i && n.element.parentNode ? n.element.parentNode.insertBefore(n.calendarContainer, n._input.nextSibling) : void 0 !== n.config.appendTo && n.config.appendTo.appendChild(n.calendarContainer)), n.config.static)) {
                var s = h("div", "flatpickr-wrapper");
                n.element.parentNode && n.element.parentNode.insertBefore(s, n.element), s.appendChild(n.element), n.altInput && s.appendChild(n.altInput), s.appendChild(n.calendarContainer);
              }

              n.config.static || n.config.inline || (void 0 !== n.config.appendTo ? n.config.appendTo : window.document.body).appendChild(n.calendarContainer);
            }(), function () {
              if (n.config.wrap && ["open", "close", "toggle", "clear"].forEach(function (e) {
                Array.prototype.forEach.call(n.element.querySelectorAll("[data-" + e + "]"), function (t) {
                  return F(t, "click", n[e]);
                });
              }), n.isMobile) !function () {
                var e = n.config.enableTime ? n.config.noCalendar ? "time" : "datetime-local" : "date";
                n.mobileInput = h("input", n.input.className + " flatpickr-mobile"), n.mobileInput.tabIndex = 1, n.mobileInput.type = e, n.mobileInput.disabled = n.input.disabled, n.mobileInput.required = n.input.required, n.mobileInput.placeholder = n.input.placeholder, n.mobileFormatStr = "datetime-local" === e ? "Y-m-d\\TH:i:S" : "date" === e ? "Y-m-d" : "H:i:S", n.selectedDates.length > 0 && (n.mobileInput.defaultValue = n.mobileInput.value = n.formatDate(n.selectedDates[0], n.mobileFormatStr)), n.config.minDate && (n.mobileInput.min = n.formatDate(n.config.minDate, "Y-m-d")), n.config.maxDate && (n.mobileInput.max = n.formatDate(n.config.maxDate, "Y-m-d")), n.input.getAttribute("step") && (n.mobileInput.step = String(n.input.getAttribute("step"))), n.input.type = "hidden", void 0 !== n.altInput && (n.altInput.type = "hidden");

                try {
                  n.input.parentNode && n.input.parentNode.insertBefore(n.mobileInput, n.input.nextSibling);
                } catch (e) {}

                F(n.mobileInput, "change", function (e) {
                  n.setDate(m(e).value, !1, n.mobileFormatStr), ve("onChange"), ve("onClose");
                });
              }();else {
                var e = c(ie, 50);

                if (n._debouncedChange = c(L, 300), n.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent) && F(n.daysContainer, "mouseover", function (e) {
                  "range" === n.config.mode && oe(m(e));
                }), F(n._input, "keydown", re), void 0 !== n.calendarContainer && F(n.calendarContainer, "keydown", re), n.config.inline || n.config.static || F(window, "resize", e), void 0 !== window.ontouchstart ? F(window.document, "touchstart", J) : F(window.document, "mousedown", J), F(window.document, "focus", J, {
                  capture: !0
                }), !0 === n.config.clickOpens && (F(n._input, "focus", n.open), F(n._input, "click", n.open)), void 0 !== n.daysContainer && (F(n.monthNav, "click", _e), F(n.monthNav, ["keyup", "increment"], A), F(n.daysContainer, "click", he)), void 0 !== n.timeContainer && void 0 !== n.minuteElement && void 0 !== n.hourElement) {
                  F(n.timeContainer, ["increment"], O), F(n.timeContainer, "blur", O, {
                    capture: !0
                  }), F(n.timeContainer, "click", R), F([n.hourElement, n.minuteElement], ["focus", "click"], function (e) {
                    return m(e).select();
                  }), void 0 !== n.secondElement && F(n.secondElement, "focus", function () {
                    return n.secondElement && n.secondElement.select();
                  }), void 0 !== n.amPM && F(n.amPM, "click", function (e) {
                    O(e);
                  });
                }

                n.config.allowInput && F(n._input, "blur", ne);
              }
            }(), (n.selectedDates.length || n.config.noCalendar) && (n.config.enableTime && T(n.config.noCalendar ? n.latestSelectedDateObj : void 0), Ee(!1)), b();
            var i = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            !n.isMobile && i && ce(), ve("onReady");
          }(), n;
        }

        function T(e, t) {
          for (var n = Array.prototype.slice.call(e).filter(function (e) {
            return e instanceof HTMLElement;
          }), r = [], o = 0; o < n.length; o++) {
            var i = n[o];

            try {
              if (null !== i.getAttribute("data-fp-omit")) continue;
              void 0 !== i._flatpickr && (i._flatpickr.destroy(), i._flatpickr = void 0), i._flatpickr = j(i, t || {}), r.push(i._flatpickr);
            } catch (e) {
              console.error(e);
            }
          }

          return 1 === r.length ? r[0] : r;
        }

        "undefined" != typeof HTMLElement && "undefined" != typeof HTMLCollection && "undefined" != typeof NodeList && (HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (e) {
          return T(this, e);
        }, HTMLElement.prototype.flatpickr = function (e) {
          return T([this], e);
        });

        var D = function D(e, t) {
          return "string" == typeof e ? T(window.document.querySelectorAll(e), t) : e instanceof Node ? T([e], t) : T(e, t);
        };

        D.defaultConfig = {}, D.l10ns = {
          en: _k({}, s),
          default: _k({}, s)
        }, D.localize = function (e) {
          D.l10ns.default = _k(_k({}, D.l10ns.default), e);
        }, D.setDefaults = function (e) {
          D.defaultConfig = _k(_k({}, D.defaultConfig), e);
        }, D.parseDate = _({}), D.formatDate = E({}), D.compareDates = S, "undefined" != typeof jQuery && void 0 !== jQuery.fn && (jQuery.fn.flatpickr = function (e) {
          return T(this, e);
        }), Date.prototype.fp_incr = function (e) {
          return new Date(this.getFullYear(), this.getMonth(), this.getDate() + ("string" == typeof e ? parseInt(e, 10) : e));
        }, "undefined" != typeof window && (window.flatpickr = D);
        var M = D;

        function A(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function F(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function L(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }

        function I(e, t) {
          var n = Object.keys(e);

          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }

          return n;
        }

        function R(e) {
          return R = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, R(e);
        }

        function N(e, t) {
          return N = Object.setPrototypeOf || function (e, t) {
            return e.__proto__ = t, e;
          }, N(e, t);
        }

        function B() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }

        function $(e, t) {
          return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e) : t;
        }

        function H(e) {
          return e.replace(/(?:[_-])([a-z0-9])/g, function (e, t) {
            return t.toUpperCase();
          });
        }

        function U(e) {
          return e.charAt(0).toUpperCase() + e.slice(1);
        }

        function z(e, t) {
          var n = Y(e);
          return Array.from(n.reduce(function (e, n) {
            return function (e, t) {
              var n = e[t];
              return Array.isArray(n) ? n : [];
            }(n, t).forEach(function (t) {
              return e.add(t);
            }), e;
          }, new Set()));
        }

        function Y(e) {
          var t = [];

          for (; e;) {
            t.push(e), e = Object.getPrototypeOf(e);
          }

          return t.reverse();
        }

        function q(_ref36) {
          var _ref37 = _slicedToArray(_ref36, 2),
              e = _ref37[0],
              t = _ref37[1];

          return function (e, t) {
            var n = "".concat((o = e, o.replace(/([A-Z])/g, function (e, t) {
              return "-".concat(t.toLowerCase());
            })), "-value"),
                r = function (e) {
              var t = function (e) {
                var t = V(e.type);

                if (t) {
                  var _n16 = W(e.default);

                  if (t !== _n16) throw new Error("Type \"".concat(t, "\" must match the type of the default value. Given default value: \"").concat(e.default, "\" as \"").concat(_n16, "\""));
                  return t;
                }
              }(e),
                  n = W(e),
                  r = V(e),
                  o = t || n || r;

              if (o) return o;
              throw new Error("Unknown value type \"".concat(e, "\""));
            }(t);

            var o;
            return {
              type: r,
              key: n,
              name: H(n),

              get defaultValue() {
                return function (e) {
                  var t = V(e);
                  if (t) return K[t];
                  var n = e.default;
                  return void 0 !== n ? n : e;
                }(t);
              },

              get hasCustomDefaultValue() {
                return void 0 !== W(t);
              },

              reader: X[r],
              writer: Q[r] || Q.default
            };
          }(e, t);
        }

        function V(e) {
          switch (e) {
            case Array:
              return "array";

            case Boolean:
              return "boolean";

            case Number:
              return "number";

            case Object:
              return "object";

            case String:
              return "string";
          }
        }

        function W(e) {
          switch (_typeof(e)) {
            case "boolean":
              return "boolean";

            case "number":
              return "number";

            case "string":
              return "string";
          }

          return Array.isArray(e) ? "array" : "[object Object]" === Object.prototype.toString.call(e) ? "object" : void 0;
        }

        (function () {
          try {
            !function () {
              var e = function (e) {
                function t() {
                  return Reflect.construct(e, arguments, this instanceof t ? this.constructor : void 0);
                }

                return t.prototype = Object.create(e.prototype, {
                  constructor: {
                    value: t
                  }
                }), Reflect.setPrototypeOf(t, e), t;
              }(function () {
                this.a.call(this);
              });

              e.prototype.a = function () {}, new e();
            }();
          } catch (e) {
            return function (e) {
              return /*#__PURE__*/function (_e28) {
                _inherits(_class7, _e28);

                var _super61 = _createSuper(_class7);

                function _class7() {
                  _classCallCheck(this, _class7);

                  return _super61.apply(this, arguments);
                }

                return _class7;
              }(e);
            };
          }
        })();

        var K = {
          get array() {
            return [];
          },

          boolean: !1,
          number: 0,

          get object() {
            return {};
          },

          string: ""
        },
            X = {
          array: function array(e) {
            var t = JSON.parse(e);
            if (!Array.isArray(t)) throw new TypeError("Expected array");
            return t;
          },
          boolean: function boolean(e) {
            return !("0" == e || "false" == e);
          },
          number: function number(e) {
            return Number(e);
          },
          object: function object(e) {
            var t = JSON.parse(e);
            if (null === t || "object" != _typeof(t) || Array.isArray(t)) throw new TypeError("Expected object");
            return t;
          },
          string: function string(e) {
            return e;
          }
        },
            Q = {
          default: function _default(e) {
            return "".concat(e);
          },
          array: G,
          object: G
        };

        function G(e) {
          return JSON.stringify(e);
        }

        var J = /*#__PURE__*/function () {
          function J(e) {
            _classCallCheck(this, J);

            this.context = e;
          }

          _createClass(J, [{
            key: "application",
            get: function get() {
              return this.context.application;
            }
          }, {
            key: "scope",
            get: function get() {
              return this.context.scope;
            }
          }, {
            key: "element",
            get: function get() {
              return this.scope.element;
            }
          }, {
            key: "identifier",
            get: function get() {
              return this.scope.identifier;
            }
          }, {
            key: "targets",
            get: function get() {
              return this.scope.targets;
            }
          }, {
            key: "classes",
            get: function get() {
              return this.scope.classes;
            }
          }, {
            key: "data",
            get: function get() {
              return this.scope.data;
            }
          }, {
            key: "initialize",
            value: function initialize() {}
          }, {
            key: "connect",
            value: function connect() {}
          }, {
            key: "disconnect",
            value: function disconnect() {}
          }, {
            key: "dispatch",
            value: function dispatch(e) {
              var _ref38 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                  _ref38$target = _ref38.target,
                  t = _ref38$target === void 0 ? this.element : _ref38$target,
                  _ref38$detail = _ref38.detail,
                  n = _ref38$detail === void 0 ? {} : _ref38$detail,
                  _ref38$prefix = _ref38.prefix,
                  r = _ref38$prefix === void 0 ? this.identifier : _ref38$prefix,
                  _ref38$bubbles = _ref38.bubbles,
                  o = _ref38$bubbles === void 0 ? !0 : _ref38$bubbles,
                  _ref38$cancelable = _ref38.cancelable,
                  i = _ref38$cancelable === void 0 ? !0 : _ref38$cancelable;

              var s = new CustomEvent(r ? "".concat(r, ":").concat(e) : e, {
                detail: n,
                bubbles: o,
                cancelable: i
              });
              return t.dispatchEvent(s), s;
            }
          }], [{
            key: "shouldLoad",
            get: function get() {
              return !0;
            }
          }]);

          return J;
        }();

        J.blessings = [function (e) {
          return z(e, "classes").reduce(function (e, t) {
            var _Object$assign7;

            return Object.assign(e, (_Object$assign7 = {}, _defineProperty(_Object$assign7, "".concat(n = t, "Class"), {
              get: function get() {
                var e = this.classes;
                if (e.has(n)) return e.get(n);
                {
                  var _t14 = e.getAttributeName(n);

                  throw new Error("Missing attribute \"".concat(_t14, "\""));
                }
              }
            }), _defineProperty(_Object$assign7, "".concat(n, "Classes"), {
              get: function get() {
                return this.classes.getAll(n);
              }
            }), _defineProperty(_Object$assign7, "has".concat(U(n), "Class"), {
              get: function get() {
                return this.classes.has(n);
              }
            }), _Object$assign7));
            var n;
          }, {});
        }, function (e) {
          return z(e, "targets").reduce(function (e, t) {
            var _Object$assign8;

            return Object.assign(e, (_Object$assign8 = {}, _defineProperty(_Object$assign8, "".concat(n = t, "Target"), {
              get: function get() {
                var e = this.targets.find(n);
                if (e) return e;
                throw new Error("Missing target element \"".concat(n, "\" for \"").concat(this.identifier, "\" controller"));
              }
            }), _defineProperty(_Object$assign8, "".concat(n, "Targets"), {
              get: function get() {
                return this.targets.findAll(n);
              }
            }), _defineProperty(_Object$assign8, "has".concat(U(n), "Target"), {
              get: function get() {
                return this.targets.has(n);
              }
            }), _Object$assign8));
            var n;
          }, {});
        }, function (e) {
          var t = function (e, t) {
            return Y(e).reduce(function (e, n) {
              return e.push.apply(e, _toConsumableArray(function (e, t) {
                var n = e[t];
                return n ? Object.keys(n).map(function (e) {
                  return [e, n[e]];
                }) : [];
              }(n, t))), e;
            }, []);
          }(e, "values"),
              n = {
            valueDescriptorMap: {
              get: function get() {
                var _this76 = this;

                return t.reduce(function (e, t) {
                  var n = q(t),
                      r = _this76.data.getAttributeNameForKey(n.key);

                  return Object.assign(e, _defineProperty({}, r, n));
                }, {});
              }
            }
          };

          return t.reduce(function (e, t) {
            return Object.assign(e, function (e) {
              var _ref39;

              var t = q(e),
                  n = t.key,
                  r = t.name,
                  o = t.reader,
                  i = t.writer;
              return _ref39 = {}, _defineProperty(_ref39, r, {
                get: function get() {
                  var e = this.data.get(n);
                  return null !== e ? o(e) : t.defaultValue;
                },
                set: function set(e) {
                  void 0 === e ? this.data.delete(n) : this.data.set(n, i(e));
                }
              }), _defineProperty(_ref39, "has".concat(U(r)), {
                get: function get() {
                  return this.data.has(n) || t.hasCustomDefaultValue;
                }
              }), _ref39;
            }(t));
          }, n);
        }], J.targets = [], J.values = {};
        var Z = ["altFormat", "ariaDateFormat", "dateFormat"],
            ee = {
          string: ["altInputClass", "conjunction", "mode", "nextArrow", "position", "prevArrow", "monthSelectorType"],
          boolean: ["allowInput", "altInput", "animate", "clickOpens", "closeOnSelect", "disableMobile", "enableSeconds", "enableTime", "inline", "noCalendar", "shorthandCurrentMonth", "static", "time_24hr", "weekNumbers", "wrap"],
          date: ["maxDate", "minDate", "maxTime", "minTime", "now"],
          array: ["disable", "enable", "disableDaysOfWeek", "enableDaysOfWeek"],
          number: ["defaultHour", "defaultMinute", "defaultSeconds", "hourIncrement", "minuteIncrement", "showMonths"],
          arrayOrString: ["defaultDate"]
        },
            te = ["change", "open", "close", "monthChange", "yearChange", "ready", "valueUpdate", "dayCreate"],
            ne = ["calendarContainer", "currentYearElement", "days", "daysContainer", "input", "nextMonthNav", "monthNav", "prevMonthNav", "rContainer", "selectedDateElem", "todayDateElem", "weekdayContainer"],
            re = {
          "%Y": "Y",
          "%y": "y",
          "%C": "Y",
          "%m": "m",
          "%-m": "n",
          "%_m": "n",
          "%B": "F",
          "%^B": "F",
          "%b": "M",
          "%^b": "M",
          "%h": "M",
          "%^h": "M",
          "%d": "d",
          "%-d": "j",
          "%e": "j",
          "%H": "H",
          "%k": "H",
          "%I": "h",
          "%l": "h",
          "%-l": "h",
          "%P": "K",
          "%p": "K",
          "%M": "i",
          "%S": "S",
          "%A": "l",
          "%a": "D",
          "%w": "w"
        },
            oe = new RegExp(Object.keys(re).join("|").replace(new RegExp("\\^", "g"), "\\^"), "g");

        var ie = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), t && N(e, t);
          }(i, e);
          var t,
              n,
              r,
              o = (t = i, function () {
            var e,
                n = R(t);

            if (B()) {
              var r = R(this).constructor;
              e = Reflect.construct(n, arguments, r);
            } else e = n.apply(this, arguments);

            return $(this, e);
          });

          function i() {
            return A(this, i), o.apply(this, arguments);
          }

          return n = i, r = [{
            key: "initialize",
            value: function value() {
              this.config = {};
            }
          }, {
            key: "connect",
            value: function value() {
              this._initializeEvents(), this._initializeOptions(), this._initializeDateFormats(), this.fp = M(this.flatpickrElement, function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = null != arguments[t] ? arguments[t] : {};
                  t % 2 ? I(Object(n), !0).forEach(function (t) {
                    L(e, t, n[t]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : I(Object(n)).forEach(function (t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                  });
                }

                return e;
              }({}, this.config)), this._initializeElements();
            }
          }, {
            key: "disconnect",
            value: function value() {
              var e = this.inputTarget.value;
              this.fp.destroy(), this.inputTarget.value = e;
            }
          }, {
            key: "_initializeEvents",
            value: function value() {
              var _this77 = this;

              te.forEach(function (e) {
                if (_this77[e]) {
                  var _n17 = "on".concat((t = e, t.charAt(0).toUpperCase() + t.slice(1)));

                  _this77.config[_n17] = _this77[e].bind(_this77);
                }

                var t;
              });
            }
          }, {
            key: "_initializeOptions",
            value: function value() {
              var _this78 = this;

              Object.keys(ee).forEach(function (e) {
                ee[e].forEach(function (t) {
                  var n = t.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
                  _this78.data.has(n) && (_this78.config[t] = _this78["_".concat(e)](n));
                });
              }), this._handleDaysOfWeek();
            }
          }, {
            key: "_handleDaysOfWeek",
            value: function value() {
              this.config.disableDaysOfWeek && (this.config.disableDaysOfWeek = this._validateDaysOfWeek(this.config.disableDaysOfWeek), this.config.disable = [].concat(_toConsumableArray(this.config.disable || []), [this._disable.bind(this)])), this.config.enableDaysOfWeek && (this.config.enableDaysOfWeek = this._validateDaysOfWeek(this.config.enableDaysOfWeek), this.config.enable = [].concat(_toConsumableArray(this.config.enable || []), [this._enable.bind(this)]));
            }
          }, {
            key: "_validateDaysOfWeek",
            value: function value(e) {
              return Array.isArray(e) ? e.map(function (e) {
                return parseInt(e);
              }) : (console.error("days of week must be a valid array"), []);
            }
          }, {
            key: "_disable",
            value: function value(e) {
              return this.config.disableDaysOfWeek.includes(e.getDay());
            }
          }, {
            key: "_enable",
            value: function value(e) {
              return this.config.enableDaysOfWeek.includes(e.getDay());
            }
          }, {
            key: "_initializeDateFormats",
            value: function value() {
              var _this79 = this;

              Z.forEach(function (e) {
                _this79.data.has(e) && (_this79.config[e] = _this79.data.get(e).replace(oe, function (e) {
                  return re[e];
                }));
              });
            }
          }, {
            key: "_initializeElements",
            value: function value() {
              var _this80 = this;

              ne.forEach(function (e) {
                _this80["".concat(e, "Target")] = _this80.fp[e];
              });
            }
          }, {
            key: "_string",
            value: function value(e) {
              return this.data.get(e);
            }
          }, {
            key: "_date",
            value: function value(e) {
              return this.data.get(e);
            }
          }, {
            key: "_boolean",
            value: function value(e) {
              return !("0" == this.data.get(e) || "false" == this.data.get(e));
            }
          }, {
            key: "_array",
            value: function value(e) {
              return JSON.parse(this.data.get(e));
            }
          }, {
            key: "_number",
            value: function value(e) {
              return parseInt(this.data.get(e));
            }
          }, {
            key: "_arrayOrString",
            value: function value(e) {
              var t = this.data.get(e);

              try {
                return JSON.parse(t);
              } catch (e) {
                return t;
              }
            }
          }, {
            key: "flatpickrElement",
            get: function get() {
              return this.hasInstanceTarget && this.instanceTarget || this.element;
            }
          }], r && F(n.prototype, r), i;
        }(J);

        function se(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function ae(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function le() {
          return le = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, n) {
            var r = ce(e, t);

            if (r) {
              var o = Object.getOwnPropertyDescriptor(r, t);
              return o.get ? o.get.call(arguments.length < 3 ? e : n) : o.value;
            }
          }, le.apply(this, arguments);
        }

        function ce(e, t) {
          for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = he(e));) {
            ;
          }

          return e;
        }

        function ue(e, t) {
          return ue = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, ue(e, t);
        }

        function de(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function he(e) {
          return he = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, he(e);
        }

        L(ie, "targets", ["instance"]);

        var fe = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && ue(e, t);
          }(s, e);
          var t,
              n,
              r,
              o,
              i = (r = s, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = he(r);

            if (o) {
              var n = he(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return de(this, e);
          });

          function s() {
            return se(this, s), i.apply(this, arguments);
          }

          return t = s, (n = [{
            key: "connect",
            value: function value() {
              this.config = {
                altInput: !0,
                altFormat: this.dateFormat,
                dateFormat: this.dateFormat,
                enableTime: this.enableTimeValue,
                noCalendar: !this.enableDateValue,
                time_24hr: this.enableTimeValue,
                showMonths: this.showMonths
              }, le(he(s.prototype), "connect", this).call(this);
            }
          }, {
            key: "showMonths",
            get: function get() {
              if (this.enableDateValue) return 1;
            }
          }, {
            key: "dateFormat",
            get: function get() {
              return this.enableDateValue && this.enableTimeValue ? "Y-m-d H:i" : this.enableDateValue ? "Y-m-d" : "H:i";
            }
          }]) && ae(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), s;
        }(ie);

        var pe, ge, me;
        pe = fe, ge = "values", me = {
          enableDate: Boolean,
          enableTime: Boolean
        }, ge in pe ? Object.defineProperty(pe, ge, {
          value: me,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : pe[ge] = me;
      },
      9980: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return h;
          }
        });
        var r = n(6599),
            o = n(4183),
            i = n.n(o),
            s = n(3033);

        function a(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function l(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function c(e, t) {
          return c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, c(e, t);
        }

        function u(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function d(e) {
          return d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, d(e);
        }

        i().define("sortable", s.Z);

        var h = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && c(e, t);
          }(h, e);
          var t,
              n,
              r,
              o,
              s = (r = h, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = d(r);

            if (o) {
              var n = d(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return u(this, e);
          });

          function h() {
            return a(this, h), s.apply(this, arguments);
          }

          return t = h, (n = [{
            key: "connect",
            value: function value() {
              this.tomSelect = new (i())(this.element, {
                plugins: this.tomSelectPlugins,
                onItemAdd: function onItemAdd() {
                  this.setTextboxValue("");
                }
              });
            }
          }, {
            key: "disconnect",
            value: function value() {
              this.tomSelect && this.tomSelect.destroy();
            }
          }, {
            key: "tomSelectPlugins",
            get: function get() {
              return this.isMultiple, this.sortableValue && this.isMultiple, [];
            }
          }, {
            key: "isMultiple",
            get: function get() {
              return this.element.multiple;
            }
          }]) && l(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), h;
        }(r.Qr);

        var f, p, g;
        f = h, p = "values", g = {
          sortable: Boolean
        }, p in f ? Object.defineProperty(f, p, {
          value: g,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : f[p] = g;
      },
      8401: function _(e, t, n) {
        "use strict";

        function r(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function o(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function i(e, t) {
          return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, i(e, t);
        }

        function s(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function a(e) {
          return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, a(e);
        }

        n.r(t), n.d(t, {
          default: function _default() {
            return l;
          }
        });

        var l = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && i(e, t);
          }(d, e);
          var t,
              n,
              l,
              c,
              u = (l = d, c = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = a(l);

            if (c) {
              var n = a(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return s(this, e);
          });

          function d() {
            return r(this, d), u.apply(this, arguments);
          }

          return t = d, (n = [{
            key: "connect",
            value: function value() {}
          }, {
            key: "setWidthMax",
            value: function value() {
              this.widthTarget.value > this.columnsTarget.value && (this.widthTarget.value = this.columnsTarget.value), this.widthTarget.setAttribute("max", this.columnsTarget.value);
            }
          }, {
            key: "setWidth",
            value: function value(e) {
              var t = e.currentTarget.dataset.width;
              this.widthTarget.value = t, this.previewTarget.dataset.width = t;
            }
          }, {
            key: "updatePreview",
            value: function value() {
              this.previewTarget.dataset.width = this.widthTarget.value;
            }
          }]) && o(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), d;
        }(n(6599).Qr);

        var c, u, d;
        d = ["width", "max", "preview"], (u = "targets") in (c = l) ? Object.defineProperty(c, u, {
          value: d,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : c[u] = d;
      },
      7686: function _(e, t, n) {
        "use strict";

        function r(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function o(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function i(e, t) {
          return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, i(e, t);
        }

        function s(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function a(e) {
          return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, a(e);
        }

        n.r(t), n.d(t, {
          default: function _default() {
            return l;
          }
        });

        var l = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && i(e, t);
          }(d, e);
          var t,
              n,
              l,
              c,
              u = (l = d, c = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = a(l);

            if (c) {
              var n = a(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return s(this, e);
          });

          function d() {
            return r(this, d), u.apply(this, arguments);
          }

          return t = d, (n = [{
            key: "connect",
            value: function value() {
              this.updatePreview();
            }
          }, {
            key: "setWidthMax",
            value: function value() {
              parseInt(this.widthInputTarget.value) > parseInt(this.maxInputTarget.value) && (this.widthInputTarget.value = this.maxInputTarget.value), this.widthInputTarget.setAttribute("max", this.maxInputTarget.value);
            }
          }, {
            key: "updatePreview",
            value: function value() {
              this.previewWrapperTarget.dataset.columns = this.maxInputTarget.value, this.previewTarget.style.width = "".concat(this.calculatePreviewWidth(), "%");
            }
          }, {
            key: "calculatePreviewWidth",
            value: function value() {
              return this.widthInputTarget.value / this.maxInputTarget.value * 100;
            }
          }, {
            key: "calculateColumnWidth",
            value: function value() {
              return Math.floor(this.previewWrapperTarget.offsetWidth / this.maxInputTarget.value);
            }
          }]) && o(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), d;
        }(n(6599).Qr);

        var c, u, d;
        d = ["widthInput", "maxInput", "previewWrapper", "preview"], (u = "targets") in (c = l) ? Object.defineProperty(c, u, {
          value: d,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : c[u] = d;
      },
      6179: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return d;
          }
        });
        var r = n(6599),
            o = n(8535),
            i = n.n(o);

        function s(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function a(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function l(e, t) {
          return l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, l(e, t);
        }

        function c(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function u(e) {
          return u = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, u(e);
        }

        var d = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && l(e, t);
          }(h, e);
          var t,
              n,
              r,
              o,
              d = (r = h, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = u(r);

            if (o) {
              var n = u(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return c(this, e);
          });

          function h() {
            return s(this, h), d.apply(this, arguments);
          }

          return t = h, (n = [{
            key: "connect",
            value: function value() {
              this.loadUrl();
            }
          }, {
            key: "loadUrl",
            value: function value() {
              var _this81 = this;

              this.hasUrlValue && i().ajax({
                type: "GET",
                dataType: "html",
                url: this.urlValue,
                success: function success(e) {
                  _this81.element.outerHTML = e.body.innerHTML;
                }
              });
            }
          }]) && a(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), h;
        }(r.Qr);

        var h, f, p;
        h = d, f = "values", p = {
          url: String
        }, f in h ? Object.defineProperty(h, f, {
          value: p,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : h[f] = p;
      },
      5534: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return d;
          }
        });
        var r = n(6599),
            o = n(9404);

        function i(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function s(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function a(e, t) {
          return a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, a(e, t);
        }

        function l(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function c(e) {
          return c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, c(e);
        }

        function u(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }

        var d = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && a(e, t);
          }(h, e);
          var t,
              n,
              r,
              u,
              d = (r = h, u = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = c(r);

            if (u) {
              var n = c(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return l(this, e);
          });

          function h() {
            return i(this, h), d.apply(this, arguments);
          }

          return t = h, (n = [{
            key: "applyStyle",
            value: function value(e) {
              var t = e.currentTarget;
              if (t.tagName.startsWith("MD")) return;
              var n = t.controller.applyStyleToText(this.selectedText);
              this.replaceSelectionWith(n);
            }
          }, {
            key: "showSuggestions",
            value: function () {
              var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e) {
                var _e$detail4, t, n, r;

                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        _e$detail4 = e.detail, t = _e$detail4.key, n = _e$detail4.provide, r = _e$detail4.text;
                        "/" === t && n(this.getSuggestionsFor(r));

                      case 2:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6, this);
              }));

              function value(_x5) {
                return _value.apply(this, arguments);
              }

              return value;
            }()
          }, {
            key: "useSuggestion",
            value: function value(e) {
              var _e$detail5 = e.detail,
                  t = _e$detail5.key,
                  n = _e$detail5.item;
              console.log(t, n), "/" === t && (e.detail.value = n.getAttribute("data-value"));
            }
          }, {
            key: "getSuggestionsFor",
            value: function () {
              var _value2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(e) {
                var t, n;
                return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.next = 2;
                        return (0, o.v_)(this.pageSuggestionsUrlValue, {
                          body: JSON.stringify({
                            query: e
                          })
                        });

                      case 2:
                        t = _context7.sent;
                        _context7.next = 5;
                        return t.html;

                      case 5:
                        n = _context7.sent;
                        return _context7.abrupt("return", {
                          matched: !0,
                          fragment: document.createRange().createContextualFragment(n).firstElementChild
                        });

                      case 7:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7, this);
              }));

              function value(_x6) {
                return _value2.apply(this, arguments);
              }

              return value;
            }()
          }, {
            key: "replaceSelectionWith",
            value: function value(e) {
              var t = this.selectionStart,
                  n = this.selectionEnd;
              document.execCommand("insertText", !1, e), this.textareaTarget.setSelectionRange(t, n);
            }
          }, {
            key: "selectedText",
            get: function get() {
              return this.textareaTarget.value.slice(this.selectionStart, this.selectionEnd);
            }
          }, {
            key: "selectionStart",
            get: function get() {
              return this.textareaTarget.selectionStart;
            }
          }, {
            key: "selectionEnd",
            get: function get() {
              return this.textareaTarget.selectionEnd;
            }
          }]) && s(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), h;
        }(r.Qr);

        u(d, "values", {
          pageSuggestionsUrl: String
        }), u(d, "targets", ["textarea"]);
      },
      1421: function _(e, t, n) {
        "use strict";

        n.d(t, {
          J: function J() {
            return r;
          }
        });

        var r = function r(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          Object.assign(e, {
            append: function append(e) {
              var _this82 = this;

              this.parseRemoteResponse(e, function (t) {
                _this82._responseTarget(e).append(t);
              });
            },
            prepend: function prepend(e) {
              var _this83 = this;

              this.parseRemoteResponse(e, function (t) {
                _this83._responseTarget(e).prepend(t);
              });
            },
            replace: function replace(e) {
              var _this84 = this;

              this.parseRemoteResponse(e, function (t) {
                _this84._responseTarget(e).replaceWith(t);
              });
            },
            remove: function remove(e) {
              var _this85 = this;

              this.parseRemoteResponse(e, function (t) {
                _this85._responseTarget(e).remove();
              });
            },
            replaceInner: function replaceInner(e) {
              var _this86 = this;

              this.parseRemoteResponse(e, function (t) {
                var n = _this86._responseTarget(e);

                n.innerHTML = "", n.appendChild(t);
              });
            },
            parseRemoteResponse: function parseRemoteResponse(e, t) {
              var _e$detail6 = _slicedToArray(e.detail, 3),
                  n = _e$detail6[2];

              t(this._documentFragment(n.response));
            },
            _documentFragment: function _documentFragment(e) {
              var t = document.createElement("template");
              return t.innerHTML = e, t.content;
            },
            _responseTarget: function _responseTarget(e) {
              var n = t.target || this.element;

              if (this.hasRemoteResponseTargetValue) {
                var _t15 = this.remoteResponseTargetValue;

                try {
                  var _r14 = JSON.parse(_t15);

                  void 0 !== _r14[e.type] && (n = document.querySelector(_r14[e.type]));
                } catch (_unused) {
                  n = document.querySelector(_t15);
                }
              }

              return n;
            }
          });
        };
      },
      5386: function _(e, t, n) {
        "use strict";

        function r(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function o(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function i(e, t) {
          return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, i(e, t);
        }

        function s(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function a(e) {
          return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, a(e);
        }

        n.r(t), n.d(t, {
          default: function _default() {
            return l;
          }
        });

        var l = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && i(e, t);
          }(d, e);
          var t,
              n,
              l,
              c,
              u = (l = d, c = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = a(l);

            if (c) {
              var n = a(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return s(this, e);
          });

          function d() {
            return r(this, d), u.apply(this, arguments);
          }

          return t = d, (n = [{
            key: "connect",
            value: function value() {
              this.element.classList.contains(this.data.get("disabled-class"));
            }
          }, {
            key: "onBefore",
            value: function value(e) {
              this.setLoadingState(!0), this.toggleState();
            }
          }, {
            key: "onSuccess",
            value: function value(e) {
              this.setLoadingState(!1);
            }
          }, {
            key: "onError",
            value: function value(e) {
              this.toggleState();
            }
          }, {
            key: "setLoadingState",
            value: function value(e) {
              this.element.classList.toggle(this.data.get("loading-class"), e);
            }
          }, {
            key: "toggleState",
            value: function value() {
              this.isOn ? (this.element.classList.remove(this.data.get("on-class")), this.element.classList.add(this.data.get("off-class"))) : (this.element.classList.remove(this.data.get("off-class")), this.element.classList.add(this.data.get("on-class")));
            }
          }, {
            key: "isOn",
            get: function get() {
              return this.element.classList.contains(this.data.get("on-class"));
            }
          }]) && o(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), d;
        }(n(6599).Qr);
      },
      3142: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return p;
          }
        });
        var r = n(6599),
            o = n(8535),
            i = n.n(o),
            s = n(4183),
            a = n.n(s),
            l = n(3033);

        function c(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function u(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function d(e, t) {
          return d = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, d(e, t);
        }

        function h(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function f(e) {
          return f = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, f(e);
        }

        a().define("sortable", l.Z);

        var p = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && d(e, t);
          }(l, e);
          var t,
              n,
              r,
              o,
              s = (r = l, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = f(r);

            if (o) {
              var n = f(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return h(this, e);
          });

          function l() {
            return c(this, l), s.apply(this, arguments);
          }

          return t = l, (n = [{
            key: "connect",
            value: function value() {
              var _this87 = this;

              this.tomSelect = new (a())(this.element, {
                valueField: "id",
                labelField: "title",
                searchField: "title",
                highlight: !1,
                openOnFocus: !0,
                preload: "focus",
                maxOptions: 20,
                plugins: this.tomSelectPlugins,
                onItemAdd: function onItemAdd() {
                  this.setTextboxValue("");
                },
                render: {
                  option: function option(e, t) {
                    return e.option;
                  }
                },
                load: function load(e, t) {
                  fetch(_this87.queryURL(e), {
                    method: "GET",
                    headers: {
                      "Content-Type": "application/json",
                      Accept: "application/json",
                      "X-CSRF_Token": i().csrfToken()
                    }
                  }).then(function (e) {
                    return e.json();
                  }).then(function (e) {
                    return t(e);
                  });
                }
              });
            }
          }, {
            key: "disconnect",
            value: function value() {
              this.tomSelect && this.tomSelect.destroy();
            }
          }, {
            key: "queryURL",
            value: function value(e) {
              var t = new URL(this.urlValue);
              return t.searchParams.append("q", e), t.toString();
            }
          }, {
            key: "tomSelectPlugins",
            get: function get() {
              return this.isMultiple ? ["sortable", "remove_button"] : [];
            }
          }, {
            key: "isMultiple",
            get: function get() {
              return this.element.multiple;
            }
          }]) && u(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), l;
        }(r.Qr);

        var g, m, v;
        g = p, m = "values", v = {
          url: String
        }, m in g ? Object.defineProperty(g, m, {
          value: v,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : g[m] = v;
      },
      4083: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return u;
          }
        });
        var r = n(6599),
            o = n(1421);

        function i(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function s(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function a(e, t) {
          return a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, a(e, t);
        }

        function l(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function c(e) {
          return c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, c(e);
        }

        var u = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && a(e, t);
          }(h, e);
          var t,
              n,
              r,
              u,
              d = (r = h, u = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = c(r);

            if (u) {
              var n = c(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return l(this, e);
          });

          function h() {
            return i(this, h), d.apply(this, arguments);
          }

          return t = h, (n = [{
            key: "connect",
            value: function value() {
              (0, o.J)(this);
            }
          }]) && s(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), h;
        }(r.Qr);
      },
      5775: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return d;
          }
        });
        var r = n(6599),
            o = n(8535),
            i = n.n(o);

        function s(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function a(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function l(e, t) {
          return l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, l(e, t);
        }

        function c(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function u(e) {
          return u = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, u(e);
        }

        var d = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && l(e, t);
          }(h, e);
          var t,
              n,
              r,
              o,
              d = (r = h, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = u(r);

            if (o) {
              var n = u(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return c(this, e);
          });

          function h() {
            return s(this, h), d.apply(this, arguments);
          }

          return t = h, (n = [{
            key: "connect",
            value: function value() {
              this.indexPath && this._fetchIndex();
            }
          }, {
            key: "update",
            value: function value(e) {
              e.detail[0], e.detail[1];
              var t = e.detail[2];
              this.element.innerHTML = t.responseText;
            }
          }, {
            key: "isEditable",
            get: function get() {
              return this.element.classList.contains("editable");
            }
          }, {
            key: "indexPath",
            get: function get() {
              return this.data.get("indexPath");
            }
          }, {
            key: "_fetchIndex",
            value: function value() {
              var _this88 = this;

              i().ajax({
                type: "GET",
                dataType: "html",
                url: this.indexPath,
                success: function success(e) {
                  _this88.element.innerHTML = e.body.innerHTML;
                }
              });
            }
          }]) && a(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), h;
        }(r.Qr);
      },
      8013: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return f;
          }
        });
        var r = n(6599),
            o = n(5564),
            i = n.n(o);

        function s(e) {
          return null !== e.offsetParent && e.offsetWidth > 0 && e.offsetHeight > 0;
        }

        function a(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function l(e, t) {
          return l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, l(e, t);
        }

        function c(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return u(e);
        }

        function u(e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }

        function d(e) {
          return d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, d(e);
        }

        function h(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }

        var f = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && l(e, t);
          }(p, e);
          var t,
              n,
              r,
              o,
              f = (r = p, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = d(r);

            if (o) {
              var n = d(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return c(this, e);
          });

          function p() {
            var t;

            for (var _len18 = arguments.length, e = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
              e[_key18] = arguments[_key18];
            }

            return function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, p), h(u(t = f.call.apply(f, [this].concat(e))), "defaults", {
              scopeSelector: ".simple_form_dependent_fields__scope, .simple_form_dependent_fields__item, .simple_form_nested_fields__item, form"
            }), t;
          }

          return t = p, (n = [{
            key: "initialize",
            value: function value() {
              this.boundOnInput = this.onInput.bind(this);
            }
          }, {
            key: "connect",
            value: function value() {
              this.scopeElement = this.element.closest(this.scopeSelector), this.bindEvents(), this.toggleFields();
            }
          }, {
            key: "disconnect",
            value: function value() {
              this.unbindEvents();
            }
          }, {
            key: "toggleFields",
            value: function value() {
              this.requirementsMet ? this.showFields() : this.hideFields();
            }
          }, {
            key: "bindEvents",
            value: function value() {
              this.scopeElement.addEventListener("input", this.boundOnInput), this.scopeElement.addEventListener("select", this.boundOnInput), this.scopeElement.addEventListener("change", this.boundOnInput);
            }
          }, {
            key: "unbindEvents",
            value: function value() {
              this.scopeElement.removeEventListener("input", this.boundOnInput), this.scopeElement.removeEventListener("select", this.boundOnInput), this.scopeElement.removeEventListener("change", this.boundOnInput);
            }
          }, {
            key: "onInput",
            value: function value(e) {
              s(e.target) && this.isDependentOnInput(e.target) && this.withinScope(e.target) && this.toggleFields();
            }
          }, {
            key: "getInputsWithName",
            value: function value(e) {
              var _this89 = this;

              return this.inputs ? this.inputs.filter(function (t) {
                return _this89.inputHasName(t, e);
              }) : [];
            }
          }, {
            key: "withinScope",
            value: function value(e) {
              return e.closest(this.scopeSelector) === this.scopeElement;
            }
          }, {
            key: "isDependentOnInput",
            value: function value(e) {
              var _this90 = this;

              return this.inputNames.filter(function (t) {
                return _this90.inputHasName(e, t);
              }).length > 0;
            }
          }, {
            key: "inputHasName",
            value: function value(e, t) {
              return e.name.endsWith("[".concat(t, "]"));
            }
          }, {
            key: "showFields",
            value: function value() {
              this.element.children.length > 0 || this.templateHtml && this.element.insertAdjacentHTML("beforeend", this.templateHtml);
            }
          }, {
            key: "hideFields",
            value: function value() {
              this.templateHtml = this.element.innerHTML, this.element.innerHTML = "";
            }
          }, {
            key: "check",
            value: function value(e, t) {
              var n = this.getInputsWithName(e);
              var r = n[0];

              if (r) {
                switch (t = t.toString(), "radio" === r.type && (r = _toConsumableArray(n).filter(function (e) {
                  return e.checked;
                })[0]), t) {
                  case "true":
                    t = "1";
                    break;

                  case "false":
                    t = "0";
                }

                switch (r.type) {
                  case "checkbox":
                    switch (t) {
                      case "1":
                        return r.checked;

                      case "0":
                        return !r.checked;
                    }

                  case "select-multiple":
                    return _toConsumableArray(r.querySelectorAll("option:checked")).map(function (e) {
                      return e.value;
                    }).includes(t);

                  default:
                    return r.value === t;
                }
              }
            }
          }, {
            key: "scopeSelector",
            get: function get() {
              return this.hasScopeSelectorValue ? this.scopeSelectorValue : this.defaults.scopeSelector;
            }
          }, {
            key: "dependsOnAny",
            get: function get() {
              return this.dependsOnValue.depends_on_any;
            }
          }, {
            key: "dependsOnAll",
            get: function get() {
              return this.dependsOnValue.depends_on_all;
            }
          }, {
            key: "dependsOnNone",
            get: function get() {
              return this.dependsOnValue.depends_on_none;
            }
          }, {
            key: "form",
            get: function get() {
              return this.element.closest("form");
            }
          }, {
            key: "inputNames",
            get: function get() {
              return Object.keys(this.dependsOnAny || {}).concat(Object.keys(this.dependsOnAll || {}).concat(Object.keys(this.dependsOnNone || {})));
            }
          }, {
            key: "inputs",
            get: function get() {
              var _this91 = this;

              return _toConsumableArray(this.scopeElement.querySelectorAll("input, select")).filter(function (e) {
                return s(e) && _this91.withinScope(e);
              });
            }
          }, {
            key: "templateHtml",
            get: function get() {
              return this.element.dataset.templateHtml;
            },
            set: function set(e) {
              this.templateHtml || (this.element.dataset.templateHtml = e);
            }
          }, {
            key: "requirementsMet",
            get: function get() {
              return this.dependsOnAny ? this.anyValid : this.dependsOnAll ? this.allValid : this.dependsOnNone ? this.noneValid : void 0;
            }
          }, {
            key: "anyValid",
            get: function get() {
              var e = !1;
              var t = this.dependsOnAny;

              for (var _n18 in t) {
                var _r15 = t[_n18];

                for (var _i44 = 0, _Array$from5 = Array.from(i()([_r15])); _i44 < _Array$from5.length; _i44++) {
                  var _t16 = _Array$from5[_i44];

                  var _r16 = this.check(_n18, _t16);

                  e = e || _r16;
                }
              }

              return e;
            }
          }, {
            key: "allValid",
            get: function get() {
              var e = !0;
              var t = this.dependsOnAll;

              for (var _n19 in t) {
                var _r17 = t[_n19];

                for (var _i45 = 0, _Array$from6 = Array.from(i()([_r17])); _i45 < _Array$from6.length; _i45++) {
                  var _t17 = _Array$from6[_i45];

                  var _r18 = this.check(_n19, _t17);

                  e = e && _r18;
                }
              }

              return e;
            }
          }, {
            key: "noneValid",
            get: function get() {
              var e = !0;
              var t = this.dependsOnNone;

              for (var _n20 in t) {
                var _r19 = t[_n20];

                for (var _i46 = 0, _Array$from7 = Array.from(i()([_r19])); _i46 < _Array$from7.length; _i46++) {
                  var _t18 = _Array$from7[_i46];

                  var _r20 = this.check(_n20, _t18);

                  e = e && !_r20;
                }
              }

              return e;
            }
          }]) && a(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), p;
        }(r.Qr);

        h(f, "values", {
          scopeSelector: String,
          dependsOn: Object
        });
      },
      5428: function _(e, t, n) {
        "use strict";

        function r(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function o(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function i(e, t) {
          return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, i(e, t);
        }

        function s(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function a(e) {
          return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, a(e);
        }

        function l(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }

        n.r(t), n.d(t, {
          default: function _default() {
            return c;
          }
        });

        var c = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && i(e, t);
          }(d, e);
          var t,
              n,
              l,
              c,
              u = (l = d, c = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = a(l);

            if (c) {
              var n = a(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return s(this, e);
          });

          function d() {
            return r(this, d), u.apply(this, arguments);
          }

          return t = d, (n = [{
            key: "add",
            value: function value() {
              var e = this.template.content.firstChild.cloneNode(!0);
              e.innerHTML = e.innerHTML.replace(this.regexp, new Date().getTime().toString()), this.itemsTarget.append(e);
            }
          }, {
            key: "remove",
            value: function value(e) {
              e.preventDefault();
              var t = this.itemTargets.find(function (t) {
                return _toConsumableArray(t.children).includes(e.target);
              });
              t.classList.add(this.removedItemClass), t.querySelector("input[name*='_destroy']").value = 1;
            }
          }, {
            key: "itemTargetConnected",
            value: function value() {
              this.updatePositions();
            }
          }, {
            key: "itemTargetDisconnected",
            value: function value() {
              this.updatePositions();
            }
          }, {
            key: "updatePositions",
            value: function value() {
              this.positionInputTargets.forEach(function (e, t) {
                e.value = t;
              });
            }
          }, {
            key: "regexp",
            get: function get() {
              return new RegExp(this.indexPlaceholderValue, "g");
            }
          }, {
            key: "template",
            get: function get() {
              var _this92 = this;

              return this.templateTargets.find(function (e) {
                return e.dataset.class == _this92.classSelectorTarget.value;
              });
            }
          }]) && o(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), d;
        }(n(6599).Qr);

        l(c, "targets", ["template", "item", "items", "classSelector", "positionInput"]), l(c, "values", {
          indexPlaceholder: String
        }), l(c, "classes", ["removedItem"]);
      },
      593: function _(e, t, n) {
        "use strict";

        function r(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function o(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function i(e, t) {
          return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, i(e, t);
        }

        function s(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function a(e) {
          return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, a(e);
        }

        n.r(t), n.d(t, {
          default: function _default() {
            return l;
          }
        });

        var l = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && i(e, t);
          }(d, e);
          var t,
              n,
              l,
              c,
              u = (l = d, c = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = a(l);

            if (c) {
              var n = a(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return s(this, e);
          });

          function d() {
            return r(this, d), u.apply(this, arguments);
          }

          return t = d, (n = [{
            key: "sort",
            value: function value() {
              var _this93 = this;

              var e = this.itemTargets.map(function (e) {
                return e.dataset.id;
              }),
                  t = this._options.sort(function (t, n) {
                return e.index(t.value) - e.index(n.value);
              });

              this.selectTarget.innerHTML = "", t.forEach(function (e) {
                return _this93.selectTarget.appendChild(e);
              });
            }
          }, {
            key: "_options",
            get: function get() {
              return _toConsumableArray(this.selectTarget.querySelectorAll("option"));
            }
          }]) && o(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), d;
        }(n(6599).Qr);

        var c, u, d;
        d = ["item", "select"], (u = "targets") in (c = l) ? Object.defineProperty(c, u, {
          value: d,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : c[u] = d;
      },
      4734: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          default: function _default() {
            return st;
          }
        });
        var r = n(6599);

        function o(e, t) {
          var n = Object.keys(e);

          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }

          return n;
        }

        function i(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? o(Object(n), !0).forEach(function (t) {
              a(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : o(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }

          return e;
        }

        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }

        function a(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }

        function l() {
          return l = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];

              for (var r in n) {
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
              }
            }

            return e;
          }, l.apply(this, arguments);
        }

        function c(e, t) {
          if (null == e) return {};

          var n,
              r,
              o = function (e, t) {
            if (null == e) return {};
            var n,
                r,
                o = {},
                i = Object.keys(e);

            for (r = 0; r < i.length; r++) {
              n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            }

            return o;
          }(e, t);

          if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);

            for (r = 0; r < i.length; r++) {
              n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
          }

          return o;
        }

        function u(e) {
          if ("undefined" != typeof window && window.navigator) return !!navigator.userAgent.match(e);
        }

        var d = u(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i),
            h = u(/Edge/i),
            f = u(/firefox/i),
            p = u(/safari/i) && !u(/chrome/i) && !u(/android/i),
            g = u(/iP(ad|od|hone)/i),
            m = u(/chrome/i) && u(/android/i),
            v = {
          capture: !1,
          passive: !1
        };

        function y(e, t, n) {
          e.addEventListener(t, n, !d && v);
        }

        function b(e, t, n) {
          e.removeEventListener(t, n, !d && v);
        }

        function w(e, t) {
          if (t) {
            if (">" === t[0] && (t = t.substring(1)), e) try {
              if (e.matches) return e.matches(t);
              if (e.msMatchesSelector) return e.msMatchesSelector(t);
              if (e.webkitMatchesSelector) return e.webkitMatchesSelector(t);
            } catch (e) {
              return !1;
            }
            return !1;
          }
        }

        function O(e) {
          return e.host && e !== document && e.host.nodeType ? e.host : e.parentNode;
        }

        function E(e, t, n, r) {
          if (e) {
            n = n || document;

            do {
              if (null != t && (">" === t[0] ? e.parentNode === n && w(e, t) : w(e, t)) || r && e === n) return e;
              if (e === n) break;
            } while (e = O(e));
          }

          return null;
        }

        var _,
            S = /\s+/g;

        function x(e, t, n) {
          if (e && t) if (e.classList) e.classList[n ? "add" : "remove"](t);else {
            var r = (" " + e.className + " ").replace(S, " ").replace(" " + t + " ", " ");
            e.className = (r + (n ? " " + t : "")).replace(S, " ");
          }
        }

        function C(e, t, n) {
          var r = e && e.style;

          if (r) {
            if (void 0 === n) return document.defaultView && document.defaultView.getComputedStyle ? n = document.defaultView.getComputedStyle(e, "") : e.currentStyle && (n = e.currentStyle), void 0 === t ? n : n[t];
            t in r || -1 !== t.indexOf("webkit") || (t = "-webkit-" + t), r[t] = n + ("string" == typeof n ? "" : "px");
          }
        }

        function k(e, t) {
          var n = "";
          if ("string" == typeof e) n = e;else do {
            var r = C(e, "transform");
            r && "none" !== r && (n = r + " " + n);
          } while (!t && (e = e.parentNode));
          var o = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
          return o && new o(n);
        }

        function P(e, t, n) {
          if (e) {
            var r = e.getElementsByTagName(t),
                o = 0,
                i = r.length;
            if (n) for (; o < i; o++) {
              n(r[o], o);
            }
            return r;
          }

          return [];
        }

        function j() {
          return document.scrollingElement || document.documentElement;
        }

        function T(e, t, n, r, o) {
          if (e.getBoundingClientRect || e === window) {
            var i, s, a, l, c, u, h;
            if (e !== window && e.parentNode && e !== j() ? (s = (i = e.getBoundingClientRect()).top, a = i.left, l = i.bottom, c = i.right, u = i.height, h = i.width) : (s = 0, a = 0, l = window.innerHeight, c = window.innerWidth, u = window.innerHeight, h = window.innerWidth), (t || n) && e !== window && (o = o || e.parentNode, !d)) do {
              if (o && o.getBoundingClientRect && ("none" !== C(o, "transform") || n && "static" !== C(o, "position"))) {
                var f = o.getBoundingClientRect();
                s -= f.top + parseInt(C(o, "border-top-width")), a -= f.left + parseInt(C(o, "border-left-width")), l = s + i.height, c = a + i.width;
                break;
              }
            } while (o = o.parentNode);

            if (r && e !== window) {
              var p = k(o || e),
                  g = p && p.a,
                  m = p && p.d;
              p && (l = (s /= m) + (u /= m), c = (a /= g) + (h /= g));
            }

            return {
              top: s,
              left: a,
              bottom: l,
              right: c,
              width: h,
              height: u
            };
          }
        }

        function D(e, t, n) {
          for (var r = I(e, !0), o = T(e)[t]; r;) {
            var i = T(r)[n];
            if (!("top" === n || "left" === n ? o >= i : o <= i)) return r;
            if (r === j()) break;
            r = I(r, !1);
          }

          return !1;
        }

        function M(e, t, n, r) {
          for (var o = 0, i = 0, s = e.children; i < s.length;) {
            if ("none" !== s[i].style.display && s[i] !== Ne.ghost && (r || s[i] !== Ne.dragged) && E(s[i], n.draggable, e, !1)) {
              if (o === t) return s[i];
              o++;
            }

            i++;
          }

          return null;
        }

        function A(e, t) {
          for (var n = e.lastElementChild; n && (n === Ne.ghost || "none" === C(n, "display") || t && !w(n, t));) {
            n = n.previousElementSibling;
          }

          return n || null;
        }

        function F(e, t) {
          var n = 0;
          if (!e || !e.parentNode) return -1;

          for (; e = e.previousElementSibling;) {
            "TEMPLATE" === e.nodeName.toUpperCase() || e === Ne.clone || t && !w(e, t) || n++;
          }

          return n;
        }

        function L(e) {
          var t = 0,
              n = 0,
              r = j();
          if (e) do {
            var o = k(e),
                i = o.a,
                s = o.d;
            t += e.scrollLeft * i, n += e.scrollTop * s;
          } while (e !== r && (e = e.parentNode));
          return [t, n];
        }

        function I(e, t) {
          if (!e || !e.getBoundingClientRect) return j();
          var n = e,
              r = !1;

          do {
            if (n.clientWidth < n.scrollWidth || n.clientHeight < n.scrollHeight) {
              var o = C(n);

              if (n.clientWidth < n.scrollWidth && ("auto" == o.overflowX || "scroll" == o.overflowX) || n.clientHeight < n.scrollHeight && ("auto" == o.overflowY || "scroll" == o.overflowY)) {
                if (!n.getBoundingClientRect || n === document.body) return j();
                if (r || t) return n;
                r = !0;
              }
            }
          } while (n = n.parentNode);

          return j();
        }

        function R(e, t) {
          return Math.round(e.top) === Math.round(t.top) && Math.round(e.left) === Math.round(t.left) && Math.round(e.height) === Math.round(t.height) && Math.round(e.width) === Math.round(t.width);
        }

        function N(e, t) {
          return function () {
            if (!_) {
              var n = arguments,
                  r = this;
              1 === n.length ? e.call(r, n[0]) : e.apply(r, n), _ = setTimeout(function () {
                _ = void 0;
              }, t);
            }
          };
        }

        function B(e, t, n) {
          e.scrollLeft += t, e.scrollTop += n;
        }

        function $(e) {
          var t = window.Polymer,
              n = window.jQuery || window.Zepto;
          return t && t.dom ? t.dom(e).cloneNode(!0) : n ? n(e).clone(!0)[0] : e.cloneNode(!0);
        }

        var H = "Sortable" + new Date().getTime();
        var U = [],
            z = {
          initializeByDefault: !0
        },
            Y = {
          mount: function mount(e) {
            for (var t in z) {
              z.hasOwnProperty(t) && !(t in e) && (e[t] = z[t]);
            }

            U.forEach(function (t) {
              if (t.pluginName === e.pluginName) throw "Sortable: Cannot mount plugin ".concat(e.pluginName, " more than once");
            }), U.push(e);
          },
          pluginEvent: function pluginEvent(e, t, n) {
            var r = this;
            this.eventCanceled = !1, n.cancel = function () {
              r.eventCanceled = !0;
            };
            var o = e + "Global";
            U.forEach(function (r) {
              t[r.pluginName] && (t[r.pluginName][o] && t[r.pluginName][o](i({
                sortable: t
              }, n)), t.options[r.pluginName] && t[r.pluginName][e] && t[r.pluginName][e](i({
                sortable: t
              }, n)));
            });
          },
          initializePlugins: function initializePlugins(e, t, n, r) {
            for (var o in U.forEach(function (r) {
              var o = r.pluginName;

              if (e.options[o] || r.initializeByDefault) {
                var i = new r(e, t, e.options);
                i.sortable = e, i.options = e.options, e[o] = i, l(n, i.defaults);
              }
            }), e.options) {
              if (e.options.hasOwnProperty(o)) {
                var i = this.modifyOption(e, o, e.options[o]);
                void 0 !== i && (e.options[o] = i);
              }
            }
          },
          getEventProperties: function getEventProperties(e, t) {
            var n = {};
            return U.forEach(function (r) {
              "function" == typeof r.eventProperties && l(n, r.eventProperties.call(t[r.pluginName], e));
            }), n;
          },
          modifyOption: function modifyOption(e, t, n) {
            var r;
            return U.forEach(function (o) {
              e[o.pluginName] && o.optionListeners && "function" == typeof o.optionListeners[t] && (r = o.optionListeners[t].call(e[o.pluginName], n));
            }), r;
          }
        };

        var q = ["evt"],
            V = function V(e, t) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = n.evt,
              o = c(n, q);
          Y.pluginEvent.bind(Ne)(e, t, i({
            dragEl: K,
            parentEl: X,
            ghostEl: Q,
            rootEl: G,
            nextEl: J,
            lastDownEl: Z,
            cloneEl: ee,
            cloneHidden: te,
            dragStarted: pe,
            putSortable: ae,
            activeSortable: Ne.active,
            originalEvent: r,
            oldIndex: ne,
            oldDraggableIndex: oe,
            newIndex: re,
            newDraggableIndex: ie,
            hideGhostForTarget: Fe,
            unhideGhostForTarget: Le,
            cloneNowHidden: function cloneNowHidden() {
              te = !0;
            },
            cloneNowShown: function cloneNowShown() {
              te = !1;
            },
            dispatchSortableEvent: function dispatchSortableEvent(e) {
              W({
                sortable: t,
                name: e,
                originalEvent: r
              });
            }
          }, o));
        };

        function W(e) {
          !function (e) {
            var t = e.sortable,
                n = e.rootEl,
                r = e.name,
                o = e.targetEl,
                s = e.cloneEl,
                a = e.toEl,
                l = e.fromEl,
                c = e.oldIndex,
                u = e.newIndex,
                f = e.oldDraggableIndex,
                p = e.newDraggableIndex,
                g = e.originalEvent,
                m = e.putSortable,
                v = e.extraEventProperties;

            if (t = t || n && n[H]) {
              var y,
                  b = t.options,
                  w = "on" + r.charAt(0).toUpperCase() + r.substr(1);
              !window.CustomEvent || d || h ? (y = document.createEvent("Event")).initEvent(r, !0, !0) : y = new CustomEvent(r, {
                bubbles: !0,
                cancelable: !0
              }), y.to = a || n, y.from = l || n, y.item = o || n, y.clone = s, y.oldIndex = c, y.newIndex = u, y.oldDraggableIndex = f, y.newDraggableIndex = p, y.originalEvent = g, y.pullMode = m ? m.lastPutMode : void 0;
              var O = i(i({}, v), Y.getEventProperties(r, t));

              for (var E in O) {
                y[E] = O[E];
              }

              n && n.dispatchEvent(y), b[w] && b[w].call(t, y);
            }
          }(i({
            putSortable: ae,
            cloneEl: ee,
            targetEl: K,
            rootEl: G,
            oldIndex: ne,
            oldDraggableIndex: oe,
            newIndex: re,
            newDraggableIndex: ie
          }, e));
        }

        var K,
            X,
            Q,
            G,
            J,
            Z,
            ee,
            te,
            ne,
            re,
            oe,
            ie,
            se,
            ae,
            le,
            ce,
            ue,
            de,
            he,
            fe,
            pe,
            ge,
            me,
            ve,
            ye,
            be = !1,
            we = !1,
            Oe = [],
            Ee = !1,
            _e = !1,
            Se = [],
            xe = !1,
            Ce = [],
            ke = "undefined" != typeof document,
            Pe = g,
            je = h || d ? "cssFloat" : "float",
            Te = ke && !m && !g && "draggable" in document.createElement("div"),
            De = function () {
          if (ke) {
            if (d) return !1;
            var e = document.createElement("x");
            return e.style.cssText = "pointer-events:auto", "auto" === e.style.pointerEvents;
          }
        }(),
            Me = function Me(e, t) {
          var n = C(e),
              r = parseInt(n.width) - parseInt(n.paddingLeft) - parseInt(n.paddingRight) - parseInt(n.borderLeftWidth) - parseInt(n.borderRightWidth),
              o = M(e, 0, t),
              i = M(e, 1, t),
              s = o && C(o),
              a = i && C(i),
              l = s && parseInt(s.marginLeft) + parseInt(s.marginRight) + T(o).width,
              c = a && parseInt(a.marginLeft) + parseInt(a.marginRight) + T(i).width;
          if ("flex" === n.display) return "column" === n.flexDirection || "column-reverse" === n.flexDirection ? "vertical" : "horizontal";
          if ("grid" === n.display) return n.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";

          if (o && s.float && "none" !== s.float) {
            var u = "left" === s.float ? "left" : "right";
            return !i || "both" !== a.clear && a.clear !== u ? "horizontal" : "vertical";
          }

          return o && ("block" === s.display || "flex" === s.display || "table" === s.display || "grid" === s.display || l >= r && "none" === n[je] || i && "none" === n[je] && l + c > r) ? "vertical" : "horizontal";
        },
            Ae = function Ae(e) {
          function t(e, n) {
            return function (r, o, i, s) {
              var a = r.options.group.name && o.options.group.name && r.options.group.name === o.options.group.name;
              if (null == e && (n || a)) return !0;
              if (null == e || !1 === e) return !1;
              if (n && "clone" === e) return e;
              if ("function" == typeof e) return t(e(r, o, i, s), n)(r, o, i, s);
              var l = (n ? r : o).options.group.name;
              return !0 === e || "string" == typeof e && e === l || e.join && e.indexOf(l) > -1;
            };
          }

          var n = {},
              r = e.group;
          r && "object" == s(r) || (r = {
            name: r
          }), n.name = r.name, n.checkPull = t(r.pull, !0), n.checkPut = t(r.put), n.revertClone = r.revertClone, e.group = n;
        },
            Fe = function Fe() {
          !De && Q && C(Q, "display", "none");
        },
            Le = function Le() {
          !De && Q && C(Q, "display", "");
        };

        ke && !m && document.addEventListener("click", function (e) {
          if (we) return e.preventDefault(), e.stopPropagation && e.stopPropagation(), e.stopImmediatePropagation && e.stopImmediatePropagation(), we = !1, !1;
        }, !0);

        var Ie = function Ie(e) {
          if (K) {
            e = e.touches ? e.touches[0] : e;
            var t = (o = e.clientX, i = e.clientY, Oe.some(function (e) {
              var t = e[H].options.emptyInsertThreshold;

              if (t && !A(e)) {
                var n = T(e),
                    r = o >= n.left - t && o <= n.right + t,
                    a = i >= n.top - t && i <= n.bottom + t;
                return r && a ? s = e : void 0;
              }
            }), s);

            if (t) {
              var n = {};

              for (var r in e) {
                e.hasOwnProperty(r) && (n[r] = e[r]);
              }

              n.target = n.rootEl = t, n.preventDefault = void 0, n.stopPropagation = void 0, t[H]._onDragOver(n);
            }
          }

          var o, i, s;
        },
            Re = function Re(e) {
          K && K.parentNode[H]._isOutsideThisEl(e.target);
        };

        function Ne(e, t) {
          if (!e || !e.nodeType || 1 !== e.nodeType) throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(e));
          this.el = e, this.options = t = l({}, t), e[H] = this;
          var n,
              r,
              o = {
            group: null,
            sort: !0,
            disabled: !1,
            store: null,
            handle: null,
            draggable: /^[uo]l$/i.test(e.nodeName) ? ">li" : ">*",
            swapThreshold: 1,
            invertSwap: !1,
            invertedSwapThreshold: null,
            removeCloneOnHide: !0,
            direction: function direction() {
              return Me(e, this.options);
            },
            ghostClass: "sortable-ghost",
            chosenClass: "sortable-chosen",
            dragClass: "sortable-drag",
            ignore: "a, img",
            filter: null,
            preventOnFilter: !0,
            animation: 0,
            easing: null,
            setData: function setData(e, t) {
              e.setData("Text", t.textContent);
            },
            dropBubble: !1,
            dragoverBubble: !1,
            dataIdAttr: "data-id",
            delay: 0,
            delayOnTouchOnly: !1,
            touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
            forceFallback: !1,
            fallbackClass: "sortable-fallback",
            fallbackOnBody: !1,
            fallbackTolerance: 0,
            fallbackOffset: {
              x: 0,
              y: 0
            },
            supportPointer: !1 !== Ne.supportPointer && "PointerEvent" in window && !p,
            emptyInsertThreshold: 5
          };

          for (var s in Y.initializePlugins(this, e, o), o) {
            !(s in t) && (t[s] = o[s]);
          }

          for (var a in Ae(t), this) {
            "_" === a.charAt(0) && "function" == typeof this[a] && (this[a] = this[a].bind(this));
          }

          this.nativeDraggable = !t.forceFallback && Te, this.nativeDraggable && (this.options.touchStartThreshold = 1), t.supportPointer ? y(e, "pointerdown", this._onTapStart) : (y(e, "mousedown", this._onTapStart), y(e, "touchstart", this._onTapStart)), this.nativeDraggable && (y(e, "dragover", this), y(e, "dragenter", this)), Oe.push(this.el), t.store && t.store.get && this.sort(t.store.get(this) || []), l(this, (r = [], {
            captureAnimationState: function captureAnimationState() {
              r = [], this.options.animation && [].slice.call(this.el.children).forEach(function (e) {
                if ("none" !== C(e, "display") && e !== Ne.ghost) {
                  r.push({
                    target: e,
                    rect: T(e)
                  });
                  var t = i({}, r[r.length - 1].rect);

                  if (e.thisAnimationDuration) {
                    var n = k(e, !0);
                    n && (t.top -= n.f, t.left -= n.e);
                  }

                  e.fromRect = t;
                }
              });
            },
            addAnimationState: function addAnimationState(e) {
              r.push(e);
            },
            removeAnimationState: function removeAnimationState(e) {
              r.splice(function (e, t) {
                for (var n in e) {
                  if (e.hasOwnProperty(n)) for (var r in t) {
                    if (t.hasOwnProperty(r) && t[r] === e[n][r]) return Number(n);
                  }
                }

                return -1;
              }(r, {
                target: e
              }), 1);
            },
            animateAll: function animateAll(e) {
              var t = this;
              if (!this.options.animation) return clearTimeout(n), void ("function" == typeof e && e());
              var o = !1,
                  i = 0;
              r.forEach(function (e) {
                var n = 0,
                    r = e.target,
                    s = r.fromRect,
                    a = T(r),
                    l = r.prevFromRect,
                    c = r.prevToRect,
                    u = e.rect,
                    d = k(r, !0);
                d && (a.top -= d.f, a.left -= d.e), r.toRect = a, r.thisAnimationDuration && R(l, a) && !R(s, a) && (u.top - a.top) / (u.left - a.left) == (s.top - a.top) / (s.left - a.left) && (n = function (e, t, n, r) {
                  return Math.sqrt(Math.pow(t.top - e.top, 2) + Math.pow(t.left - e.left, 2)) / Math.sqrt(Math.pow(t.top - n.top, 2) + Math.pow(t.left - n.left, 2)) * r.animation;
                }(u, l, c, t.options)), R(a, s) || (r.prevFromRect = s, r.prevToRect = a, n || (n = t.options.animation), t.animate(r, u, a, n)), n && (o = !0, i = Math.max(i, n), clearTimeout(r.animationResetTimer), r.animationResetTimer = setTimeout(function () {
                  r.animationTime = 0, r.prevFromRect = null, r.fromRect = null, r.prevToRect = null, r.thisAnimationDuration = null;
                }, n), r.thisAnimationDuration = n);
              }), clearTimeout(n), o ? n = setTimeout(function () {
                "function" == typeof e && e();
              }, i) : "function" == typeof e && e(), r = [];
            },
            animate: function animate(e, t, n, r) {
              if (r) {
                C(e, "transition", ""), C(e, "transform", "");
                var o = k(this.el),
                    i = o && o.a,
                    s = o && o.d,
                    a = (t.left - n.left) / (i || 1),
                    l = (t.top - n.top) / (s || 1);
                e.animatingX = !!a, e.animatingY = !!l, C(e, "transform", "translate3d(" + a + "px," + l + "px,0)"), this.forRepaintDummy = function (e) {
                  return e.offsetWidth;
                }(e), C(e, "transition", "transform " + r + "ms" + (this.options.easing ? " " + this.options.easing : "")), C(e, "transform", "translate3d(0,0,0)"), "number" == typeof e.animated && clearTimeout(e.animated), e.animated = setTimeout(function () {
                  C(e, "transition", ""), C(e, "transform", ""), e.animated = !1, e.animatingX = !1, e.animatingY = !1;
                }, r);
              }
            }
          }));
        }

        function Be(e, t, n, r, o, i, s, a) {
          var l,
              c,
              u = e[H],
              f = u.options.onMove;
          return !window.CustomEvent || d || h ? (l = document.createEvent("Event")).initEvent("move", !0, !0) : l = new CustomEvent("move", {
            bubbles: !0,
            cancelable: !0
          }), l.to = t, l.from = e, l.dragged = n, l.draggedRect = r, l.related = o || t, l.relatedRect = i || T(t), l.willInsertAfter = a, l.originalEvent = s, e.dispatchEvent(l), f && (c = f.call(u, l, s)), c;
        }

        function $e(e) {
          e.draggable = !1;
        }

        function He() {
          xe = !1;
        }

        function Ue(e) {
          for (var t = e.tagName + e.className + e.src + e.href + e.textContent, n = t.length, r = 0; n--;) {
            r += t.charCodeAt(n);
          }

          return r.toString(36);
        }

        function ze(e) {
          return setTimeout(e, 0);
        }

        function Ye(e) {
          return clearTimeout(e);
        }

        Ne.prototype = {
          constructor: Ne,
          _isOutsideThisEl: function _isOutsideThisEl(e) {
            this.el.contains(e) || e === this.el || (ge = null);
          },
          _getDirection: function _getDirection(e, t) {
            return "function" == typeof this.options.direction ? this.options.direction.call(this, e, t, K) : this.options.direction;
          },
          _onTapStart: function _onTapStart(e) {
            if (e.cancelable) {
              var t = this,
                  n = this.el,
                  r = this.options,
                  o = r.preventOnFilter,
                  i = e.type,
                  s = e.touches && e.touches[0] || e.pointerType && "touch" === e.pointerType && e,
                  a = (s || e).target,
                  l = e.target.shadowRoot && (e.path && e.path[0] || e.composedPath && e.composedPath()[0]) || a,
                  c = r.filter;

              if (function (e) {
                Ce.length = 0;

                for (var t = e.getElementsByTagName("input"), n = t.length; n--;) {
                  var r = t[n];
                  r.checked && Ce.push(r);
                }
              }(n), !K && !(/mousedown|pointerdown/.test(i) && 0 !== e.button || r.disabled) && !l.isContentEditable && (this.nativeDraggable || !p || !a || "SELECT" !== a.tagName.toUpperCase()) && !((a = E(a, r.draggable, n, !1)) && a.animated || Z === a)) {
                if (ne = F(a), oe = F(a, r.draggable), "function" == typeof c) {
                  if (c.call(this, e, a, this)) return W({
                    sortable: t,
                    rootEl: l,
                    name: "filter",
                    targetEl: a,
                    toEl: n,
                    fromEl: n
                  }), V("filter", t, {
                    evt: e
                  }), void (o && e.cancelable && e.preventDefault());
                } else if (c && (c = c.split(",").some(function (r) {
                  if (r = E(l, r.trim(), n, !1)) return W({
                    sortable: t,
                    rootEl: r,
                    name: "filter",
                    targetEl: a,
                    fromEl: n,
                    toEl: n
                  }), V("filter", t, {
                    evt: e
                  }), !0;
                }))) return void (o && e.cancelable && e.preventDefault());

                r.handle && !E(l, r.handle, n, !1) || this._prepareDragStart(e, s, a);
              }
            }
          },
          _prepareDragStart: function _prepareDragStart(e, t, n) {
            var r,
                o = this,
                i = o.el,
                s = o.options,
                a = i.ownerDocument;

            if (n && !K && n.parentNode === i) {
              var l = T(n);
              if (G = i, X = (K = n).parentNode, J = K.nextSibling, Z = n, se = s.group, Ne.dragged = K, le = {
                target: K,
                clientX: (t || e).clientX,
                clientY: (t || e).clientY
              }, he = le.clientX - l.left, fe = le.clientY - l.top, this._lastX = (t || e).clientX, this._lastY = (t || e).clientY, K.style["will-change"] = "all", r = function r() {
                V("delayEnded", o, {
                  evt: e
                }), Ne.eventCanceled ? o._onDrop() : (o._disableDelayedDragEvents(), !f && o.nativeDraggable && (K.draggable = !0), o._triggerDragStart(e, t), W({
                  sortable: o,
                  name: "choose",
                  originalEvent: e
                }), x(K, s.chosenClass, !0));
              }, s.ignore.split(",").forEach(function (e) {
                P(K, e.trim(), $e);
              }), y(a, "dragover", Ie), y(a, "mousemove", Ie), y(a, "touchmove", Ie), y(a, "mouseup", o._onDrop), y(a, "touchend", o._onDrop), y(a, "touchcancel", o._onDrop), f && this.nativeDraggable && (this.options.touchStartThreshold = 4, K.draggable = !0), V("delayStart", this, {
                evt: e
              }), !s.delay || s.delayOnTouchOnly && !t || this.nativeDraggable && (h || d)) r();else {
                if (Ne.eventCanceled) return void this._onDrop();
                y(a, "mouseup", o._disableDelayedDrag), y(a, "touchend", o._disableDelayedDrag), y(a, "touchcancel", o._disableDelayedDrag), y(a, "mousemove", o._delayedDragTouchMoveHandler), y(a, "touchmove", o._delayedDragTouchMoveHandler), s.supportPointer && y(a, "pointermove", o._delayedDragTouchMoveHandler), o._dragStartTimer = setTimeout(r, s.delay);
              }
            }
          },
          _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(e) {
            var t = e.touches ? e.touches[0] : e;
            Math.max(Math.abs(t.clientX - this._lastX), Math.abs(t.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
          },
          _disableDelayedDrag: function _disableDelayedDrag() {
            K && $e(K), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
          },
          _disableDelayedDragEvents: function _disableDelayedDragEvents() {
            var e = this.el.ownerDocument;
            b(e, "mouseup", this._disableDelayedDrag), b(e, "touchend", this._disableDelayedDrag), b(e, "touchcancel", this._disableDelayedDrag), b(e, "mousemove", this._delayedDragTouchMoveHandler), b(e, "touchmove", this._delayedDragTouchMoveHandler), b(e, "pointermove", this._delayedDragTouchMoveHandler);
          },
          _triggerDragStart: function _triggerDragStart(e, t) {
            t = t || "touch" == e.pointerType && e, !this.nativeDraggable || t ? this.options.supportPointer ? y(document, "pointermove", this._onTouchMove) : y(document, t ? "touchmove" : "mousemove", this._onTouchMove) : (y(K, "dragend", this), y(G, "dragstart", this._onDragStart));

            try {
              document.selection ? ze(function () {
                document.selection.empty();
              }) : window.getSelection().removeAllRanges();
            } catch (e) {}
          },
          _dragStarted: function _dragStarted(e, t) {
            if (be = !1, G && K) {
              V("dragStarted", this, {
                evt: t
              }), this.nativeDraggable && y(document, "dragover", Re);
              var n = this.options;
              !e && x(K, n.dragClass, !1), x(K, n.ghostClass, !0), Ne.active = this, e && this._appendGhost(), W({
                sortable: this,
                name: "start",
                originalEvent: t
              });
            } else this._nulling();
          },
          _emulateDragOver: function _emulateDragOver() {
            if (ce) {
              this._lastX = ce.clientX, this._lastY = ce.clientY, Fe();

              for (var e = document.elementFromPoint(ce.clientX, ce.clientY), t = e; e && e.shadowRoot && (e = e.shadowRoot.elementFromPoint(ce.clientX, ce.clientY)) !== t;) {
                t = e;
              }

              if (K.parentNode[H]._isOutsideThisEl(e), t) do {
                if (t[H] && t[H]._onDragOver({
                  clientX: ce.clientX,
                  clientY: ce.clientY,
                  target: e,
                  rootEl: t
                }) && !this.options.dragoverBubble) break;
                e = t;
              } while (t = t.parentNode);
              Le();
            }
          },
          _onTouchMove: function _onTouchMove(e) {
            if (le) {
              var t = this.options,
                  n = t.fallbackTolerance,
                  r = t.fallbackOffset,
                  o = e.touches ? e.touches[0] : e,
                  i = Q && k(Q, !0),
                  s = Q && i && i.a,
                  a = Q && i && i.d,
                  l = Pe && ye && L(ye),
                  c = (o.clientX - le.clientX + r.x) / (s || 1) + (l ? l[0] - Se[0] : 0) / (s || 1),
                  u = (o.clientY - le.clientY + r.y) / (a || 1) + (l ? l[1] - Se[1] : 0) / (a || 1);

              if (!Ne.active && !be) {
                if (n && Math.max(Math.abs(o.clientX - this._lastX), Math.abs(o.clientY - this._lastY)) < n) return;

                this._onDragStart(e, !0);
              }

              if (Q) {
                i ? (i.e += c - (ue || 0), i.f += u - (de || 0)) : i = {
                  a: 1,
                  b: 0,
                  c: 0,
                  d: 1,
                  e: c,
                  f: u
                };
                var d = "matrix(".concat(i.a, ",").concat(i.b, ",").concat(i.c, ",").concat(i.d, ",").concat(i.e, ",").concat(i.f, ")");
                C(Q, "webkitTransform", d), C(Q, "mozTransform", d), C(Q, "msTransform", d), C(Q, "transform", d), ue = c, de = u, ce = o;
              }

              e.cancelable && e.preventDefault();
            }
          },
          _appendGhost: function _appendGhost() {
            if (!Q) {
              var e = this.options.fallbackOnBody ? document.body : G,
                  t = T(K, !0, Pe, !0, e),
                  n = this.options;

              if (Pe) {
                for (ye = e; "static" === C(ye, "position") && "none" === C(ye, "transform") && ye !== document;) {
                  ye = ye.parentNode;
                }

                ye !== document.body && ye !== document.documentElement ? (ye === document && (ye = j()), t.top += ye.scrollTop, t.left += ye.scrollLeft) : ye = j(), Se = L(ye);
              }

              x(Q = K.cloneNode(!0), n.ghostClass, !1), x(Q, n.fallbackClass, !0), x(Q, n.dragClass, !0), C(Q, "transition", ""), C(Q, "transform", ""), C(Q, "box-sizing", "border-box"), C(Q, "margin", 0), C(Q, "top", t.top), C(Q, "left", t.left), C(Q, "width", t.width), C(Q, "height", t.height), C(Q, "opacity", "0.8"), C(Q, "position", Pe ? "absolute" : "fixed"), C(Q, "zIndex", "100000"), C(Q, "pointerEvents", "none"), Ne.ghost = Q, e.appendChild(Q), C(Q, "transform-origin", he / parseInt(Q.style.width) * 100 + "% " + fe / parseInt(Q.style.height) * 100 + "%");
            }
          },
          _onDragStart: function _onDragStart(e, t) {
            var n = this,
                r = e.dataTransfer,
                o = n.options;
            V("dragStart", this, {
              evt: e
            }), Ne.eventCanceled ? this._onDrop() : (V("setupClone", this), Ne.eventCanceled || ((ee = $(K)).removeAttribute("id"), ee.draggable = !1, ee.style["will-change"] = "", this._hideClone(), x(ee, this.options.chosenClass, !1), Ne.clone = ee), n.cloneId = ze(function () {
              V("clone", n), Ne.eventCanceled || (n.options.removeCloneOnHide || G.insertBefore(ee, K), n._hideClone(), W({
                sortable: n,
                name: "clone"
              }));
            }), !t && x(K, o.dragClass, !0), t ? (we = !0, n._loopId = setInterval(n._emulateDragOver, 50)) : (b(document, "mouseup", n._onDrop), b(document, "touchend", n._onDrop), b(document, "touchcancel", n._onDrop), r && (r.effectAllowed = "move", o.setData && o.setData.call(n, r, K)), y(document, "drop", n), C(K, "transform", "translateZ(0)")), be = !0, n._dragStartId = ze(n._dragStarted.bind(n, t, e)), y(document, "selectstart", n), pe = !0, p && C(document.body, "user-select", "none"));
          },
          _onDragOver: function _onDragOver(e) {
            var t,
                n,
                r,
                o,
                s = this.el,
                a = e.target,
                l = this.options,
                c = l.group,
                u = Ne.active,
                d = se === c,
                h = l.sort,
                f = ae || u,
                p = this,
                g = !1;

            if (!xe) {
              if (void 0 !== e.preventDefault && e.cancelable && e.preventDefault(), a = E(a, l.draggable, s, !0), N("dragOver"), Ne.eventCanceled) return g;
              if (K.contains(e.target) || a.animated && a.animatingX && a.animatingY || p._ignoreWhileAnimating === a) return U(!1);

              if (we = !1, u && !l.disabled && (d ? h || (r = X !== G) : ae === this || (this.lastPutMode = se.checkPull(this, u, K, e)) && c.checkPut(this, u, K, e))) {
                if (o = "vertical" === this._getDirection(e, a), t = T(K), N("dragOverValid"), Ne.eventCanceled) return g;
                if (r) return X = G, $(), this._hideClone(), N("revert"), Ne.eventCanceled || (J ? G.insertBefore(K, J) : G.appendChild(K)), U(!0);
                var m = A(s, l.draggable);

                if (!m || function (e, t, n) {
                  var r = T(A(n.el, n.options.draggable));
                  return t ? e.clientX > r.right + 10 || e.clientX <= r.right && e.clientY > r.bottom && e.clientX >= r.left : e.clientX > r.right && e.clientY > r.top || e.clientX <= r.right && e.clientY > r.bottom + 10;
                }(e, o, this) && !m.animated) {
                  if (m === K) return U(!1);
                  if (m && s === e.target && (a = m), a && (n = T(a)), !1 !== Be(G, s, K, t, a, n, e, !!a)) return $(), m && m.nextSibling ? s.insertBefore(K, m.nextSibling) : s.appendChild(K), X = s, z(), U(!0);
                } else if (m && function (e, t, n) {
                  var r = T(M(n.el, 0, n.options, !0));
                  return t ? e.clientX < r.left - 10 || e.clientY < r.top && e.clientX < r.right : e.clientY < r.top - 10 || e.clientY < r.bottom && e.clientX < r.left;
                }(e, o, this)) {
                  var v = M(s, 0, l, !0);
                  if (v === K) return U(!1);
                  if (n = T(a = v), !1 !== Be(G, s, K, t, a, n, e, !1)) return $(), s.insertBefore(K, v), X = s, z(), U(!0);
                } else if (a.parentNode === s) {
                  n = T(a);

                  var y,
                      b,
                      w,
                      O = K.parentNode !== s,
                      _ = !function (e, t, n) {
                    var r = n ? e.left : e.top,
                        o = n ? e.right : e.bottom,
                        i = n ? e.width : e.height,
                        s = n ? t.left : t.top,
                        a = n ? t.right : t.bottom,
                        l = n ? t.width : t.height;
                    return r === s || o === a || r + i / 2 === s + l / 2;
                  }(K.animated && K.toRect || t, a.animated && a.toRect || n, o),
                      S = o ? "top" : "left",
                      k = D(a, "top", "top") || D(K, "top", "top"),
                      P = k ? k.scrollTop : void 0;

                  if (ge !== a && (b = n[S], Ee = !1, _e = !_ && l.invertSwap || O), y = function (e, t, n, r, o, i, s, a) {
                    var l = r ? e.clientY : e.clientX,
                        c = r ? n.height : n.width,
                        u = r ? n.top : n.left,
                        d = r ? n.bottom : n.right,
                        h = !1;
                    if (!s) if (a && ve < c * o) {
                      if (!Ee && (1 === me ? l > u + c * i / 2 : l < d - c * i / 2) && (Ee = !0), Ee) h = !0;else if (1 === me ? l < u + ve : l > d - ve) return -me;
                    } else if (l > u + c * (1 - o) / 2 && l < d - c * (1 - o) / 2) return function (e) {
                      return F(K) < F(e) ? 1 : -1;
                    }(t);
                    return (h = h || s) && (l < u + c * i / 2 || l > d - c * i / 2) ? l > u + c / 2 ? 1 : -1 : 0;
                  }(e, a, n, o, _ ? 1 : l.swapThreshold, null == l.invertedSwapThreshold ? l.swapThreshold : l.invertedSwapThreshold, _e, ge === a), 0 !== y) {
                    var j = F(K);

                    do {
                      j -= y, w = X.children[j];
                    } while (w && ("none" === C(w, "display") || w === Q));
                  }

                  if (0 === y || w === a) return U(!1);
                  ge = a, me = y;
                  var L = a.nextElementSibling,
                      I = !1,
                      R = Be(G, s, K, t, a, n, e, I = 1 === y);
                  if (!1 !== R) return 1 !== R && -1 !== R || (I = 1 === R), xe = !0, setTimeout(He, 30), $(), I && !L ? s.appendChild(K) : a.parentNode.insertBefore(K, I ? L : a), k && B(k, 0, P - k.scrollTop), X = K.parentNode, void 0 === b || _e || (ve = Math.abs(b - T(a)[S])), z(), U(!0);
                }

                if (s.contains(K)) return U(!1);
              }

              return !1;
            }

            function N(l, c) {
              V(l, p, i({
                evt: e,
                isOwner: d,
                axis: o ? "vertical" : "horizontal",
                revert: r,
                dragRect: t,
                targetRect: n,
                canSort: h,
                fromSortable: f,
                target: a,
                completed: U,
                onMove: function onMove(n, r) {
                  return Be(G, s, K, t, n, T(n), e, r);
                },
                changed: z
              }, c));
            }

            function $() {
              N("dragOverAnimationCapture"), p.captureAnimationState(), p !== f && f.captureAnimationState();
            }

            function U(t) {
              return N("dragOverCompleted", {
                insertion: t
              }), t && (d ? u._hideClone() : u._showClone(p), p !== f && (x(K, ae ? ae.options.ghostClass : u.options.ghostClass, !1), x(K, l.ghostClass, !0)), ae !== p && p !== Ne.active ? ae = p : p === Ne.active && ae && (ae = null), f === p && (p._ignoreWhileAnimating = a), p.animateAll(function () {
                N("dragOverAnimationComplete"), p._ignoreWhileAnimating = null;
              }), p !== f && (f.animateAll(), f._ignoreWhileAnimating = null)), (a === K && !K.animated || a === s && !a.animated) && (ge = null), l.dragoverBubble || e.rootEl || a === document || (K.parentNode[H]._isOutsideThisEl(e.target), !t && Ie(e)), !l.dragoverBubble && e.stopPropagation && e.stopPropagation(), g = !0;
            }

            function z() {
              re = F(K), ie = F(K, l.draggable), W({
                sortable: p,
                name: "change",
                toEl: s,
                newIndex: re,
                newDraggableIndex: ie,
                originalEvent: e
              });
            }
          },
          _ignoreWhileAnimating: null,
          _offMoveEvents: function _offMoveEvents() {
            b(document, "mousemove", this._onTouchMove), b(document, "touchmove", this._onTouchMove), b(document, "pointermove", this._onTouchMove), b(document, "dragover", Ie), b(document, "mousemove", Ie), b(document, "touchmove", Ie);
          },
          _offUpEvents: function _offUpEvents() {
            var e = this.el.ownerDocument;
            b(e, "mouseup", this._onDrop), b(e, "touchend", this._onDrop), b(e, "pointerup", this._onDrop), b(e, "touchcancel", this._onDrop), b(document, "selectstart", this);
          },
          _onDrop: function _onDrop(e) {
            var t = this.el,
                n = this.options;
            re = F(K), ie = F(K, n.draggable), V("drop", this, {
              evt: e
            }), X = K && K.parentNode, re = F(K), ie = F(K, n.draggable), Ne.eventCanceled || (be = !1, _e = !1, Ee = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), Ye(this.cloneId), Ye(this._dragStartId), this.nativeDraggable && (b(document, "drop", this), b(t, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), p && C(document.body, "user-select", ""), C(K, "transform", ""), e && (pe && (e.cancelable && e.preventDefault(), !n.dropBubble && e.stopPropagation()), Q && Q.parentNode && Q.parentNode.removeChild(Q), (G === X || ae && "clone" !== ae.lastPutMode) && ee && ee.parentNode && ee.parentNode.removeChild(ee), K && (this.nativeDraggable && b(K, "dragend", this), $e(K), K.style["will-change"] = "", pe && !be && x(K, ae ? ae.options.ghostClass : this.options.ghostClass, !1), x(K, this.options.chosenClass, !1), W({
              sortable: this,
              name: "unchoose",
              toEl: X,
              newIndex: null,
              newDraggableIndex: null,
              originalEvent: e
            }), G !== X ? (re >= 0 && (W({
              rootEl: X,
              name: "add",
              toEl: X,
              fromEl: G,
              originalEvent: e
            }), W({
              sortable: this,
              name: "remove",
              toEl: X,
              originalEvent: e
            }), W({
              rootEl: X,
              name: "sort",
              toEl: X,
              fromEl: G,
              originalEvent: e
            }), W({
              sortable: this,
              name: "sort",
              toEl: X,
              originalEvent: e
            })), ae && ae.save()) : re !== ne && re >= 0 && (W({
              sortable: this,
              name: "update",
              toEl: X,
              originalEvent: e
            }), W({
              sortable: this,
              name: "sort",
              toEl: X,
              originalEvent: e
            })), Ne.active && (null != re && -1 !== re || (re = ne, ie = oe), W({
              sortable: this,
              name: "end",
              toEl: X,
              originalEvent: e
            }), this.save())))), this._nulling();
          },
          _nulling: function _nulling() {
            V("nulling", this), G = K = X = Q = J = ee = Z = te = le = ce = pe = re = ie = ne = oe = ge = me = ae = se = Ne.dragged = Ne.ghost = Ne.clone = Ne.active = null, Ce.forEach(function (e) {
              e.checked = !0;
            }), Ce.length = ue = de = 0;
          },
          handleEvent: function handleEvent(e) {
            switch (e.type) {
              case "drop":
              case "dragend":
                this._onDrop(e);

                break;

              case "dragenter":
              case "dragover":
                K && (this._onDragOver(e), function (e) {
                  e.dataTransfer && (e.dataTransfer.dropEffect = "move"), e.cancelable && e.preventDefault();
                }(e));
                break;

              case "selectstart":
                e.preventDefault();
            }
          },
          toArray: function toArray() {
            for (var e, t = [], n = this.el.children, r = 0, o = n.length, i = this.options; r < o; r++) {
              E(e = n[r], i.draggable, this.el, !1) && t.push(e.getAttribute(i.dataIdAttr) || Ue(e));
            }

            return t;
          },
          sort: function sort(e, t) {
            var n = {},
                r = this.el;
            this.toArray().forEach(function (e, t) {
              var o = r.children[t];
              E(o, this.options.draggable, r, !1) && (n[e] = o);
            }, this), t && this.captureAnimationState(), e.forEach(function (e) {
              n[e] && (r.removeChild(n[e]), r.appendChild(n[e]));
            }), t && this.animateAll();
          },
          save: function save() {
            var e = this.options.store;
            e && e.set && e.set(this);
          },
          closest: function closest(e, t) {
            return E(e, t || this.options.draggable, this.el, !1);
          },
          option: function option(e, t) {
            var n = this.options;
            if (void 0 === t) return n[e];
            var r = Y.modifyOption(this, e, t);
            n[e] = void 0 !== r ? r : t, "group" === e && Ae(n);
          },
          destroy: function destroy() {
            V("destroy", this);
            var e = this.el;
            e[H] = null, b(e, "mousedown", this._onTapStart), b(e, "touchstart", this._onTapStart), b(e, "pointerdown", this._onTapStart), this.nativeDraggable && (b(e, "dragover", this), b(e, "dragenter", this)), Array.prototype.forEach.call(e.querySelectorAll("[draggable]"), function (e) {
              e.removeAttribute("draggable");
            }), this._onDrop(), this._disableDelayedDragEvents(), Oe.splice(Oe.indexOf(this.el), 1), this.el = e = null;
          },
          _hideClone: function _hideClone() {
            if (!te) {
              if (V("hideClone", this), Ne.eventCanceled) return;
              C(ee, "display", "none"), this.options.removeCloneOnHide && ee.parentNode && ee.parentNode.removeChild(ee), te = !0;
            }
          },
          _showClone: function _showClone(e) {
            if ("clone" === e.lastPutMode) {
              if (te) {
                if (V("showClone", this), Ne.eventCanceled) return;
                K.parentNode != G || this.options.group.revertClone ? J ? G.insertBefore(ee, J) : G.appendChild(ee) : G.insertBefore(ee, K), this.options.group.revertClone && this.animate(K, ee), C(ee, "display", ""), te = !1;
              }
            } else this._hideClone();
          }
        }, ke && y(document, "touchmove", function (e) {
          (Ne.active || be) && e.cancelable && e.preventDefault();
        }), Ne.utils = {
          on: y,
          off: b,
          css: C,
          find: P,
          is: function is(e, t) {
            return !!E(e, t, e, !1);
          },
          extend: function extend(e, t) {
            if (e && t) for (var n in t) {
              t.hasOwnProperty(n) && (e[n] = t[n]);
            }
            return e;
          },
          throttle: N,
          closest: E,
          toggleClass: x,
          clone: $,
          index: F,
          nextTick: ze,
          cancelNextTick: Ye,
          detectDirection: Me,
          getChild: M
        }, Ne.get = function (e) {
          return e[H];
        }, Ne.mount = function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }

          t[0].constructor === Array && (t = t[0]), t.forEach(function (e) {
            if (!e.prototype || !e.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(e));
            e.utils && (Ne.utils = i(i({}, Ne.utils), e.utils)), Y.mount(e);
          });
        }, Ne.create = function (e, t) {
          return new Ne(e, t);
        }, Ne.version = "1.15.0";
        var qe,
            Ve,
            We,
            Ke = [];
        N(function (e, t, n, r) {
          if (t.scroll) {
            var o,
                i = (e.touches ? e.touches[0] : e).clientX,
                s = (e.touches ? e.touches[0] : e).clientY,
                a = t.scrollSensitivity,
                l = t.scrollSpeed,
                c = j();
            Ve !== n && (Ve = n, Ke.forEach(function (e) {
              clearInterval(e.pid);
            }), Ke = [], qe = t.scroll, o = t.scrollFn, !0 === qe && (qe = I(n, !0)));
            var u = 0,
                d = qe;

            do {
              var h = d,
                  f = T(h),
                  p = f.top,
                  g = f.bottom,
                  m = f.left,
                  v = f.right,
                  y = f.width,
                  b = f.height,
                  w = void 0,
                  O = void 0,
                  E = h.scrollWidth,
                  _ = h.scrollHeight,
                  S = C(h),
                  x = h.scrollLeft,
                  k = h.scrollTop;
              h === c ? (w = y < E && ("auto" === S.overflowX || "scroll" === S.overflowX || "visible" === S.overflowX), O = b < _ && ("auto" === S.overflowY || "scroll" === S.overflowY || "visible" === S.overflowY)) : (w = y < E && ("auto" === S.overflowX || "scroll" === S.overflowX), O = b < _ && ("auto" === S.overflowY || "scroll" === S.overflowY));
              var P = w && (Math.abs(v - i) <= a && x + y < E) - (Math.abs(m - i) <= a && !!x),
                  D = O && (Math.abs(g - s) <= a && k + b < _) - (Math.abs(p - s) <= a && !!k);
              if (!Ke[u]) for (var M = 0; M <= u; M++) {
                Ke[M] || (Ke[M] = {});
              }
              Ke[u].vx == P && Ke[u].vy == D && Ke[u].el === h || (Ke[u].el = h, Ke[u].vx = P, Ke[u].vy = D, clearInterval(Ke[u].pid), 0 == P && 0 == D || (!0, Ke[u].pid = setInterval(function () {
                r && 0 === this.layer && Ne.active._onTouchMove(We);
                var t = Ke[this.layer].vy ? Ke[this.layer].vy * l : 0,
                    n = Ke[this.layer].vx ? Ke[this.layer].vx * l : 0;
                "function" == typeof o && "continue" !== o.call(Ne.dragged.parentNode[H], n, t, e, We, Ke[this.layer].el) || B(Ke[this.layer].el, n, t);
              }.bind({
                layer: u
              }), 24))), u++;
            } while (t.bubbleScroll && d !== c && (d = I(d, !1)));
          }
        }, 30);

        var Xe = function Xe(e) {
          var t = e.originalEvent,
              n = e.putSortable,
              r = e.dragEl,
              o = e.activeSortable,
              i = e.dispatchSortableEvent,
              s = e.hideGhostForTarget,
              a = e.unhideGhostForTarget;

          if (t) {
            var l = n || o;
            s();
            var c = t.changedTouches && t.changedTouches.length ? t.changedTouches[0] : t,
                u = document.elementFromPoint(c.clientX, c.clientY);
            a(), l && !l.el.contains(u) && (i("spill"), this.onSpill({
              dragEl: r,
              putSortable: n
            }));
          }
        };

        function Qe() {}

        function Ge() {}

        Qe.prototype = {
          startIndex: null,
          dragStart: function dragStart(e) {
            var t = e.oldDraggableIndex;
            this.startIndex = t;
          },
          onSpill: function onSpill(e) {
            var t = e.dragEl,
                n = e.putSortable;
            this.sortable.captureAnimationState(), n && n.captureAnimationState();
            var r = M(this.sortable.el, this.startIndex, this.options);
            r ? this.sortable.el.insertBefore(t, r) : this.sortable.el.appendChild(t), this.sortable.animateAll(), n && n.animateAll();
          },
          drop: Xe
        }, l(Qe, {
          pluginName: "revertOnSpill"
        }), Ge.prototype = {
          onSpill: function onSpill(e) {
            var t = e.dragEl,
                n = e.putSortable || this.sortable;
            n.captureAnimationState(), t.parentNode && t.parentNode.removeChild(t), n.animateAll();
          },
          drop: Xe
        }, l(Ge, {
          pluginName: "removeOnSpill"
        });
        var Je = Ne,
            Ze = n(7545);

        function et(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function tt(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function nt(e, t) {
          return nt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, nt(e, t);
        }

        function rt(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function ot(e) {
          return ot = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, ot(e);
        }

        function it(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }

        var st = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && nt(e, t);
          }(s, e);
          var t,
              n,
              r,
              o,
              i = (r = s, o = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = ot(r);

            if (o) {
              var n = ot(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return rt(this, e);
          });

          function s() {
            return et(this, s), i.apply(this, arguments);
          }

          return t = s, (n = [{
            key: "connect",
            value: function value() {
              var _this94 = this;

              (0, Ze.I0)(this), new Je(this.element, _objectSpread(_objectSpread({}, this.options), {}, {
                onChoose: function onChoose(e) {
                  return _this94.dispatch("choose", {
                    event: e
                  });
                },
                onUnchoose: function onUnchoose(e) {
                  return _this94.dispatch("unchoose", {
                    event: e
                  });
                },
                onStart: function onStart(e) {
                  return _this94.dispatch("start", {
                    event: e
                  });
                },
                onEnd: function onEnd(e) {
                  return _this94.dispatch("end", {
                    event: e
                  });
                },
                onAdd: function onAdd(e) {
                  return _this94.dispatch("add", {
                    event: e
                  });
                },
                onUpdate: function onUpdate(e) {
                  return _this94.dispatch("update", {
                    event: e
                  });
                },
                onSort: function onSort(e) {
                  return _this94.dispatch("sort", {
                    event: e
                  });
                },
                onRemove: function onRemove(e) {
                  return _this94.dispatch("remove", {
                    event: e
                  });
                },
                onFilter: function onFilter(e) {
                  return _this94.dispatch("filter", {
                    event: e
                  });
                },
                onMove: function onMove(e) {
                  return _this94.dispatch("move", {
                    event: e
                  });
                },
                onClone: function onClone(e) {
                  return _this94.dispatch("clone", {
                    event: e
                  });
                },
                onChange: function onChange(e) {
                  return _this94.dispatch("change", {
                    event: e
                  });
                }
              }));
            }
          }, {
            key: "options",
            get: function get() {
              return _objectSpread(_objectSpread({}, this.hasGhostClass && {
                ghostClass: this.ghostClas
              }), {}, {
                animation: this.animationValue || 150,
                draggable: this.draggableValue,
                handle: this.handleValue
              });
            }
          }]) && tt(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), s;
        }(r.Qr);

        it(st, "classes", ["draggable", "ghost", "handle"]), it(st, "values", {
          animation: Number,
          draggable: String,
          handle: String
        });
      },
      3708: function _(e, t, n) {
        "use strict";

        function r(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function o(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function i(e, t) {
          return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, i(e, t);
        }

        function s(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function a(e) {
          return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, a(e);
        }

        n.r(t), n.d(t, {
          default: function _default() {
            return l;
          }
        });

        var l = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && i(e, t);
          }(d, e);
          var t,
              n,
              l,
              c,
              u = (l = d, c = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = a(l);

            if (c) {
              var n = a(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return s(this, e);
          });

          function d() {
            return r(this, d), u.apply(this, arguments);
          }

          return t = d, (n = [{
            key: "onBefore",
            value: function value() {
              this.loading(), this.toggleState();
            }
          }, {
            key: "onSuccess",
            value: function value() {
              this.loaded();
            }
          }, {
            key: "onError",
            value: function value() {
              this.loaded(), toggleState();
            }
          }, {
            key: "loading",
            value: function value() {
              this.element.classList.add(this.loadingClass);
            }
          }, {
            key: "loaded",
            value: function value() {
              this.element.classList.remove(this.loadingClass);
            }
          }, {
            key: "toggleState",
            value: function value() {
              this.isOn ? this.setOff() : this.setOn();
            }
          }, {
            key: "setOn",
            value: function value() {
              this.element.classList.remove(this.offClass), this.element.classList.add(this.isonClass);
            }
          }, {
            key: "setOff",
            value: function value() {
              this.element.classList.remove(this.isonClass), this.element.classList.add(this.offClass);
            }
          }, {
            key: "loadingClass",
            get: function get() {
              return this.data.get("loading-class");
            }
          }, {
            key: "onClass",
            get: function get() {
              return this.data.get("on-class");
            }
          }, {
            key: "offClass",
            get: function get() {
              return this.data.get("off-class");
            }
          }, {
            key: "disabledClass",
            get: function get() {
              return this.data.get("disabled-class");
            }
          }, {
            key: "isOn",
            get: function get() {
              return this.element.classList.contains(this.onClass);
            }
          }, {
            key: "isDisabled",
            get: function get() {
              return this.element.classList.contains(this.disabledClass);
            }
          }]) && o(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), d;
        }(n(6599).Qr);
      },
      3248: function _(e, t, n) {
        "use strict";

        function r(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function o(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function i(e, t) {
          return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, i(e, t);
        }

        function s(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function a(e) {
          return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, a(e);
        }

        n.r(t), n.d(t, {
          default: function _default() {
            return l;
          }
        });

        var l = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && i(e, t);
          }(d, e);
          var t,
              n,
              l,
              c,
              u = (l = d, c = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = a(l);

            if (c) {
              var n = a(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return s(this, e);
          });

          function d() {
            return r(this, d), u.apply(this, arguments);
          }

          return t = d, (n = [{
            key: "setLocale",
            value: function value(e) {
              var t = window.location.toString().replace("".concat(this.data.get("locale")), e.target.value);
              Turbo.visit(t);
            }
          }]) && o(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), d;
        }(n(6599).Qr);
      },
      8963: function _(e, t, n) {
        "use strict";

        function r(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function o(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function i(e, t) {
          return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, i(e, t);
        }

        function s(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function a(e) {
          return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, a(e);
        }

        n.r(t), n.d(t, {
          default: function _default() {
            return l;
          }
        });

        var l = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && i(e, t);
          }(d, e);
          var t,
              n,
              l,
              c,
              u = (l = d, c = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = a(l);

            if (c) {
              var n = a(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return s(this, e);
          });

          function d() {
            return r(this, d), u.apply(this, arguments);
          }

          return t = d, (n = [{
            key: "connect",
            value: function value() {
              this.updateOriginalValue();
            }
          }, {
            key: "onSuccess",
            value: function value() {
              this.updateOriginalValue(), this.updateChangedState();
            }
          }, {
            key: "cancel",
            value: function value() {
              var e = new Event("input", {
                bubbles: !0,
                cancelable: !0
              });
              this.inputTarget.value = this.data.get("originalValue"), this.inputTarget.dispatchEvent(e), this.updateChangedState();
            }
          }, {
            key: "updateOriginalValue",
            value: function value() {
              this.data.set("originalValue", this.inputTarget.value);
            }
          }, {
            key: "updateChangedState",
            value: function value() {
              this.element.classList.toggle("changed", this.hasChanged);
            }
          }, {
            key: "hasChanged",
            get: function get() {
              return this.inputTarget.value != this.data.get("originalValue");
            }
          }]) && o(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), d;
        }(n(6599).Qr);

        var c, u, d;
        d = ["input"], (u = "targets") in (c = l) ? Object.defineProperty(c, u, {
          value: d,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : c[u] = d;
      },
      1555: function _(e, t, n) {
        "use strict";

        function r(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function o(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function i(e, t) {
          return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, i(e, t);
        }

        function s(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function a(e) {
          return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, a(e);
        }

        n.r(t), n.d(t, {
          default: function _default() {
            return l;
          }
        });

        var l = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && i(e, t);
          }(d, e);
          var t,
              n,
              l,
              c,
              u = (l = d, c = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = a(l);

            if (c) {
              var n = a(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return s(this, e);
          });

          function d() {
            return r(this, d), u.apply(this, arguments);
          }

          return t = d, (n = [{
            key: "hide",
            value: function value() {
              this.element.classList.toggle(this.data.get("hiddenClass"));
            }
          }]) && o(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), d;
        }(n(6599).Qr);
      },
      9303: function _(e, t, n) {
        "use strict";

        function r(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }

        function o(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function i(e, t) {
          return i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, i(e, t);
        }

        function s(e, t) {
          if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }

        function a(e) {
          return a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, a(e);
        }

        n.r(t), n.d(t, {
          default: function _default() {
            return l;
          }
        });

        var l = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && i(e, t);
          }(d, e);
          var t,
              n,
              l,
              c,
              u = (l = d, c = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }(), function () {
            var e,
                t = a(l);

            if (c) {
              var n = a(this).constructor;
              e = Reflect.construct(t, arguments, n);
            } else e = t.apply(this, arguments);

            return s(this, e);
          });

          function d() {
            return r(this, d), u.apply(this, arguments);
          }

          return t = d, (n = [{
            key: "dirty",
            value: function value() {
              this.element.classList.add(this.data.get("dirtyClass"));
            }
          }, {
            key: "public",
            value: function value() {
              this.element.classList.remove(this.data.get("privateClass"));
            }
          }, {
            key: "private",
            value: function value() {
              this.element.classList.add(this.data.get("privateClass"));
            }
          }]) && o(t.prototype, n), Object.defineProperty(t, "prototype", {
            writable: !1
          }), d;
        }(n(6599).Qr);
      },
      3033: function _(e, t, n) {
        "use strict";

        n.d(t, {
          Z: function Z() {
            return i;
          }
        });
        var r = n(4320);

        function o(e) {
          if (e instanceof HTMLElement) return e;

          if (e.indexOf("<") > -1) {
            var _t19 = document.createElement("div");

            return _t19.innerHTML = e.trim(), _t19.firstChild;
          }

          return document.querySelector(e);
        }

        function i() {
          var _this95 = this;

          if ("multi" !== this.settings.mode) return;
          var e = this.lock;
          this.hook("instead", "lock", function () {
            return console.log(_this95.sortable), _this95.sortable && _this95.sortable.disable(), e.call(_this95);
          });
          var t = this.unlock;
          this.hook("instead", "unlock", function () {
            return console.log(_this95.sortable), _this95.sortable && _this95.sortable.enable(), t.call(_this95);
          }), this.hook("after", "setupTemplates", function () {
            var e = _this95.settings.render.item;

            _this95.settings.render.item = function (t, n) {
              var r = o(e.call(_this95, t, n)),
                  i = o("<div class='item__handle'>&vellip;</div>");
              return r.prepend(i), r;
            };
          }), this.on("initialize", function () {
            _this95.sortable = new r.Sortable(_this95.control, {
              draggable: ".item",
              handle: ".item__handle"
            }), _this95.sortable.on("sortable:stop", function (e) {
              requestAnimationFrame(function () {
                var e = _toConsumableArray(_this95.control.querySelectorAll("[data-value]")).map(function (e) {
                  return e.dataset.value;
                });

                _this95.setValue(e), console.log(e, _this95.getValue());
              });
            });
          });
        }
      },
      1668: function _(e, t, n) {
        "use strict";

        function r(e, t) {
          e.removeEventListener("transitionend", r), t();
        }

        function o(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 150;
          return new Promise(function (n) {
            requestAnimationFrame(function () {
              e.addEventListener("transitionend", function () {
                return r(e, n);
              }, !1), e.style.opacity = 1, e.style.transition = "all ease-in ".concat(t, "ms"), e.style.opacity = 0, e.style.scale = "0.95";
            });
          });
        }

        n.d(t, {
          C: function C() {
            return o;
          }
        });
      },
      1895: function _() {
        "use strict";

        "function" != typeof Object.assign && (Object.assign = function (e) {
          for (var t = [], n = 1; n < arguments.length; n++) {
            t[n - 1] = arguments[n];
          }

          if (!e) throw TypeError("Cannot convert undefined or null to object");

          for (var r = function r(t) {
            t && Object.keys(t).forEach(function (n) {
              return e[n] = t[n];
            });
          }, o = 0, i = t; o < i.length; o++) {
            var s = i[o];
            r(s);
          }

          return e;
        });
      },
      8515: function _(e, t, n) {
        "use strict";

        var r = "undefined" != typeof navigator && navigator.userAgent.toLowerCase().indexOf("firefox") > 0;

        function o(e, t, n, r) {
          e.addEventListener ? e.addEventListener(t, n, r) : e.attachEvent && e.attachEvent("on".concat(t), function () {
            n(window.event);
          });
        }

        function i(e, t) {
          for (var n = t.slice(0, t.length - 1), r = 0; r < n.length; r++) {
            n[r] = e[n[r].toLowerCase()];
          }

          return n;
        }

        function s(e) {
          "string" != typeof e && (e = "");

          for (var t = (e = e.replace(/\s/g, "")).split(","), n = t.lastIndexOf(""); n >= 0;) {
            t[n - 1] += ",", t.splice(n, 1), n = t.lastIndexOf("");
          }

          return t;
        }

        for (var a = {
          backspace: 8,
          tab: 9,
          clear: 12,
          enter: 13,
          return: 13,
          esc: 27,
          escape: 27,
          space: 32,
          left: 37,
          up: 38,
          right: 39,
          down: 40,
          del: 46,
          delete: 46,
          ins: 45,
          insert: 45,
          home: 36,
          end: 35,
          pageup: 33,
          pagedown: 34,
          capslock: 20,
          num_0: 96,
          num_1: 97,
          num_2: 98,
          num_3: 99,
          num_4: 100,
          num_5: 101,
          num_6: 102,
          num_7: 103,
          num_8: 104,
          num_9: 105,
          num_multiply: 106,
          num_add: 107,
          num_enter: 108,
          num_subtract: 109,
          num_decimal: 110,
          num_divide: 111,
          "⇪": 20,
          ",": 188,
          ".": 190,
          "/": 191,
          "`": 192,
          "-": r ? 173 : 189,
          "=": r ? 61 : 187,
          ";": r ? 59 : 186,
          "'": 222,
          "[": 219,
          "]": 221,
          "\\": 220
        }, l = {
          "⇧": 16,
          shift: 16,
          "⌥": 18,
          alt: 18,
          option: 18,
          "⌃": 17,
          ctrl: 17,
          control: 17,
          "⌘": 91,
          cmd: 91,
          command: 91
        }, c = {
          16: "shiftKey",
          18: "altKey",
          17: "ctrlKey",
          91: "metaKey",
          shiftKey: 16,
          ctrlKey: 17,
          altKey: 18,
          metaKey: 91
        }, u = {
          16: !1,
          18: !1,
          17: !1,
          91: !1
        }, d = {}, h = 1; h < 20; h++) {
          a["f".concat(h)] = 111 + h;
        }

        var f = [],
            p = !1,
            g = "all",
            m = [],
            v = function v(e) {
          return a[e.toLowerCase()] || l[e.toLowerCase()] || e.toUpperCase().charCodeAt(0);
        };

        function y(e) {
          g = e || "all";
        }

        function b() {
          return g || "all";
        }

        var w = function w(e) {
          var t = e.key,
              n = e.scope,
              r = e.method,
              o = e.splitKey,
              a = void 0 === o ? "+" : o;
          s(t).forEach(function (e) {
            var t = e.split(a),
                o = t.length,
                s = t[o - 1],
                c = "*" === s ? "*" : v(s);

            if (d[c]) {
              n || (n = b());
              var u = o > 1 ? i(l, t) : [];
              d[c] = d[c].filter(function (e) {
                return !((!r || e.method === r) && e.scope === n && function (e, t) {
                  for (var n = e.length >= t.length ? e : t, r = e.length >= t.length ? t : e, o = !0, i = 0; i < n.length; i++) {
                    -1 === r.indexOf(n[i]) && (o = !1);
                  }

                  return o;
                }(e.mods, u));
              });
            }
          });
        };

        function O(e, t, n, r) {
          var o;

          if (t.element === r && (t.scope === n || "all" === t.scope)) {
            for (var i in o = t.mods.length > 0, u) {
              Object.prototype.hasOwnProperty.call(u, i) && (!u[i] && t.mods.indexOf(+i) > -1 || u[i] && -1 === t.mods.indexOf(+i)) && (o = !1);
            }

            (0 !== t.mods.length || u[16] || u[18] || u[17] || u[91]) && !o && "*" !== t.shortcut || !1 === t.method(e, t) && (e.preventDefault ? e.preventDefault() : e.returnValue = !1, e.stopPropagation && e.stopPropagation(), e.cancelBubble && (e.cancelBubble = !0));
          }
        }

        function E(e, t) {
          var n = d["*"],
              r = e.keyCode || e.which || e.charCode;

          if (_.filter.call(this, e)) {
            if (93 !== r && 224 !== r || (r = 91), -1 === f.indexOf(r) && 229 !== r && f.push(r), ["ctrlKey", "altKey", "shiftKey", "metaKey"].forEach(function (t) {
              var n = c[t];
              e[t] && -1 === f.indexOf(n) ? f.push(n) : !e[t] && f.indexOf(n) > -1 ? f.splice(f.indexOf(n), 1) : "metaKey" === t && e[t] && 3 === f.length && (e.ctrlKey || e.shiftKey || e.altKey || (f = f.slice(f.indexOf(n))));
            }), r in u) {
              for (var o in u[r] = !0, l) {
                l[o] === r && (_[o] = !0);
              }

              if (!n) return;
            }

            for (var i in u) {
              Object.prototype.hasOwnProperty.call(u, i) && (u[i] = e[c[i]]);
            }

            e.getModifierState && (!e.altKey || e.ctrlKey) && e.getModifierState("AltGraph") && (-1 === f.indexOf(17) && f.push(17), -1 === f.indexOf(18) && f.push(18), u[17] = !0, u[18] = !0);
            var s = b();
            if (n) for (var a = 0; a < n.length; a++) {
              n[a].scope === s && ("keydown" === e.type && n[a].keydown || "keyup" === e.type && n[a].keyup) && O(e, n[a], s, t);
            }
            if (r in d) for (var h = 0; h < d[r].length; h++) {
              if (("keydown" === e.type && d[r][h].keydown || "keyup" === e.type && d[r][h].keyup) && d[r][h].key) {
                for (var p = d[r][h], g = p.splitKey, m = p.key.split(g), y = [], w = 0; w < m.length; w++) {
                  y.push(v(m[w]));
                }

                y.sort().join("") === f.sort().join("") && O(e, p, s, t);
              }
            }
          }
        }

        function _(e, t, n) {
          f = [];
          var r = s(e),
              a = [],
              c = "all",
              h = document,
              g = 0,
              y = !1,
              b = !0,
              w = "+",
              O = !1;

          for (void 0 === n && "function" == typeof t && (n = t), "[object Object]" === Object.prototype.toString.call(t) && (t.scope && (c = t.scope), t.element && (h = t.element), t.keyup && (y = t.keyup), void 0 !== t.keydown && (b = t.keydown), void 0 !== t.capture && (O = t.capture), "string" == typeof t.splitKey && (w = t.splitKey)), "string" == typeof t && (c = t); g < r.length; g++) {
            a = [], (e = r[g].split(w)).length > 1 && (a = i(l, e)), (e = "*" === (e = e[e.length - 1]) ? "*" : v(e)) in d || (d[e] = []), d[e].push({
              keyup: y,
              keydown: b,
              scope: c,
              mods: a,
              shortcut: r[g],
              method: n,
              key: r[g],
              splitKey: w,
              element: h
            });
          }

          void 0 !== h && !function (e) {
            return m.indexOf(e) > -1;
          }(h) && window && (m.push(h), o(h, "keydown", function (e) {
            E(e, h);
          }, O), p || (p = !0, o(window, "focus", function () {
            f = [];
          }, O)), o(h, "keyup", function (e) {
            E(e, h), function (e) {
              var t = e.keyCode || e.which || e.charCode,
                  n = f.indexOf(t);
              if (n >= 0 && f.splice(n, 1), e.key && "meta" === e.key.toLowerCase() && f.splice(0, f.length), 93 !== t && 224 !== t || (t = 91), t in u) for (var r in u[t] = !1, l) {
                l[r] === t && (_[r] = !1);
              }
            }(e);
          }, O));
        }

        var S = {
          setScope: y,
          getScope: b,
          deleteScope: function deleteScope(e, t) {
            var n, r;

            for (var o in e || (e = b()), d) {
              if (Object.prototype.hasOwnProperty.call(d, o)) for (n = d[o], r = 0; r < n.length;) {
                n[r].scope === e ? n.splice(r, 1) : r++;
              }
            }

            b() === e && y(t || "all");
          },
          getPressedKeyCodes: function getPressedKeyCodes() {
            return f.slice(0);
          },
          isPressed: function isPressed(e) {
            return "string" == typeof e && (e = v(e)), -1 !== f.indexOf(e);
          },
          filter: function filter(e) {
            var t = e.target || e.srcElement,
                n = t.tagName,
                r = !0;
            return !t.isContentEditable && ("INPUT" !== n && "TEXTAREA" !== n && "SELECT" !== n || t.readOnly) || (r = !1), r;
          },
          trigger: function trigger(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "all";
            Object.keys(d).forEach(function (n) {
              var r = d[n].find(function (n) {
                return n.scope === t && n.shortcut === e;
              });
              r && r.method && r.method();
            });
          },
          unbind: function unbind(e) {
            if (void 0 === e) Object.keys(d).forEach(function (e) {
              return delete d[e];
            });else if (Array.isArray(e)) e.forEach(function (e) {
              e.key && w(e);
            });else if ("object" == _typeof(e)) e.key && w(e);else if ("string" == typeof e) {
              for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
                n[r - 1] = arguments[r];
              }

              var o = n[0],
                  i = n[1];
              "function" == typeof o && (i = o, o = ""), w({
                key: e,
                scope: o,
                method: i,
                splitKey: "+"
              });
            }
          },
          keyMap: a,
          modifier: l,
          modifierMap: c
        };

        for (var x in S) {
          Object.prototype.hasOwnProperty.call(S, x) && (_[x] = S[x]);
        }

        if ("undefined" != typeof window) {
          var C = window.hotkeys;
          _.noConflict = function (e) {
            return e && window.hotkeys === _ && (window.hotkeys = C), _;
          }, window.hotkeys = _;
        }
      },
      3096: function _(e, t, n) {
        var r = "Expected a function",
            o = /^\s+|\s+$/g,
            i = /^[-+]0x[0-9a-f]+$/i,
            s = /^0b[01]+$/i,
            a = /^0o[0-7]+$/i,
            l = parseInt,
            c = "object" == _typeof(n.g) && n.g && n.g.Object === Object && n.g,
            u = "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
            d = c || u || Function("return this")(),
            h = Object.prototype.toString,
            f = Math.max,
            p = Math.min,
            g = function g() {
          return d.Date.now();
        };

        function m(e) {
          var t = _typeof(e);

          return !!e && ("object" == t || "function" == t);
        }

        function v(e) {
          if ("number" == typeof e) return e;
          if (function (e) {
            return "symbol" == _typeof(e) || function (e) {
              return !!e && "object" == _typeof(e);
            }(e) && "[object Symbol]" == h.call(e);
          }(e)) return NaN;

          if (m(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = m(t) ? t + "" : t;
          }

          if ("string" != typeof e) return 0 === e ? e : +e;
          e = e.replace(o, "");
          var n = s.test(e);
          return n || a.test(e) ? l(e.slice(2), n ? 2 : 8) : i.test(e) ? NaN : +e;
        }

        e.exports = function (e, t, n) {
          var o = !0,
              i = !0;
          if ("function" != typeof e) throw new TypeError(r);
          return m(n) && (o = "leading" in n ? !!n.leading : o, i = "trailing" in n ? !!n.trailing : i), function (e, t, n) {
            var o,
                i,
                s,
                a,
                l,
                c,
                u = 0,
                d = !1,
                h = !1,
                y = !0;
            if ("function" != typeof e) throw new TypeError(r);

            function b(t) {
              var n = o,
                  r = i;
              return o = i = void 0, u = t, a = e.apply(r, n);
            }

            function w(e) {
              return u = e, l = setTimeout(E, t), d ? b(e) : a;
            }

            function O(e) {
              var n = e - c;
              return void 0 === c || n >= t || n < 0 || h && e - u >= s;
            }

            function E() {
              var e = g();
              if (O(e)) return _(e);
              l = setTimeout(E, function (e) {
                var n = t - (e - c);
                return h ? p(n, s - (e - u)) : n;
              }(e));
            }

            function _(e) {
              return l = void 0, y && o ? b(e) : (o = i = void 0, a);
            }

            function S() {
              var e = g(),
                  n = O(e);

              if (o = arguments, i = this, c = e, n) {
                if (void 0 === l) return w(c);
                if (h) return l = setTimeout(E, t), b(c);
              }

              return void 0 === l && (l = setTimeout(E, t)), a;
            }

            return t = v(t) || 0, m(n) && (d = !!n.leading, s = (h = "maxWait" in n) ? f(v(n.maxWait) || 0, t) : s, y = "trailing" in n ? !!n.trailing : y), S.cancel = function () {
              void 0 !== l && clearTimeout(l), u = 0, o = c = i = l = void 0;
            }, S.flush = function () {
              return void 0 === l ? a : _(g());
            }, S;
          }(e, t, {
            leading: o,
            maxWait: t,
            trailing: i
          });
        };
      },
      2705: function _(e, t, n) {
        var r = n(5639).Symbol;
        e.exports = r;
      },
      2488: function _(e) {
        e.exports = function (e, t) {
          for (var n = -1, r = t.length, o = e.length; ++n < r;) {
            e[o + n] = t[n];
          }

          return e;
        };
      },
      1078: function _(e, t, n) {
        var r = n(2488),
            o = n(7285);

        e.exports = function e(t, n, i, s, a) {
          var l = -1,
              c = t.length;

          for (i || (i = o), a || (a = []); ++l < c;) {
            var u = t[l];
            n > 0 && i(u) ? n > 1 ? e(u, n - 1, i, s, a) : r(a, u) : s || (a[a.length] = u);
          }

          return a;
        };
      },
      4239: function _(e, t, n) {
        var r = n(2705),
            o = n(9607),
            i = n(2333),
            s = r ? r.toStringTag : void 0;

        e.exports = function (e) {
          return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : s && s in Object(e) ? o(e) : i(e);
        };
      },
      9454: function _(e, t, n) {
        var r = n(4239),
            o = n(7005);

        e.exports = function (e) {
          return o(e) && "[object Arguments]" == r(e);
        };
      },
      1957: function _(e, t, n) {
        var r = "object" == _typeof(n.g) && n.g && n.g.Object === Object && n.g;
        e.exports = r;
      },
      9607: function _(e, t, n) {
        var r = n(2705),
            o = Object.prototype,
            i = o.hasOwnProperty,
            s = o.toString,
            a = r ? r.toStringTag : void 0;

        e.exports = function (e) {
          var t = i.call(e, a),
              n = e[a];

          try {
            e[a] = void 0;
            var r = !0;
          } catch (e) {}

          var o = s.call(e);
          return r && (t ? e[a] = n : delete e[a]), o;
        };
      },
      7285: function _(e, t, n) {
        var r = n(2705),
            o = n(5694),
            i = n(1469),
            s = r ? r.isConcatSpreadable : void 0;

        e.exports = function (e) {
          return i(e) || o(e) || !!(s && e && e[s]);
        };
      },
      2333: function _(e) {
        var t = Object.prototype.toString;

        e.exports = function (e) {
          return t.call(e);
        };
      },
      5639: function _(e, t, n) {
        var r = n(1957),
            o = "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
            i = r || o || Function("return this")();
        e.exports = i;
      },
      5564: function _(e, t, n) {
        var r = n(1078);

        e.exports = function (e) {
          return null != e && e.length ? r(e, 1) : [];
        };
      },
      5694: function _(e, t, n) {
        var r = n(9454),
            o = n(7005),
            i = Object.prototype,
            s = i.hasOwnProperty,
            a = i.propertyIsEnumerable,
            l = r(function () {
          return arguments;
        }()) ? r : function (e) {
          return o(e) && s.call(e, "callee") && !a.call(e, "callee");
        };
        e.exports = l;
      },
      1469: function _(e) {
        var t = Array.isArray;
        e.exports = t;
      },
      7005: function _(e) {
        e.exports = function (e) {
          return null != e && "object" == _typeof(e);
        };
      },
      4193: function _(e, t, n) {
        var r = n(1196),
            o = /[\/\+\.]/;

        e.exports = function (e, t) {
          function n(t) {
            var n = r(t, e, o);
            return n && n.length >= 2;
          }

          return t ? n(t.split(";")[0]) : n;
        };
      },
      4800: function _(e) {
        e.exports = function () {
          var e = {},
              t = e._fns = {};
          return e.emit = function (e, n, r, o, i, s, a) {
            var l = function (e) {
              for (var n = t[e] ? t[e] : [], r = e.indexOf(":"), o = -1 === r ? [e] : [e.substring(0, r), e.substring(r + 1)], i = Object.keys(t), s = 0, a = i.length; s < a; s++) {
                var l = i[s];

                if ("*" === l && (n = n.concat(t[l])), 2 === o.length && o[0] === l) {
                  n = n.concat(t[l]);
                  break;
                }
              }

              return n;
            }(e);

            l.length && function (e, t, n) {
              for (var r = 0, o = t.length; r < o && t[r]; r++) {
                t[r].event = e, t[r].apply(t[r], n);
              }
            }(e, l, [n, r, o, i, s, a]);
          }, e.on = function (e, n) {
            t[e] || (t[e] = []), t[e].push(n);
          }, e.once = function (t, n) {
            this.on(t, function r() {
              n.apply(this, arguments), e.off(t, r);
            });
          }, e.off = function (e, t) {
            var n = [];
            if (e && t) for (var r = this._fns[e], o = 0, i = r ? r.length : 0; o < i; o++) {
              r[o] !== t && n.push(r[o]);
            }
            n.length ? this._fns[e] = n : delete this._fns[e];
          }, e;
        };
      },
      6400: function _(e, t, n) {
        "use strict";

        n.r(t), n.d(t, {
          Component: function Component() {
            return w;
          },
          Fragment: function Fragment() {
            return b;
          },
          cloneElement: function cloneElement() {
            return H;
          },
          createContext: function createContext() {
            return U;
          },
          createElement: function createElement() {
            return m;
          },
          createRef: function createRef() {
            return y;
          },
          h: function h() {
            return m;
          },
          hydrate: function hydrate() {
            return $;
          },
          isValidElement: function isValidElement() {
            return s;
          },
          options: function options() {
            return o;
          },
          render: function render() {
            return B;
          },
          toChildArray: function toChildArray() {
            return k;
          }
        });
        var r,
            o,
            i,
            s,
            a,
            l,
            c,
            u,
            d = {},
            h = [],
            f = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;

        function p(e, t) {
          for (var n in t) {
            e[n] = t[n];
          }

          return e;
        }

        function g(e) {
          var t = e.parentNode;
          t && t.removeChild(e);
        }

        function m(e, t, n) {
          var o,
              i,
              s,
              a = {};

          for (s in t) {
            "key" == s ? o = t[s] : "ref" == s ? i = t[s] : a[s] = t[s];
          }

          if (arguments.length > 2 && (a.children = arguments.length > 3 ? r.call(arguments, 2) : n), "function" == typeof e && null != e.defaultProps) for (s in e.defaultProps) {
            void 0 === a[s] && (a[s] = e.defaultProps[s]);
          }
          return v(e, a, o, i, null);
        }

        function v(e, t, n, r, s) {
          var a = {
            type: e,
            props: t,
            key: n,
            ref: r,
            __k: null,
            __: null,
            __b: 0,
            __e: null,
            __d: void 0,
            __c: null,
            __h: null,
            constructor: void 0,
            __v: null == s ? ++i : s
          };
          return null == s && null != o.vnode && o.vnode(a), a;
        }

        function y() {
          return {
            current: null
          };
        }

        function b(e) {
          return e.children;
        }

        function w(e, t) {
          this.props = e, this.context = t;
        }

        function O(e, t) {
          if (null == t) return e.__ ? O(e.__, e.__.__k.indexOf(e) + 1) : null;

          for (var n; t < e.__k.length; t++) {
            if (null != (n = e.__k[t]) && null != n.__e) return n.__e;
          }

          return "function" == typeof e.type ? O(e) : null;
        }

        function E(e) {
          var t, n;

          if (null != (e = e.__) && null != e.__c) {
            for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++) {
              if (null != (n = e.__k[t]) && null != n.__e) {
                e.__e = e.__c.base = n.__e;
                break;
              }
            }

            return E(e);
          }
        }

        function _(e) {
          (!e.__d && (e.__d = !0) && a.push(e) && !S.__r++ || c !== o.debounceRendering) && ((c = o.debounceRendering) || l)(S);
        }

        function S() {
          for (var e; S.__r = a.length;) {
            e = a.sort(function (e, t) {
              return e.__v.__b - t.__v.__b;
            }), a = [], e.some(function (e) {
              var t, n, r, o, i, s;
              e.__d && (i = (o = (t = e).__v).__e, (s = t.__P) && (n = [], (r = p({}, o)).__v = o.__v + 1, A(s, o, r, t.__n, void 0 !== s.ownerSVGElement, null != o.__h ? [i] : null, n, null == i ? O(o) : i, o.__h), F(n, o), o.__e != i && E(o)));
            });
          }
        }

        function x(e, t, n, r, o, i, s, a, l, c) {
          var u,
              f,
              p,
              g,
              m,
              y,
              w,
              E = r && r.__k || h,
              _ = E.length;

          for (n.__k = [], u = 0; u < t.length; u++) {
            if (null != (g = n.__k[u] = null == (g = t[u]) || "boolean" == typeof g ? null : "string" == typeof g || "number" == typeof g || "bigint" == typeof g ? v(null, g, null, null, g) : Array.isArray(g) ? v(b, {
              children: g
            }, null, null, null) : g.__b > 0 ? v(g.type, g.props, g.key, null, g.__v) : g)) {
              if (g.__ = n, g.__b = n.__b + 1, null === (p = E[u]) || p && g.key == p.key && g.type === p.type) E[u] = void 0;else for (f = 0; f < _; f++) {
                if ((p = E[f]) && g.key == p.key && g.type === p.type) {
                  E[f] = void 0;
                  break;
                }

                p = null;
              }
              A(e, g, p = p || d, o, i, s, a, l, c), m = g.__e, (f = g.ref) && p.ref != f && (w || (w = []), p.ref && w.push(p.ref, null, g), w.push(f, g.__c || m, g)), null != m ? (null == y && (y = m), "function" == typeof g.type && g.__k === p.__k ? g.__d = l = C(g, l, e) : l = P(e, g, p, E, m, l), "function" == typeof n.type && (n.__d = l)) : l && p.__e == l && l.parentNode != e && (l = O(p));
            }
          }

          for (n.__e = y, u = _; u--;) {
            null != E[u] && ("function" == typeof n.type && null != E[u].__e && E[u].__e == n.__d && (n.__d = O(r, u + 1)), R(E[u], E[u]));
          }

          if (w) for (u = 0; u < w.length; u++) {
            I(w[u], w[++u], w[++u]);
          }
        }

        function C(e, t, n) {
          for (var r, o = e.__k, i = 0; o && i < o.length; i++) {
            (r = o[i]) && (r.__ = e, t = "function" == typeof r.type ? C(r, t, n) : P(n, r, r, o, r.__e, t));
          }

          return t;
        }

        function k(e, t) {
          return t = t || [], null == e || "boolean" == typeof e || (Array.isArray(e) ? e.some(function (e) {
            k(e, t);
          }) : t.push(e)), t;
        }

        function P(e, t, n, r, o, i) {
          var s, a, l;
          if (void 0 !== t.__d) s = t.__d, t.__d = void 0;else if (null == n || o != i || null == o.parentNode) e: if (null == i || i.parentNode !== e) e.appendChild(o), s = null;else {
            for (a = i, l = 0; (a = a.nextSibling) && l < r.length; l += 2) {
              if (a == o) break e;
            }

            e.insertBefore(o, i), s = i;
          }
          return void 0 !== s ? s : o.nextSibling;
        }

        function j(e, t, n) {
          "-" === t[0] ? e.setProperty(t, n) : e[t] = null == n ? "" : "number" != typeof n || f.test(t) ? n : n + "px";
        }

        function T(e, t, n, r, o) {
          var i;

          e: if ("style" === t) {
            if ("string" == typeof n) e.style.cssText = n;else {
              if ("string" == typeof r && (e.style.cssText = r = ""), r) for (t in r) {
                n && t in n || j(e.style, t, "");
              }
              if (n) for (t in n) {
                r && n[t] === r[t] || j(e.style, t, n[t]);
              }
            }
          } else if ("o" === t[0] && "n" === t[1]) i = t !== (t = t.replace(/Capture$/, "")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + i] = n, n ? r || e.addEventListener(t, i ? M : D, i) : e.removeEventListener(t, i ? M : D, i);else if ("dangerouslySetInnerHTML" !== t) {
            if (o) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");else if ("href" !== t && "list" !== t && "form" !== t && "tabIndex" !== t && "download" !== t && t in e) try {
              e[t] = null == n ? "" : n;
              break e;
            } catch (e) {}
            "function" == typeof n || (null != n && (!1 !== n || "a" === t[0] && "r" === t[1]) ? e.setAttribute(t, n) : e.removeAttribute(t));
          }
        }

        function D(e) {
          this.l[e.type + !1](o.event ? o.event(e) : e);
        }

        function M(e) {
          this.l[e.type + !0](o.event ? o.event(e) : e);
        }

        function A(e, t, n, r, i, s, a, l, c) {
          var u,
              d,
              h,
              f,
              g,
              m,
              v,
              y,
              O,
              E,
              _,
              S,
              C,
              k = t.type;

          if (void 0 !== t.constructor) return null;
          null != n.__h && (c = n.__h, l = t.__e = n.__e, t.__h = null, s = [l]), (u = o.__b) && u(t);

          try {
            e: if ("function" == typeof k) {
              if (y = t.props, O = (u = k.contextType) && r[u.__c], E = u ? O ? O.props.value : u.__ : r, n.__c ? v = (d = t.__c = n.__c).__ = d.__E : ("prototype" in k && k.prototype.render ? t.__c = d = new k(y, E) : (t.__c = d = new w(y, E), d.constructor = k, d.render = N), O && O.sub(d), d.props = y, d.state || (d.state = {}), d.context = E, d.__n = r, h = d.__d = !0, d.__h = []), null == d.__s && (d.__s = d.state), null != k.getDerivedStateFromProps && (d.__s == d.state && (d.__s = p({}, d.__s)), p(d.__s, k.getDerivedStateFromProps(y, d.__s))), f = d.props, g = d.state, h) null == k.getDerivedStateFromProps && null != d.componentWillMount && d.componentWillMount(), null != d.componentDidMount && d.__h.push(d.componentDidMount);else {
                if (null == k.getDerivedStateFromProps && y !== f && null != d.componentWillReceiveProps && d.componentWillReceiveProps(y, E), !d.__e && null != d.shouldComponentUpdate && !1 === d.shouldComponentUpdate(y, d.__s, E) || t.__v === n.__v) {
                  d.props = y, d.state = d.__s, t.__v !== n.__v && (d.__d = !1), d.__v = t, t.__e = n.__e, t.__k = n.__k, t.__k.forEach(function (e) {
                    e && (e.__ = t);
                  }), d.__h.length && a.push(d);
                  break e;
                }

                null != d.componentWillUpdate && d.componentWillUpdate(y, d.__s, E), null != d.componentDidUpdate && d.__h.push(function () {
                  d.componentDidUpdate(f, g, m);
                });
              }
              if (d.context = E, d.props = y, d.__v = t, d.__P = e, _ = o.__r, S = 0, "prototype" in k && k.prototype.render) d.state = d.__s, d.__d = !1, _ && _(t), u = d.render(d.props, d.state, d.context);else do {
                d.__d = !1, _ && _(t), u = d.render(d.props, d.state, d.context), d.state = d.__s;
              } while (d.__d && ++S < 25);
              d.state = d.__s, null != d.getChildContext && (r = p(p({}, r), d.getChildContext())), h || null == d.getSnapshotBeforeUpdate || (m = d.getSnapshotBeforeUpdate(f, g)), C = null != u && u.type === b && null == u.key ? u.props.children : u, x(e, Array.isArray(C) ? C : [C], t, n, r, i, s, a, l, c), d.base = t.__e, t.__h = null, d.__h.length && a.push(d), v && (d.__E = d.__ = null), d.__e = !1;
            } else null == s && t.__v === n.__v ? (t.__k = n.__k, t.__e = n.__e) : t.__e = L(n.__e, t, n, r, i, s, a, c);

            (u = o.diffed) && u(t);
          } catch (e) {
            t.__v = null, (c || null != s) && (t.__e = l, t.__h = !!c, s[s.indexOf(l)] = null), o.__e(e, t, n);
          }
        }

        function F(e, t) {
          o.__c && o.__c(t, e), e.some(function (t) {
            try {
              e = t.__h, t.__h = [], e.some(function (e) {
                e.call(t);
              });
            } catch (e) {
              o.__e(e, t.__v);
            }
          });
        }

        function L(e, t, n, o, i, s, a, l) {
          var c,
              u,
              h,
              f = n.props,
              p = t.props,
              m = t.type,
              v = 0;
          if ("svg" === m && (i = !0), null != s) for (; v < s.length; v++) {
            if ((c = s[v]) && "setAttribute" in c == !!m && (m ? c.localName === m : 3 === c.nodeType)) {
              e = c, s[v] = null;
              break;
            }
          }

          if (null == e) {
            if (null === m) return document.createTextNode(p);
            e = i ? document.createElementNS("http://www.w3.org/2000/svg", m) : document.createElement(m, p.is && p), s = null, l = !1;
          }

          if (null === m) f === p || l && e.data === p || (e.data = p);else {
            if (s = s && r.call(e.childNodes), u = (f = n.props || d).dangerouslySetInnerHTML, h = p.dangerouslySetInnerHTML, !l) {
              if (null != s) for (f = {}, v = 0; v < e.attributes.length; v++) {
                f[e.attributes[v].name] = e.attributes[v].value;
              }
              (h || u) && (h && (u && h.__html == u.__html || h.__html === e.innerHTML) || (e.innerHTML = h && h.__html || ""));
            }

            if (function (e, t, n, r, o) {
              var i;

              for (i in n) {
                "children" === i || "key" === i || i in t || T(e, i, null, n[i], r);
              }

              for (i in t) {
                o && "function" != typeof t[i] || "children" === i || "key" === i || "value" === i || "checked" === i || n[i] === t[i] || T(e, i, t[i], n[i], r);
              }
            }(e, p, f, i, l), h) t.__k = [];else if (v = t.props.children, x(e, Array.isArray(v) ? v : [v], t, n, o, i && "foreignObject" !== m, s, a, s ? s[0] : n.__k && O(n, 0), l), null != s) for (v = s.length; v--;) {
              null != s[v] && g(s[v]);
            }
            l || ("value" in p && void 0 !== (v = p.value) && (v !== e.value || "progress" === m && !v || "option" === m && v !== f.value) && T(e, "value", v, f.value, !1), "checked" in p && void 0 !== (v = p.checked) && v !== e.checked && T(e, "checked", v, f.checked, !1));
          }
          return e;
        }

        function I(e, t, n) {
          try {
            "function" == typeof e ? e(t) : e.current = t;
          } catch (e) {
            o.__e(e, n);
          }
        }

        function R(e, t, n) {
          var r, i;

          if (o.unmount && o.unmount(e), (r = e.ref) && (r.current && r.current !== e.__e || I(r, null, t)), null != (r = e.__c)) {
            if (r.componentWillUnmount) try {
              r.componentWillUnmount();
            } catch (e) {
              o.__e(e, t);
            }
            r.base = r.__P = null;
          }

          if (r = e.__k) for (i = 0; i < r.length; i++) {
            r[i] && R(r[i], t, "function" != typeof e.type);
          }
          n || null == e.__e || g(e.__e), e.__e = e.__d = void 0;
        }

        function N(e, t, n) {
          return this.constructor(e, n);
        }

        function B(e, t, n) {
          var i, s, a;
          o.__ && o.__(e, t), s = (i = "function" == typeof n) ? null : n && n.__k || t.__k, a = [], A(t, e = (!i && n || t).__k = m(b, null, [e]), s || d, d, void 0 !== t.ownerSVGElement, !i && n ? [n] : s ? null : t.firstChild ? r.call(t.childNodes) : null, a, !i && n ? n : s ? s.__e : t.firstChild, i), F(a, e);
        }

        function $(e, t) {
          B(e, t, $);
        }

        function H(e, t, n) {
          var o,
              i,
              s,
              a = p({}, e.props);

          for (s in t) {
            "key" == s ? o = t[s] : "ref" == s ? i = t[s] : a[s] = t[s];
          }

          return arguments.length > 2 && (a.children = arguments.length > 3 ? r.call(arguments, 2) : n), v(e.type, a, o || e.key, i || e.ref, null);
        }

        function U(e, t) {
          var n = {
            __c: t = "__cC" + u++,
            __: e,
            Consumer: function Consumer(e, t) {
              return e.children(t);
            },
            Provider: function Provider(e) {
              var n, r;
              return this.getChildContext || (n = [], (r = {})[t] = this, this.getChildContext = function () {
                return r;
              }, this.shouldComponentUpdate = function (e) {
                this.props.value !== e.value && n.some(_);
              }, this.sub = function (e) {
                n.push(e);
                var t = e.componentWillUnmount;

                e.componentWillUnmount = function () {
                  n.splice(n.indexOf(e), 1), t && t.call(e);
                };
              }), e.children;
            }
          };
          return n.Provider.__ = n.Consumer.contextType = n;
        }

        r = h.slice, o = {
          __e: function __e(e, t, n, r) {
            for (var o, i, s; t = t.__;) {
              if ((o = t.__c) && !o.__) try {
                if ((i = o.constructor) && null != i.getDerivedStateFromError && (o.setState(i.getDerivedStateFromError(e)), s = o.__d), null != o.componentDidCatch && (o.componentDidCatch(e, r || {}), s = o.__d), s) return o.__E = o;
              } catch (t) {
                e = t;
              }
            }

            throw e;
          }
        }, i = 0, s = function s(e) {
          return null != e && void 0 === e.constructor;
        }, w.prototype.setState = function (e, t) {
          var n;
          n = null != this.__s && this.__s !== this.state ? this.__s : this.__s = p({}, this.state), "function" == typeof e && (e = e(p({}, n), this.props)), e && p(n, e), null != e && this.__v && (t && this.__h.push(t), _(this));
        }, w.prototype.forceUpdate = function (e) {
          this.__v && (this.__e = !0, e && this.__h.push(e), _(this));
        }, w.prototype.render = b, a = [], l = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, S.__r = 0, u = 0;
      },
      7545: function _(e, t, n) {
        "use strict";

        n.d(t, {
          I0: function I0() {
            return c;
          },
          Nr: function Nr() {
            return h;
          },
          O8: function O8() {
            return s;
          }
        });
        var r = n(6599);
        n(8515);

        var o = function o(e, t, n) {
          var r = e;
          return !0 === n ? r = "".concat(t.identifier, ":").concat(e) : "string" == typeof n && (r = "".concat(n, ":").concat(e)), r;
        },
            i = {
          events: ["click", "touchend"],
          onlyVisible: !0,
          dispatchEvent: !0,
          eventPrefix: !0
        },
            s = function s(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          var _Object$assign10 = Object.assign({}, i, t),
              n = _Object$assign10.onlyVisible,
              r = _Object$assign10.dispatchEvent,
              s = _Object$assign10.events,
              a = _Object$assign10.eventPrefix,
              l = function l(i) {
            var s = (null == t ? void 0 : t.element) || e.element;

            if (!(s.contains(i.target) || !function (e) {
              var t = e.getBoundingClientRect(),
                  n = window.innerHeight || document.documentElement.clientHeight,
                  r = window.innerWidth || document.documentElement.clientWidth,
                  o = t.top <= n && t.top + t.height >= 0,
                  i = t.left <= r && t.left + t.width >= 0;
              return o && i;
            }(s) && n) && (e.clickOutside && e.clickOutside(i), r)) {
              var _t20 = function (e, t, n) {
                var _ref40 = t || {
                  bubbles: !0,
                  cancelable: !0,
                  composed: !0
                },
                    r = _ref40.bubbles,
                    o = _ref40.cancelable,
                    i = _ref40.composed;

                return t && Object.assign(n, {
                  originalEvent: t
                }), new CustomEvent(e, {
                  bubbles: r,
                  cancelable: o,
                  composed: i,
                  detail: n
                });
              }(o("click:outside", e, a), i, {
                controller: e
              });

              s.dispatchEvent(_t20);
            }
          },
              c = function c() {
            null == s || s.forEach(function (e) {
              window.addEventListener(e, l, !1);
            });
          },
              u = function u() {
            null == s || s.forEach(function (e) {
              window.removeEventListener(e, l, !1);
            });
          },
              d = e.disconnect.bind(e);

          return Object.assign(e, {
            disconnect: function disconnect() {
              u(), d();
            }
          }), c(), [c, u];
        },
            a = {
          debug: !1,
          logger: console,
          dispatchEvent: !0,
          eventPrefix: !0
        };

        var l = /*#__PURE__*/function (_ref41) {
          _inherits(l, _ref41);

          var _super62 = _createSuper(l);

          function l(e) {
            var _this96;

            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            _classCallCheck(this, l);

            var n, r, i, s;
            _this96 = _super62.call(this, e, t), _this96.dispatch = function (e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

              var _assertThisInitialize = _assertThisInitialized(_this96),
                  n = _assertThisInitialize.controller,
                  r = _assertThisInitialize.targetElement,
                  i = _assertThisInitialize.eventPrefix,
                  s = _assertThisInitialize.bubbles,
                  a = _assertThisInitialize.cancelable,
                  _l = _assertThisInitialize.log;

              Object.assign(t, {
                controller: n
              });
              var c = o(e, _this96.controller, i),
                  u = new CustomEvent(c, {
                detail: t,
                bubbles: s,
                cancelable: a
              });
              return r.dispatchEvent(u), _l("dispatch", {
                eventName: c,
                detail: t,
                bubbles: s,
                cancelable: a
              }), u;
            }, _this96.targetElement = null !== (n = t.element) && void 0 !== n ? n : e.element, _this96.eventPrefix = null === (r = t.eventPrefix) || void 0 === r || r, _this96.bubbles = null === (i = t.bubbles) || void 0 === i || i, _this96.cancelable = null === (s = t.cancelable) || void 0 === s || s, _this96.enhanceController();
            return _this96;
          }

          _createClass(l, [{
            key: "enhanceController",
            value: function enhanceController() {
              Object.assign(this.controller, {
                dispatch: this.dispatch
              });
            }
          }]);

          return l;
        }( /*#__PURE__*/function () {
          function _class8(e) {
            var _this97 = this;

            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            _classCallCheck(this, _class8);

            var n, r, o;
            this.log = function (e, t) {
              _this97.debug && (_this97.logger.groupCollapsed("%c".concat(_this97.controller.identifier, " %c#").concat(e), "color: #3B82F6", "color: unset"), _this97.logger.log(Object.assign({
                controllerId: _this97.controllerId
              }, t)), _this97.logger.groupEnd());
            }, this.dispatch = function (e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

              if (_this97.dispatchEvent) {
                var _n21 = t.event,
                    _r21 = function (e, t) {
                  var n = {};

                  for (var r in e) {
                    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
                  }

                  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                    var o = 0;

                    for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
                      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
                    }
                  }

                  return n;
                }(t, ["event"]),
                    _o10 = _this97.extendedEvent(e, _n21 || null, _r21);

                _this97.targetElement.dispatchEvent(_o10), _this97.log("dispatchEvent", Object.assign({
                  eventName: _o10.type
                }, _r21));
              }
            }, this.call = function (e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var n = _this97.controller[e];
              if ("function" == typeof n) return n.call(_this97.controller, t);
            }, this.extendedEvent = function (e, t, n) {
              var _ref42 = t || {
                bubbles: !0,
                cancelable: !0,
                composed: !0
              },
                  r = _ref42.bubbles,
                  o = _ref42.cancelable,
                  i = _ref42.composed;

              return t && Object.assign(n, {
                originalEvent: t
              }), new CustomEvent(_this97.composeEventName(e), {
                bubbles: r,
                cancelable: o,
                composed: i,
                detail: n
              });
            }, this.composeEventName = function (e) {
              var t = e;
              return !0 === _this97.eventPrefix ? t = "".concat(_this97.controller.identifier, ":").concat(e) : "string" == typeof _this97.eventPrefix && (t = "".concat(_this97.eventPrefix, ":").concat(e)), t;
            }, this.debug = null !== (r = null !== (n = null == t ? void 0 : t.debug) && void 0 !== n ? n : e.application.stimulusUseDebug) && void 0 !== r ? r : a.debug, this.logger = null !== (o = null == t ? void 0 : t.logger) && void 0 !== o ? o : a.logger, this.controller = e, this.controllerId = e.element.id || e.element.dataset.id, this.targetElement = (null == t ? void 0 : t.element) || e.element;

            var _Object$assign11 = Object.assign({}, a, t),
                i = _Object$assign11.dispatchEvent,
                s = _Object$assign11.eventPrefix;

            Object.assign(this, {
              dispatchEvent: i,
              eventPrefix: s
            }), this.controllerInitialize = e.initialize.bind(e), this.controllerConnect = e.connect.bind(e), this.controllerDisconnect = e.disconnect.bind(e);
          }

          return _class8;
        }());

        var c = function c(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return new l(e, t);
        };

        var u = /*#__PURE__*/function (_r$Qr) {
          _inherits(u, _r$Qr);

          var _super63 = _createSuper(u);

          function u() {
            _classCallCheck(this, u);

            return _super63.apply(this, arguments);
          }

          return u;
        }(r.Qr);

        u.debounces = [];

        var d = function d(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
          var n = null;
          return function () {
            var r = arguments,
                o = this,
                i = function i() {
              return e.apply(o, r);
            };

            n && clearTimeout(n), n = setTimeout(i, t);
          };
        },
            h = function h(e, t) {
          var n;
          null === (n = e.constructor.debounces) || void 0 === n || n.forEach(function (n) {
            if ("string" == typeof n && (e[n] = d(e[n], null == t ? void 0 : t.wait)), "object" == _typeof(n)) {
              var _r22 = n.name,
                  _o11 = n.wait;
              if (!_r22) return;
              e[_r22] = d(e[_r22], _o11 || (null == t ? void 0 : t.wait));
            }
          });
        };

        var f = /*#__PURE__*/function (_r$Qr2) {
          _inherits(f, _r$Qr2);

          var _super64 = _createSuper(f);

          function f() {
            _classCallCheck(this, f);

            return _super64.apply(this, arguments);
          }

          return f;
        }(r.Qr);

        f.throttles = [];
      },
      4183: function _(e) {
        e.exports = function () {
          "use strict";

          function e(e, t) {
            e.split(/\s+/).forEach(function (e) {
              t(e);
            });
          }

          var t = /*#__PURE__*/function () {
            function t() {
              _classCallCheck(this, t);

              this._events = void 0, this._events = {};
            }

            _createClass(t, [{
              key: "on",
              value: function on(_t21, n) {
                var _this98 = this;

                e(_t21, function (e) {
                  _this98._events[e] = _this98._events[e] || [], _this98._events[e].push(n);
                });
              }
            }, {
              key: "off",
              value: function off(_t22, n) {
                var _this99 = this;

                var r = arguments.length;
                0 !== r ? e(_t22, function (e) {
                  if (1 === r) return delete _this99._events[e];
                  e in _this99._events != 0 && _this99._events[e].splice(_this99._events[e].indexOf(n), 1);
                }) : this._events = {};
              }
            }, {
              key: "trigger",
              value: function trigger(_t23) {
                for (var _len19 = arguments.length, n = new Array(_len19 > 1 ? _len19 - 1 : 0), _key19 = 1; _key19 < _len19; _key19++) {
                  n[_key19 - 1] = arguments[_key19];
                }

                var r = this;
                e(_t23, function (e) {
                  if (e in r._events != 0) {
                    var _iterator14 = _createForOfIteratorHelper(r._events[e]),
                        _step14;

                    try {
                      for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                        var _t25 = _step14.value;

                        _t25.apply(r, n);
                      }
                    } catch (err) {
                      _iterator14.e(err);
                    } finally {
                      _iterator14.f();
                    }
                  }
                });
              }
            }]);

            return t;
          }();

          var n;
          var r = "[̀-ͯ·ʾ]",
              o = new RegExp(r, "gu");
          var i;

          var s = {
            "æ": "ae",
            "ⱥ": "a",
            "ø": "o"
          },
              a = new RegExp(Object.keys(s).join("|"), "gu"),
              l = [[0, 65535]],
              c = function c(e) {
            return e.normalize("NFKD").replace(o, "").toLowerCase().replace(a, function (e) {
              return s[e];
            });
          },
              u = function u(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "|";
            if (1 == e.length) return e[0];
            var n = 1;
            return e.forEach(function (e) {
              n = Math.max(n, e.length);
            }), 1 == n ? "[" + e.join("") + "]" : "(?:" + e.join(t) + ")";
          },
              d = function d(e) {
            var t = e.map(function (e) {
              return v(e);
            });
            return u(t);
          },
              h = function h(e) {
            if (1 === e.length) return [[e]];
            var t = [];
            return h(e.substring(1)).forEach(function (n) {
              var r = n.slice(0);
              r[0] = e.charAt(0) + r[0], t.push(r), (r = n.slice(0)).unshift(e.charAt(0)), t.push(r);
            }), t;
          },
              f = function f(e) {
            return void 0 === i && (i = function (e) {
              var t = {};
              e.forEach(function (e) {
                for (var _r23 = e[0]; _r23 <= e[1]; _r23++) {
                  var _e29 = String.fromCharCode(_r23),
                      _o12 = c(_e29);

                  if (_o12 != _e29.toLowerCase() && !(_o12.length > 3)) {
                    _o12 in t || (t[_o12] = [_o12]);
                    var n = new RegExp(d(t[_o12]), "iu");
                    _e29.match(n) || t[_o12].push(_e29);
                  }
                }
              });
              var r = Object.keys(t);

              for (var _e30 = 0; _e30 < r.length; _e30++) {
                var _n22 = r[_e30];
                t[_n22].length < 2 && delete t[_n22];
              }

              r = Object.keys(t).sort(function (e, t) {
                return t.length - e.length;
              }), n = new RegExp("(" + d(r) + "[̀-ͯ·ʾ]*)", "gu");
              var o = {};
              return r.sort(function (e, t) {
                return e.length - t.length;
              }).forEach(function (e) {
                var n = h(e).map(function (e) {
                  return e = e.map(function (e) {
                    return t.hasOwnProperty(e) ? d(t[e]) : e;
                  }), u(e, "");
                });
                o[e] = u(n);
              }), o;
            }(l)), e.normalize("NFKD").toLowerCase().split(n).map(function (e) {
              var t = c(e);
              return "" == t ? "" : i.hasOwnProperty(t) ? i[t] : e;
            }).join("");
          },
              p = function p(e, t) {
            if (e) return e[t];
          },
              g = function g(e, t) {
            if (e) {
              for (var n, r = t.split("."); (n = r.shift()) && (e = e[n]);) {
                ;
              }

              return e;
            }
          },
              m = function m(e, t, n) {
            var r, o;
            return e ? -1 === (o = (e += "").search(t.regex)) ? 0 : (r = t.string.length / e.length, 0 === o && (r += .5), r * n) : 0;
          },
              v = function v(e) {
            return (e + "").replace(/([\$\(-\+\.\?\[-\^\{-\}])/g, "\\$1");
          },
              y = function y(e, t) {
            var n = e[t];
            if ("function" == typeof n) return n;
            n && !Array.isArray(n) && (e[t] = [n]);
          },
              b = function b(e, t) {
            if (Array.isArray(e)) e.forEach(t);else for (var n in e) {
              e.hasOwnProperty(n) && t(e[n], n);
            }
          },
              w = function w(e, t) {
            return "number" == typeof e && "number" == typeof t ? e > t ? 1 : e < t ? -1 : 0 : (e = c(e + "").toLowerCase()) > (t = c(t + "").toLowerCase()) ? 1 : t > e ? -1 : 0;
          };

          var O = /*#__PURE__*/function () {
            function O(e, t) {
              _classCallCheck(this, O);

              this.items = void 0, this.settings = void 0, this.items = e, this.settings = t || {
                diacritics: !0
              };
            }

            _createClass(O, [{
              key: "tokenize",
              value: function tokenize(e, t, n) {
                var _this100 = this;

                if (!e || !e.length) return [];
                var r = [],
                    o = e.split(/\s+/);
                var i;
                return n && (i = new RegExp("^(" + Object.keys(n).map(v).join("|") + "):(.*)$")), o.forEach(function (e) {
                  var n,
                      o = null,
                      s = null;
                  i && (n = e.match(i)) && (o = n[1], e = n[2]), e.length > 0 && (s = _this100.settings.diacritics ? f(e) : v(e), t && (s = "\\b" + s)), r.push({
                    string: e,
                    regex: s ? new RegExp(s, "iu") : null,
                    field: o
                  });
                }), r;
              }
            }, {
              key: "getScoreFunction",
              value: function getScoreFunction(e, t) {
                var n = this.prepareSearch(e, t);
                return this._getScoreFunction(n);
              }
            }, {
              key: "_getScoreFunction",
              value: function _getScoreFunction(e) {
                var t = e.tokens,
                    n = t.length;
                if (!n) return function () {
                  return 0;
                };
                var r = e.options.fields,
                    o = e.weights,
                    i = r.length,
                    s = e.getAttrFn;
                if (!i) return function () {
                  return 1;
                };
                var a = 1 === i ? function (e, t) {
                  var n = r[0].field;
                  return m(s(t, n), e, o[n]);
                } : function (e, t) {
                  var n = 0;

                  if (e.field) {
                    var _r24 = s(t, e.field);

                    !e.regex && _r24 ? n += 1 / i : n += m(_r24, e, 1);
                  } else b(o, function (r, o) {
                    n += m(s(t, o), e, r);
                  });

                  return n / i;
                };
                return 1 === n ? function (e) {
                  return a(t[0], e);
                } : "and" === e.options.conjunction ? function (e) {
                  for (var r, o = 0, i = 0; o < n; o++) {
                    if ((r = a(t[o], e)) <= 0) return 0;
                    i += r;
                  }

                  return i / n;
                } : function (e) {
                  var r = 0;
                  return b(t, function (t) {
                    r += a(t, e);
                  }), r / n;
                };
              }
            }, {
              key: "getSortFunction",
              value: function getSortFunction(e, t) {
                var n = this.prepareSearch(e, t);
                return this._getSortFunction(n);
              }
            }, {
              key: "_getSortFunction",
              value: function _getSortFunction(e) {
                var t, n, r;
                var o = this,
                    i = e.options,
                    s = !e.query && i.sort_empty ? i.sort_empty : i.sort,
                    a = [],
                    l = [];
                if ("function" == typeof s) return s.bind(this);

                var c = function c(t, n) {
                  return "$score" === t ? n.score : e.getAttrFn(o.items[n.id], t);
                };

                if (s) for (t = 0, n = s.length; t < n; t++) {
                  (e.query || "$score" !== s[t].field) && a.push(s[t]);
                }

                if (e.query) {
                  for (r = !0, t = 0, n = a.length; t < n; t++) {
                    if ("$score" === a[t].field) {
                      r = !1;
                      break;
                    }
                  }

                  r && a.unshift({
                    field: "$score",
                    direction: "desc"
                  });
                } else for (t = 0, n = a.length; t < n; t++) {
                  if ("$score" === a[t].field) {
                    a.splice(t, 1);
                    break;
                  }
                }

                for (t = 0, n = a.length; t < n; t++) {
                  l.push("desc" === a[t].direction ? -1 : 1);
                }

                var u = a.length;

                if (u) {
                  if (1 === u) {
                    var _e31 = a[0].field,
                        _t26 = l[0];
                    return function (n, r) {
                      return _t26 * w(c(_e31, n), c(_e31, r));
                    };
                  }

                  return function (e, t) {
                    var n, r, o;

                    for (n = 0; n < u; n++) {
                      if (o = a[n].field, r = l[n] * w(c(o, e), c(o, t))) return r;
                    }

                    return 0;
                  };
                }

                return null;
              }
            }, {
              key: "prepareSearch",
              value: function prepareSearch(e, t) {
                var n = {};
                var r = Object.assign({}, t);

                if (y(r, "sort"), y(r, "sort_empty"), r.fields) {
                  y(r, "fields");
                  var _e32 = [];
                  r.fields.forEach(function (t) {
                    "string" == typeof t && (t = {
                      field: t,
                      weight: 1
                    }), _e32.push(t), n[t.field] = "weight" in t ? t.weight : 1;
                  }), r.fields = _e32;
                }

                return {
                  options: r,
                  query: e.toLowerCase().trim(),
                  tokens: this.tokenize(e, r.respect_word_boundaries, n),
                  total: 0,
                  items: [],
                  weights: n,
                  getAttrFn: r.nesting ? g : p
                };
              }
            }, {
              key: "search",
              value: function search(e, t) {
                var n,
                    r,
                    o = this;
                r = this.prepareSearch(e, t), t = r.options, e = r.query;

                var i = t.score || o._getScoreFunction(r);

                e.length ? b(o.items, function (e, o) {
                  n = i(e), (!1 === t.filter || n > 0) && r.items.push({
                    score: n,
                    id: o
                  });
                }) : b(o.items, function (e, t) {
                  r.items.push({
                    score: 1,
                    id: t
                  });
                });

                var s = o._getSortFunction(r);

                return s && r.items.sort(s), r.total = r.items.length, "number" == typeof t.limit && (r.items = r.items.slice(0, t.limit)), r;
              }
            }]);

            return O;
          }();

          var E = function E(e) {
            if (e.jquery) return e[0];
            if (e instanceof HTMLElement) return e;

            if (_(e)) {
              var _t27 = document.createElement("div");

              return _t27.innerHTML = e.trim(), _t27.firstChild;
            }

            return document.querySelector(e);
          },
              _ = function _(e) {
            return "string" == typeof e && e.indexOf("<") > -1;
          },
              S = function S(e, t) {
            var n = document.createEvent("HTMLEvents");
            n.initEvent(t, !0, !1), e.dispatchEvent(n);
          },
              x = function x(e, t) {
            Object.assign(e.style, t);
          },
              C = function C(e) {
            for (var _len20 = arguments.length, t = new Array(_len20 > 1 ? _len20 - 1 : 0), _key20 = 1; _key20 < _len20; _key20++) {
              t[_key20 - 1] = arguments[_key20];
            }

            var n = P(t);
            (e = j(e)).map(function (e) {
              n.map(function (t) {
                e.classList.add(t);
              });
            });
          },
              k = function k(e) {
            for (var _len21 = arguments.length, t = new Array(_len21 > 1 ? _len21 - 1 : 0), _key21 = 1; _key21 < _len21; _key21++) {
              t[_key21 - 1] = arguments[_key21];
            }

            var n = P(t);
            (e = j(e)).map(function (e) {
              n.map(function (t) {
                e.classList.remove(t);
              });
            });
          },
              P = function P(e) {
            var t = [];
            return b(e, function (e) {
              "string" == typeof e && (e = e.trim().split(/[\11\12\14\15\40]/)), Array.isArray(e) && (t = t.concat(e));
            }), t.filter(Boolean);
          },
              j = function j(e) {
            return Array.isArray(e) || (e = [e]), e;
          },
              T = function T(e, t, n) {
            if (!n || n.contains(e)) for (; e && e.matches;) {
              if (e.matches(t)) return e;
              e = e.parentNode;
            }
          },
              D = function D(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            return t > 0 ? e[e.length - 1] : e[0];
          },
              M = function M(e, t) {
            if (!e) return -1;
            t = t || e.nodeName;

            for (var n = 0; e = e.previousElementSibling;) {
              e.matches(t) && n++;
            }

            return n;
          },
              A = function A(e, t) {
            b(t, function (t, n) {
              null == t ? e.removeAttribute(n) : e.setAttribute(n, "" + t);
            });
          },
              F = function F(e, t) {
            e.parentNode && e.parentNode.replaceChild(t, e);
          },
              L = function L(e, t) {
            if (null === t) return;

            if ("string" == typeof t) {
              if (!t.length) return;
              t = new RegExp(t, "i");
            }

            var n = function n(e) {
              return 3 === e.nodeType ? function (e) {
                var n = e.data.match(t);

                if (n && e.data.length > 0) {
                  var r = document.createElement("span");
                  r.className = "highlight";
                  var o = e.splitText(n.index);
                  o.splitText(n[0].length);
                  var i = o.cloneNode(!0);
                  return r.appendChild(i), F(o, r), 1;
                }

                return 0;
              }(e) : (function (e) {
                if (1 === e.nodeType && e.childNodes && !/(script|style)/i.test(e.tagName) && ("highlight" !== e.className || "SPAN" !== e.tagName)) for (var t = 0; t < e.childNodes.length; ++t) {
                  t += n(e.childNodes[t]);
                }
              }(e), 0);
            };

            n(e);
          },
              I = "undefined" != typeof navigator && /Mac/.test(navigator.userAgent) ? "metaKey" : "ctrlKey";

          var R = {
            options: [],
            optgroups: [],
            plugins: [],
            delimiter: ",",
            splitOn: null,
            persist: !0,
            diacritics: !0,
            create: null,
            createOnBlur: !1,
            createFilter: null,
            highlight: !0,
            openOnFocus: !0,
            shouldOpen: null,
            maxOptions: 50,
            maxItems: null,
            hideSelected: null,
            duplicates: !1,
            addPrecedence: !1,
            selectOnTab: !1,
            preload: null,
            allowEmptyOption: !1,
            loadThrottle: 300,
            loadingClass: "loading",
            dataAttr: null,
            optgroupField: "optgroup",
            valueField: "value",
            labelField: "text",
            disabledField: "disabled",
            optgroupLabelField: "label",
            optgroupValueField: "value",
            lockOptgroupOrder: !1,
            sortField: "$order",
            searchField: ["text"],
            searchConjunction: "and",
            mode: null,
            wrapperClass: "ts-wrapper",
            controlClass: "ts-control",
            dropdownClass: "ts-dropdown",
            dropdownContentClass: "ts-dropdown-content",
            itemClass: "item",
            optionClass: "option",
            dropdownParent: null,
            controlInput: '<input type="text" autocomplete="off" size="1" />',
            copyClassesToDropdown: !1,
            placeholder: null,
            hidePlaceholder: null,
            shouldLoad: function shouldLoad(e) {
              return e.length > 0;
            },
            render: {}
          };

          var N = function N(e) {
            return null == e ? null : B(e);
          },
              B = function B(e) {
            return "boolean" == typeof e ? e ? "1" : "0" : e + "";
          },
              H = function H(e) {
            return (e + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
          },
              U = function U(e, t) {
            var n;
            return function (r, o) {
              var i = this;
              n && (i.loading = Math.max(i.loading - 1, 0), clearTimeout(n)), n = setTimeout(function () {
                n = null, i.loadedSearches[r] = !0, e.call(i, r, o);
              }, t);
            };
          },
              z = function z(e, t, n) {
            var r,
                o = e.trigger,
                i = {};

            var _iterator15 = _createForOfIteratorHelper((e.trigger = function () {
              var n = arguments[0];
              if (-1 === t.indexOf(n)) return o.apply(e, arguments);
              i[n] = arguments;
            }, n.apply(e, []), e.trigger = o, t)),
                _step15;

            try {
              for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                r = _step15.value;
                r in i && o.apply(e, i[r]);
              }
            } catch (err) {
              _iterator15.e(err);
            } finally {
              _iterator15.f();
            }
          },
              Y = function Y(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            e && (e.preventDefault(), t && e.stopPropagation());
          },
              q = function q(e, t, n, r) {
            e.addEventListener(t, n, r);
          },
              V = function V(e, t) {
            return !!t && !!t[e] && 1 == (t.altKey ? 1 : 0) + (t.ctrlKey ? 1 : 0) + (t.shiftKey ? 1 : 0) + (t.metaKey ? 1 : 0);
          },
              W = function W(e, t) {
            return e.getAttribute("id") || (e.setAttribute("id", t), t);
          },
              K = function K(e) {
            return e.replace(/[\\"']/g, "\\$&");
          },
              X = function X(e, t) {
            t && e.append(t);
          };

          function Q(e, t) {
            var n = Object.assign({}, R, t),
                r = n.dataAttr,
                o = n.labelField,
                i = n.valueField,
                s = n.disabledField,
                a = n.optgroupField,
                l = n.optgroupLabelField,
                c = n.optgroupValueField,
                u = e.tagName.toLowerCase(),
                d = e.getAttribute("placeholder") || e.getAttribute("data-placeholder");

            if (!d && !n.allowEmptyOption) {
              var _t28 = e.querySelector('option[value=""]');

              _t28 && (d = _t28.textContent);
            }

            var h,
                f,
                p,
                g,
                m,
                v,
                y,
                w = {
              placeholder: d,
              options: [],
              optgroups: [],
              items: [],
              maxItems: null
            };
            return "select" === u ? (f = w.options, p = {}, g = 1, m = function m(e) {
              var t = Object.assign({}, e.dataset),
                  n = r && t[r];
              return "string" == typeof n && n.length && (t = Object.assign(t, JSON.parse(n))), t;
            }, v = function v(e, t) {
              var r = N(e.value);

              if (null != r && (r || n.allowEmptyOption)) {
                if (p.hasOwnProperty(r)) {
                  if (t) {
                    var l = p[r][a];
                    l ? Array.isArray(l) ? l.push(t) : p[r][a] = [l, t] : p[r][a] = t;
                  }
                } else {
                  var c = m(e);
                  c[o] = c[o] || e.textContent, c[i] = c[i] || r, c[s] = c[s] || e.disabled, c[a] = c[a] || t, c.$option = e, p[r] = c, f.push(c);
                }

                e.selected && w.items.push(r);
              }
            }, y = function y(e) {
              var t, n;
              (n = m(e))[l] = n[l] || e.getAttribute("label") || "", n[c] = n[c] || g++, n[s] = n[s] || e.disabled, w.optgroups.push(n), t = n[c], b(e.children, function (e) {
                v(e, t);
              });
            }, w.maxItems = e.hasAttribute("multiple") ? null : 1, b(e.children, function (e) {
              "optgroup" === (h = e.tagName.toLowerCase()) ? y(e) : "option" === h && v(e);
            })) : function () {
              var t = e.getAttribute(r);
              if (t) w.options = JSON.parse(t), b(w.options, function (e) {
                w.items.push(e[i]);
              });else {
                var s = e.value.trim() || "";
                if (!n.allowEmptyOption && !s.length) return;

                var _t29 = s.split(n.delimiter);

                b(_t29, function (e) {
                  var t = {};
                  t[o] = e, t[i] = e, w.options.push(t);
                }), w.items = _t29;
              }
            }(), Object.assign({}, R, w, t);
          }

          var G = 0;

          var J = /*#__PURE__*/function (_ref43) {
            _inherits(J, _ref43);

            var _super65 = _createSuper(J);

            function J(e, t) {
              var _this101;

              _classCallCheck(this, J);

              var n;
              _this101 = _super65.call(this), _this101.control_input = void 0, _this101.wrapper = void 0, _this101.dropdown = void 0, _this101.control = void 0, _this101.dropdown_content = void 0, _this101.focus_node = void 0, _this101.order = 0, _this101.settings = void 0, _this101.input = void 0, _this101.tabIndex = void 0, _this101.is_select_tag = void 0, _this101.rtl = void 0, _this101.inputId = void 0, _this101._destroy = void 0, _this101.sifter = void 0, _this101.isOpen = !1, _this101.isDisabled = !1, _this101.isRequired = void 0, _this101.isInvalid = !1, _this101.isValid = !0, _this101.isLocked = !1, _this101.isFocused = !1, _this101.isInputHidden = !1, _this101.isSetup = !1, _this101.ignoreFocus = !1, _this101.ignoreHover = !1, _this101.hasOptions = !1, _this101.currentResults = void 0, _this101.lastValue = "", _this101.caretPos = 0, _this101.loading = 0, _this101.loadedSearches = {}, _this101.activeOption = null, _this101.activeItems = [], _this101.optgroups = {}, _this101.options = {}, _this101.userOptions = {}, _this101.items = [], G++;
              var r = E(e);
              if (r.tomselect) throw new Error("Tom Select already initialized on this element");
              r.tomselect = _assertThisInitialized(_this101), n = (window.getComputedStyle && window.getComputedStyle(r, null)).getPropertyValue("direction");
              var o = Q(r, t);
              _this101.settings = o, _this101.input = r, _this101.tabIndex = r.tabIndex || 0, _this101.is_select_tag = "select" === r.tagName.toLowerCase(), _this101.rtl = /rtl/i.test(n), _this101.inputId = W(r, "tomselect-" + G), _this101.isRequired = r.required, _this101.sifter = new O(_this101.options, {
                diacritics: o.diacritics
              }), o.mode = o.mode || (1 === o.maxItems ? "single" : "multi"), "boolean" != typeof o.hideSelected && (o.hideSelected = "multi" === o.mode), "boolean" != typeof o.hidePlaceholder && (o.hidePlaceholder = "multi" !== o.mode);
              var i = o.createFilter;
              "function" != typeof i && ("string" == typeof i && (i = new RegExp(i)), i instanceof RegExp ? o.createFilter = function (e) {
                return i.test(e);
              } : o.createFilter = function (e) {
                return _this101.settings.duplicates || !_this101.options[e];
              }), _this101.initializePlugins(o.plugins), _this101.setupCallbacks(), _this101.setupTemplates();

              var s = E("<div>"),
                  a = E("<div>"),
                  l = _this101._render("dropdown"),
                  c = E('<div role="listbox" tabindex="-1">'),
                  u = _this101.input.getAttribute("class") || "",
                  d = o.mode;

              var h;
              C(s, o.wrapperClass, u, d), C(a, o.controlClass), X(s, a), C(l, o.dropdownClass, d), o.copyClassesToDropdown && C(l, u), C(c, o.dropdownContentClass), X(l, c), E(o.dropdownParent || s).appendChild(l), _(o.controlInput) ? (h = E(o.controlInput), b(["autocorrect", "autocapitalize", "autocomplete"], function (e) {
                r.getAttribute(e) && A(h, _defineProperty({}, e, r.getAttribute(e)));
              }), h.tabIndex = -1, a.appendChild(h), _this101.focus_node = h) : o.controlInput ? (h = E(o.controlInput), _this101.focus_node = h) : (h = E("<input/>"), _this101.focus_node = a), _this101.wrapper = s, _this101.dropdown = l, _this101.dropdown_content = c, _this101.control = a, _this101.control_input = h, _this101.setup();
              return _this101;
            }

            _createClass(J, [{
              key: "setup",
              value: function setup() {
                var e = this,
                    t = e.settings,
                    n = e.control_input,
                    r = e.dropdown,
                    o = e.dropdown_content,
                    i = e.wrapper,
                    s = e.control,
                    a = e.input,
                    l = e.focus_node,
                    c = {
                  passive: !0
                },
                    u = e.inputId + "-ts-dropdown";
                A(o, {
                  id: u
                }), A(l, {
                  role: "combobox",
                  "aria-haspopup": "listbox",
                  "aria-expanded": "false",
                  "aria-controls": u
                });

                var d = W(l, e.inputId + "-ts-control"),
                    h = "label[for='" + function (e) {
                  return e.replace(/['"\\]/g, "\\$&");
                }(e.inputId) + "']",
                    f = document.querySelector(h),
                    p = e.focus.bind(e);

                if (f) {
                  q(f, "click", p), A(f, {
                    for: d
                  });

                  var _t30 = W(f, e.inputId + "-ts-label");

                  A(l, {
                    "aria-labelledby": _t30
                  }), A(o, {
                    "aria-labelledby": _t30
                  });
                }

                if (i.style.width = a.style.width, e.plugins.names.length) {
                  var _t31 = "plugin-" + e.plugins.names.join(" plugin-");

                  C([i, r], _t31);
                }

                (null === t.maxItems || t.maxItems > 1) && e.is_select_tag && A(a, {
                  multiple: "multiple"
                }), t.placeholder && A(n, {
                  placeholder: t.placeholder
                }), !t.splitOn && t.delimiter && (t.splitOn = new RegExp("\\s*" + v(t.delimiter) + "+\\s*")), t.load && t.loadThrottle && (t.load = U(t.load, t.loadThrottle)), e.control_input.type = a.type, q(r, "mouseenter", function (t) {
                  var n = T(t.target, "[data-selectable]", r);
                  n && e.onOptionHover(t, n);
                }, {
                  capture: !0
                }), q(r, "click", function (t) {
                  var n = T(t.target, "[data-selectable]");
                  n && (e.onOptionSelect(t, n), Y(t, !0));
                }), q(s, "click", function (t) {
                  var r = T(t.target, "[data-ts-item]", s);
                  r && e.onItemSelect(t, r) ? Y(t, !0) : "" == n.value && (e.onClick(), Y(t, !0));
                }), q(l, "keydown", function (t) {
                  return e.onKeyDown(t);
                }), q(n, "keypress", function (t) {
                  return e.onKeyPress(t);
                }), q(n, "input", function (t) {
                  return e.onInput(t);
                }), q(l, "resize", function () {
                  return e.positionDropdown();
                }, c), q(l, "blur", function (t) {
                  return e.onBlur(t);
                }), q(l, "focus", function (t) {
                  return e.onFocus(t);
                }), q(n, "paste", function (t) {
                  return e.onPaste(t);
                });

                var g = function g(t) {
                  var o = t.composedPath()[0];
                  if (!i.contains(o) && !r.contains(o)) return e.isFocused && e.blur(), void e.inputState();
                  o == n && e.isOpen ? t.stopPropagation() : Y(t, !0);
                },
                    m = function m() {
                  e.isOpen && e.positionDropdown();
                },
                    y = function y() {
                  e.ignoreHover = !1;
                };

                q(document, "mousedown", g), q(window, "scroll", m, c), q(window, "resize", m, c), q(window, "mousemove", y, c), this._destroy = function () {
                  document.removeEventListener("mousedown", g), window.removeEventListener("mousemove", y), window.removeEventListener("scroll", m), window.removeEventListener("resize", m), f && f.removeEventListener("click", p);
                }, this.revertSettings = {
                  innerHTML: a.innerHTML,
                  tabIndex: a.tabIndex
                }, a.tabIndex = -1, a.insertAdjacentElement("afterend", e.wrapper), e.sync(!1), t.items = [], delete t.optgroups, delete t.options, q(a, "invalid", function (t) {
                  e.isValid && (e.isValid = !1, e.isInvalid = !0, e.refreshState());
                }), e.updateOriginalInput(), e.refreshItems(), e.close(!1), e.inputState(), e.isSetup = !0, a.disabled ? e.disable() : e.enable(), e.on("change", this.onChange), C(a, "tomselected", "ts-hidden-accessible"), e.trigger("initialize"), !0 === t.preload && e.preload();
              }
            }, {
              key: "setupOptions",
              value: function setupOptions() {
                var _this102 = this;

                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                this.addOptions(e), b(t, function (e) {
                  _this102.registerOptionGroup(e);
                });
              }
            }, {
              key: "setupTemplates",
              value: function setupTemplates() {
                var e = this,
                    t = e.settings.labelField,
                    n = e.settings.optgroupLabelField,
                    r = {
                  optgroup: function optgroup(e) {
                    var t = document.createElement("div");
                    return t.className = "optgroup", t.appendChild(e.options), t;
                  },
                  optgroup_header: function optgroup_header(e, t) {
                    return '<div class="optgroup-header">' + t(e[n]) + "</div>";
                  },
                  option: function option(e, n) {
                    return "<div>" + n(e[t]) + "</div>";
                  },
                  item: function item(e, n) {
                    return "<div>" + n(e[t]) + "</div>";
                  },
                  option_create: function option_create(e, t) {
                    return '<div class="create">Add <strong>' + t(e.input) + "</strong>&hellip;</div>";
                  },
                  no_results: function no_results() {
                    return '<div class="no-results">No results found</div>';
                  },
                  loading: function loading() {
                    return '<div class="spinner"></div>';
                  },
                  not_loading: function not_loading() {},
                  dropdown: function dropdown() {
                    return "<div></div>";
                  }
                };
                e.settings.render = Object.assign({}, r, e.settings.render);
              }
            }, {
              key: "setupCallbacks",
              value: function setupCallbacks() {
                var e,
                    t,
                    n = {
                  initialize: "onInitialize",
                  change: "onChange",
                  item_add: "onItemAdd",
                  item_remove: "onItemRemove",
                  item_select: "onItemSelect",
                  clear: "onClear",
                  option_add: "onOptionAdd",
                  option_remove: "onOptionRemove",
                  option_clear: "onOptionClear",
                  optgroup_add: "onOptionGroupAdd",
                  optgroup_remove: "onOptionGroupRemove",
                  optgroup_clear: "onOptionGroupClear",
                  dropdown_open: "onDropdownOpen",
                  dropdown_close: "onDropdownClose",
                  type: "onType",
                  load: "onLoad",
                  focus: "onFocus",
                  blur: "onBlur"
                };

                for (e in n) {
                  (t = this.settings[n[e]]) && this.on(e, t);
                }
              }
            }, {
              key: "sync",
              value: function sync() {
                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
                var t = this,
                    n = e ? Q(t.input, {
                  delimiter: t.settings.delimiter
                }) : t.settings;
                t.setupOptions(n.options, n.optgroups), t.setValue(n.items || [], !0), t.lastQuery = null;
              }
            }, {
              key: "onClick",
              value: function onClick() {
                var e = this;
                if (e.activeItems.length > 0) return e.clearActiveItems(), void e.focus();
                e.isFocused && e.isOpen ? e.blur() : e.focus();
              }
            }, {
              key: "onMouseDown",
              value: function onMouseDown() {}
            }, {
              key: "onChange",
              value: function onChange() {
                S(this.input, "input"), S(this.input, "change");
              }
            }, {
              key: "onPaste",
              value: function onPaste(e) {
                var _this103 = this;

                var t = this;
                t.isInputHidden || t.isLocked ? Y(e) : t.settings.splitOn && setTimeout(function () {
                  var e = t.inputValue();

                  if (e.match(t.settings.splitOn)) {
                    var n = e.trim().split(t.settings.splitOn);
                    b(n, function (e) {
                      e = N(e), _this103.options[e] ? t.addItem(e) : t.createItem(e);
                    });
                  }
                }, 0);
              }
            }, {
              key: "onKeyPress",
              value: function onKeyPress(e) {
                var t = this;

                if (!t.isLocked) {
                  var n = String.fromCharCode(e.keyCode || e.which);
                  return t.settings.create && "multi" === t.settings.mode && n === t.settings.delimiter ? (t.createItem(), void Y(e)) : void 0;
                }

                Y(e);
              }
            }, {
              key: "onKeyDown",
              value: function onKeyDown(e) {
                var t = this;
                if (t.ignoreHover = !0, t.isLocked) 9 !== e.keyCode && Y(e);else {
                  switch (e.keyCode) {
                    case 65:
                      if (V(I, e) && "" == t.control_input.value) return Y(e), void t.selectAll();
                      break;

                    case 27:
                      return t.isOpen && (Y(e, !0), t.close()), void t.clearActiveItems();

                    case 40:
                      if (!t.isOpen && t.hasOptions) t.open();else if (t.activeOption) {
                        var _e33 = t.getAdjacent(t.activeOption, 1);

                        _e33 && t.setActiveOption(_e33);
                      }
                      return void Y(e);

                    case 38:
                      if (t.activeOption) {
                        var _e34 = t.getAdjacent(t.activeOption, -1);

                        _e34 && t.setActiveOption(_e34);
                      }

                      return void Y(e);

                    case 13:
                      return void (t.canSelect(t.activeOption) ? (t.onOptionSelect(e, t.activeOption), Y(e)) : (t.settings.create && t.createItem() || document.activeElement == t.control_input && t.isOpen) && Y(e));

                    case 37:
                      return void t.advanceSelection(-1, e);

                    case 39:
                      return void t.advanceSelection(1, e);

                    case 9:
                      return void (t.settings.selectOnTab && (t.canSelect(t.activeOption) && (t.onOptionSelect(e, t.activeOption), Y(e)), t.settings.create && t.createItem() && Y(e)));

                    case 8:
                    case 46:
                      return void t.deleteSelection(e);
                  }

                  t.isInputHidden && !V(I, e) && Y(e);
                }
              }
            }, {
              key: "onInput",
              value: function onInput(e) {
                var t = this;

                if (!t.isLocked) {
                  var n = t.inputValue();
                  t.lastValue !== n && (t.lastValue = n, t.settings.shouldLoad.call(t, n) && t.load(n), t.refreshOptions(), t.trigger("type", n));
                }
              }
            }, {
              key: "onOptionHover",
              value: function onOptionHover(e, t) {
                this.ignoreHover || this.setActiveOption(t, !1);
              }
            }, {
              key: "onFocus",
              value: function onFocus(e) {
                var t = this,
                    n = t.isFocused;
                if (t.isDisabled) return t.blur(), void Y(e);
                t.ignoreFocus || (t.isFocused = !0, "focus" === t.settings.preload && t.preload(), n || t.trigger("focus"), t.activeItems.length || (t.showInput(), t.refreshOptions(!!t.settings.openOnFocus)), t.refreshState());
              }
            }, {
              key: "onBlur",
              value: function onBlur(e) {
                if (!1 !== document.hasFocus()) {
                  var t = this;

                  if (t.isFocused) {
                    t.isFocused = !1, t.ignoreFocus = !1;

                    var n = function n() {
                      t.close(), t.setActiveItem(), t.setCaret(t.items.length), t.trigger("blur");
                    };

                    t.settings.create && t.settings.createOnBlur ? t.createItem(null, !1, n) : n();
                  }
                }
              }
            }, {
              key: "onOptionSelect",
              value: function onOptionSelect(e, t) {
                var n,
                    r = this;
                t.parentElement && t.parentElement.matches("[data-disabled]") || (t.classList.contains("create") ? r.createItem(null, !0, function () {
                  r.settings.closeAfterSelect && r.close();
                }) : void 0 !== (n = t.dataset.value) && (r.lastQuery = null, r.addItem(n), r.settings.closeAfterSelect && r.close(), !r.settings.hideSelected && e.type && /click/.test(e.type) && r.setActiveOption(t)));
              }
            }, {
              key: "canSelect",
              value: function canSelect(e) {
                return !!(this.isOpen && e && this.dropdown_content.contains(e));
              }
            }, {
              key: "onItemSelect",
              value: function onItemSelect(e, t) {
                var n = this;
                return !n.isLocked && "multi" === n.settings.mode && (Y(e), n.setActiveItem(t, e), !0);
              }
            }, {
              key: "canLoad",
              value: function canLoad(e) {
                return !!this.settings.load && !this.loadedSearches.hasOwnProperty(e);
              }
            }, {
              key: "load",
              value: function load(e) {
                var t = this;
                if (!t.canLoad(e)) return;
                C(t.wrapper, t.settings.loadingClass), t.loading++;
                var n = t.loadCallback.bind(t);
                t.settings.load.call(t, e, n);
              }
            }, {
              key: "loadCallback",
              value: function loadCallback(e, t) {
                var n = this;
                n.loading = Math.max(n.loading - 1, 0), n.lastQuery = null, n.clearActiveOption(), n.setupOptions(e, t), n.refreshOptions(n.isFocused && !n.isInputHidden), n.loading || k(n.wrapper, n.settings.loadingClass), n.trigger("load", e, t);
              }
            }, {
              key: "preload",
              value: function preload() {
                var e = this.wrapper.classList;
                e.contains("preloaded") || (e.add("preloaded"), this.load(""));
              }
            }, {
              key: "setTextboxValue",
              value: function setTextboxValue() {
                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                var t = this.control_input;
                t.value !== e && (t.value = e, S(t, "update"), this.lastValue = e);
              }
            }, {
              key: "getValue",
              value: function getValue() {
                return this.is_select_tag && this.input.hasAttribute("multiple") ? this.items : this.items.join(this.settings.delimiter);
              }
            }, {
              key: "setValue",
              value: function setValue(e, t) {
                var _this104 = this;

                z(this, t ? [] : ["change"], function () {
                  _this104.clear(t), _this104.addItems(e, t);
                });
              }
            }, {
              key: "setMaxItems",
              value: function setMaxItems(e) {
                0 === e && (e = null), this.settings.maxItems = e, this.refreshState();
              }
            }, {
              key: "setActiveItem",
              value: function setActiveItem(e, t) {
                var n,
                    r,
                    o,
                    i,
                    s,
                    a,
                    l = this;

                if ("single" !== l.settings.mode) {
                  if (!e) return l.clearActiveItems(), void (l.isFocused && l.showInput());

                  if ("click" === (n = t && t.type.toLowerCase()) && V("shiftKey", t) && l.activeItems.length) {
                    for (a = l.getLastActive(), (o = Array.prototype.indexOf.call(l.control.children, a)) > (i = Array.prototype.indexOf.call(l.control.children, e)) && (s = o, o = i, i = s), r = o; r <= i; r++) {
                      e = l.control.children[r], -1 === l.activeItems.indexOf(e) && l.setActiveItemClass(e);
                    }

                    Y(t);
                  } else "click" === n && V(I, t) || "keydown" === n && V("shiftKey", t) ? e.classList.contains("active") ? l.removeActiveItem(e) : l.setActiveItemClass(e) : (l.clearActiveItems(), l.setActiveItemClass(e));

                  l.hideInput(), l.isFocused || l.focus();
                }
              }
            }, {
              key: "setActiveItemClass",
              value: function setActiveItemClass(e) {
                var t = this,
                    n = t.control.querySelector(".last-active");
                n && k(n, "last-active"), C(e, "active last-active"), t.trigger("item_select", e), -1 == t.activeItems.indexOf(e) && t.activeItems.push(e);
              }
            }, {
              key: "removeActiveItem",
              value: function removeActiveItem(e) {
                var t = this.activeItems.indexOf(e);
                this.activeItems.splice(t, 1), k(e, "active");
              }
            }, {
              key: "clearActiveItems",
              value: function clearActiveItems() {
                k(this.activeItems, "active"), this.activeItems = [];
              }
            }, {
              key: "setActiveOption",
              value: function setActiveOption(e) {
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
                e !== this.activeOption && (this.clearActiveOption(), e && (this.activeOption = e, A(this.focus_node, {
                  "aria-activedescendant": e.getAttribute("id")
                }), A(e, {
                  "aria-selected": "true"
                }), C(e, "active"), t && this.scrollToOption(e)));
              }
            }, {
              key: "scrollToOption",
              value: function scrollToOption(e, t) {
                if (!e) return;
                var n = this.dropdown_content,
                    r = n.clientHeight,
                    o = n.scrollTop || 0,
                    i = e.offsetHeight,
                    s = e.getBoundingClientRect().top - n.getBoundingClientRect().top + o;
                s + i > r + o ? this.scroll(s - r + i, t) : s < o && this.scroll(s, t);
              }
            }, {
              key: "scroll",
              value: function scroll(e, t) {
                var n = this.dropdown_content;
                t && (n.style.scrollBehavior = t), n.scrollTop = e, n.style.scrollBehavior = "";
              }
            }, {
              key: "clearActiveOption",
              value: function clearActiveOption() {
                this.activeOption && (k(this.activeOption, "active"), A(this.activeOption, {
                  "aria-selected": null
                })), this.activeOption = null, A(this.focus_node, {
                  "aria-activedescendant": null
                });
              }
            }, {
              key: "selectAll",
              value: function selectAll() {
                var e = this;
                if ("single" === e.settings.mode) return;
                var t = e.controlChildren();
                t.length && (e.hideInput(), e.close(), e.activeItems = t, b(t, function (t) {
                  e.setActiveItemClass(t);
                }));
              }
            }, {
              key: "inputState",
              value: function inputState() {
                var e = this;
                e.control.contains(e.control_input) && (A(e.control_input, {
                  placeholder: e.settings.placeholder
                }), e.activeItems.length > 0 || !e.isFocused && e.settings.hidePlaceholder && e.items.length > 0 ? (e.setTextboxValue(), e.isInputHidden = !0) : (e.settings.hidePlaceholder && e.items.length > 0 && A(e.control_input, {
                  placeholder: ""
                }), e.isInputHidden = !1), e.wrapper.classList.toggle("input-hidden", e.isInputHidden));
              }
            }, {
              key: "hideInput",
              value: function hideInput() {
                this.inputState();
              }
            }, {
              key: "showInput",
              value: function showInput() {
                this.inputState();
              }
            }, {
              key: "inputValue",
              value: function inputValue() {
                return this.control_input.value.trim();
              }
            }, {
              key: "focus",
              value: function focus() {
                var e = this;
                e.isDisabled || (e.ignoreFocus = !0, e.control_input.offsetWidth ? e.control_input.focus() : e.focus_node.focus(), setTimeout(function () {
                  e.ignoreFocus = !1, e.onFocus();
                }, 0));
              }
            }, {
              key: "blur",
              value: function blur() {
                this.focus_node.blur(), this.onBlur();
              }
            }, {
              key: "getScoreFunction",
              value: function getScoreFunction(e) {
                return this.sifter.getScoreFunction(e, this.getSearchOptions());
              }
            }, {
              key: "getSearchOptions",
              value: function getSearchOptions() {
                var e = this.settings,
                    t = e.sortField;
                return "string" == typeof e.sortField && (t = [{
                  field: e.sortField
                }]), {
                  fields: e.searchField,
                  conjunction: e.searchConjunction,
                  sort: t,
                  nesting: e.nesting
                };
              }
            }, {
              key: "search",
              value: function search(e) {
                var t,
                    n,
                    r,
                    o = this,
                    i = this.getSearchOptions();
                if (o.settings.score && "function" != typeof (r = o.settings.score.call(o, e))) throw new Error('Tom Select "score" setting must be a function that returns a function');
                if (e !== o.lastQuery ? (o.lastQuery = e, n = o.sifter.search(e, Object.assign(i, {
                  score: r
                })), o.currentResults = n) : n = Object.assign({}, o.currentResults), o.settings.hideSelected) for (t = n.items.length - 1; t >= 0; t--) {
                  var _e35 = N(n.items[t].id);

                  _e35 && -1 !== o.items.indexOf(_e35) && n.items.splice(t, 1);
                }
                return n;
              }
            }, {
              key: "refreshOptions",
              value: function refreshOptions() {
                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
                var t, n, r, o, i, s, a, l, c, u, d;
                var h = {},
                    f = [];
                var p,
                    g = this,
                    m = g.inputValue(),
                    v = g.search(m),
                    y = null,
                    w = g.settings.shouldOpen || !1,
                    O = g.dropdown_content;

                for (g.activeOption && (c = g.activeOption.dataset.value, u = g.activeOption.closest("[data-group]")), o = v.items.length, "number" == typeof g.settings.maxOptions && (o = Math.min(o, g.settings.maxOptions)), o > 0 && (w = !0), t = 0; t < o; t++) {
                  var _e36 = v.items[t].id,
                      _o13 = g.options[_e36],
                      _a2 = g.getOption(_e36, !0);

                  for (g.settings.hideSelected || _a2.classList.toggle("selected", g.items.includes(_e36)), i = _o13[g.settings.optgroupField] || "", n = 0, r = (s = Array.isArray(i) ? i : [i]) && s.length; n < r; n++) {
                    i = s[n], g.optgroups.hasOwnProperty(i) || (i = ""), h.hasOwnProperty(i) || (h[i] = document.createDocumentFragment(), f.push(i)), n > 0 && (_a2 = _a2.cloneNode(!0), A(_a2, {
                      id: _o13.$id + "-clone-" + n,
                      "aria-selected": null
                    }), _a2.classList.add("ts-cloned"), k(_a2, "active")), y || c != _e36 || (u ? u.dataset.group === i && (y = _a2) : y = _a2), h[i].appendChild(_a2);
                  }
                }

                this.settings.lockOptgroupOrder && f.sort(function (e, t) {
                  return (g.optgroups[e] && g.optgroups[e].$order || 0) - (g.optgroups[t] && g.optgroups[t].$order || 0);
                }), a = document.createDocumentFragment(), b(f, function (e) {
                  if (g.optgroups.hasOwnProperty(e) && h[e].children.length) {
                    var _t32 = document.createDocumentFragment(),
                        _n23 = g.render("optgroup_header", g.optgroups[e]);

                    X(_t32, _n23), X(_t32, h[e]);

                    var _r25 = g.render("optgroup", {
                      group: g.optgroups[e],
                      options: _t32
                    });

                    X(a, _r25);
                  } else X(a, h[e]);
                }), O.innerHTML = "", X(O, a), g.settings.highlight && (p = O.querySelectorAll("span.highlight"), Array.prototype.forEach.call(p, function (e) {
                  var t = e.parentNode;
                  t.replaceChild(e.firstChild, e), t.normalize();
                }), v.query.length && v.tokens.length && b(v.tokens, function (e) {
                  L(O, e.regex);
                }));

                var E = function E(e) {
                  var t = g.render(e, {
                    input: m
                  });
                  return t && (w = !0, O.insertBefore(t, O.firstChild)), t;
                };

                if (g.loading ? E("loading") : g.settings.shouldLoad.call(g, m) ? 0 === v.items.length && E("no_results") : E("not_loading"), (l = g.canCreate(m)) && (d = E("option_create")), g.hasOptions = v.items.length > 0 || l, w) {
                  if (v.items.length > 0) {
                    if (!y && "single" === g.settings.mode && g.items.length && (y = g.getOption(g.items[0])), !O.contains(y)) {
                      var _e37 = 0;
                      d && !g.settings.addPrecedence && (_e37 = 1), y = g.selectable()[_e37];
                    }
                  } else d && (y = d);

                  e && !g.isOpen && (g.open(), g.scrollToOption(y, "auto")), g.setActiveOption(y);
                } else g.clearActiveOption(), e && g.isOpen && g.close(!1);
              }
            }, {
              key: "selectable",
              value: function selectable() {
                return this.dropdown_content.querySelectorAll("[data-selectable]");
              }
            }, {
              key: "addOption",
              value: function addOption(e) {
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                var n = this;
                if (Array.isArray(e)) return n.addOptions(e, t), !1;
                var r = N(e[n.settings.valueField]);
                return null !== r && !n.options.hasOwnProperty(r) && (e.$order = e.$order || ++n.order, e.$id = n.inputId + "-opt-" + e.$order, n.options[r] = e, n.lastQuery = null, t && (n.userOptions[r] = t, n.trigger("option_add", r, e)), r);
              }
            }, {
              key: "addOptions",
              value: function addOptions(e) {
                var _this105 = this;

                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                b(e, function (e) {
                  _this105.addOption(e, t);
                });
              }
            }, {
              key: "registerOption",
              value: function registerOption(e) {
                return this.addOption(e);
              }
            }, {
              key: "registerOptionGroup",
              value: function registerOptionGroup(e) {
                var t = N(e[this.settings.optgroupValueField]);
                return null !== t && (e.$order = e.$order || ++this.order, this.optgroups[t] = e, t);
              }
            }, {
              key: "addOptionGroup",
              value: function addOptionGroup(e, t) {
                var n;
                t[this.settings.optgroupValueField] = e, (n = this.registerOptionGroup(t)) && this.trigger("optgroup_add", n, t);
              }
            }, {
              key: "removeOptionGroup",
              value: function removeOptionGroup(e) {
                this.optgroups.hasOwnProperty(e) && (delete this.optgroups[e], this.clearCache(), this.trigger("optgroup_remove", e));
              }
            }, {
              key: "clearOptionGroups",
              value: function clearOptionGroups() {
                this.optgroups = {}, this.clearCache(), this.trigger("optgroup_clear");
              }
            }, {
              key: "updateOption",
              value: function updateOption(e, t) {
                var n = this;
                var r, o;
                var i = N(e),
                    s = N(t[n.settings.valueField]);
                if (null === i) return;
                if (!n.options.hasOwnProperty(i)) return;
                if ("string" != typeof s) throw new Error("Value must be set in option data");
                var a = n.getOption(i),
                    l = n.getItem(i);

                if (t.$order = t.$order || n.options[i].$order, delete n.options[i], n.uncacheValue(s), n.options[s] = t, a) {
                  if (n.dropdown_content.contains(a)) {
                    var _e38 = n._render("option", t);

                    F(a, _e38), n.activeOption === a && n.setActiveOption(_e38);
                  }

                  a.remove();
                }

                l && (-1 !== (o = n.items.indexOf(i)) && n.items.splice(o, 1, s), r = n._render("item", t), l.classList.contains("active") && C(r, "active"), F(l, r)), n.lastQuery = null;
              }
            }, {
              key: "removeOption",
              value: function removeOption(e, t) {
                var n = this;
                e = B(e), n.uncacheValue(e), delete n.userOptions[e], delete n.options[e], n.lastQuery = null, n.trigger("option_remove", e), n.removeItem(e, t);
              }
            }, {
              key: "clearOptions",
              value: function clearOptions(e) {
                var _this106 = this;

                var t = (e || this.clearFilter).bind(this);
                this.loadedSearches = {}, this.userOptions = {}, this.clearCache();
                var n = {};
                b(this.options, function (e, r) {
                  t(e, r) && (n[r] = _this106.options[r]);
                }), this.options = this.sifter.items = n, this.lastQuery = null, this.trigger("option_clear");
              }
            }, {
              key: "clearFilter",
              value: function clearFilter(e, t) {
                return this.items.indexOf(t) >= 0;
              }
            }, {
              key: "getOption",
              value: function getOption(e) {
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
                var n = N(e);

                if (null !== n && this.options.hasOwnProperty(n)) {
                  var _e39 = this.options[n];
                  if (_e39.$div) return _e39.$div;
                  if (t) return this._render("option", _e39);
                }

                return null;
              }
            }, {
              key: "getAdjacent",
              value: function getAdjacent(e, t) {
                var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "option";
                var r;
                if (!e) return null;
                r = "item" == n ? this.controlChildren() : this.dropdown_content.querySelectorAll("[data-selectable]");

                for (var _n24 = 0; _n24 < r.length; _n24++) {
                  if (r[_n24] == e) return t > 0 ? r[_n24 + 1] : r[_n24 - 1];
                }

                return null;
              }
            }, {
              key: "getItem",
              value: function getItem(e) {
                if ("object" == _typeof(e)) return e;
                var t = N(e);
                return null !== t ? this.control.querySelector("[data-value=\"".concat(K(t), "\"]")) : null;
              }
            }, {
              key: "addItems",
              value: function addItems(e, t) {
                var n = this,
                    r = Array.isArray(e) ? e : [e];

                for (var _e40 = 0, _o14 = (r = r.filter(function (e) {
                  return -1 === n.items.indexOf(e);
                })).length; _e40 < _o14; _e40++) {
                  n.isPending = _e40 < _o14 - 1, n.addItem(r[_e40], t);
                }
              }
            }, {
              key: "addItem",
              value: function addItem(e, t) {
                var _this107 = this;

                z(this, t ? [] : ["change", "dropdown_close"], function () {
                  var n, r;
                  var o = _this107,
                      i = o.settings.mode,
                      s = N(e);

                  if ((!s || -1 === o.items.indexOf(s) || ("single" === i && o.close(), "single" !== i && o.settings.duplicates)) && null !== s && o.options.hasOwnProperty(s) && ("single" === i && o.clear(t), "multi" !== i || !o.isFull())) {
                    if (n = o._render("item", o.options[s]), o.control.contains(n) && (n = n.cloneNode(!0)), r = o.isFull(), o.items.splice(o.caretPos, 0, s), o.insertAtCaret(n), o.isSetup) {
                      if (!o.isPending && o.settings.hideSelected) {
                        var _e41 = o.getOption(s),
                            _t33 = o.getAdjacent(_e41, 1);

                        _t33 && o.setActiveOption(_t33);
                      }

                      o.isPending || o.settings.closeAfterSelect || o.refreshOptions(o.isFocused && "single" !== i), 0 != o.settings.closeAfterSelect && o.isFull() ? o.close() : o.isPending || o.positionDropdown(), o.trigger("item_add", s, n), o.isPending || o.updateOriginalInput({
                        silent: t
                      });
                    }

                    (!o.isPending || !r && o.isFull()) && (o.inputState(), o.refreshState());
                  }
                });
              }
            }, {
              key: "removeItem",
              value: function removeItem() {
                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                var t = arguments.length > 1 ? arguments[1] : undefined;
                var n = this;
                if (!(e = n.getItem(e))) return;
                var r, o;
                var i = e.dataset.value;
                r = M(e), e.remove(), e.classList.contains("active") && (o = n.activeItems.indexOf(e), n.activeItems.splice(o, 1), k(e, "active")), n.items.splice(r, 1), n.lastQuery = null, !n.settings.persist && n.userOptions.hasOwnProperty(i) && n.removeOption(i, t), r < n.caretPos && n.setCaret(n.caretPos - 1), n.updateOriginalInput({
                  silent: t
                }), n.refreshState(), n.positionDropdown(), n.trigger("item_remove", i, e);
              }
            }, {
              key: "createItem",
              value: function createItem() {
                var _ref44;

                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
                var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
                var r,
                    o = this,
                    i = o.caretPos;
                if (e = e || o.inputValue(), !o.canCreate(e)) return n(), !1;
                o.lock();

                var s = !1,
                    a = function a(e) {
                  if (o.unlock(), !e || "object" != _typeof(e)) return n();
                  var t = N(e[o.settings.valueField]);
                  if ("string" != typeof t) return n();
                  o.setTextboxValue(), o.addOption(e, !0), o.setCaret(i), o.addItem(t), n(e), s = !0;
                };

                return r = "function" == typeof o.settings.create ? o.settings.create.call(this, e, a) : (_ref44 = {}, _defineProperty(_ref44, o.settings.labelField, e), _defineProperty(_ref44, o.settings.valueField, e), _ref44), s || a(r), !0;
              }
            }, {
              key: "refreshItems",
              value: function refreshItems() {
                var e = this;
                e.lastQuery = null, e.isSetup && e.addItems(e.items), e.updateOriginalInput(), e.refreshState();
              }
            }, {
              key: "refreshState",
              value: function refreshState() {
                var e = this;
                e.refreshValidityState();
                var t = e.isFull(),
                    n = e.isLocked;
                e.wrapper.classList.toggle("rtl", e.rtl);
                var r = e.wrapper.classList;
                var o;
                r.toggle("focus", e.isFocused), r.toggle("disabled", e.isDisabled), r.toggle("required", e.isRequired), r.toggle("invalid", !e.isValid), r.toggle("locked", n), r.toggle("full", t), r.toggle("input-active", e.isFocused && !e.isInputHidden), r.toggle("dropdown-active", e.isOpen), r.toggle("has-options", (o = e.options, 0 === Object.keys(o).length)), r.toggle("has-items", e.items.length > 0);
              }
            }, {
              key: "refreshValidityState",
              value: function refreshValidityState() {
                var e = this;
                e.input.validity && (e.isValid = e.input.validity.valid, e.isInvalid = !e.isValid);
              }
            }, {
              key: "isFull",
              value: function isFull() {
                return null !== this.settings.maxItems && this.items.length >= this.settings.maxItems;
              }
            }, {
              key: "updateOriginalInput",
              value: function updateOriginalInput() {
                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var t = this;
                var n, r;
                var o = t.input.querySelector('option[value=""]');

                if (t.is_select_tag) {
                  var _i47 = [],
                      _s4 = t.input.querySelectorAll("option:checked").length;

                  function _a3(e, n, r) {
                    return e || (e = E('<option value="' + H(n) + '">' + H(r) + "</option>")), e != o && t.input.append(e), _i47.push(e), (e != o || _s4 > 0) && (e.selected = !0), e;
                  }

                  t.input.querySelectorAll("option:checked").forEach(function (e) {
                    e.selected = !1;
                  }), 0 == t.items.length && "single" == t.settings.mode ? _a3(o, "", "") : t.items.forEach(function (e) {
                    n = t.options[e], r = n[t.settings.labelField] || "", _i47.includes(n.$option) ? _a3(t.input.querySelector("option[value=\"".concat(K(e), "\"]:not(:checked)")), e, r) : n.$option = _a3(n.$option, e, r);
                  });
                } else t.input.value = t.getValue();

                t.isSetup && (e.silent || t.trigger("change", t.getValue()));
              }
            }, {
              key: "open",
              value: function open() {
                var e = this;
                e.isLocked || e.isOpen || "multi" === e.settings.mode && e.isFull() || (e.isOpen = !0, A(e.focus_node, {
                  "aria-expanded": "true"
                }), e.refreshState(), x(e.dropdown, {
                  visibility: "hidden",
                  display: "block"
                }), e.positionDropdown(), x(e.dropdown, {
                  visibility: "visible",
                  display: "block"
                }), e.focus(), e.trigger("dropdown_open", e.dropdown));
              }
            }, {
              key: "close",
              value: function close() {
                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
                var t = this,
                    n = t.isOpen;
                e && (t.setTextboxValue(), "single" === t.settings.mode && t.items.length && t.hideInput()), t.isOpen = !1, A(t.focus_node, {
                  "aria-expanded": "false"
                }), x(t.dropdown, {
                  display: "none"
                }), t.settings.hideSelected && t.clearActiveOption(), t.refreshState(), n && t.trigger("dropdown_close", t.dropdown);
              }
            }, {
              key: "positionDropdown",
              value: function positionDropdown() {
                if ("body" === this.settings.dropdownParent) {
                  var e = this.control,
                      t = e.getBoundingClientRect(),
                      n = e.offsetHeight + t.top + window.scrollY,
                      r = t.left + window.scrollX;
                  x(this.dropdown, {
                    width: t.width + "px",
                    top: n + "px",
                    left: r + "px"
                  });
                }
              }
            }, {
              key: "clear",
              value: function clear(e) {
                var t = this;

                if (t.items.length) {
                  var n = t.controlChildren();
                  b(n, function (e) {
                    t.removeItem(e, !0);
                  }), t.showInput(), e || t.updateOriginalInput(), t.trigger("clear");
                }
              }
            }, {
              key: "insertAtCaret",
              value: function insertAtCaret(e) {
                var t = this,
                    n = t.caretPos,
                    r = t.control;
                r.insertBefore(e, r.children[n]), t.setCaret(n + 1);
              }
            }, {
              key: "deleteSelection",
              value: function deleteSelection(e) {
                var t,
                    n,
                    r,
                    o,
                    i,
                    s = this;
                t = e && 8 === e.keyCode ? -1 : 1, n = {
                  start: (i = s.control_input).selectionStart || 0,
                  length: (i.selectionEnd || 0) - (i.selectionStart || 0)
                };
                var a = [];
                if (s.activeItems.length) o = D(s.activeItems, t), r = M(o), t > 0 && r++, b(s.activeItems, function (e) {
                  return a.push(e);
                });else if ((s.isFocused || "single" === s.settings.mode) && s.items.length) {
                  var _e42 = s.controlChildren();

                  t < 0 && 0 === n.start && 0 === n.length ? a.push(_e42[s.caretPos - 1]) : t > 0 && n.start === s.inputValue().length && a.push(_e42[s.caretPos]);
                }
                if (!s.shouldDelete(a, e)) return !1;

                for (Y(e, !0), void 0 !== r && s.setCaret(r); a.length;) {
                  s.removeItem(a.pop());
                }

                return s.showInput(), s.positionDropdown(), s.refreshOptions(!1), !0;
              }
            }, {
              key: "shouldDelete",
              value: function shouldDelete(e, t) {
                var n = e.map(function (e) {
                  return e.dataset.value;
                });
                return !(!n.length || "function" == typeof this.settings.onDelete && !1 === this.settings.onDelete(n, t));
              }
            }, {
              key: "advanceSelection",
              value: function advanceSelection(e, t) {
                var n,
                    r,
                    o = this;
                o.rtl && (e *= -1), o.inputValue().length || (V(I, t) || V("shiftKey", t) ? (r = (n = o.getLastActive(e)) ? n.classList.contains("active") ? o.getAdjacent(n, e, "item") : n : e > 0 ? o.control_input.nextElementSibling : o.control_input.previousElementSibling) && (r.classList.contains("active") && o.removeActiveItem(n), o.setActiveItemClass(r)) : o.moveCaret(e));
              }
            }, {
              key: "moveCaret",
              value: function moveCaret(e) {}
            }, {
              key: "getLastActive",
              value: function getLastActive(e) {
                var t = this.control.querySelector(".last-active");
                if (t) return t;
                var n = this.control.querySelectorAll(".active");
                return n ? D(n, e) : void 0;
              }
            }, {
              key: "setCaret",
              value: function setCaret(e) {
                this.caretPos = this.items.length;
              }
            }, {
              key: "controlChildren",
              value: function controlChildren() {
                return Array.from(this.control.querySelectorAll("[data-ts-item]"));
              }
            }, {
              key: "lock",
              value: function lock() {
                this.isLocked = !0, this.refreshState();
              }
            }, {
              key: "unlock",
              value: function unlock() {
                this.isLocked = !1, this.refreshState();
              }
            }, {
              key: "disable",
              value: function disable() {
                var e = this;
                e.input.disabled = !0, e.control_input.disabled = !0, e.focus_node.tabIndex = -1, e.isDisabled = !0, this.close(), e.lock();
              }
            }, {
              key: "enable",
              value: function enable() {
                var e = this;
                e.input.disabled = !1, e.control_input.disabled = !1, e.focus_node.tabIndex = e.tabIndex, e.isDisabled = !1, e.unlock();
              }
            }, {
              key: "destroy",
              value: function destroy() {
                var e = this,
                    t = e.revertSettings;
                e.trigger("destroy"), e.off(), e.wrapper.remove(), e.dropdown.remove(), e.input.innerHTML = t.innerHTML, e.input.tabIndex = t.tabIndex, k(e.input, "tomselected", "ts-hidden-accessible"), e._destroy(), delete e.input.tomselect;
              }
            }, {
              key: "render",
              value: function render(e, t) {
                return "function" != typeof this.settings.render[e] ? null : this._render(e, t);
              }
            }, {
              key: "_render",
              value: function _render(e, t) {
                var n,
                    r,
                    o = "";
                var i = this;
                return "option" !== e && "item" != e || (o = B(t[i.settings.valueField])), null == (r = i.settings.render[e].call(this, t, H)) || (r = E(r), "option" === e || "option_create" === e ? t[i.settings.disabledField] ? A(r, {
                  "aria-disabled": "true"
                }) : A(r, {
                  "data-selectable": ""
                }) : "optgroup" === e && (n = t.group[i.settings.optgroupValueField], A(r, {
                  "data-group": n
                }), t.group[i.settings.disabledField] && A(r, {
                  "data-disabled": ""
                })), "option" !== e && "item" !== e || (A(r, {
                  "data-value": o
                }), "item" === e ? (C(r, i.settings.itemClass), A(r, {
                  "data-ts-item": ""
                })) : (C(r, i.settings.optionClass), A(r, {
                  role: "option",
                  id: t.$id
                }), i.options[o].$div = r))), r;
              }
            }, {
              key: "clearCache",
              value: function clearCache() {
                b(this.options, function (e, t) {
                  e.$div && (e.$div.remove(), delete e.$div);
                });
              }
            }, {
              key: "uncacheValue",
              value: function uncacheValue(e) {
                var t = this.getOption(e);
                t && t.remove();
              }
            }, {
              key: "canCreate",
              value: function canCreate(e) {
                return this.settings.create && e.length > 0 && this.settings.createFilter.call(this, e);
              }
            }, {
              key: "hook",
              value: function hook(e, t, n) {
                var r = this,
                    o = r[t];

                r[t] = function () {
                  var t, i;
                  return "after" === e && (t = o.apply(r, arguments)), i = n.apply(r, arguments), "instead" === e ? i : ("before" === e && (t = o.apply(r, arguments)), t);
                };
              }
            }]);

            return J;
          }(function (e) {
            return e.plugins = {}, /*#__PURE__*/function (_e43) {
              _inherits(_class9, _e43);

              var _super66 = _createSuper(_class9);

              function _class9() {
                var _this108;

                _classCallCheck(this, _class9);

                for (var _len22 = arguments.length, e = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
                  e[_key22] = arguments[_key22];
                }

                _this108 = _super66.call.apply(_super66, [this].concat(e)), _this108.plugins = {
                  names: [],
                  settings: {},
                  requested: {},
                  loaded: {}
                };
                return _this108;
              }

              _createClass(_class9, [{
                key: "initializePlugins",
                value: function initializePlugins(e) {
                  var t, n;
                  var r = this,
                      o = [];
                  if (Array.isArray(e)) e.forEach(function (e) {
                    "string" == typeof e ? o.push(e) : (r.plugins.settings[e.name] = e.options, o.push(e.name));
                  });else if (e) for (t in e) {
                    e.hasOwnProperty(t) && (r.plugins.settings[t] = e[t], o.push(t));
                  }

                  for (; n = o.shift();) {
                    r.require(n);
                  }
                }
              }, {
                key: "loadPlugin",
                value: function loadPlugin(t) {
                  var n = this,
                      r = n.plugins,
                      o = e.plugins[t];
                  if (!e.plugins.hasOwnProperty(t)) throw new Error('Unable to find "' + t + '" plugin');
                  r.requested[t] = !0, r.loaded[t] = o.fn.apply(n, [n.plugins.settings[t] || {}]), r.names.push(t);
                }
              }, {
                key: "require",
                value: function require(e) {
                  var t = this,
                      n = t.plugins;

                  if (!t.plugins.loaded.hasOwnProperty(e)) {
                    if (n.requested[e]) throw new Error('Plugin has circular dependency ("' + e + '")');
                    t.loadPlugin(e);
                  }

                  return n.loaded[e];
                }
              }], [{
                key: "define",
                value: function define(t, n) {
                  e.plugins[t] = {
                    name: t,
                    fn: n
                  };
                }
              }]);

              return _class9;
            }(e);
          }(t));

          return J.define("change_listener", function () {
            var _this109 = this;

            q(this.input, "change", function () {
              _this109.sync();
            });
          }), J.define("checkbox_options", function () {
            var e = this,
                t = e.onOptionSelect;
            e.settings.hideSelected = !1;

            var n = function n(e) {
              setTimeout(function () {
                var t = e.querySelector("input");
                t instanceof HTMLInputElement && (e.classList.contains("selected") ? t.checked = !0 : t.checked = !1);
              }, 1);
            };

            e.hook("after", "setupTemplates", function () {
              var t = e.settings.render.option;

              e.settings.render.option = function (n, r) {
                var o = E(t.call(e, n, r)),
                    i = document.createElement("input");
                i.addEventListener("click", function (e) {
                  Y(e);
                }), i.type = "checkbox";
                var s = N(n[e.settings.valueField]);
                return s && e.items.indexOf(s) > -1 && (i.checked = !0), o.prepend(i), o;
              };
            }), e.on("item_remove", function (t) {
              var r = e.getOption(t);
              r && (r.classList.remove("selected"), n(r));
            }), e.on("item_add", function (t) {
              var r = e.getOption(t);
              r && n(r);
            }), e.hook("instead", "onOptionSelect", function (r, o) {
              if (o.classList.contains("selected")) return o.classList.remove("selected"), e.removeItem(o.dataset.value), e.refreshOptions(), void Y(r, !0);
              t.call(e, r, o), n(o);
            });
          }), J.define("clear_button", function (e) {
            var t = this,
                n = Object.assign({
              className: "clear-button",
              title: "Clear All",
              html: function html(e) {
                return "<div class=\"".concat(e.className, "\" title=\"").concat(e.title, "\">&times;</div>");
              }
            }, e);
            t.on("initialize", function () {
              var e = E(n.html(n));
              e.addEventListener("click", function (e) {
                t.isDisabled || (t.clear(), "single" === t.settings.mode && t.settings.allowEmptyOption && t.addItem(""), e.preventDefault(), e.stopPropagation());
              }), t.control.appendChild(e);
            });
          }), J.define("drag_drop", function () {
            var e = this;
            if (!$.fn.sortable) throw new Error('The "drag_drop" plugin requires jQuery UI "sortable".');

            if ("multi" === e.settings.mode) {
              var t = e.lock,
                  n = e.unlock;
              e.hook("instead", "lock", function () {
                var n = $(e.control).data("sortable");
                return n && n.disable(), t.call(e);
              }), e.hook("instead", "unlock", function () {
                var t = $(e.control).data("sortable");
                return t && t.enable(), n.call(e);
              }), e.on("initialize", function () {
                var t = $(e.control).sortable({
                  items: "[data-value]",
                  forcePlaceholderSize: !0,
                  disabled: e.isLocked,
                  start: function start(e, n) {
                    n.placeholder.css("width", n.helper.css("width")), t.css({
                      overflow: "visible"
                    });
                  },
                  stop: function stop() {
                    t.css({
                      overflow: "hidden"
                    });
                    var n = [];
                    t.children("[data-value]").each(function () {
                      this.dataset.value && n.push(this.dataset.value);
                    }), e.setValue(n);
                  }
                });
              });
            }
          }), J.define("dropdown_header", function (e) {
            var t = this,
                n = Object.assign({
              title: "Untitled",
              headerClass: "dropdown-header",
              titleRowClass: "dropdown-header-title",
              labelClass: "dropdown-header-label",
              closeClass: "dropdown-header-close",
              html: function html(e) {
                return '<div class="' + e.headerClass + '"><div class="' + e.titleRowClass + '"><span class="' + e.labelClass + '">' + e.title + '</span><a class="' + e.closeClass + '">&times;</a></div></div>';
              }
            }, e);
            t.on("initialize", function () {
              var e = E(n.html(n)),
                  r = e.querySelector("." + n.closeClass);
              r && r.addEventListener("click", function (e) {
                Y(e, !0), t.close();
              }), t.dropdown.insertBefore(e, t.dropdown.firstChild);
            });
          }), J.define("caret_position", function () {
            var e = this;
            e.hook("instead", "setCaret", function (t) {
              "single" !== e.settings.mode && e.control.contains(e.control_input) ? (t = Math.max(0, Math.min(e.items.length, t))) == e.caretPos || e.isPending || e.controlChildren().forEach(function (n, r) {
                r < t ? e.control_input.insertAdjacentElement("beforebegin", n) : e.control.appendChild(n);
              }) : t = e.items.length, e.caretPos = t;
            }), e.hook("instead", "moveCaret", function (t) {
              if (!e.isFocused) return;
              var n = e.getLastActive(t);

              if (n) {
                var _r26 = M(n);

                e.setCaret(t > 0 ? _r26 + 1 : _r26), e.setActiveItem(), k(n, "last-active");
              } else e.setCaret(e.caretPos + t);
            });
          }), J.define("dropdown_input", function () {
            var e = this;
            e.settings.shouldOpen = !0, e.hook("before", "setup", function () {
              e.focus_node = e.control, C(e.control_input, "dropdown-input");
              var t = E('<div class="dropdown-input-wrap">');
              t.append(e.control_input), e.dropdown.insertBefore(t, e.dropdown.firstChild);
              var n = E('<input class="items-placeholder" tabindex="-1" />');
              n.placeholder = e.settings.placeholder || "", e.control.append(n);
            }), e.on("initialize", function () {
              e.control_input.addEventListener("keydown", function (t) {
                switch (t.keyCode) {
                  case 27:
                    return e.isOpen && (Y(t, !0), e.close()), void e.clearActiveItems();

                  case 9:
                    e.focus_node.tabIndex = -1;
                }

                return e.onKeyDown.call(e, t);
              }), e.on("blur", function () {
                e.focus_node.tabIndex = e.isDisabled ? -1 : e.tabIndex;
              }), e.on("dropdown_open", function () {
                e.control_input.focus();
              });
              var t = e.onBlur;
              e.hook("instead", "onBlur", function (n) {
                if (!n || n.relatedTarget != e.control_input) return t.call(e);
              }), q(e.control_input, "blur", function () {
                return e.onBlur();
              }), e.hook("before", "close", function () {
                e.isOpen && e.focus_node.focus({
                  preventScroll: !0
                });
              });
            });
          }), J.define("input_autogrow", function () {
            var e = this;
            e.on("initialize", function () {
              var t = document.createElement("span"),
                  n = e.control_input;
              t.style.cssText = "position:absolute; top:-99999px; left:-99999px; width:auto; padding:0; white-space:pre; ", e.wrapper.appendChild(t);

              for (var _i48 = 0, _arr4 = ["letterSpacing", "fontSize", "fontFamily", "fontWeight", "textTransform"]; _i48 < _arr4.length; _i48++) {
                var _e44 = _arr4[_i48];
                t.style[_e44] = n.style[_e44];
              }

              var r = function r() {
                t.textContent = n.value, n.style.width = t.clientWidth + "px";
              };

              r(), e.on("update item_add item_remove", r), q(n, "input", r), q(n, "keyup", r), q(n, "blur", r), q(n, "update", r);
            });
          }), J.define("no_backspace_delete", function () {
            var e = this,
                t = e.deleteSelection;
            this.hook("instead", "deleteSelection", function (n) {
              return !!e.activeItems.length && t.call(e, n);
            });
          }), J.define("no_active_items", function () {
            this.hook("instead", "setActiveItem", function () {}), this.hook("instead", "selectAll", function () {});
          }), J.define("optgroup_columns", function () {
            var e = this,
                t = e.onKeyDown;
            e.hook("instead", "onKeyDown", function (n) {
              var r, o, i, s;
              if (!e.isOpen || 37 !== n.keyCode && 39 !== n.keyCode) return t.call(e, n);
              e.ignoreHover = !0, s = T(e.activeOption, "[data-group]"), r = M(e.activeOption, "[data-selectable]"), s && (s = 37 === n.keyCode ? s.previousSibling : s.nextSibling) && (o = (i = s.querySelectorAll("[data-selectable]"))[Math.min(i.length - 1, r)]) && e.setActiveOption(o);
            });
          }), J.define("remove_button", function (e) {
            var t = Object.assign({
              label: "&times;",
              title: "Remove",
              className: "remove",
              append: !0
            }, e);
            var n = this;

            if (t.append) {
              var r = '<a href="javascript:void(0)" class="' + t.className + '" tabindex="-1" title="' + H(t.title) + '">' + t.label + "</a>";
              n.hook("after", "setupTemplates", function () {
                var e = n.settings.render.item;

                n.settings.render.item = function (t, o) {
                  var i = E(e.call(n, t, o)),
                      s = E(r);
                  return i.appendChild(s), q(s, "mousedown", function (e) {
                    Y(e, !0);
                  }), q(s, "click", function (e) {
                    Y(e, !0), n.isLocked || n.shouldDelete([i], e) && (n.removeItem(i), n.refreshOptions(!1), n.inputState());
                  }), i;
                };
              });
            }
          }), J.define("restore_on_backspace", function (e) {
            var t = this,
                n = Object.assign({
              text: function text(e) {
                return e[t.settings.labelField];
              }
            }, e);
            t.on("item_remove", function (e) {
              if (t.isFocused && "" === t.control_input.value.trim()) {
                var r = t.options[e];
                r && t.setTextboxValue(n.text.call(t, r));
              }
            });
          }), J.define("virtual_scroll", function () {
            var e = this,
                t = e.canLoad,
                n = e.clearActiveOption,
                r = e.loadCallback;
            var o,
                i,
                s = {},
                a = !1,
                l = [];
            if (e.settings.shouldLoadMore || (e.settings.shouldLoadMore = function () {
              if (o.clientHeight / (o.scrollHeight - o.scrollTop) > .9) return !0;

              if (e.activeOption) {
                var t = e.selectable();
                if (_toConsumableArray(t).indexOf(e.activeOption) >= t.length - 2) return !0;
              }

              return !1;
            }), !e.settings.firstUrl) throw "virtual_scroll plugin requires a firstUrl() method";
            e.settings.sortField = [{
              field: "$order"
            }, {
              field: "$score"
            }];

            var c = function c(t) {
              return !("number" == typeof e.settings.maxOptions && o.children.length >= e.settings.maxOptions || !(t in s) || !s[t]);
            },
                u = function u(t, n) {
              return e.items.indexOf(n) >= 0 || l.indexOf(n) >= 0;
            };

            e.setNextUrl = function (e, t) {
              s[e] = t;
            }, e.getUrl = function (t) {
              if (t in s) {
                var _e45 = s[t];
                return s[t] = !1, _e45;
              }

              return s = {}, e.settings.firstUrl.call(e, t);
            }, e.hook("instead", "clearActiveOption", function () {
              if (!a) return n.call(e);
            }), e.hook("instead", "canLoad", function (n) {
              return n in s ? c(n) : t.call(e, n);
            }), e.hook("instead", "loadCallback", function (t, n) {
              a ? i && t.length > 0 && (i.dataset.value = t[0][e.settings.valueField]) : e.clearOptions(u), r.call(e, t, n), a = !1;
            }), e.hook("after", "refreshOptions", function () {
              var t = e.lastValue;
              var n;
              c(t) ? (n = e.render("loading_more", {
                query: t
              })) && (n.setAttribute("data-selectable", ""), i = n) : t in s && !o.querySelector(".no-results") && (n = e.render("no_more_results", {
                query: t
              })), n && (C(n, e.settings.optionClass), o.append(n));
            }), e.on("initialize", function () {
              l = Object.keys(e.options), o = e.dropdown_content, e.settings.render = Object.assign({}, {
                loading_more: function loading_more() {
                  return '<div class="loading-more-results">Loading more results ... </div>';
                },
                no_more_results: function no_more_results() {
                  return '<div class="no-more-results">No more results</div>';
                }
              }, e.settings.render), o.addEventListener("scroll", function () {
                e.settings.shouldLoadMore.call(e) && c(e.lastValue) && (a || (a = !0, e.load.call(e, e.lastValue)));
              });
            });
          }), J;
        }();
      },
      1196: function _(e) {
        "use strict";

        function t(e, t) {
          this.text = e = e || "", this.hasWild = ~e.indexOf("*"), this.separator = t, this.parts = e.split(t);
        }

        t.prototype.match = function (e) {
          var t,
              n,
              r = !0,
              o = this.parts,
              i = o.length;
          if ("string" == typeof e || e instanceof String) {
            if (this.hasWild || this.text == e) {
              for (n = (e || "").split(this.separator), t = 0; r && t < i; t++) {
                "*" !== o[t] && (r = t < n.length && o[t] === n[t]);
              }

              r = r && n;
            } else r = !1;
          } else if ("function" == typeof e.splice) for (r = [], t = e.length; t--;) {
            this.match(e[t]) && (r[r.length] = e[t]);
          } else if ("object" == _typeof(e)) for (var s in r = {}, e) {
            this.match(s) && (r[s] = e[s]);
          }
          return r;
        }, e.exports = function (e, n, r) {
          var o = new t(e, r || /[\/\.]/);
          return void 0 !== n ? o.match(n) : o;
        };
      },
      321: function _(e, t, n) {
        var r = {
          "./apparatus/attachment_component_controller.js": 9334,
          "./apparatus/attachment_list_block/search_component_controller.js": 1906,
          "./apparatus/attachments/attachment_selector_component/attachments_component_controller.js": 1261,
          "./apparatus/attachments/attachment_selector_component/search_component_controller.js": 8831,
          "./apparatus/attachments/attachment_selector_component_controller.js": 1795,
          "./apparatus/blocks/editor_component_controller.js": 7057,
          "./apparatus/dialog_loader_controller.js": 7823,
          "./apparatus/draft_component_controller.js": 2365,
          "./apparatus/drafts/block_composer_component_controller.js": 2359,
          "./apparatus/infinite_scroll_controller.js": 6963,
          "./apparatus/pages/visibility_switch_component_controller.js": 4929,
          "./apparatus/roles/permissions_table_section_component_controller.js": 7142,
          "./apparatus/ui/dialog_component_controller.js": 8307,
          "./apparatus/ui/dropdown_component_controller.js": 53,
          "./apparatus/ui/flash_component_controller.js": 5191,
          "./apparatus/ui/page_tree_component/node_component_controller.js": 2763,
          "./apparatus/ui/search_field_component_controller.js": 476,
          "./apparatus/ui/warning_component_controller.js": 5027,
          "./attachment_list_block_controller.js": 7504,
          "./attachment_uploader/attachments_list_component_controller.js": 9799,
          "./attachment_uploader_component_controller.js": 2595,
          "./autogrow_input_controller.js": 941,
          "./autogrow_text_input_controller.js": 623,
          "./block/destroy_button_controller.js": 2427,
          "./block/edit_button_controller.js": 3012,
          "./block_type_select_input_controller.js": 2207,
          "./date_time_picker_controller.js": 302,
          "./filterable_select_input_controller.js": 9980,
          "./inputs/block_width_controller.js": 8401,
          "./inputs/column_width_controller.js": 7686,
          "./lazy_loading_controller.js": 6179,
          "./markdown_input_controller.js": 5534,
          "./page/visibility_toggle_controller.js": 5386,
          "./page_selector_input_controller.js": 3142,
          "./remote_controller.js": 4083,
          "./resource_block/crud_component_controller.js": 5775,
          "./simple_form_dependent_fields_controller.js": 8013,
          "./simple_form_nested_fields_controller.js": 5428,
          "./sortable_association_input_controller.js": 593,
          "./sortable_controller.js": 4734,
          "./toggle_controller.js": 3708,
          "./toolbar_block/page_path_component/locale_component_controller.js": 3248,
          "./toolbar_block/page_path_component/permalink_component_controller.js": 8963,
          "./toolbar_block_component_controller.js": 1555,
          "./toolbar_block_controller.js": 9303
        };

        function o(e) {
          var t = i(e);
          return n(t);
        }

        function i(e) {
          if (!n.o(r, e)) {
            var t = new Error("Cannot find module '" + e + "'");
            throw t.code = "MODULE_NOT_FOUND", t;
          }

          return r[e];
        }

        o.keys = function () {
          return Object.keys(r);
        }, o.resolve = i, e.exports = o, o.id = 321;
      },
      3370: function _(e) {
        "use strict";

        var t = /*#__PURE__*/function (_Error) {
          _inherits(t, _Error);

          var _super67 = _createSuper(t);

          function t() {
            var _this110;

            _classCallCheck(this, t);

            _this110 = _super67.call(this, "Authorization required"), _this110.name = "AuthError", _this110.isAuthError = !0;
            return _this110;
          }

          return t;
        }( /*#__PURE__*/_wrapNativeSuper(Error));

        e.exports = t;
      },
      4125: function _(e, t, n) {
        "use strict";

        var r = n(5421);
        var o = n(5189);

        e.exports = /*#__PURE__*/function (_o15) {
          _inherits(_class10, _o15);

          var _super68 = _createSuper(_class10);

          function _class10(e, t) {
            var _this111;

            _classCallCheck(this, _class10);

            _this111 = _super68.call(this, e, t), _this111.provider = t.provider, _this111.id = _this111.provider, _this111.name = _this111.opts.name || _this111.id.split("-").map(function (e) {
              return e.charAt(0).toUpperCase() + e.slice(1);
            }).join(" "), _this111.pluginId = _this111.opts.pluginId, _this111.tokenKey = "companion-".concat(_this111.pluginId, "-auth-token"), _this111.companionKeysParams = _this111.opts.companionKeysParams, _this111.preAuthToken = null;
            return _this111;
          }

          _createClass(_class10, [{
            key: "headers",
            value: function headers() {
              var _this112 = this;

              return Promise.all([_get(_getPrototypeOf(_class10.prototype), "headers", this).call(this), this.getAuthToken()]).then(function (e) {
                var _e46 = _slicedToArray(e, 2),
                    t = _e46[0],
                    n = _e46[1];

                var r = {};
                return n && (r["uppy-auth-token"] = n), _this112.companionKeysParams && (r["uppy-credentials-params"] = btoa(JSON.stringify({
                  params: _this112.companionKeysParams
                }))), _objectSpread(_objectSpread({}, t), r);
              });
            }
          }, {
            key: "onReceiveResponse",
            value: function onReceiveResponse(e) {
              e = _get(_getPrototypeOf(_class10.prototype), "onReceiveResponse", this).call(this, e);
              var t = this.uppy.getPlugin(this.pluginId),
                  n = t.getPluginState().authenticated ? 401 !== e.status : e.status < 400;
              return t.setPluginState({
                authenticated: n
              }), e;
            }
          }, {
            key: "setAuthToken",
            value: function setAuthToken(e) {
              return this.uppy.getPlugin(this.pluginId).storage.setItem(this.tokenKey, e);
            }
          }, {
            key: "getAuthToken",
            value: function getAuthToken() {
              return this.uppy.getPlugin(this.pluginId).storage.getItem(this.tokenKey);
            }
          }, {
            key: "ensurePreAuth",
            value: function () {
              var _ensurePreAuth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        _context8.t0 = this.companionKeysParams && !this.preAuthToken;

                        if (!_context8.t0) {
                          _context8.next = 5;
                          break;
                        }

                        _context8.next = 4;
                        return this.fetchPreAuthToken();

                      case 4:
                        _context8.t0 = !this.preAuthToken;

                      case 5:
                        if (!_context8.t0) {
                          _context8.next = 7;
                          break;
                        }

                        throw new Error("Could not load authentication data required for third-party login. Please try again later.");

                      case 7:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee8, this);
              }));

              function ensurePreAuth() {
                return _ensurePreAuth.apply(this, arguments);
              }

              return ensurePreAuth;
            }()
          }, {
            key: "authUrl",
            value: function authUrl(e) {
              void 0 === e && (e = {});
              var t = new URLSearchParams(e);
              return this.preAuthToken && t.set("uppyPreAuthToken", this.preAuthToken), "".concat(this.hostname, "/").concat(this.id, "/connect?").concat(t);
            }
          }, {
            key: "fileUrl",
            value: function fileUrl(e) {
              return "".concat(this.hostname, "/").concat(this.id, "/get/").concat(e);
            }
          }, {
            key: "fetchPreAuthToken",
            value: function () {
              var _fetchPreAuthToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
                var _e47;

                return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        if (!this.companionKeysParams) {
                          _context9.next = 11;
                          break;
                        }

                        _context9.prev = 1;
                        _context9.next = 4;
                        return this.post("".concat(this.id, "/preauth/"), {
                          params: this.companionKeysParams
                        });

                      case 4:
                        _e47 = _context9.sent;
                        this.preAuthToken = _e47.token;
                        _context9.next = 11;
                        break;

                      case 8:
                        _context9.prev = 8;
                        _context9.t0 = _context9["catch"](1);
                        this.uppy.log("[CompanionClient] unable to fetch preAuthToken ".concat(_context9.t0), "warning");

                      case 11:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee9, this, [[1, 8]]);
              }));

              function fetchPreAuthToken() {
                return _fetchPreAuthToken.apply(this, arguments);
              }

              return fetchPreAuthToken;
            }()
          }, {
            key: "list",
            value: function list(e) {
              return this.get("".concat(this.id, "/list/").concat(e || ""));
            }
          }, {
            key: "logout",
            value: function logout() {
              var _this113 = this;

              return this.get("".concat(this.id, "/logout")).then(function (e) {
                return Promise.all([e, _this113.uppy.getPlugin(_this113.pluginId).storage.removeItem(_this113.tokenKey)]);
              }).then(function (e) {
                var _e48 = _slicedToArray(e, 1),
                    t = _e48[0];

                return t;
              });
            }
          }], [{
            key: "initPlugin",
            value: function initPlugin(e, t, n) {
              if (e.type = "acquirer", e.files = [], n && (e.opts = _objectSpread(_objectSpread({}, n), t)), t.serverUrl || t.serverPattern) throw new Error("`serverUrl` and `serverPattern` have been renamed to `companionUrl` and `companionAllowedHosts` respectively in the 0.30.5 release. Please consult the docs (for example, https://uppy.io/docs/instagram/ for the Instagram plugin) and use the updated options.`");

              if (t.companionAllowedHosts) {
                var _n25 = t.companionAllowedHosts;
                if (!("string" == typeof _n25 || Array.isArray(_n25) || _n25 instanceof RegExp)) throw new TypeError("".concat(e.id, ": the option \"companionAllowedHosts\" must be one of string, Array, RegExp"));
                e.opts.companionAllowedHosts = _n25;
              } else /^(?!https?:\/\/).*$/i.test(t.companionUrl) ? e.opts.companionAllowedHosts = "https://".concat(t.companionUrl.replace(/^\/\//, "")) : e.opts.companionAllowedHosts = new URL(t.companionUrl).origin;

              e.storage = e.opts.storage || r;
            }
          }]);

          return _class10;
        }(o);
      },
      5189: function _(e, t, n) {
        "use strict";

        var r;

        function o(e, t) {
          if (!Object.prototype.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
          return e;
        }

        var i = 0;

        function s(e) {
          return "__private_" + i++ + "_" + e;
        }

        var a = n(104),
            l = n(8391),
            c = n(3370);

        function u(_x7) {
          return _u.apply(this, arguments);
        }

        function _u() {
          _u = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(e) {
            var t, _n26, _e50;

            return _regeneratorRuntime.wrap(function _callee10$(_context10) {
              while (1) {
                switch (_context10.prev = _context10.next) {
                  case 0:
                    if (!(401 === e.status)) {
                      _context10.next = 2;
                      break;
                    }

                    throw new c();

                  case 2:
                    t = e.json();

                    if (!(e.status < 200 || e.status > 300)) {
                      _context10.next = 13;
                      break;
                    }

                    _n26 = "Failed request with status: ".concat(e.status, ". ").concat(e.statusText);
                    _context10.prev = 5;
                    _context10.next = 8;
                    return t;

                  case 8:
                    _e50 = _context10.sent;
                    _n26 = _e50.message ? "".concat(_n26, " message: ").concat(_e50.message) : _n26, _n26 = _e50.requestId ? "".concat(_n26, " request-Id: ").concat(_e50.requestId) : _n26;

                  case 10:
                    _context10.prev = 10;
                    throw new Error(_n26);

                  case 13:
                    return _context10.abrupt("return", t);

                  case 14:
                  case "end":
                    return _context10.stop();
                }
              }
            }, _callee10, null, [[5,, 10, 13]]);
          }));
          return _u.apply(this, arguments);
        }

        var d = s("companionHeaders"),
            h = s("getPostResponseFunc"),
            f = s("getUrl"),
            p = s("errorHandler");
        r = Symbol.for("uppy test: getCompanionHeaders");

        var g = /*#__PURE__*/function (_r27) {
          function g(e, t) {
            var _this114 = this;

            _classCallCheck(this, g);

            Object.defineProperty(this, p, {
              value: v
            }), Object.defineProperty(this, f, {
              value: m
            }), Object.defineProperty(this, d, {
              writable: !0,
              value: void 0
            }), Object.defineProperty(this, h, {
              writable: !0,
              value: function value(e) {
                return function (t) {
                  return e ? t : _this114.onReceiveResponse(t);
                };
              }
            }), this.uppy = e, this.opts = t, this.onReceiveResponse = this.onReceiveResponse.bind(this), this.allowedHeaders = ["accept", "content-type", "uppy-auth-token"], this.preflightDone = !1, o(this, d)[d] = null == t ? void 0 : t.companionHeaders;
          }

          _createClass(g, [{
            key: "setCompanionHeaders",
            value: function setCompanionHeaders(e) {
              o(this, d)[d] = e;
            }
          }, {
            key: _r27,
            value: function value() {
              return o(this, d)[d];
            }
          }, {
            key: "hostname",
            get: function get() {
              var _this$uppy$getState = this.uppy.getState(),
                  e = _this$uppy$getState.companion,
                  t = this.opts.companionUrl;

              return (e && e[t] ? e[t] : t).replace(/\/$/, "");
            }
          }, {
            key: "headers",
            value: function headers() {
              return Promise.resolve(_objectSpread(_objectSpread({}, g.defaultHeaders), o(this, d)[d]));
            }
          }, {
            key: "onReceiveResponse",
            value: function onReceiveResponse(e) {
              var t = this.uppy.getState().companion || {},
                  n = this.opts.companionUrl,
                  r = e.headers;
              return r.has("i-am") && r.get("i-am") !== t[n] && this.uppy.setState({
                companion: _objectSpread(_objectSpread({}, t), {}, _defineProperty({}, n, r.get("i-am")))
              }), e;
            }
          }, {
            key: "preflight",
            value: function preflight(e) {
              var _this115 = this;

              return this.preflightDone ? Promise.resolve(this.allowedHeaders.slice()) : fetch(o(this, f)[f](e), {
                method: "OPTIONS"
              }).then(function (e) {
                return e.headers.has("access-control-allow-headers") && (_this115.allowedHeaders = e.headers.get("access-control-allow-headers").split(",").map(function (e) {
                  return e.trim().toLowerCase();
                })), _this115.preflightDone = !0, _this115.allowedHeaders.slice();
              }).catch(function (e) {
                return _this115.uppy.log("[CompanionClient] unable to make preflight request ".concat(e), "warning"), _this115.preflightDone = !0, _this115.allowedHeaders.slice();
              });
            }
          }, {
            key: "preflightAndHeaders",
            value: function preflightAndHeaders(e) {
              var _this116 = this;

              return Promise.all([this.preflight(e), this.headers()]).then(function (e) {
                var _e49 = _slicedToArray(e, 2),
                    t = _e49[0],
                    n = _e49[1];

                return Object.keys(n).forEach(function (e) {
                  t.includes(e.toLowerCase()) || (_this116.uppy.log("[CompanionClient] excluding disallowed header ".concat(e)), delete n[e]);
                }), n;
              });
            }
          }, {
            key: "get",
            value: function get(e, t) {
              var _this117 = this;

              return this.preflightAndHeaders(e).then(function (t) {
                return a(o(_this117, f)[f](e), {
                  method: "get",
                  headers: t,
                  credentials: _this117.opts.companionCookiesRule || "same-origin"
                });
              }).then(o(this, h)[h](t)).then(u).catch(o(this, p)[p]("get", e));
            }
          }, {
            key: "post",
            value: function post(e, t, n) {
              var _this118 = this;

              var r = "post";
              return this.preflightAndHeaders(e).then(function (n) {
                return a(o(_this118, f)[f](e), {
                  method: r,
                  headers: n,
                  credentials: _this118.opts.companionCookiesRule || "same-origin",
                  body: JSON.stringify(t)
                });
              }).then(o(this, h)[h](n)).then(u).catch(o(this, p)[p](r, e));
            }
          }, {
            key: "delete",
            value: function _delete(e, t, n) {
              var _this119 = this;

              var r = "delete";
              return this.preflightAndHeaders(e).then(function (n) {
                return a("".concat(_this119.hostname, "/").concat(e), {
                  method: r,
                  headers: n,
                  credentials: _this119.opts.companionCookiesRule || "same-origin",
                  body: t ? JSON.stringify(t) : null
                });
              }).then(o(this, h)[h](n)).then(u).catch(o(this, p)[p](r, e));
            }
          }]);

          return g;
        }(r);

        function m(e) {
          return /^(https?:|)\/\//.test(e) ? e : "".concat(this.hostname, "/").concat(e);
        }

        function v(e, t) {
          var _this120 = this;

          return function (n) {
            var r;
            return null != (r = n) && r.isAuthError || (n = new l("Could not ".concat(e, " ").concat(o(_this120, f)[f](t)), {
              cause: n
            })), Promise.reject(n);
          };
        }

        g.VERSION = "2.2.1", g.defaultHeaders = {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Uppy-Versions": "@uppy/companion-client=".concat(g.VERSION)
        }, e.exports = g;
      },
      1863: function _(e, t, n) {
        "use strict";

        var r = n(5189);

        e.exports = /*#__PURE__*/function (_r28) {
          _inherits(_class11, _r28);

          var _super69 = _createSuper(_class11);

          function _class11(e, t) {
            var _this121;

            _classCallCheck(this, _class11);

            _this121 = _super69.call(this, e, t), _this121.provider = t.provider, _this121.id = _this121.provider, _this121.name = _this121.opts.name || _this121.id.split("-").map(function (e) {
              return e.charAt(0).toUpperCase() + e.slice(1);
            }).join(" "), _this121.pluginId = _this121.opts.pluginId;
            return _this121;
          }

          _createClass(_class11, [{
            key: "fileUrl",
            value: function fileUrl(e) {
              return "".concat(this.hostname, "/search/").concat(this.id, "/get/").concat(e);
            }
          }, {
            key: "search",
            value: function search(e, t) {
              return this.get("search/".concat(this.id, "/list?q=").concat(encodeURIComponent(e)).concat(t ? "&".concat(t) : ""));
            }
          }]);

          return _class11;
        }(r);
      },
      773: function _(e, t, n) {
        "use strict";

        var r, o;

        function i(e, t) {
          if (!Object.prototype.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
          return e;
        }

        var s = 0;

        function a(e) {
          return "__private_" + s++ + "_" + e;
        }

        var l = n(4800);
        var c = a("queued"),
            u = a("emitter"),
            d = a("isOpen"),
            h = a("socket"),
            f = a("handleMessage");
        r = Symbol.for("uppy test: getSocket"), o = Symbol.for("uppy test: getQueued"), e.exports = /*#__PURE__*/function (_r29, _o16) {
          function _class12(e) {
            var _this122 = this;

            _classCallCheck(this, _class12);

            Object.defineProperty(this, c, {
              writable: !0,
              value: []
            }), Object.defineProperty(this, u, {
              writable: !0,
              value: l()
            }), Object.defineProperty(this, d, {
              writable: !0,
              value: !1
            }), Object.defineProperty(this, h, {
              writable: !0,
              value: void 0
            }), Object.defineProperty(this, f, {
              writable: !0,
              value: function value(e) {
                try {
                  var _t34 = JSON.parse(e.data);

                  _this122.emit(_t34.action, _t34.payload);
                } catch (e) {
                  console.log(e);
                }
              }
            }), this.opts = e, e && !1 === e.autoOpen || this.open();
          }

          _createClass(_class12, [{
            key: "isOpen",
            get: function get() {
              return i(this, d)[d];
            }
          }, {
            key: _r29,
            value: function value() {
              return i(this, h)[h];
            }
          }, {
            key: _o16,
            value: function value() {
              return i(this, c)[c];
            }
          }, {
            key: "open",
            value: function open() {
              var _this123 = this;

              i(this, h)[h] = new WebSocket(this.opts.target), i(this, h)[h].onopen = function () {
                for (i(_this123, d)[d] = !0; i(_this123, c)[c].length > 0 && i(_this123, d)[d];) {
                  var _e51 = i(_this123, c)[c].shift();

                  _this123.send(_e51.action, _e51.payload);
                }
              }, i(this, h)[h].onclose = function () {
                i(_this123, d)[d] = !1;
              }, i(this, h)[h].onmessage = i(this, f)[f];
            }
          }, {
            key: "close",
            value: function close() {
              var e;
              null == (e = i(this, h)[h]) || e.close();
            }
          }, {
            key: "send",
            value: function send(e, t) {
              i(this, d)[d] ? i(this, h)[h].send(JSON.stringify({
                action: e,
                payload: t
              })) : i(this, c)[c].push({
                action: e,
                payload: t
              });
            }
          }, {
            key: "on",
            value: function on(e, t) {
              i(this, u)[u].on(e, t);
            }
          }, {
            key: "emit",
            value: function emit(e, t) {
              i(this, u)[u].emit(e, t);
            }
          }, {
            key: "once",
            value: function once(e, t) {
              i(this, u)[u].once(e, t);
            }
          }]);

          return _class12;
        }(r, o);
      },
      3145: function _(e, t, n) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.Socket = t.SearchProvider = t.RequestClient = t.Provider = void 0;
        var r = n(5189);
        t.RequestClient = r;
        var o = n(4125);
        t.Provider = o;
        var i = n(1863);
        t.SearchProvider = i;
        var s = n(773);
        t.Socket = s;
      },
      5421: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getItem = function (e) {
          return Promise.resolve(localStorage.getItem(e));
        }, t.removeItem = function (e) {
          return new Promise(function (t) {
            localStorage.removeItem(e), t();
          });
        }, t.setItem = function (e, t) {
          return new Promise(function (n) {
            localStorage.setItem(e, t), n();
          });
        };
      },
      3521: function _(e, t, n) {
        "use strict";

        var r = n(3149);

        e.exports = /*#__PURE__*/function () {
          function _class13(e, t) {
            _classCallCheck(this, _class13);

            void 0 === t && (t = {}), this.uppy = e, this.opts = t;
          }

          _createClass(_class13, [{
            key: "getPluginState",
            value: function getPluginState() {
              var _this$uppy$getState2 = this.uppy.getState(),
                  e = _this$uppy$getState2.plugins;

              return e[this.id] || {};
            }
          }, {
            key: "setPluginState",
            value: function setPluginState(e) {
              var _this$uppy$getState3 = this.uppy.getState(),
                  t = _this$uppy$getState3.plugins;

              this.uppy.setState({
                plugins: _objectSpread(_objectSpread({}, t), {}, _defineProperty({}, this.id, _objectSpread(_objectSpread({}, t[this.id]), e)))
              });
            }
          }, {
            key: "setOptions",
            value: function setOptions(e) {
              this.opts = _objectSpread(_objectSpread({}, this.opts), e), this.setPluginState(), this.i18nInit();
            }
          }, {
            key: "i18nInit",
            value: function i18nInit() {
              var e = new r([this.defaultLocale, this.uppy.locale, this.opts.locale]);
              this.i18n = e.translate.bind(e), this.i18nArray = e.translateArray.bind(e), this.setPluginState();
            }
          }, {
            key: "addTarget",
            value: function addTarget() {
              throw new Error("Extend the addTarget method to add your plugin to another plugin's target");
            }
          }, {
            key: "install",
            value: function install() {}
          }, {
            key: "uninstall",
            value: function uninstall() {}
          }, {
            key: "render",
            value: function render() {
              throw new Error("Extend the render method to add your plugin to a DOM element");
            }
          }, {
            key: "update",
            value: function update() {}
          }, {
            key: "afterUpdate",
            value: function afterUpdate() {}
          }]);

          return _class13;
        }();
      },
      9001: function _(e, t, n) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.defaultOptions = t.RestrictionError = t.Restricter = void 0;
        var r = n(5158),
            o = n(4193);
        t.defaultOptions = {
          maxFileSize: null,
          minFileSize: null,
          maxTotalFileSize: null,
          maxNumberOfFiles: null,
          minNumberOfFiles: null,
          allowedFileTypes: null,
          requiredMetaFields: []
        };

        var i = /*#__PURE__*/function (_Error2) {
          _inherits(i, _Error2);

          var _super70 = _createSuper(i);

          function i() {
            var _this124;

            _classCallCheck(this, i);

            _this124 = _super70.apply(this, arguments), _this124.isRestriction = !0;
            return _this124;
          }

          return i;
        }( /*#__PURE__*/_wrapNativeSuper(Error));

        t.RestrictionError = i, "undefined" == typeof AggregateError && (globalThis.AggregateError = /*#__PURE__*/function (_Error3) {
          _inherits(_class14, _Error3);

          var _super71 = _createSuper(_class14);

          function _class14(e, t) {
            var _this125;

            _classCallCheck(this, _class14);

            _this125 = _super71.call(this, t), _this125.errors = e;
            return _this125;
          }

          return _class14;
        }( /*#__PURE__*/_wrapNativeSuper(Error))), t.Restricter = /*#__PURE__*/function () {
          function _class15(e, t) {
            _classCallCheck(this, _class15);

            this.i18n = t, this.getOpts = function () {
              var t = e();
              if (null != t.restrictions.allowedFileTypes && !Array.isArray(t.restrictions.allowedFileTypes)) throw new TypeError("`restrictions.allowedFileTypes` must be an array");
              return t;
            };
          }

          _createClass(_class15, [{
            key: "validate",
            value: function validate(e, t) {
              var _this$getOpts$restric = this.getOpts().restrictions,
                  n = _this$getOpts$restric.maxFileSize,
                  s = _this$getOpts$restric.minFileSize,
                  a = _this$getOpts$restric.maxTotalFileSize,
                  l = _this$getOpts$restric.maxNumberOfFiles,
                  c = _this$getOpts$restric.allowedFileTypes;
              if (l && t.length + 1 > l) throw new i("".concat(this.i18n("youCanOnlyUploadX", {
                smart_count: l
              })));

              if (c && !c.some(function (t) {
                return t.includes("/") ? !!e.type && o(e.type.replace(/;.*?$/, ""), t) : !("." !== t[0] || !e.extension) && e.extension.toLowerCase() === t.slice(1).toLowerCase();
              })) {
                var _e52 = c.join(", ");

                throw new i(this.i18n("youCanOnlyUploadFileTypes", {
                  types: _e52
                }));
              }

              if (a && null != e.size && t.reduce(function (e, t) {
                return e + t.size;
              }, e.size) > a) throw new i(this.i18n("exceedsSize", {
                size: r(a),
                file: e.name
              }));
              if (n && null != e.size && e.size > n) throw new i(this.i18n("exceedsSize", {
                size: r(n),
                file: e.name
              }));
              if (s && null != e.size && e.size < s) throw new i(this.i18n("inferiorSize", {
                size: r(s)
              }));
            }
          }, {
            key: "validateMinNumberOfFiles",
            value: function validateMinNumberOfFiles(e) {
              var t = this.getOpts().restrictions.minNumberOfFiles;
              if (Object.keys(e).length < t) throw new i(this.i18n("youHaveToAtLeastSelectX", {
                smart_count: t
              }));
            }
          }, {
            key: "getMissingRequiredMetaFields",
            value: function getMissingRequiredMetaFields(e) {
              var t = new i(this.i18n("missingRequiredMetaFieldOnFile", {
                fileName: e.name
              })),
                  n = this.getOpts().restrictions.requiredMetaFields,
                  r = Object.prototype.hasOwnProperty,
                  o = [];

              var _iterator16 = _createForOfIteratorHelper(n),
                  _step16;

              try {
                for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                  var _t35 = _step16.value;
                  r.call(e.meta, _t35) && "" !== e.meta[_t35] || o.push(_t35);
                }
              } catch (err) {
                _iterator16.e(err);
              } finally {
                _iterator16.f();
              }

              return {
                missingFields: o,
                error: t
              };
            }
          }]);

          return _class15;
        }();
      },
      2693: function _(e, t, n) {
        "use strict";

        var r = n(6400);

        function o(e, t) {
          if (!Object.prototype.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
          return e;
        }

        var i = 0;

        function s(e) {
          return "__private_" + i++ + "_" + e;
        }

        var a = n(4088),
            l = n(5589),
            c = n(3521);
        var u = s("updateUI");

        var d = /*#__PURE__*/function (_c) {
          _inherits(d, _c);

          var _super72 = _createSuper(d);

          function d() {
            var _this126;

            _classCallCheck(this, d);

            _this126 = _super72.apply(this, arguments), Object.defineProperty(_assertThisInitialized(_this126), u, {
              writable: !0,
              value: void 0
            });
            return _this126;
          }

          _createClass(d, [{
            key: "mount",
            value: function mount(e, t) {
              var _this127 = this;

              var n = t.id,
                  i = a(e);

              if (i) {
                this.isTargetDOMEl = !0;

                var _t36 = document.createElement("div");

                return _t36.classList.add("uppy-Root"), o(this, u)[u] = function (e) {
                  var t = null,
                      n = null;
                  return function () {
                    for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++) {
                      o[i] = arguments[i];
                    }

                    return n = o, t || (t = Promise.resolve().then(function () {
                      return t = null, e.apply(void 0, _toConsumableArray(n));
                    })), t;
                  };
                }(function (e) {
                  _this127.uppy.getPlugin(_this127.id) && ((0, r.render)(_this127.render(e), _t36), _this127.afterUpdate());
                }), this.uppy.log("Installing ".concat(n, " to a DOM element '").concat(e, "'")), this.opts.replaceTargetContent && (i.innerHTML = ""), (0, r.render)(this.render(this.uppy.getState()), _t36), this.el = _t36, i.appendChild(_t36), _t36.dir = this.opts.direction || l(_t36) || "ltr", this.onMount(), this.el;
              }

              var s;
              if ("object" == _typeof(e) && e instanceof d) s = e;else if ("function" == typeof e) {
                var _t37 = e;
                this.uppy.iteratePlugins(function (e) {
                  e instanceof _t37 && (s = e);
                });
              }
              if (s) return this.uppy.log("Installing ".concat(n, " to ").concat(s.id)), this.parent = s, this.el = s.addTarget(t), this.onMount(), this.el;
              this.uppy.log("Not installing ".concat(n));
              var c = "Invalid target option given to ".concat(n, ".");
              throw c += "function" == typeof e ? " The given target is not a Plugin class. Please check that you're not specifying a React Component instead of a plugin. If you are using @uppy/* packages directly, make sure you have only 1 version of @uppy/core installed: run `npm ls @uppy/core` on the command line and verify that all the versions match and are deduped correctly." : "If you meant to target an HTML element, please make sure that the element exists. Check that the <script> tag initializing Uppy is right before the closing </body> tag at the end of the page. (see https://github.com/transloadit/uppy/issues/1042)\n\nIf you meant to target a plugin, please confirm that your `import` statements or `require` calls are correct.", new Error(c);
            }
          }, {
            key: "update",
            value: function update(e) {
              var t, n;
              null != this.el && (null == (t = (n = o(this, u))[u]) || t.call(n, e));
            }
          }, {
            key: "unmount",
            value: function unmount() {
              var e;
              this.isTargetDOMEl && (null == (e = this.el) || e.remove()), this.onUnmount();
            }
          }, {
            key: "onMount",
            value: function onMount() {}
          }, {
            key: "onUnmount",
            value: function onUnmount() {}
          }]);

          return d;
        }(c);

        e.exports = d;
      },
      9069: function _(e, t, n) {
        "use strict";

        var r = n(2961),
            o = n(9721),
            i = n(9001);
        var s, a;

        function l(e, t) {
          if (!Object.prototype.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
          return e;
        }

        var c = 0;

        function u(e) {
          return "__private_" + c++ + "_" + e;
        }

        var d = n(3149),
            h = n(4800),
            f = n(3096),
            p = n(4284),
            g = n(9187),
            m = n(9655),
            v = n(6526),
            y = n(9109),
            b = n(5850),
            w = n(2187);

        var O = u("plugins"),
            E = u("restricter"),
            _ = u("storeUnsubscribe"),
            S = u("emitter"),
            x = u("preProcessors"),
            C = u("uploaders"),
            k = u("postProcessors"),
            P = u("informAndEmit"),
            j = u("checkRequiredMetaFieldsOnFile"),
            T = u("checkRequiredMetaFields"),
            D = u("assertNewUploadAllowed"),
            M = u("checkAndCreateFileStateObject"),
            A = u("startIfAutoProceed"),
            F = u("addListeners"),
            L = u("updateOnlineStatus"),
            I = u("createUpload"),
            R = u("getUpload"),
            N = u("removeUpload"),
            B = u("runUpload");

        s = Symbol.for("uppy test: getPlugins"), a = Symbol.for("uppy test: createUpload");

        var $ = /*#__PURE__*/function (_s5, _a4) {
          function $(e) {
            var _this128 = this;

            _classCallCheck(this, $);

            Object.defineProperty(this, B, {
              value: G
            }), Object.defineProperty(this, N, {
              value: Q
            }), Object.defineProperty(this, R, {
              value: X
            }), Object.defineProperty(this, I, {
              value: K
            }), Object.defineProperty(this, F, {
              value: W
            }), Object.defineProperty(this, A, {
              value: V
            }), Object.defineProperty(this, M, {
              value: q
            }), Object.defineProperty(this, D, {
              value: Y
            }), Object.defineProperty(this, T, {
              value: z
            }), Object.defineProperty(this, j, {
              value: U
            }), Object.defineProperty(this, P, {
              value: H
            }), Object.defineProperty(this, O, {
              writable: !0,
              value: Object.create(null)
            }), Object.defineProperty(this, E, {
              writable: !0,
              value: void 0
            }), Object.defineProperty(this, _, {
              writable: !0,
              value: void 0
            }), Object.defineProperty(this, S, {
              writable: !0,
              value: h()
            }), Object.defineProperty(this, x, {
              writable: !0,
              value: new Set()
            }), Object.defineProperty(this, C, {
              writable: !0,
              value: new Set()
            }), Object.defineProperty(this, k, {
              writable: !0,
              value: new Set()
            }), Object.defineProperty(this, L, {
              writable: !0,
              value: this.updateOnlineStatus.bind(this)
            }), this.defaultLocale = w;
            var t = {
              id: "uppy",
              autoProceed: !1,
              allowMultipleUploads: !0,
              allowMultipleUploadBatches: !0,
              debug: !1,
              restrictions: i.defaultOptions,
              meta: {},
              onBeforeFileAdded: function onBeforeFileAdded(e) {
                return e;
              },
              onBeforeUpload: function onBeforeUpload(e) {
                return e;
              },
              store: p(),
              logger: o.justErrorsLogger,
              infoTimeout: 5e3
            };
            this.opts = _objectSpread(_objectSpread(_objectSpread({}, t), e), {}, {
              restrictions: _objectSpread(_objectSpread({}, t.restrictions), e && e.restrictions)
            }), e && e.logger && e.debug ? this.log("You are using a custom `logger`, but also set `debug: true`, which uses built-in logger to output logs to console. Ignoring `debug: true` and using your custom `logger`.", "warning") : e && e.debug && (this.opts.logger = o.debugLogger), this.log("Using Core v".concat(this.constructor.VERSION)), this.i18nInit(), this.calculateProgress = f(this.calculateProgress.bind(this), 500, {
              leading: !0,
              trailing: !0
            }), this.store = this.opts.store, this.setState({
              plugins: {},
              files: {},
              currentUploads: {},
              allowNewUpload: !0,
              capabilities: {
                uploadProgress: y(),
                individualCancellation: !0,
                resumableUploads: !1
              },
              totalProgress: 0,
              meta: _objectSpread({}, this.opts.meta),
              info: [],
              recoveredState: null
            }), l(this, E)[E] = new i.Restricter(function () {
              return _this128.opts;
            }, this.i18n), l(this, _)[_] = this.store.subscribe(function (e, t, n) {
              _this128.emit("state-update", e, t, n), _this128.updateAll(t);
            }), this.opts.debug && "undefined" != typeof window && (window[this.opts.id] = this), l(this, F)[F]();
          }

          _createClass($, [{
            key: "emit",
            value: function emit(e) {
              var _l$S;

              for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
                n[r - 1] = arguments[r];
              }

              (_l$S = l(this, S)[S]).emit.apply(_l$S, [e].concat(n));
            }
          }, {
            key: "on",
            value: function on(e, t) {
              return l(this, S)[S].on(e, t), this;
            }
          }, {
            key: "once",
            value: function once(e, t) {
              return l(this, S)[S].once(e, t), this;
            }
          }, {
            key: "off",
            value: function off(e, t) {
              return l(this, S)[S].off(e, t), this;
            }
          }, {
            key: "updateAll",
            value: function updateAll(e) {
              this.iteratePlugins(function (t) {
                t.update(e);
              });
            }
          }, {
            key: "setState",
            value: function setState(e) {
              this.store.setState(e);
            }
          }, {
            key: "getState",
            value: function getState() {
              return this.store.getState();
            }
          }, {
            key: "state",
            get: function get() {
              return this.getState();
            }
          }, {
            key: "setFileState",
            value: function setFileState(e, t) {
              if (!this.getState().files[e]) throw new Error("Can\u2019t set state for ".concat(e, " (the file could have been removed)"));
              this.setState({
                files: _objectSpread(_objectSpread({}, this.getState().files), {}, _defineProperty({}, e, _objectSpread(_objectSpread({}, this.getState().files[e]), t)))
              });
            }
          }, {
            key: "i18nInit",
            value: function i18nInit() {
              var e = new d([this.defaultLocale, this.opts.locale]);
              this.i18n = e.translate.bind(e), this.i18nArray = e.translateArray.bind(e), this.locale = e.locale;
            }
          }, {
            key: "setOptions",
            value: function setOptions(e) {
              this.opts = _objectSpread(_objectSpread(_objectSpread({}, this.opts), e), {}, {
                restrictions: _objectSpread(_objectSpread({}, this.opts.restrictions), e && e.restrictions)
              }), e.meta && this.setMeta(e.meta), this.i18nInit(), e.locale && this.iteratePlugins(function (e) {
                e.setOptions();
              }), this.setState();
            }
          }, {
            key: "resetProgress",
            value: function resetProgress() {
              var e = {
                percentage: 0,
                bytesUploaded: 0,
                uploadComplete: !1,
                uploadStarted: null
              },
                  t = _objectSpread({}, this.getState().files),
                  n = {};

              Object.keys(t).forEach(function (r) {
                var o = _objectSpread({}, t[r]);

                o.progress = _objectSpread(_objectSpread({}, o.progress), e), n[r] = o;
              }), this.setState({
                files: n,
                totalProgress: 0
              }), this.emit("reset-progress");
            }
          }, {
            key: "addPreProcessor",
            value: function addPreProcessor(e) {
              l(this, x)[x].add(e);
            }
          }, {
            key: "removePreProcessor",
            value: function removePreProcessor(e) {
              return l(this, x)[x].delete(e);
            }
          }, {
            key: "addPostProcessor",
            value: function addPostProcessor(e) {
              l(this, k)[k].add(e);
            }
          }, {
            key: "removePostProcessor",
            value: function removePostProcessor(e) {
              return l(this, k)[k].delete(e);
            }
          }, {
            key: "addUploader",
            value: function addUploader(e) {
              l(this, C)[C].add(e);
            }
          }, {
            key: "removeUploader",
            value: function removeUploader(e) {
              return l(this, C)[C].delete(e);
            }
          }, {
            key: "setMeta",
            value: function setMeta(e) {
              var t = _objectSpread(_objectSpread({}, this.getState().meta), e),
                  n = _objectSpread({}, this.getState().files);

              Object.keys(n).forEach(function (t) {
                n[t] = _objectSpread(_objectSpread({}, n[t]), {}, {
                  meta: _objectSpread(_objectSpread({}, n[t].meta), e)
                });
              }), this.log("Adding metadata:"), this.log(e), this.setState({
                meta: t,
                files: n
              });
            }
          }, {
            key: "setFileMeta",
            value: function setFileMeta(e, t) {
              var n = _objectSpread({}, this.getState().files);

              if (!n[e]) return void this.log("Was trying to set metadata for a file that has been removed: ", e);

              var r = _objectSpread(_objectSpread({}, n[e].meta), t);

              n[e] = _objectSpread(_objectSpread({}, n[e]), {}, {
                meta: r
              }), this.setState({
                files: n
              });
            }
          }, {
            key: "getFile",
            value: function getFile(e) {
              return this.getState().files[e];
            }
          }, {
            key: "getFiles",
            value: function getFiles() {
              var _this$getState = this.getState(),
                  e = _this$getState.files;

              return Object.values(e);
            }
          }, {
            key: "getObjectOfFilesPerState",
            value: function getObjectOfFilesPerState() {
              var _this$getState2 = this.getState(),
                  e = _this$getState2.files,
                  t = _this$getState2.totalProgress,
                  n = _this$getState2.error,
                  r = Object.values(e),
                  o = r.filter(function (e) {
                var t = e.progress;
                return !t.uploadComplete && t.uploadStarted;
              }),
                  i = r.filter(function (e) {
                return !e.progress.uploadStarted;
              }),
                  s = r.filter(function (e) {
                return e.progress.uploadStarted || e.progress.preprocess || e.progress.postprocess;
              }),
                  a = r.filter(function (e) {
                return e.progress.uploadStarted;
              }),
                  l = r.filter(function (e) {
                return e.isPaused;
              }),
                  c = r.filter(function (e) {
                return e.progress.uploadComplete;
              }),
                  u = r.filter(function (e) {
                return e.error;
              }),
                  d = o.filter(function (e) {
                return !e.isPaused;
              }),
                  h = r.filter(function (e) {
                return e.progress.preprocess || e.progress.postprocess;
              });

              return {
                newFiles: i,
                startedFiles: s,
                uploadStartedFiles: a,
                pausedFiles: l,
                completeFiles: c,
                erroredFiles: u,
                inProgressFiles: o,
                inProgressNotPausedFiles: d,
                processingFiles: h,
                isUploadStarted: a.length > 0,
                isAllComplete: 100 === t && c.length === r.length && 0 === h.length,
                isAllErrored: !!n && u.length === r.length,
                isAllPaused: 0 !== o.length && l.length === o.length,
                isUploadInProgress: o.length > 0,
                isSomeGhost: r.some(function (e) {
                  return e.isGhost;
                })
              };
            }
          }, {
            key: "validateRestrictions",
            value: function validateRestrictions(e, t) {
              void 0 === t && (t = this.getFiles());

              try {
                return l(this, E)[E].validate(e, t), {
                  result: !0
                };
              } catch (e) {
                return {
                  result: !1,
                  reason: e.message
                };
              }
            }
          }, {
            key: "checkIfFileAlreadyExists",
            value: function checkIfFileAlreadyExists(e) {
              var _this$getState3 = this.getState(),
                  t = _this$getState3.files;

              return !(!t[e] || t[e].isGhost);
            }
          }, {
            key: "addFile",
            value: function addFile(e) {
              l(this, D)[D](e);

              var _this$getState4 = this.getState(),
                  t = _this$getState4.files;

              var n = l(this, M)[M](t, e);
              return t[n.id] && t[n.id].isGhost && (n = _objectSpread(_objectSpread({}, t[n.id]), {}, {
                data: e.data,
                isGhost: !1
              }), this.log("Replaced the blob in the restored ghost file: ".concat(n.name, ", ").concat(n.id))), this.setState({
                files: _objectSpread(_objectSpread({}, t), {}, _defineProperty({}, n.id, n))
              }), this.emit("file-added", n), this.emit("files-added", [n]), this.log("Added file: ".concat(n.name, ", ").concat(n.id, ", mime type: ").concat(n.type)), l(this, A)[A](), n.id;
            }
          }, {
            key: "addFiles",
            value: function addFiles(e) {
              var _this129 = this;

              l(this, D)[D]();

              var t = _objectSpread({}, this.getState().files),
                  n = [],
                  r = [];

              for (var _o17 = 0; _o17 < e.length; _o17++) {
                try {
                  var _r30 = l(this, M)[M](t, e[_o17]);

                  t[_r30.id] && t[_r30.id].isGhost && (_r30 = _objectSpread(_objectSpread({}, t[_r30.id]), {}, {
                    data: e[_o17].data,
                    isGhost: !1
                  }), this.log("Replaced blob in a ghost file: ".concat(_r30.name, ", ").concat(_r30.id))), t[_r30.id] = _r30, n.push(_r30);
                } catch (e) {
                  e.isRestriction || r.push(e);
                }
              }

              if (this.setState({
                files: t
              }), n.forEach(function (e) {
                _this129.emit("file-added", e);
              }), this.emit("files-added", n), n.length > 5 ? this.log("Added batch of ".concat(n.length, " files")) : Object.keys(n).forEach(function (e) {
                _this129.log("Added file: ".concat(n[e].name, "\n id: ").concat(n[e].id, "\n type: ").concat(n[e].type));
              }), n.length > 0 && l(this, A)[A](), r.length > 0) {
                var _e53 = "Multiple errors occurred while adding files:\n";
                if (r.forEach(function (t) {
                  _e53 += "\n * ".concat(t.message);
                }), this.info({
                  message: this.i18n("addBulkFilesFailed", {
                    smart_count: r.length
                  }),
                  details: _e53
                }, "error", this.opts.infoTimeout), "function" == typeof AggregateError) throw new AggregateError(r, _e53);
                {
                  var _t38 = new Error(_e53);

                  throw _t38.errors = r, _t38;
                }
              }
            }
          }, {
            key: "removeFiles",
            value: function removeFiles(e, t) {
              var _this130 = this;

              var _this$getState5 = this.getState(),
                  n = _this$getState5.files,
                  r = _this$getState5.currentUploads,
                  o = _objectSpread({}, n),
                  i = _objectSpread({}, r),
                  s = Object.create(null);

              function a(e) {
                return void 0 === s[e];
              }

              e.forEach(function (e) {
                n[e] && (s[e] = n[e], delete o[e]);
              }), Object.keys(i).forEach(function (e) {
                var t = r[e].fileIDs.filter(a);
                if (0 === t.length) return void delete i[e];

                var _this130$getState = _this130.getState(),
                    n = _this130$getState.capabilities;

                if (t.length !== r[e].fileIDs.length && !n.individualCancellation) throw new Error("individualCancellation is disabled");
                i[e] = _objectSpread(_objectSpread({}, r[e]), {}, {
                  fileIDs: t
                });
              });
              var l = {
                currentUploads: i,
                files: o
              };
              0 === Object.keys(o).length && (l.allowNewUpload = !0, l.error = null, l.recoveredState = null), this.setState(l), this.calculateTotalProgress();
              var c = Object.keys(s);
              c.forEach(function (e) {
                _this130.emit("file-removed", s[e], t);
              }), c.length > 5 ? this.log("Removed ".concat(c.length, " files")) : this.log("Removed files: ".concat(c.join(", ")));
            }
          }, {
            key: "removeFile",
            value: function removeFile(e, t) {
              void 0 === t && (t = null), this.removeFiles([e], t);
            }
          }, {
            key: "pauseResume",
            value: function pauseResume(e) {
              if (!this.getState().capabilities.resumableUploads || this.getFile(e).uploadComplete) return;
              var t = !this.getFile(e).isPaused;
              return this.setFileState(e, {
                isPaused: t
              }), this.emit("upload-pause", e, t), t;
            }
          }, {
            key: "pauseAll",
            value: function pauseAll() {
              var e = _objectSpread({}, this.getState().files);

              Object.keys(e).filter(function (t) {
                return !e[t].progress.uploadComplete && e[t].progress.uploadStarted;
              }).forEach(function (t) {
                var n = _objectSpread(_objectSpread({}, e[t]), {}, {
                  isPaused: !0
                });

                e[t] = n;
              }), this.setState({
                files: e
              }), this.emit("pause-all");
            }
          }, {
            key: "resumeAll",
            value: function resumeAll() {
              var e = _objectSpread({}, this.getState().files);

              Object.keys(e).filter(function (t) {
                return !e[t].progress.uploadComplete && e[t].progress.uploadStarted;
              }).forEach(function (t) {
                var n = _objectSpread(_objectSpread({}, e[t]), {}, {
                  isPaused: !1,
                  error: null
                });

                e[t] = n;
              }), this.setState({
                files: e
              }), this.emit("resume-all");
            }
          }, {
            key: "retryAll",
            value: function retryAll() {
              var e = _objectSpread({}, this.getState().files),
                  t = Object.keys(e).filter(function (t) {
                return e[t].error;
              });

              if (t.forEach(function (t) {
                var n = _objectSpread(_objectSpread({}, e[t]), {}, {
                  isPaused: !1,
                  error: null
                });

                e[t] = n;
              }), this.setState({
                files: e,
                error: null
              }), this.emit("retry-all", t), 0 === t.length) return Promise.resolve({
                successful: [],
                failed: []
              });
              var n = l(this, I)[I](t, {
                forceAllowNewUpload: !0
              });
              return l(this, B)[B](n);
            }
          }, {
            key: "cancelAll",
            value: function cancelAll(e) {
              var _ref45 = void 0 === e ? {} : e,
                  _ref45$reason = _ref45.reason,
                  t = _ref45$reason === void 0 ? "user" : _ref45$reason;

              if (this.emit("cancel-all", {
                reason: t
              }), "user" === t) {
                var _this$getState6 = this.getState(),
                    _e54 = _this$getState6.files,
                    _t39 = Object.keys(_e54);

                _t39.length && this.removeFiles(_t39, "cancel-all"), this.setState({
                  totalProgress: 0,
                  error: null,
                  recoveredState: null
                });
              }
            }
          }, {
            key: "retryUpload",
            value: function retryUpload(e) {
              this.setFileState(e, {
                error: null,
                isPaused: !1
              }), this.emit("upload-retry", e);
              var t = l(this, I)[I]([e], {
                forceAllowNewUpload: !0
              });
              return l(this, B)[B](t);
            }
          }, {
            key: "reset",
            value: function reset() {
              this.cancelAll.apply(this, arguments);
            }
          }, {
            key: "logout",
            value: function logout() {
              this.iteratePlugins(function (e) {
                e.provider && e.provider.logout && e.provider.logout();
              });
            }
          }, {
            key: "calculateProgress",
            value: function calculateProgress(e, t) {
              if (null == e || !this.getFile(e.id)) return void this.log("Not setting progress for a file that has been removed: ".concat(null == e ? void 0 : e.id));
              var n = Number.isFinite(t.bytesTotal) && t.bytesTotal > 0;
              this.setFileState(e.id, {
                progress: _objectSpread(_objectSpread({}, this.getFile(e.id).progress), {}, {
                  bytesUploaded: t.bytesUploaded,
                  bytesTotal: t.bytesTotal,
                  percentage: n ? Math.round(t.bytesUploaded / t.bytesTotal * 100) : 0
                })
              }), this.calculateTotalProgress();
            }
          }, {
            key: "calculateTotalProgress",
            value: function calculateTotalProgress() {
              var e = this.getFiles().filter(function (e) {
                return e.progress.uploadStarted || e.progress.preprocess || e.progress.postprocess;
              });
              if (0 === e.length) return this.emit("progress", 0), void this.setState({
                totalProgress: 0
              });
              var t = e.filter(function (e) {
                return null != e.progress.bytesTotal;
              }),
                  n = e.filter(function (e) {
                return null == e.progress.bytesTotal;
              });

              if (0 === t.length) {
                var _t40 = 100 * e.length,
                    _r31 = n.reduce(function (e, t) {
                  return e + t.progress.percentage;
                }, 0),
                    _o18 = Math.round(_r31 / _t40 * 100);

                return void this.setState({
                  totalProgress: _o18
                });
              }

              var r = t.reduce(function (e, t) {
                return e + t.progress.bytesTotal;
              }, 0);
              var o = r / t.length;
              r += o * n.length;
              var i = 0;
              t.forEach(function (e) {
                i += e.progress.bytesUploaded;
              }), n.forEach(function (e) {
                i += o * (e.progress.percentage || 0) / 100;
              });
              var s = 0 === r ? 0 : Math.round(i / r * 100);
              s > 100 && (s = 100), this.setState({
                totalProgress: s
              }), this.emit("progress", s);
            }
          }, {
            key: "updateOnlineStatus",
            value: function updateOnlineStatus() {
              void 0 === window.navigator.onLine || window.navigator.onLine ? (this.emit("is-online"), this.wasOffline && (this.emit("back-online"), this.info(this.i18n("connectedToInternet"), "success", 3e3), this.wasOffline = !1)) : (this.emit("is-offline"), this.info(this.i18n("noInternetConnection"), "error", 0), this.wasOffline = !0);
            }
          }, {
            key: "getID",
            value: function getID() {
              return this.opts.id;
            }
          }, {
            key: "use",
            value: function use(e, t) {
              if ("function" != typeof e) throw new TypeError("Expected a plugin class, but got ".concat(null === e ? "null" : _typeof(e), ". Please verify that the plugin was imported and spelled correctly."));
              var n = new e(this, t),
                  r = n.id;
              if (!r) throw new Error("Your plugin must have an id");
              if (!n.type) throw new Error("Your plugin must have a type");
              var o = this.getPlugin(r);

              if (o) {
                var _e55 = "Already found a plugin named '".concat(o.id, "'. Tried to use: '").concat(r, "'.\nUppy plugins must have unique `id` options. See https://uppy.io/docs/plugins/#id.");

                throw new Error(_e55);
              }

              return e.VERSION && this.log("Using ".concat(r, " v").concat(e.VERSION)), n.type in l(this, O)[O] ? l(this, O)[O][n.type].push(n) : l(this, O)[O][n.type] = [n], n.install(), this;
            }
          }, {
            key: "getPlugin",
            value: function getPlugin(e) {
              for (var _i49 = 0, _Object$values = Object.values(l(this, O)[O]); _i49 < _Object$values.length; _i49++) {
                var _t41 = _Object$values[_i49];

                var _n27 = _t41.find(function (t) {
                  return t.id === e;
                });

                if (null != _n27) return _n27;
              }
            }
          }, {
            key: _s5,
            value: function value(e) {
              return l(this, O)[O][e];
            }
          }, {
            key: "iteratePlugins",
            value: function iteratePlugins(e) {
              Object.values(l(this, O)[O]).flat(1).forEach(e);
            }
          }, {
            key: "removePlugin",
            value: function removePlugin(e) {
              this.log("Removing plugin ".concat(e.id)), this.emit("plugin-remove", e), e.uninstall && e.uninstall();
              var t = l(this, O)[O][e.type],
                  n = t.findIndex(function (t) {
                return t.id === e.id;
              });
              -1 !== n && t.splice(n, 1);
              var r = {
                plugins: _objectSpread(_objectSpread({}, this.getState().plugins), {}, _defineProperty({}, e.id, void 0))
              };
              this.setState(r);
            }
          }, {
            key: "close",
            value: function close(e) {
              var _this131 = this;

              var _ref46 = void 0 === e ? {} : e,
                  t = _ref46.reason;

              this.log("Closing Uppy instance ".concat(this.opts.id, ": removing all files and uninstalling plugins")), this.cancelAll({
                reason: t
              }), l(this, _)[_](), this.iteratePlugins(function (e) {
                _this131.removePlugin(e);
              }), "undefined" != typeof window && window.removeEventListener && (window.removeEventListener("online", l(this, L)[L]), window.removeEventListener("offline", l(this, L)[L]));
            }
          }, {
            key: "hideInfo",
            value: function hideInfo() {
              var _this$getState7 = this.getState(),
                  e = _this$getState7.info;

              this.setState({
                info: e.slice(1)
              }), this.emit("info-hidden");
            }
          }, {
            key: "info",
            value: function info(e, t, n) {
              var _this132 = this;

              void 0 === t && (t = "info"), void 0 === n && (n = 3e3);

              var r = "object" == _typeof(e);

              this.setState({
                info: [].concat(_toConsumableArray(this.getState().info), [{
                  type: t,
                  message: r ? e.message : e,
                  details: r ? e.details : null
                }])
              }), setTimeout(function () {
                return _this132.hideInfo();
              }, n), this.emit("info-visible");
            }
          }, {
            key: "log",
            value: function log(e, t) {
              var n = this.opts.logger;

              switch (t) {
                case "error":
                  n.error(e);
                  break;

                case "warning":
                  n.warn(e);
                  break;

                default:
                  n.debug(e);
              }
            }
          }, {
            key: "restore",
            value: function restore(e) {
              return this.log("Core: attempting to restore upload \"".concat(e, "\"")), this.getState().currentUploads[e] ? l(this, B)[B](e) : (l(this, N)[N](e), Promise.reject(new Error("Nonexistent upload")));
            }
          }, {
            key: _a4,
            value: function value() {
              var _l2;

              return (_l2 = l(this, I))[I].apply(_l2, arguments);
            }
          }, {
            key: "addResultData",
            value: function addResultData(e, t) {
              if (!l(this, R)[R](e)) return void this.log("Not setting result for an upload that has been removed: ".concat(e));

              var _this$getState8 = this.getState(),
                  n = _this$getState8.currentUploads,
                  r = _objectSpread(_objectSpread({}, n[e]), {}, {
                result: _objectSpread(_objectSpread({}, n[e].result), t)
              });

              this.setState({
                currentUploads: _objectSpread(_objectSpread({}, n), {}, _defineProperty({}, e, r))
              });
            }
          }, {
            key: "upload",
            value: function upload() {
              var _this133 = this;

              var e;
              null != (e = l(this, O)[O].uploader) && e.length || this.log("No uploader type plugins are used", "warning");

              var _this$getState9 = this.getState(),
                  t = _this$getState9.files;

              var n = this.opts.onBeforeUpload(t);
              return !1 === n ? Promise.reject(new Error("Not starting the upload because onBeforeUpload returned false")) : (n && "object" == _typeof(n) && (t = n, this.setState({
                files: t
              })), Promise.resolve().then(function () {
                return l(_this133, E)[E].validateMinNumberOfFiles(t);
              }).catch(function (e) {
                throw l(_this133, P)[P](e), e;
              }).then(function () {
                if (!l(_this133, T)[T](t)) throw new i.RestrictionError(_this133.i18n("missingRequiredMetaField"));
              }).catch(function (e) {
                throw e;
              }).then(function () {
                var _this133$getState = _this133.getState(),
                    e = _this133$getState.currentUploads,
                    n = Object.values(e).flatMap(function (e) {
                  return e.fileIDs;
                }),
                    r = [];

                Object.keys(t).forEach(function (e) {
                  var t = _this133.getFile(e);

                  t.progress.uploadStarted || -1 !== n.indexOf(e) || r.push(t.id);
                });
                var o = l(_this133, I)[I](r);
                return l(_this133, B)[B](o);
              }).catch(function (e) {
                throw _this133.emit("error", e), _this133.log(e, "error"), e;
              }));
            }
          }]);

          return $;
        }(s, a);

        function H(e, t) {
          var n = e.message,
              _e$details = e.details,
              r = _e$details === void 0 ? "" : _e$details;
          e.isRestriction ? this.emit("restriction-failed", t, e) : this.emit("error", e), this.info({
            message: n,
            details: r
          }, "error", this.opts.infoTimeout), this.log("".concat(n, " ").concat(r).trim(), "error");
        }

        function U(e) {
          var _l$E$getMissingRequir = l(this, E)[E].getMissingRequiredMetaFields(e),
              t = _l$E$getMissingRequir.missingFields,
              n = _l$E$getMissingRequir.error;

          return !(t.length > 0 && (this.setFileState(e.id, {
            missingRequiredMetaFields: t
          }), this.log(n.message), this.emit("restriction-failed", e, n), 1));
        }

        function z(e) {
          var t = !0;

          for (var _i50 = 0, _Object$values2 = Object.values(e); _i50 < _Object$values2.length; _i50++) {
            var _n28 = _Object$values2[_i50];
            l(this, j)[j](_n28) || (t = !1);
          }

          return t;
        }

        function Y(e) {
          var _this$getState10 = this.getState(),
              t = _this$getState10.allowNewUpload;

          if (!1 === t) {
            var _t42 = new i.RestrictionError(this.i18n("noMoreFilesAllowed"));

            throw l(this, P)[P](_t42, e), _t42;
          }
        }

        function q(e, t) {
          var n = g(t),
              r = b(n, t),
              o = m(r).extension,
              s = Boolean(t.isRemote),
              a = v(_objectSpread(_objectSpread({}, t), {}, {
            type: n
          }));

          if (this.checkIfFileAlreadyExists(a)) {
            var _e56 = new i.RestrictionError(this.i18n("noDuplicates", {
              fileName: r
            }));

            throw l(this, P)[P](_e56, t), _e56;
          }

          var c = t.meta || {};
          c.name = r, c.type = n;
          var u = Number.isFinite(t.data.size) ? t.data.size : null;
          var d = {
            source: t.source || "",
            id: a,
            name: r,
            extension: o || "",
            meta: _objectSpread(_objectSpread({}, this.getState().meta), c),
            type: n,
            data: t.data,
            progress: {
              percentage: 0,
              bytesUploaded: 0,
              bytesTotal: u,
              uploadComplete: !1,
              uploadStarted: null
            },
            size: u,
            isRemote: s,
            remote: t.remote || "",
            preview: t.preview
          };
          var h = this.opts.onBeforeFileAdded(d, e);

          if (!1 === h) {
            var _e57 = new i.RestrictionError("Cannot add the file because onBeforeFileAdded returned false.");

            throw this.emit("restriction-failed", t, _e57), _e57;
          }

          "object" == _typeof(h) && null !== h && (d = h);

          try {
            var _t43 = Object.keys(e).map(function (t) {
              return e[t];
            });

            l(this, E)[E].validate(d, _t43);
          } catch (e) {
            throw l(this, P)[P](e, d), e;
          }

          return d;
        }

        function V() {
          var _this134 = this;

          this.opts.autoProceed && !this.scheduledAutoProceed && (this.scheduledAutoProceed = setTimeout(function () {
            _this134.scheduledAutoProceed = null, _this134.upload().catch(function (e) {
              e.isRestriction || _this134.log(e.stack || e.message || e);
            });
          }, 4));
        }

        function W() {
          var _this135 = this;

          var e = function e(_e58, t, n) {
            var r = _e58.message || "Unknown error";
            _e58.details && (r += " ".concat(_e58.details)), _this135.setState({
              error: r
            }), null != t && t.id in _this135.getState().files && _this135.setFileState(t.id, {
              error: r,
              response: n
            });
          };

          this.on("error", e), this.on("upload-error", function (t, n, r) {
            if (e(n, t, r), "object" == _typeof(n) && n.message) {
              var _e59 = new Error(n.message);

              _e59.details = n.message, n.details && (_e59.details += " ".concat(n.details)), _e59.message = _this135.i18n("failedToUpload", {
                file: null == t ? void 0 : t.name
              }), l(_this135, P)[P](_e59);
            } else l(_this135, P)[P](n);
          }), this.on("upload", function () {
            _this135.setState({
              error: null
            });
          }), this.on("upload-started", function (e) {
            null != e && _this135.getFile(e.id) ? _this135.setFileState(e.id, {
              progress: {
                uploadStarted: Date.now(),
                uploadComplete: !1,
                percentage: 0,
                bytesUploaded: 0,
                bytesTotal: e.size
              }
            }) : _this135.log("Not setting progress for a file that has been removed: ".concat(null == e ? void 0 : e.id));
          }), this.on("upload-progress", this.calculateProgress), this.on("upload-success", function (e, t) {
            if (null == e || !_this135.getFile(e.id)) return void _this135.log("Not setting progress for a file that has been removed: ".concat(null == e ? void 0 : e.id));

            var n = _this135.getFile(e.id).progress;

            _this135.setFileState(e.id, {
              progress: _objectSpread(_objectSpread({}, n), {}, {
                postprocess: l(_this135, k)[k].size > 0 ? {
                  mode: "indeterminate"
                } : null,
                uploadComplete: !0,
                percentage: 100,
                bytesUploaded: n.bytesTotal
              }),
              response: t,
              uploadURL: t.uploadURL,
              isPaused: !1
            }), null == e.size && _this135.setFileState(e.id, {
              size: t.bytesUploaded || n.bytesTotal
            }), _this135.calculateTotalProgress();
          }), this.on("preprocess-progress", function (e, t) {
            null != e && _this135.getFile(e.id) ? _this135.setFileState(e.id, {
              progress: _objectSpread(_objectSpread({}, _this135.getFile(e.id).progress), {}, {
                preprocess: t
              })
            }) : _this135.log("Not setting progress for a file that has been removed: ".concat(null == e ? void 0 : e.id));
          }), this.on("preprocess-complete", function (e) {
            if (null == e || !_this135.getFile(e.id)) return void _this135.log("Not setting progress for a file that has been removed: ".concat(null == e ? void 0 : e.id));

            var t = _objectSpread({}, _this135.getState().files);

            t[e.id] = _objectSpread(_objectSpread({}, t[e.id]), {}, {
              progress: _objectSpread({}, t[e.id].progress)
            }), delete t[e.id].progress.preprocess, _this135.setState({
              files: t
            });
          }), this.on("postprocess-progress", function (e, t) {
            null != e && _this135.getFile(e.id) ? _this135.setFileState(e.id, {
              progress: _objectSpread(_objectSpread({}, _this135.getState().files[e.id].progress), {}, {
                postprocess: t
              })
            }) : _this135.log("Not setting progress for a file that has been removed: ".concat(null == e ? void 0 : e.id));
          }), this.on("postprocess-complete", function (e) {
            if (null == e || !_this135.getFile(e.id)) return void _this135.log("Not setting progress for a file that has been removed: ".concat(null == e ? void 0 : e.id));

            var t = _objectSpread({}, _this135.getState().files);

            t[e.id] = _objectSpread(_objectSpread({}, t[e.id]), {}, {
              progress: _objectSpread({}, t[e.id].progress)
            }), delete t[e.id].progress.postprocess, _this135.setState({
              files: t
            });
          }), this.on("restored", function () {
            _this135.calculateTotalProgress();
          }), this.on("dashboard:file-edit-complete", function (e) {
            e && l(_this135, j)[j](e);
          }), "undefined" != typeof window && window.addEventListener && (window.addEventListener("online", l(this, L)[L]), window.addEventListener("offline", l(this, L)[L]), setTimeout(l(this, L)[L], 3e3));
        }

        function K(e, t) {
          void 0 === t && (t = {});

          var _t44 = t,
              _t44$forceAllowNewUpl = _t44.forceAllowNewUpload,
              n = _t44$forceAllowNewUpl === void 0 ? !1 : _t44$forceAllowNewUpl,
              _this$getState11 = this.getState(),
              o = _this$getState11.allowNewUpload,
              i = _this$getState11.currentUploads;

          if (!o && !n) throw new Error("Cannot create a new upload: already uploading.");
          var s = (0, r.nanoid)();
          return this.emit("upload", {
            id: s,
            fileIDs: e
          }), this.setState({
            allowNewUpload: !1 !== this.opts.allowMultipleUploadBatches && !1 !== this.opts.allowMultipleUploads,
            currentUploads: _objectSpread(_objectSpread({}, i), {}, _defineProperty({}, s, {
              fileIDs: e,
              step: 0,
              result: {}
            }))
          }), s;
        }

        function X(e) {
          var _this$getState12 = this.getState(),
              t = _this$getState12.currentUploads;

          return t[e];
        }

        function Q(e) {
          var t = _objectSpread({}, this.getState().currentUploads);

          delete t[e], this.setState({
            currentUploads: t
          });
        }

        function G(_x8) {
          return _G.apply(this, arguments);
        }

        function _G() {
          _G = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(e) {
            var _this136 = this;

            var _this$getState13, t, n, r, o, _i51, _r32, _s6, _r33, _o19, _i52, i;

            return _regeneratorRuntime.wrap(function _callee11$(_context11) {
              while (1) {
                switch (_context11.prev = _context11.next) {
                  case 0:
                    _this$getState13 = this.getState(), t = _this$getState13.currentUploads, n = t[e];
                    r = n.step || 0, o = [].concat(_toConsumableArray(l(this, x)[x]), _toConsumableArray(l(this, C)[C]), _toConsumableArray(l(this, k)[k]));
                    _context11.prev = 2;
                    _i51 = r;

                  case 4:
                    if (!(_i51 < o.length && n)) {
                      _context11.next = 14;
                      break;
                    }

                    _r32 = o[_i51], _s6 = _objectSpread(_objectSpread({}, n), {}, {
                      step: _i51
                    });
                    this.setState({
                      currentUploads: _objectSpread(_objectSpread({}, t), {}, _defineProperty({}, e, _s6))
                    });
                    _context11.next = 9;
                    return _r32(_s6.fileIDs, e);

                  case 9:
                    t = this.getState().currentUploads;
                    n = t[e];

                  case 11:
                    _i51++;
                    _context11.next = 4;
                    break;

                  case 14:
                    _context11.next = 19;
                    break;

                  case 16:
                    _context11.prev = 16;
                    _context11.t0 = _context11["catch"](2);
                    throw l(this, N)[N](e), _context11.t0;

                  case 19:
                    if (!n) {
                      _context11.next = 26;
                      break;
                    }

                    n.fileIDs.forEach(function (e) {
                      var t = _this136.getFile(e);

                      t && t.progress.postprocess && _this136.emit("postprocess-complete", t);
                    });
                    _r33 = n.fileIDs.map(function (e) {
                      return _this136.getFile(e);
                    }), _o19 = _r33.filter(function (e) {
                      return !e.error;
                    }), _i52 = _r33.filter(function (e) {
                      return e.error;
                    });
                    _context11.next = 24;
                    return this.addResultData(e, {
                      successful: _o19,
                      failed: _i52,
                      uploadID: e
                    });

                  case 24:
                    t = this.getState().currentUploads;
                    n = t[e];

                  case 26:
                    return _context11.abrupt("return", (n && (i = n.result, this.emit("complete", i), l(this, N)[N](e)), null == i && this.log("Not setting result for an upload that has been removed: ".concat(e)), i));

                  case 27:
                  case "end":
                    return _context11.stop();
                }
              }
            }, _callee11, this, [[2, 16]]);
          }));
          return _G.apply(this, arguments);
        }

        $.VERSION = "2.3.2", e.exports = $;
      },
      5850: function _(e) {
        "use strict";

        e.exports = function (e, t) {
          return t.name ? t.name : "image" === e.split("/")[0] ? "".concat(e.split("/")[0], ".").concat(e.split("/")[1]) : "noname";
        };
      },
      7841: function _(e, t, n) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.Uppy = t.UIPlugin = t.BasePlugin = void 0, Object.defineProperty(t, "debugLogger", {
          enumerable: !0,
          get: function get() {
            return r.debugLogger;
          }
        });
        var r = n(9721);
        e.exports = n(9069);
        var o = n(2693);
        t.UIPlugin = o;
        var i = n(3521);
        t.BasePlugin = i;
        var s = n(9069);
        t.Uppy = s;
        var a = n(2693),
            l = n(3521);
        s.Uppy = s, s.UIPlugin = a, s.BasePlugin = l, s.debugLogger = r.debugLogger;
      },
      2187: function _(e) {
        "use strict";

        e.exports = {
          strings: {
            addBulkFilesFailed: {
              0: "Failed to add %{smart_count} file due to an internal error",
              1: "Failed to add %{smart_count} files due to internal errors"
            },
            youCanOnlyUploadX: {
              0: "You can only upload %{smart_count} file",
              1: "You can only upload %{smart_count} files"
            },
            youHaveToAtLeastSelectX: {
              0: "You have to select at least %{smart_count} file",
              1: "You have to select at least %{smart_count} files"
            },
            exceedsSize: "%{file} exceeds maximum allowed size of %{size}",
            missingRequiredMetaField: "Missing required meta fields",
            missingRequiredMetaFieldOnFile: "Missing required meta fields in %{fileName}",
            inferiorSize: "This file is smaller than the allowed size of %{size}",
            youCanOnlyUploadFileTypes: "You can only upload: %{types}",
            noMoreFilesAllowed: "Cannot add more files",
            noDuplicates: "Cannot add the duplicate file '%{fileName}', it already exists",
            companionError: "Connection with Companion failed",
            authAborted: "Authentication aborted",
            companionUnauthorizeHint: "To unauthorize to your %{provider} account, please go to %{url}",
            failedToUpload: "Failed to upload %{file}",
            noInternetConnection: "No Internet connection",
            connectedToInternet: "Connected to the Internet",
            noFilesFound: "You have no files or folders here",
            selectX: {
              0: "Select %{smart_count}",
              1: "Select %{smart_count}"
            },
            allFilesFromFolderNamed: "All files from folder %{name}",
            openFolderNamed: "Open folder %{name}",
            cancel: "Cancel",
            logOut: "Log out",
            filter: "Filter",
            resetFilter: "Reset filter",
            loading: "Loading...",
            authenticateWithTitle: "Please authenticate with %{pluginName} to select files",
            authenticateWith: "Connect to %{pluginName}",
            signInWithGoogle: "Sign in with Google",
            searchImages: "Search for images",
            enterTextToSearch: "Enter text to search for images",
            search: "Search",
            emptyFolderAdded: "No files were added from empty folder",
            folderAlreadyAdded: 'The folder "%{folder}" was already added',
            folderAdded: {
              0: "Added %{smart_count} file from %{folder}",
              1: "Added %{smart_count} files from %{folder}"
            }
          }
        };
      },
      9721: function _(e, t, n) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.justErrorsLogger = t.debugLogger = void 0;
        var r = n(152),
            o = {
          debug: function debug() {},
          warn: function warn() {},
          error: function error() {
            var _console;

            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
              t[n] = arguments[n];
            }

            return (_console = console).error.apply(_console, ["[Uppy] [".concat(r(), "]")].concat(t));
          }
        };
        t.justErrorsLogger = o;
        var i = {
          debug: function debug() {
            var _console2;

            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
              t[n] = arguments[n];
            }

            return (_console2 = console).debug.apply(_console2, ["[Uppy] [".concat(r(), "]")].concat(t));
          },
          warn: function warn() {
            var _console3;

            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
              t[n] = arguments[n];
            }

            return (_console3 = console).warn.apply(_console3, ["[Uppy] [".concat(r(), "]")].concat(t));
          },
          error: function error() {
            var _console4;

            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
              t[n] = arguments[n];
            }

            return (_console4 = console).error.apply(_console4, ["[Uppy] [".concat(r(), "]")].concat(t));
          }
        };
        t.debugLogger = i;
      },
      9109: function _(e) {
        "use strict";

        e.exports = function (e) {
          if (null == e && "undefined" != typeof navigator && (e = navigator.userAgent), !e) return !0;
          var t = /Edge\/(\d+\.\d+)/.exec(e);
          if (!t) return !0;
          var n = t[1];

          var _n$split = n.split("."),
              _n$split2 = _slicedToArray(_n$split, 2),
              r = _n$split2[0],
              o = _n$split2[1];

          return r = parseInt(r, 10), o = parseInt(o, 10), r < 15 || 15 === r && o < 15063 || r > 18 || 18 === r && o >= 18218;
        };
      },
      2868: function _(e, t, n) {
        "use strict";

        var r = n(3521),
            o = n(6397),
            i = n(3356);

        function s(e) {
          var t, n;
          return null != (t = null == (n = e.dataTransfer.types) ? void 0 : n.some(function (e) {
            return "Files" === e;
          })) && t;
        }

        var a = /*#__PURE__*/function (_r34) {
          _inherits(a, _r34);

          var _super73 = _createSuper(a);

          function a(e, t) {
            var _this137;

            _classCallCheck(this, a);

            _this137 = _super73.call(this, e, t), _this137.addFiles = function (e) {
              var t = e.map(function (e) {
                return {
                  source: _this137.id,
                  name: e.name,
                  type: e.type,
                  data: e,
                  meta: {
                    relativePath: e.relativePath || null
                  }
                };
              });

              try {
                _this137.uppy.addFiles(t);
              } catch (e) {
                _this137.uppy.log(e);
              }
            }, _this137.isFileTransfer = s, _this137.handleDrop = /*#__PURE__*/function () {
              var _ref47 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(e) {
                var t, n, r, i;
                return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                  while (1) {
                    switch (_context12.prev = _context12.next) {
                      case 0:
                        if (_this137.isFileTransfer(e)) {
                          _context12.next = 2;
                          break;
                        }

                        return _context12.abrupt("return");

                      case 2:
                        e.preventDefault(), e.stopPropagation(), clearTimeout(_this137.removeDragOverClassTimeout), e.currentTarget.classList.remove("uppy-is-drag-over"), _this137.setPluginState({
                          isDraggingOver: !1
                        }), _this137.uppy.iteratePlugins(function (t) {
                          "acquirer" === t.type && (null == t.handleRootDrop || t.handleRootDrop(e));
                        });
                        r = !1;
                        _context12.next = 6;
                        return o(e.dataTransfer, {
                          logDropError: function logDropError(e) {
                            _this137.uppy.log(e, "error"), r || (_this137.uppy.info(e.message, "error"), r = !0);
                          }
                        });

                      case 6:
                        i = _context12.sent;
                        i.length > 0 && (_this137.uppy.log("[DropTarget] Files were dropped"), _this137.addFiles(i)), null == (t = (n = _this137.opts).onDrop) || t.call(n, e);

                      case 8:
                      case "end":
                        return _context12.stop();
                    }
                  }
                }, _callee12);
              }));

              return function (_x9) {
                return _ref47.apply(this, arguments);
              };
            }(), _this137.handleDragOver = function (e) {
              var t, n;
              _this137.isFileTransfer(e) && (e.preventDefault(), e.stopPropagation(), e.dataTransfer.dropEffect = "copy", clearTimeout(_this137.removeDragOverClassTimeout), e.currentTarget.classList.add("uppy-is-drag-over"), _this137.setPluginState({
                isDraggingOver: !0
              }), null == (t = (n = _this137.opts).onDragOver) || t.call(n, e));
            }, _this137.handleDragLeave = function (e) {
              var t, n;
              if (!_this137.isFileTransfer(e)) return;
              e.preventDefault(), e.stopPropagation();
              var r = e.currentTarget;
              clearTimeout(_this137.removeDragOverClassTimeout), _this137.removeDragOverClassTimeout = setTimeout(function () {
                r.classList.remove("uppy-is-drag-over"), _this137.setPluginState({
                  isDraggingOver: !1
                });
              }, 50), null == (t = (n = _this137.opts).onDragLeave) || t.call(n, e);
            }, _this137.addListeners = function () {
              var e = _this137.opts.target;
              if (e instanceof Element ? _this137.nodes = [e] : "string" == typeof e && (_this137.nodes = i(document.querySelectorAll(e))), !_this137.nodes && !_this137.nodes.length > 0) throw new Error("\"".concat(e, "\" does not match any HTML elements"));

              _this137.nodes.forEach(function (e) {
                e.addEventListener("dragover", _this137.handleDragOver, !1), e.addEventListener("dragleave", _this137.handleDragLeave, !1), e.addEventListener("drop", _this137.handleDrop, !1);
              });
            }, _this137.removeListeners = function () {
              _this137.nodes && _this137.nodes.forEach(function (e) {
                e.removeEventListener("dragover", _this137.handleDragOver, !1), e.removeEventListener("dragleave", _this137.handleDragLeave, !1), e.removeEventListener("drop", _this137.handleDrop, !1);
              });
            }, _this137.type = "acquirer", _this137.id = _this137.opts.id || "DropTarget", _this137.title = "Drop Target", _this137.opts = _objectSpread({
              target: null
            }, t), _this137.removeDragOverClassTimeout = null;
            return _this137;
          }

          _createClass(a, [{
            key: "install",
            value: function install() {
              this.setPluginState({
                isDraggingOver: !1
              }), this.addListeners();
            }
          }, {
            key: "uninstall",
            value: function uninstall() {
              this.removeListeners();
            }
          }]);

          return a;
        }(r);

        a.VERSION = "1.1.3", e.exports = a;
      },
      3417: function _(e, t, n) {
        "use strict";

        var r = n(7841),
            o = n(6400);
        var i = n(3356),
            s = n(3762);

        var a = /*#__PURE__*/function (_r$UIPlugin) {
          _inherits(a, _r$UIPlugin);

          var _super74 = _createSuper(a);

          function a(e, t) {
            var _this138;

            _classCallCheck(this, a);

            _this138 = _super74.call(this, e, t), _this138.id = _this138.opts.id || "FileInput", _this138.title = "File Input", _this138.type = "acquirer", _this138.defaultLocale = s, _this138.opts = _objectSpread({
              target: null,
              pretty: !0,
              inputName: "files[]"
            }, t), _this138.i18nInit(), _this138.render = _this138.render.bind(_assertThisInitialized(_this138)), _this138.handleInputChange = _this138.handleInputChange.bind(_assertThisInitialized(_this138)), _this138.handleClick = _this138.handleClick.bind(_assertThisInitialized(_this138));
            return _this138;
          }

          _createClass(a, [{
            key: "addFiles",
            value: function addFiles(e) {
              var _this139 = this;

              var t = e.map(function (e) {
                return {
                  source: _this139.id,
                  name: e.name,
                  type: e.type,
                  data: e
                };
              });

              try {
                this.uppy.addFiles(t);
              } catch (e) {
                this.uppy.log(e);
              }
            }
          }, {
            key: "handleInputChange",
            value: function handleInputChange(e) {
              this.uppy.log("[FileInput] Something selected through input...");
              var t = i(e.target.files);
              this.addFiles(t), e.target.value = null;
            }
          }, {
            key: "handleClick",
            value: function handleClick() {
              this.input.click();
            }
          }, {
            key: "render",
            value: function render() {
              var _this140 = this;

              var e = this.uppy.opts.restrictions,
                  t = e.allowedFileTypes ? e.allowedFileTypes.join(",") : null;
              return (0, o.h)("div", {
                className: "uppy-FileInput-container"
              }, (0, o.h)("input", {
                className: "uppy-FileInput-input",
                style: this.opts.pretty && {
                  width: "0.1px",
                  height: "0.1px",
                  opacity: 0,
                  overflow: "hidden",
                  position: "absolute",
                  zIndex: -1
                },
                type: "file",
                name: this.opts.inputName,
                onChange: this.handleInputChange,
                multiple: 1 !== e.maxNumberOfFiles,
                accept: t,
                ref: function ref(e) {
                  _this140.input = e;
                }
              }), this.opts.pretty && (0, o.h)("button", {
                className: "uppy-FileInput-btn",
                type: "button",
                onClick: this.handleClick
              }, this.i18n("chooseFiles")));
            }
          }, {
            key: "install",
            value: function install() {
              var e = this.opts.target;
              e && this.mount(e, this);
            }
          }, {
            key: "uninstall",
            value: function uninstall() {
              this.unmount();
            }
          }]);

          return a;
        }(r.UIPlugin);

        a.VERSION = "2.1.1", e.exports = a;
      },
      3993: function _(e, t, n) {
        "use strict";

        e.exports = n(3417);
      },
      3762: function _(e) {
        "use strict";

        e.exports = {
          strings: {
            chooseFiles: "Choose files"
          }
        };
      },
      7320: function _(e, t, n) {
        "use strict";

        var r = n(6400),
            o = n(7841);

        var i = /*#__PURE__*/function (_o$UIPlugin) {
          _inherits(i, _o$UIPlugin);

          var _super75 = _createSuper(i);

          function i(e, t) {
            var _this141;

            _classCallCheck(this, i);

            _this141 = _super75.call(this, e, t), _this141.id = _this141.opts.id || "ProgressBar", _this141.title = "Progress Bar", _this141.type = "progressindicator", _this141.opts = _objectSpread({
              target: "body",
              fixed: !1,
              hideAfterFinish: !0
            }, t), _this141.render = _this141.render.bind(_assertThisInitialized(_this141));
            return _this141;
          }

          _createClass(i, [{
            key: "render",
            value: function render(e) {
              var t = e.totalProgress || 0,
                  n = (0 === t || 100 === t) && this.opts.hideAfterFinish;
              return (0, r.h)("div", {
                className: "uppy uppy-ProgressBar",
                style: {
                  position: this.opts.fixed ? "fixed" : "initial"
                },
                "aria-hidden": n
              }, (0, r.h)("div", {
                className: "uppy-ProgressBar-inner",
                style: {
                  width: "".concat(t, "%")
                }
              }), (0, r.h)("div", {
                className: "uppy-ProgressBar-percentage"
              }, t));
            }
          }, {
            key: "install",
            value: function install() {
              var e = this.opts.target;
              e && this.mount(e, this);
            }
          }, {
            key: "uninstall",
            value: function uninstall() {
              this.unmount();
            }
          }]);

          return i;
        }(o.UIPlugin);

        i.VERSION = "2.1.1", e.exports = i;
      },
      5117: function _(e, t, n) {
        "use strict";

        e.exports = n(7320);
      },
      4284: function _(e) {
        "use strict";

        var t = 0;

        function n(e) {
          return "__private_" + t++ + "_" + e;
        }

        var r = n("publish");

        var o = /*#__PURE__*/function () {
          function o() {
            _classCallCheck(this, o);

            Object.defineProperty(this, r, {
              value: i
            }), this.state = {}, this.callbacks = [];
          }

          _createClass(o, [{
            key: "getState",
            value: function getState() {
              return this.state;
            }
          }, {
            key: "setState",
            value: function setState(e) {
              var t = _objectSpread({}, this.state),
                  n = _objectSpread(_objectSpread({}, this.state), e);

              this.state = n, function (e, t) {
                if (!Object.prototype.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
                return e;
              }(this, r)[r](t, n, e);
            }
          }, {
            key: "subscribe",
            value: function subscribe(e) {
              var _this142 = this;

              return this.callbacks.push(e), function () {
                _this142.callbacks.splice(_this142.callbacks.indexOf(e), 1);
              };
            }
          }]);

          return o;
        }();

        function i() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }

          this.callbacks.forEach(function (e) {
            e.apply(void 0, t);
          });
        }

        o.VERSION = "2.1.0", e.exports = function () {
          return new o();
        };
      },
      8391: function _(e, t, n) {
        "use strict";

        var r = n(3689);

        var o = /*#__PURE__*/function (_Error4) {
          _inherits(o, _Error4);

          var _super76 = _createSuper(o);

          function o(e, t) {
            var _this143;

            _classCallCheck(this, o);

            void 0 === t && (t = {}), _this143 = _super76.call(this, e), _this143.cause = t.cause, _this143.cause && r(_this143.cause, "isNetworkError") && (_this143.isNetworkError = _this143.cause.isNetworkError);
            return _this143;
          }

          return o;
        }( /*#__PURE__*/_wrapNativeSuper(Error));

        e.exports = o;
      },
      2328: function _(e) {
        "use strict";

        function t(e, t) {
          if (!Object.prototype.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
          return e;
        }

        var n = 0;

        function r(e) {
          return "__private_" + n++ + "_" + e;
        }

        var o = r("emitter"),
            i = r("events");

        e.exports = /*#__PURE__*/function () {
          function _class16(e) {
            _classCallCheck(this, _class16);

            Object.defineProperty(this, o, {
              writable: !0,
              value: void 0
            }), Object.defineProperty(this, i, {
              writable: !0,
              value: []
            }), t(this, o)[o] = e;
          }

          _createClass(_class16, [{
            key: "on",
            value: function on(e, n) {
              return t(this, i)[i].push([e, n]), t(this, o)[o].on(e, n);
            }
          }, {
            key: "remove",
            value: function remove() {
              var _iterator17 = _createForOfIteratorHelper(t(this, i)[i].splice(0)),
                  _step17;

              try {
                for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
                  var _ref50 = _step17.value;

                  var _ref49 = _slicedToArray(_ref50, 2);

                  var _e60 = _ref49[0];
                  var _n29 = _ref49[1];
                  t(this, o)[o].off(_e60, _n29);
                }
              } catch (err) {
                _iterator17.e(err);
              } finally {
                _iterator17.f();
              }
            }
          }]);

          return _class16;
        }();
      },
      1516: function _(e) {
        "use strict";

        var t = /*#__PURE__*/function (_Error5) {
          _inherits(t, _Error5);

          var _super77 = _createSuper(t);

          function t(e, _t45) {
            var _this144;

            _classCallCheck(this, t);

            void 0 === _t45 && (_t45 = null), _this144 = _super77.call(this, "This looks like a network error, the endpoint might be blocked by an internet provider or a firewall."), _this144.cause = e, _this144.isNetworkError = !0, _this144.request = _t45;
            return _this144;
          }

          return t;
        }( /*#__PURE__*/_wrapNativeSuper(Error));

        e.exports = t;
      },
      3822: function _(e) {
        "use strict";

        function t(e, t) {
          if (!Object.prototype.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
          return e;
        }

        var n = 0;

        function r(e) {
          return "__private_" + n++ + "_" + e;
        }

        var o = r("aliveTimer"),
            i = r("isDone"),
            s = r("onTimedOut"),
            a = r("timeout");

        e.exports = /*#__PURE__*/function () {
          function _class17(e, n) {
            _classCallCheck(this, _class17);

            Object.defineProperty(this, o, {
              writable: !0,
              value: void 0
            }), Object.defineProperty(this, i, {
              writable: !0,
              value: !1
            }), Object.defineProperty(this, s, {
              writable: !0,
              value: void 0
            }), Object.defineProperty(this, a, {
              writable: !0,
              value: void 0
            }), t(this, a)[a] = e, t(this, s)[s] = n;
          }

          _createClass(_class17, [{
            key: "progress",
            value: function progress() {
              t(this, i)[i] || t(this, a)[a] > 0 && (clearTimeout(t(this, o)[o]), t(this, o)[o] = setTimeout(t(this, s)[s], t(this, a)[a]));
            }
          }, {
            key: "done",
            value: function done() {
              t(this, i)[i] || (clearTimeout(t(this, o)[o]), t(this, o)[o] = null, t(this, i)[i] = !0);
            }
          }]);

          return _class17;
        }();
      },
      9628: function _(e, t) {
        "use strict";

        function n(e, t) {
          if (!Object.prototype.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
          return e;
        }

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.internalRateLimitedQueue = t.RateLimitedQueue = void 0;
        var r = 0;

        function o(e) {
          return "__private_" + r++ + "_" + e;
        }

        function i() {
          return new Error("Cancelled");
        }

        var s = o("activeRequests"),
            a = o("queuedHandlers"),
            l = o("paused"),
            c = o("pauseTimer"),
            u = o("downLimit"),
            d = o("upperLimit"),
            h = o("rateLimitingTimer"),
            f = o("call"),
            p = o("queueNext"),
            g = o("next"),
            m = o("queue"),
            v = o("dequeue"),
            y = o("resume"),
            b = o("increaseLimit");

        function w(e) {
          var _this145 = this;

          n(this, s)[s] += 1;
          var t,
              r = !1;

          try {
            t = e();
          } catch (e) {
            throw n(this, s)[s] -= 1, e;
          }

          return {
            abort: function abort() {
              r || (r = !0, n(_this145, s)[s] -= 1, t(), n(_this145, p)[p]());
            },
            done: function done() {
              r || (r = !0, n(_this145, s)[s] -= 1, n(_this145, p)[p]());
            }
          };
        }

        function O() {
          var _this146 = this;

          queueMicrotask(function () {
            return n(_this146, g)[g]();
          });
        }

        function E() {
          if (n(this, l)[l] || n(this, s)[s] >= this.limit) return;
          if (0 === n(this, a)[a].length) return;
          var e = n(this, a)[a].shift(),
              t = n(this, f)[f](e.fn);
          e.abort = t.abort, e.done = t.done;
        }

        function _(e, t) {
          var _this147 = this;

          void 0 === t && (t = {});
          var r = {
            fn: e,
            priority: t.priority || 0,
            abort: function abort() {
              n(_this147, v)[v](r);
            },
            done: function done() {
              throw new Error("Cannot mark a queued request as done: this indicates a bug");
            }
          },
              o = n(this, a)[a].findIndex(function (e) {
            return r.priority > e.priority;
          });
          return -1 === o ? n(this, a)[a].push(r) : n(this, a)[a].splice(o, 0, r), r;
        }

        function S(e) {
          var t = n(this, a)[a].indexOf(e);
          -1 !== t && n(this, a)[a].splice(t, 1);
        }

        t.RateLimitedQueue = /*#__PURE__*/function () {
          function _class18(e) {
            var _this148 = this;

            _classCallCheck(this, _class18);

            Object.defineProperty(this, v, {
              value: S
            }), Object.defineProperty(this, m, {
              value: _
            }), Object.defineProperty(this, g, {
              value: E
            }), Object.defineProperty(this, p, {
              value: O
            }), Object.defineProperty(this, f, {
              value: w
            }), Object.defineProperty(this, s, {
              writable: !0,
              value: 0
            }), Object.defineProperty(this, a, {
              writable: !0,
              value: []
            }), Object.defineProperty(this, l, {
              writable: !0,
              value: !1
            }), Object.defineProperty(this, c, {
              writable: !0,
              value: void 0
            }), Object.defineProperty(this, u, {
              writable: !0,
              value: 1
            }), Object.defineProperty(this, d, {
              writable: !0,
              value: void 0
            }), Object.defineProperty(this, h, {
              writable: !0,
              value: void 0
            }), Object.defineProperty(this, y, {
              writable: !0,
              value: function value() {
                return _this148.resume();
              }
            }), Object.defineProperty(this, b, {
              writable: !0,
              value: function value() {
                if (n(_this148, l)[l]) n(_this148, h)[h] = setTimeout(n(_this148, b)[b], 0);else {
                  n(_this148, u)[u] = _this148.limit, _this148.limit = Math.ceil((n(_this148, d)[d] + n(_this148, u)[u]) / 2);

                  for (var _e61 = n(_this148, u)[u]; _e61 <= _this148.limit; _e61++) {
                    n(_this148, p)[p]();
                  }

                  n(_this148, d)[d] - n(_this148, u)[u] > 3 ? n(_this148, h)[h] = setTimeout(n(_this148, b)[b], 2e3) : n(_this148, u)[u] = Math.floor(n(_this148, u)[u] / 2);
                }
              }
            }), this.limit = "number" != typeof e || 0 === e ? 1 / 0 : e;
          }

          _createClass(_class18, [{
            key: "run",
            value: function run(e, t) {
              return !n(this, l)[l] && n(this, s)[s] < this.limit ? n(this, f)[f](e) : n(this, m)[m](e, t);
            }
          }, {
            key: "wrapPromiseFunction",
            value: function wrapPromiseFunction(e, t) {
              var n = this;
              return function () {
                for (var r = arguments.length, o = new Array(r), s = 0; s < r; s++) {
                  o[s] = arguments[s];
                }

                var a;
                var l = new Promise(function (r, s) {
                  a = n.run(function () {
                    var t, n;

                    try {
                      n = Promise.resolve(e.apply(void 0, o));
                    } catch (e) {
                      n = Promise.reject(e);
                    }

                    return n.then(function (e) {
                      t ? s(t) : (a.done(), r(e));
                    }, function (e) {
                      t ? s(t) : (a.done(), s(e));
                    }), function () {
                      t = i();
                    };
                  }, t);
                });
                return l.abort = function () {
                  a.abort();
                }, l;
              };
            }
          }, {
            key: "resume",
            value: function resume() {
              n(this, l)[l] = !1, clearTimeout(n(this, c)[c]);

              for (var _e62 = 0; _e62 < this.limit; _e62++) {
                n(this, p)[p]();
              }
            }
          }, {
            key: "pause",
            value: function pause(e) {
              void 0 === e && (e = null), n(this, l)[l] = !0, clearTimeout(n(this, c)[c]), null != e && (n(this, c)[c] = setTimeout(n(this, y)[y], e));
            }
          }, {
            key: "rateLimit",
            value: function rateLimit(e) {
              clearTimeout(n(this, h)[h]), this.pause(e), this.limit > 1 && Number.isFinite(this.limit) && (n(this, d)[d] = this.limit - 1, this.limit = n(this, u)[u], n(this, h)[h] = setTimeout(n(this, b)[b], e));
            }
          }, {
            key: "isPaused",
            get: function get() {
              return n(this, l)[l];
            }
          }]);

          return _class18;
        }();

        var x = Symbol("__queue");
        t.internalRateLimitedQueue = x;
      },
      3149: function _(e, t, n) {
        "use strict";

        function r(e, t) {
          if (!Object.prototype.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
          return e;
        }

        var o = 0;

        function i(e) {
          return "__private_" + o++ + "_" + e;
        }

        var s = n(3689);

        function a(e, t, n) {
          var r = [];
          return e.forEach(function (e) {
            return "string" != typeof e ? r.push(e) : t[Symbol.split](e).forEach(function (e, t, o) {
              "" !== e && r.push(e), t < o.length - 1 && r.push(n);
            });
          }), r;
        }

        function l(e, t) {
          var n = /\$/g;
          var r = [e];
          if (null == t) return r;

          for (var _i53 = 0, _Object$keys = Object.keys(t); _i53 < _Object$keys.length; _i53++) {
            var _e63 = _Object$keys[_i53];

            if ("_" !== _e63) {
              var _o20 = t[_e63];
              "string" == typeof _o20 && (_o20 = n[Symbol.replace](_o20, "$$$$")), r = a(r, new RegExp("%\\{".concat(_e63, "\\}"), "g"), _o20);
            }
          }

          return r;
        }

        var c = i("apply");

        function u(e) {
          if (null == e || !e.strings) return;
          var t = this.locale;
          this.locale = _objectSpread(_objectSpread({}, t), {}, {
            strings: _objectSpread(_objectSpread({}, t.strings), e.strings)
          }), this.locale.pluralize = e.pluralize || t.pluralize;
        }

        e.exports = /*#__PURE__*/function () {
          function _class19(e) {
            _classCallCheck(this, _class19);

            Object.defineProperty(this, c, {
              value: u
            }), this.locale = {
              strings: {},
              pluralize: function pluralize(e) {
                return 1 === e ? 0 : 1;
              }
            }, Array.isArray(e) ? e.forEach(r(this, c)[c], this) : r(this, c)[c](e);
          }

          _createClass(_class19, [{
            key: "translate",
            value: function translate(e, t) {
              return this.translateArray(e, t).join("");
            }
          }, {
            key: "translateArray",
            value: function translateArray(e, t) {
              if (!s(this.locale.strings, e)) throw new Error("missing string: ".concat(e));
              var n = this.locale.strings[e];

              if ("object" == _typeof(n)) {
                if (t && void 0 !== t.smart_count) return l(n[this.locale.pluralize(t.smart_count)], t);
                throw new Error("Attempted to use a string with plural forms, but no value was given for %{smart_count}");
              }

              return l(n, t);
            }
          }]);

          return _class19;
        }();
      },
      9916: function _(e, t, n) {
        "use strict";

        var r = n(3096);
        e.exports = r(function (e, t, n) {
          var r = t.progress,
              o = t.bytesUploaded,
              i = t.bytesTotal;
          r && (e.uppy.log("Upload progress: ".concat(r)), e.uppy.emit("upload-progress", n, {
            uploader: e,
            bytesUploaded: o,
            bytesTotal: i
          }));
        }, 300, {
          leading: !0,
          trailing: !0
        });
      },
      104: function _(e, t, n) {
        "use strict";

        var r = n(1516);

        e.exports = function () {
          return fetch.apply(void 0, arguments).catch(function (e) {
            throw "AbortError" === e.name ? e : new r(e);
          });
        };
      },
      4088: function _(e, t, n) {
        "use strict";

        var r = n(6666);

        e.exports = function (e, t) {
          return void 0 === t && (t = document), "string" == typeof e ? t.querySelector(e) : r(e) ? e : null;
        };
      },
      6526: function _(e) {
        "use strict";

        function t(e) {
          var t = "";
          return e.replace(/[^A-Z0-9]/gi, function (e) {
            return t += "-".concat(function (e) {
              return e.charCodeAt(0).toString(32);
            }(e)), "/";
          }) + t;
        }

        e.exports = function (e) {
          var n = "uppy";
          return "string" == typeof e.name && (n += "-".concat(t(e.name.toLowerCase()))), void 0 !== e.type && (n += "-".concat(e.type)), e.meta && "string" == typeof e.meta.relativePath && (n += "-".concat(t(e.meta.relativePath.toLowerCase()))), void 0 !== e.data.size && (n += "-".concat(e.data.size)), void 0 !== e.data.lastModified && (n += "-".concat(e.data.lastModified)), n;
        };
      },
      6397: function _(e, t, n) {
        "use strict";

        var r = n(9935),
            o = n(9635);

        e.exports = function (e, t) {
          var n;

          var _ref51 = void 0 === t ? {} : t,
              _ref51$logDropError = _ref51.logDropError,
              i = _ref51$logDropError === void 0 ? function () {} : _ref51$logDropError;

          return null != (n = e.items) && n[0] && "webkitGetAsEntry" in e.items[0] ? r(e, i) : o(e);
        };
      },
      9635: function _(e, t, n) {
        "use strict";

        var r = n(3356);

        e.exports = function (e) {
          var t = r(e.files);
          return Promise.resolve(t);
        };
      },
      3413: function _(e) {
        "use strict";

        e.exports = function e(t, n, r, o) {
          var i = o.onSuccess;
          t.readEntries(function (o) {
            var s = [].concat(_toConsumableArray(n), _toConsumableArray(o));
            o.length ? setTimeout(function () {
              e(t, s, r, {
                onSuccess: i
              });
            }, 0) : i(s);
          }, function (e) {
            r(e), i(n);
          });
        };
      },
      1850: function _(e) {
        "use strict";

        e.exports = function (e) {
          return e.fullPath && e.fullPath !== "/".concat(e.name) ? e.fullPath : null;
        };
      },
      9935: function _(e, t, n) {
        "use strict";

        var r = n(1850),
            o = n(3413),
            i = n(3356);

        e.exports = function (e, t) {
          var n = [],
              s = [],
              a = function a(e) {
            return new Promise(function (i) {
              if (e.isFile) e.file(function (t) {
                t.relativePath = r(e), n.push(t), i();
              }, function (e) {
                t(e), i();
              });else if (e.isDirectory) {
                var _n30 = e.createReader();

                o(_n30, [], t, {
                  onSuccess: function onSuccess(e) {
                    return i(Promise.all(e.map(a)));
                  }
                });
              }
            });
          };

          return i(e.items).forEach(function (e) {
            var t = e.webkitGetAsEntry();
            t && s.push(a(t));
          }), Promise.all(s).then(function () {
            return n;
          });
        };
      },
      9655: function _(e) {
        "use strict";

        e.exports = function (e) {
          var t = e.lastIndexOf(".");
          return -1 === t || t === e.length - 1 ? {
            name: e,
            extension: void 0
          } : {
            name: e.slice(0, t),
            extension: e.slice(t + 1)
          };
        };
      },
      9187: function _(e, t, n) {
        "use strict";

        var r = n(9655),
            o = n(1582);

        e.exports = function (e) {
          var t;
          if (e.type) return e.type;
          var n = e.name ? null == (t = r(e.name).extension) ? void 0 : t.toLowerCase() : null;
          return n && n in o ? o[n] : "application/octet-stream";
        };
      },
      4629: function _(e) {
        "use strict";

        e.exports = function (e) {
          var t = /^(?:https?:\/\/|\/\/)?(?:[^@\n]+@)?(?:www\.)?([^\n]+)/i.exec(e)[1];
          return "".concat(/^http:\/\//i.test(e) ? "ws" : "wss", "://").concat(t);
        };
      },
      5589: function _(e) {
        "use strict";

        e.exports = function (e) {
          for (var t; e && !e.dir;) {
            e = e.parentNode;
          }

          return null == (t = e) ? void 0 : t.dir;
        };
      },
      152: function _(e) {
        "use strict";

        function t(e) {
          return e < 10 ? "0".concat(e) : e.toString();
        }

        e.exports = function () {
          var e = new Date();
          return "".concat(t(e.getHours()), ":").concat(t(e.getMinutes()), ":").concat(t(e.getSeconds()));
        };
      },
      3689: function _(e) {
        "use strict";

        e.exports = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        };
      },
      6666: function _(e) {
        "use strict";

        e.exports = function (e) {
          return (null == e ? void 0 : e.nodeType) === Node.ELEMENT_NODE;
        };
      },
      8419: function _(e) {
        "use strict";

        e.exports = function (e) {
          return !!e && (0 !== e.readyState && 4 !== e.readyState || 0 === e.status);
        };
      },
      1582: function _(e) {
        "use strict";

        e.exports = {
          md: "text/markdown",
          markdown: "text/markdown",
          mp4: "video/mp4",
          mp3: "audio/mp3",
          svg: "image/svg+xml",
          jpg: "image/jpeg",
          png: "image/png",
          gif: "image/gif",
          heic: "image/heic",
          heif: "image/heif",
          yaml: "text/yaml",
          yml: "text/yaml",
          csv: "text/csv",
          tsv: "text/tab-separated-values",
          tab: "text/tab-separated-values",
          avi: "video/x-msvideo",
          mks: "video/x-matroska",
          mkv: "video/x-matroska",
          mov: "video/quicktime",
          dicom: "application/dicom",
          doc: "application/msword",
          docm: "application/vnd.ms-word.document.macroenabled.12",
          docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          dot: "application/msword",
          dotm: "application/vnd.ms-word.template.macroenabled.12",
          dotx: "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
          xla: "application/vnd.ms-excel",
          xlam: "application/vnd.ms-excel.addin.macroenabled.12",
          xlc: "application/vnd.ms-excel",
          xlf: "application/x-xliff+xml",
          xlm: "application/vnd.ms-excel",
          xls: "application/vnd.ms-excel",
          xlsb: "application/vnd.ms-excel.sheet.binary.macroenabled.12",
          xlsm: "application/vnd.ms-excel.sheet.macroenabled.12",
          xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          xlt: "application/vnd.ms-excel",
          xltm: "application/vnd.ms-excel.template.macroenabled.12",
          xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
          xlw: "application/vnd.ms-excel",
          txt: "text/plain",
          text: "text/plain",
          conf: "text/plain",
          log: "text/plain",
          pdf: "application/pdf",
          zip: "application/zip",
          "7z": "application/x-7z-compressed",
          rar: "application/x-rar-compressed",
          tar: "application/x-tar",
          gz: "application/gzip",
          dmg: "application/x-apple-diskimage"
        };
      },
      7191: function _(e) {
        "use strict";

        e.exports = function (e) {
          var t = [],
              n = [];

          function r(e) {
            t.push(e);
          }

          function o(e) {
            n.push(e);
          }

          return Promise.all(e.map(function (e) {
            return e.then(r, o);
          })).then(function () {
            return {
              successful: t,
              failed: n
            };
          });
        };
      },
      3356: function _(e) {
        "use strict";

        e.exports = Array.from;
      },
      8978: function _(e, t, n) {
        "use strict";

        var r = n(2961),
            o = n(3145),
            i = n(9628);
        var s = n(3521),
            a = n(9916),
            l = n(4629),
            c = n(7191),
            u = n(2328),
            d = n(3822),
            h = n(1516),
            f = n(8419),
            p = n(1026);

        function g(e, t) {
          var n = t;
          return n || (n = new Error("Upload error")), "string" == typeof n && (n = new Error(n)), n instanceof Error || (n = Object.assign(new Error("Upload error"), {
            data: n
          })), f(e) ? (n = new h(n, e), n) : (n.request = e, n);
        }

        function m(e) {
          return e.data.slice(0, e.data.size, e.meta.type);
        }

        var v = /*#__PURE__*/function (_s7) {
          _inherits(v, _s7);

          var _super78 = _createSuper(v);

          function v(e, t) {
            var _this149;

            _classCallCheck(this, v);

            _this149 = _super78.call(this, e, t), _this149.type = "uploader", _this149.id = _this149.opts.id || "XHRUpload", _this149.title = "XHRUpload", _this149.defaultLocale = p;
            var n = {
              formData: !0,
              fieldName: t.bundle ? "files[]" : "file",
              method: "post",
              metaFields: null,
              responseUrlFieldName: "url",
              bundle: !1,
              headers: {},
              timeout: 3e4,
              limit: 5,
              withCredentials: !1,
              responseType: "",
              getResponseData: function getResponseData(t) {
                var n = {};

                try {
                  n = JSON.parse(t);
                } catch (t) {
                  e.log(t);
                }

                return n;
              },
              getResponseError: function getResponseError(e, t) {
                var n = new Error("Upload error");
                return f(t) && (n = new h(n, t)), n;
              },
              validateStatus: function validateStatus(e) {
                return e >= 200 && e < 300;
              }
            };
            if (_this149.opts = _objectSpread(_objectSpread({}, n), t), _this149.i18nInit(), _this149.handleUpload = _this149.handleUpload.bind(_assertThisInitialized(_this149)), i.internalRateLimitedQueue in _this149.opts ? _this149.requests = _this149.opts[i.internalRateLimitedQueue] : _this149.requests = new i.RateLimitedQueue(_this149.opts.limit), _this149.opts.bundle && !_this149.opts.formData) throw new Error("`opts.formData` must be true when `opts.bundle` is enabled.");
            _this149.uploaderEvents = Object.create(null);
            return _this149;
          }

          _createClass(v, [{
            key: "getOptions",
            value: function getOptions(e) {
              var t = this.uppy.getState().xhrUpload,
                  n = this.opts.headers,
                  r = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.opts), t || {}), e.xhrUpload || {}), {}, {
                headers: {}
              });

              return "function" == typeof n ? r.headers = n(e) : Object.assign(r.headers, this.opts.headers), t && Object.assign(r.headers, t.headers), e.xhrUpload && Object.assign(r.headers, e.xhrUpload.headers), r;
            }
          }, {
            key: "addMetadata",
            value: function addMetadata(e, t, n) {
              (Array.isArray(n.metaFields) ? n.metaFields : Object.keys(t)).forEach(function (n) {
                e.append(n, t[n]);
              });
            }
          }, {
            key: "createFormDataUpload",
            value: function createFormDataUpload(e, t) {
              var n = new FormData();
              this.addMetadata(n, e.meta, t);
              var r = m(e);
              return e.name ? n.append(t.fieldName, r, e.meta.name) : n.append(t.fieldName, r), n;
            }
          }, {
            key: "createBundledUpload",
            value: function createBundledUpload(e, t) {
              var _this150 = this;

              var n = new FormData(),
                  _this$uppy$getState4 = this.uppy.getState(),
                  r = _this$uppy$getState4.meta;

              return this.addMetadata(n, r, t), e.forEach(function (e) {
                var t = _this150.getOptions(e),
                    r = m(e);

                e.name ? n.append(t.fieldName, r, e.name) : n.append(t.fieldName, r);
              }), n;
            }
          }, {
            key: "upload",
            value: function upload(e, t, n) {
              var _this151 = this;

              var o = this.getOptions(e);
              return this.uppy.log("uploading ".concat(t, " of ").concat(n)), new Promise(function (t, n) {
                _this151.uppy.emit("upload-started", e);

                var i = o.formData ? _this151.createFormDataUpload(e, o) : e.data,
                    s = new XMLHttpRequest();
                var a;
                _this151.uploaderEvents[e.id] = new u(_this151.uppy);
                var l = new d(o.timeout, function () {
                  s.abort(), a.done();
                  var t = new Error(_this151.i18n("timedOut", {
                    seconds: Math.ceil(o.timeout / 1e3)
                  }));
                  _this151.uppy.emit("upload-error", e, t), n(t);
                }),
                    c = (0, r.nanoid)();
                s.upload.addEventListener("loadstart", function () {
                  _this151.uppy.log("[XHRUpload] ".concat(c, " started"));
                }), s.upload.addEventListener("progress", function (t) {
                  _this151.uppy.log("[XHRUpload] ".concat(c, " progress: ").concat(t.loaded, " / ").concat(t.total)), l.progress(), t.lengthComputable && _this151.uppy.emit("upload-progress", e, {
                    uploader: _this151,
                    bytesUploaded: t.loaded,
                    bytesTotal: t.total
                  });
                }), s.addEventListener("load", function () {
                  if (_this151.uppy.log("[XHRUpload] ".concat(c, " finished")), l.done(), a.done(), _this151.uploaderEvents[e.id] && (_this151.uploaderEvents[e.id].remove(), _this151.uploaderEvents[e.id] = null), o.validateStatus(s.status, s.responseText, s)) {
                    var _n31 = o.getResponseData(s.responseText, s),
                        _r35 = _n31[o.responseUrlFieldName],
                        _i54 = {
                      status: s.status,
                      body: _n31,
                      uploadURL: _r35
                    };

                    return _this151.uppy.emit("upload-success", e, _i54), _r35 && _this151.uppy.log("Download ".concat(e.name, " from ").concat(_r35)), t(e);
                  }

                  var r = o.getResponseData(s.responseText, s),
                      i = g(s, o.getResponseError(s.responseText, s)),
                      u = {
                    status: s.status,
                    body: r
                  };
                  return _this151.uppy.emit("upload-error", e, i, u), n(i);
                }), s.addEventListener("error", function () {
                  _this151.uppy.log("[XHRUpload] ".concat(c, " errored")), l.done(), a.done(), _this151.uploaderEvents[e.id] && (_this151.uploaderEvents[e.id].remove(), _this151.uploaderEvents[e.id] = null);
                  var t = g(s, o.getResponseError(s.responseText, s));
                  return _this151.uppy.emit("upload-error", e, t), n(t);
                }), s.open(o.method.toUpperCase(), o.endpoint, !0), s.withCredentials = o.withCredentials, "" !== o.responseType && (s.responseType = o.responseType), a = _this151.requests.run(function () {
                  _this151.uppy.emit("upload-started", e);

                  var t = _this151.getOptions(e);

                  return Object.keys(t.headers).forEach(function (e) {
                    s.setRequestHeader(e, t.headers[e]);
                  }), s.send(i), function () {
                    l.done(), s.abort();
                  };
                }), _this151.onFileRemove(e.id, function () {
                  a.abort(), n(new Error("File removed"));
                }), _this151.onCancelAll(e.id, function (e) {
                  var t = e.reason;
                  "user" === t && a.abort(), n(new Error("Upload cancelled"));
                });
              });
            }
          }, {
            key: "uploadRemote",
            value: function uploadRemote(e) {
              var _this152 = this;

              var t = this.getOptions(e);
              return new Promise(function (n, r) {
                _this152.uppy.emit("upload-started", e);

                var i = {};
                (Array.isArray(t.metaFields) ? t.metaFields : Object.keys(e.meta)).forEach(function (t) {
                  i[t] = e.meta[t];
                }), new (e.remote.providerOptions.provider ? o.Provider : o.RequestClient)(_this152.uppy, e.remote.providerOptions).post(e.remote.url, _objectSpread(_objectSpread({}, e.remote.body), {}, {
                  endpoint: t.endpoint,
                  size: e.data.size,
                  fieldname: t.fieldName,
                  metadata: i,
                  httpMethod: t.method,
                  useFormData: t.formData,
                  headers: t.headers
                })).then(function (i) {
                  var s = i.token,
                      c = l(e.remote.companionUrl),
                      d = new o.Socket({
                    target: "".concat(c, "/api/").concat(s),
                    autoOpen: !1
                  });
                  var h;
                  _this152.uploaderEvents[e.id] = new u(_this152.uppy), _this152.onFileRemove(e.id, function () {
                    d.send("cancel", {}), h.abort(), n("upload ".concat(e.id, " was removed"));
                  }), _this152.onCancelAll(e.id, function (t) {
                    var _ref52 = void 0 === t ? {} : t,
                        r = _ref52.reason;

                    "user" === r && (d.send("cancel", {}), h.abort()), n("upload ".concat(e.id, " was canceled"));
                  }), _this152.onRetry(e.id, function () {
                    d.send("pause", {}), d.send("resume", {});
                  }), _this152.onRetryAll(e.id, function () {
                    d.send("pause", {}), d.send("resume", {});
                  }), d.on("progress", function (t) {
                    return a(_this152, t, e);
                  }), d.on("success", function (r) {
                    var o = t.getResponseData(r.response.responseText, r.response),
                        i = o[t.responseUrlFieldName],
                        s = {
                      status: r.response.status,
                      body: o,
                      uploadURL: i
                    };
                    return _this152.uppy.emit("upload-success", e, s), h.done(), _this152.uploaderEvents[e.id] && (_this152.uploaderEvents[e.id].remove(), _this152.uploaderEvents[e.id] = null), n();
                  }), d.on("error", function (n) {
                    var o = n.response,
                        i = o ? t.getResponseError(o.responseText, o) : Object.assign(new Error(n.error.message), {
                      cause: n.error
                    });
                    _this152.uppy.emit("upload-error", e, i), h.done(), _this152.uploaderEvents[e.id] && (_this152.uploaderEvents[e.id].remove(), _this152.uploaderEvents[e.id] = null), r(i);
                  }), h = _this152.requests.run(function () {
                    return d.open(), e.isPaused && d.send("pause", {}), function () {
                      return d.close();
                    };
                  });
                }).catch(function (t) {
                  _this152.uppy.emit("upload-error", e, t), r(t);
                });
              });
            }
          }, {
            key: "uploadBundle",
            value: function uploadBundle(e) {
              var _this153 = this;

              return new Promise(function (t, n) {
                var r = _this153.opts.endpoint,
                    o = _this153.opts.method,
                    i = _this153.uppy.getState().xhrUpload,
                    s = _this153.createBundledUpload(e, _objectSpread(_objectSpread({}, _this153.opts), i || {})),
                    a = new XMLHttpRequest(),
                    l = function l(t) {
                  e.forEach(function (e) {
                    _this153.uppy.emit("upload-error", e, t);
                  });
                },
                    c = new d(_this153.opts.timeout, function () {
                  a.abort();
                  var e = new Error(_this153.i18n("timedOut", {
                    seconds: Math.ceil(_this153.opts.timeout / 1e3)
                  }));
                  l(e), n(e);
                });

                a.upload.addEventListener("loadstart", function () {
                  _this153.uppy.log("[XHRUpload] started uploading bundle"), c.progress();
                }), a.upload.addEventListener("progress", function (t) {
                  c.progress(), t.lengthComputable && e.forEach(function (e) {
                    _this153.uppy.emit("upload-progress", e, {
                      uploader: _this153,
                      bytesUploaded: t.loaded / t.total * e.size,
                      bytesTotal: e.size
                    });
                  });
                }), a.addEventListener("load", function (r) {
                  if (c.done(), _this153.opts.validateStatus(r.target.status, a.responseText, a)) {
                    var _n32 = _this153.opts.getResponseData(a.responseText, a),
                        _o21 = {
                      status: r.target.status,
                      body: _n32
                    };

                    return e.forEach(function (e) {
                      _this153.uppy.emit("upload-success", e, _o21);
                    }), t();
                  }

                  var o = _this153.opts.getResponseError(a.responseText, a) || new Error("Upload error");
                  return o.request = a, l(o), n(o);
                }), a.addEventListener("error", function () {
                  c.done();
                  var e = _this153.opts.getResponseError(a.responseText, a) || new Error("Upload error");
                  return l(e), n(e);
                }), _this153.uppy.on("cancel-all", function (e) {
                  var _ref53 = void 0 === e ? {} : e,
                      t = _ref53.reason;

                  "user" === t && (c.done(), a.abort());
                }), a.open(o.toUpperCase(), r, !0), a.withCredentials = _this153.opts.withCredentials, "" !== _this153.opts.responseType && (a.responseType = _this153.opts.responseType), Object.keys(_this153.opts.headers).forEach(function (e) {
                  a.setRequestHeader(e, _this153.opts.headers[e]);
                }), a.send(s), e.forEach(function (e) {
                  _this153.uppy.emit("upload-started", e);
                });
              });
            }
          }, {
            key: "uploadFiles",
            value: function uploadFiles(e) {
              var _this154 = this;

              var t = e.map(function (t, n) {
                var r = parseInt(n, 10) + 1,
                    o = e.length;
                return t.error ? Promise.reject(new Error(t.error)) : t.isRemote ? _this154.uploadRemote(t, r, o) : _this154.upload(t, r, o);
              });
              return c(t);
            }
          }, {
            key: "onFileRemove",
            value: function onFileRemove(e, t) {
              this.uploaderEvents[e].on("file-removed", function (n) {
                e === n.id && t(n.id);
              });
            }
          }, {
            key: "onRetry",
            value: function onRetry(e, t) {
              this.uploaderEvents[e].on("upload-retry", function (n) {
                e === n && t();
              });
            }
          }, {
            key: "onRetryAll",
            value: function onRetryAll(e, t) {
              var _this155 = this;

              this.uploaderEvents[e].on("retry-all", function () {
                _this155.uppy.getFile(e) && t();
              });
            }
          }, {
            key: "onCancelAll",
            value: function onCancelAll(e, t) {
              var n = this;
              this.uploaderEvents[e].on("cancel-all", function () {
                n.uppy.getFile(e) && t.apply(void 0, arguments);
              });
            }
          }, {
            key: "handleUpload",
            value: function handleUpload(e) {
              var _this156 = this;

              if (0 === e.length) return this.uppy.log("[XHRUpload] No files to upload!"), Promise.resolve();
              0 !== this.opts.limit || this.opts[i.internalRateLimitedQueue] || this.uppy.log("[XHRUpload] When uploading multiple files at once, consider setting the `limit` option (to `10` for example), to limit the number of concurrent uploads, which helps prevent memory and network issues: https://uppy.io/docs/xhr-upload/#limit-0", "warning"), this.uppy.log("[XHRUpload] Uploading...");
              var t = e.map(function (e) {
                return _this156.uppy.getFile(e);
              });

              if (this.opts.bundle) {
                if (t.some(function (e) {
                  return e.isRemote;
                })) throw new Error("Can’t upload remote files when the `bundle: true` option is set");
                if ("function" == typeof this.opts.headers) throw new TypeError("`headers` may not be a function when the `bundle: true` option is set");
                return this.uploadBundle(t);
              }

              return this.uploadFiles(t).then(function () {
                return null;
              });
            }
          }, {
            key: "install",
            value: function install() {
              if (this.opts.bundle) {
                var _this$uppy$getState5 = this.uppy.getState(),
                    _e64 = _this$uppy$getState5.capabilities;

                this.uppy.setState({
                  capabilities: _objectSpread(_objectSpread({}, _e64), {}, {
                    individualCancellation: !1
                  })
                });
              }

              this.uppy.addUploader(this.handleUpload);
            }
          }, {
            key: "uninstall",
            value: function uninstall() {
              if (this.opts.bundle) {
                var _this$uppy$getState6 = this.uppy.getState(),
                    _e65 = _this$uppy$getState6.capabilities;

                this.uppy.setState({
                  capabilities: _objectSpread(_objectSpread({}, _e65), {}, {
                    individualCancellation: !0
                  })
                });
              }

              this.uppy.removeUploader(this.handleUpload);
            }
          }]);

          return v;
        }(s);

        v.VERSION = "2.1.2", e.exports = v;
      },
      1026: function _(e) {
        "use strict";

        e.exports = {
          strings: {
            timedOut: "Upload stalled for %{seconds} seconds, aborting."
          }
        };
      },
      2961: function _(e) {
        e.exports = {
          nanoid: function nanoid() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 21;
            var t = "",
                n = e;

            for (; n--;) {
              t += "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict"[64 * Math.random() | 0];
            }

            return t;
          },
          customAlphabet: function customAlphabet(e) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 21;
            return function () {
              var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : t;
              var r = "",
                  o = n;

              for (; o--;) {
                r += e[Math.random() * e.length | 0];
              }

              return r;
            };
          }
        };
      }
    },
        t = {};

    function n(r) {
      var o = t[r];
      if (void 0 !== o) return o.exports;
      var i = t[r] = {
        exports: {}
      };
      return e[r].call(i.exports, i, i.exports, n), i.exports;
    }

    n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, {
        a: t
      }), t;
    }, n.d = function (e, t) {
      for (var r in t) {
        n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
          enumerable: !0,
          get: t[r]
        });
      }
    }, n.g = function () {
      if ("object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis))) return globalThis;

      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == (typeof window === "undefined" ? "undefined" : _typeof(window))) return window;
      }
    }(), n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var r = {};
    return function () {
      "use strict";

      n.r(r);

      var e = /*#__PURE__*/function (_HTMLElement) {
        _inherits(e, _HTMLElement);

        var _super79 = _createSuper(e);

        function e() {
          _classCallCheck(this, e);

          return _super79.apply(this, arguments);
        }

        _createClass(e, [{
          key: "preload",
          get: function get() {
            return this.hasAttribute("preload");
          },
          set: function set(_e66) {
            _e66 ? this.setAttribute("preload", "") : this.removeAttribute("preload");
          }
        }, {
          key: "src",
          get: function get() {
            return this.getAttribute("src") || "";
          },
          set: function set(_e67) {
            this.setAttribute("src", _e67);
          }
        }, {
          key: "connectedCallback",
          value: function connectedCallback() {
            var _this157 = this;

            this.hasAttribute("role") || this.setAttribute("role", "menu");
            var _e68 = this.parentElement;
            if (!_e68) return;

            var n = _e68.querySelector("summary");

            n && (n.setAttribute("aria-haspopup", "menu"), n.hasAttribute("role") || n.setAttribute("role", "button"));
            var r = [i(_e68, "compositionstart", function (_e69) {
              return g(_this157, _e69);
            }), i(_e68, "compositionend", function (_e70) {
              return g(_this157, _e70);
            }), i(_e68, "click", function (t) {
              return d(_e68, t);
            }), i(_e68, "change", function (t) {
              return d(_e68, t);
            }), i(_e68, "keydown", function (n) {
              return function (e, n, r) {
                if (!(r instanceof KeyboardEvent)) return;
                if (e.querySelector("details[open]")) return;
                var o = t.get(n);
                if (!o || o.isComposing) return;
                var i = r.target instanceof Element && "SUMMARY" === r.target.tagName;

                switch (r.key) {
                  case "Escape":
                    e.hasAttribute("open") && (p(e), r.preventDefault(), r.stopPropagation());
                    break;

                  case "ArrowDown":
                    {
                      i && !e.hasAttribute("open") && e.setAttribute("open", "");

                      var _t46 = c(e, !0);

                      _t46 && _t46.focus(), r.preventDefault();
                    }
                    break;

                  case "ArrowUp":
                    {
                      i && !e.hasAttribute("open") && e.setAttribute("open", "");

                      var _t47 = c(e, !1);

                      _t47 && _t47.focus(), r.preventDefault();
                    }
                    break;

                  case "n":
                    if (u && r.ctrlKey) {
                      var _t48 = c(e, !0);

                      _t48 && _t48.focus(), r.preventDefault();
                    }

                    break;

                  case "p":
                    if (u && r.ctrlKey) {
                      var _t49 = c(e, !1);

                      _t49 && _t49.focus(), r.preventDefault();
                    }

                    break;

                  case " ":
                  case "Enter":
                    {
                      var _t50 = document.activeElement;
                      _t50 instanceof HTMLElement && f(_t50) && _t50.closest("details") === e && (r.preventDefault(), r.stopPropagation(), _t50.click());
                    }
                }
              }(_e68, _this157, n);
            }), i(_e68, "toggle", function () {
              return s(_e68, _this157);
            }, {
              once: !0
            }), i(_e68, "toggle", function () {
              return function (e) {
                if (e.hasAttribute("open")) {
                  var _iterator18 = _createForOfIteratorHelper(document.querySelectorAll("details[open] > details-menu")),
                      _step18;

                  try {
                    for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                      var _t51 = _step18.value;

                      var _n33 = _t51.closest("details");

                      _n33 && _n33 !== e && !_n33.contains(e) && _n33.removeAttribute("open");
                    }
                  } catch (err) {
                    _iterator18.e(err);
                  } finally {
                    _iterator18.f();
                  }
                }
              }(_e68);
            }), this.preload ? i(_e68, "mouseover", function () {
              return s(_e68, _this157);
            }, {
              once: !0
            }) : o].concat(_toConsumableArray(a(_e68)));
            t.set(this, {
              subscriptions: r,
              loaded: !1,
              isComposing: !1
            });
          }
        }, {
          key: "disconnectedCallback",
          value: function disconnectedCallback() {
            var _e71 = t.get(this);

            if (_e71) {
              t.delete(this);

              var _iterator19 = _createForOfIteratorHelper(_e71.subscriptions),
                  _step19;

              try {
                for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
                  var _t52 = _step19.value;

                  _t52.unsubscribe();
                }
              } catch (err) {
                _iterator19.e(err);
              } finally {
                _iterator19.f();
              }
            }
          }
        }]);

        return e;
      }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

      var t = new WeakMap(),
          o = {
        unsubscribe: function unsubscribe() {}
      };

      function i(e, t, n) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
        return e.addEventListener(t, n, r), {
          unsubscribe: function unsubscribe() {
            e.removeEventListener(t, n, r);
          }
        };
      }

      function s(e, n) {
        var r = n.getAttribute("src");
        if (!r) return;
        var o = t.get(n);
        if (!o) return;
        if (o.loaded) return;
        o.loaded = !0;
        var i = n.querySelector("include-fragment");
        i && !i.hasAttribute("src") && (i.addEventListener("loadend", function () {
          return l(e);
        }), i.setAttribute("src", r));
      }

      function a(e) {
        var t = !1;
        return [i(e, "mousedown", function () {
          return t = !0;
        }), i(e, "keydown", function () {
          return t = !1;
        }), i(e, "toggle", function () {
          e.hasAttribute("open") && (l(e) || t || function (e) {
            var t = document.activeElement;
            if (t && f(t) && e.contains(t)) return;
            var n = c(e, !0);
            n && n.focus();
          }(e));
        })];
      }

      function l(e) {
        if (!e.hasAttribute("open")) return !1;
        var t = e.querySelector("details-menu [autofocus]");
        return !!t && (t.focus(), !0);
      }

      function c(e, t) {
        var n = Array.from(e.querySelectorAll('[role^="menuitem"]:not([hidden]):not([disabled]):not([aria-disabled="true"])')),
            r = document.activeElement,
            o = r instanceof HTMLElement ? n.indexOf(r) : -1,
            i = t ? n[o + 1] : n[o - 1],
            s = t ? n[0] : n[n.length - 1];
        return i || s;
      }

      var u = navigator.userAgent.match(/Macintosh/);

      function d(e, t) {
        var n = t.target;
        if (n instanceof Element && n.closest("details") === e) if ("click" === t.type) {
          var _t53 = n.closest('[role="menuitem"], [role="menuitemradio"]');

          if (!_t53) return;

          var _r36 = _t53.querySelector("input");

          if ("LABEL" === _t53.tagName && n === _r36) return;
          "LABEL" === _t53.tagName && _r36 && !_r36.checked || h(_t53, e);
        } else if ("change" === t.type) {
          var _t54 = n.closest('[role="menuitemradio"], [role="menuitemcheckbox"]');

          _t54 && h(_t54, e);
        }
      }

      function h(e, t) {
        if (e.hasAttribute("disabled") || "true" === e.getAttribute("aria-disabled")) return;
        var n = e.closest("details-menu");
        n && n.dispatchEvent(new CustomEvent("details-menu-select", {
          cancelable: !0,
          detail: {
            relatedTarget: e
          }
        })) && (function (e, t) {
          var n = t.querySelector("[data-menu-button]");
          if (!n) return;

          var r = function (e) {
            if (!e) return null;
            var t = e.hasAttribute("data-menu-button-text") ? e : e.querySelector("[data-menu-button-text]");
            return t ? t.getAttribute("data-menu-button-text") || t.textContent : null;
          }(e);

          if (r) n.textContent = r;else {
            var _t55 = function (e) {
              if (!e) return null;
              var t = e.hasAttribute("data-menu-button-contents") ? e : e.querySelector("[data-menu-button-contents]");
              return t ? t.innerHTML : null;
            }(e);

            _t55 && (n.innerHTML = _t55);
          }
        }(e, t), function (e, t) {
          var _iterator20 = _createForOfIteratorHelper(t.querySelectorAll('[role="menuitemradio"], [role="menuitemcheckbox"]')),
              _step20;

          try {
            for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
              var _n34 = _step20.value;

              var _t56 = _n34.querySelector('input[type="radio"], input[type="checkbox"]');

              var _r37 = (_n34 === e).toString();

              _t56 instanceof HTMLInputElement && (_r37 = _t56.indeterminate ? "mixed" : _t56.checked.toString()), _n34.setAttribute("aria-checked", _r37);
            }
          } catch (err) {
            _iterator20.e(err);
          } finally {
            _iterator20.f();
          }
        }(e, t), "menuitemcheckbox" !== e.getAttribute("role") && p(t), n.dispatchEvent(new CustomEvent("details-menu-selected", {
          detail: {
            relatedTarget: e
          }
        })));
      }

      function f(e) {
        var t = e.getAttribute("role");
        return "menuitem" === t || "menuitemcheckbox" === t || "menuitemradio" === t;
      }

      function p(e) {
        if (!e.hasAttribute("open")) return;
        e.removeAttribute("open");
        var t = e.querySelector("summary");
        t && t.focus();
      }

      function g(e, n) {
        var r = t.get(e);
        r && (r.isComposing = "compositionstart" === n.type);
      }

      window.customElements.get("details-menu") || (window.DetailsMenuElement = e, window.customElements.define("details-menu", e));

      var m,
          v,
          y,
          b,
          w,
          O,
          E = function E(e, t, n, r) {
        if ("a" === n && !r) throw new TypeError("Private accessor was defined without a getter");
        if ("function" == typeof t ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
        return "m" === n ? r : "a" === n ? r.call(e) : r ? r.value : t.get(e);
      };

      var _ = new WeakMap();

      function S() {
        return new Promise(function (e) {
          return setTimeout(e, 0);
        });
      }

      var x = /*#__PURE__*/function (_HTMLElement2) {
        _inherits(x, _HTMLElement2);

        var _super80 = _createSuper(x);

        function x() {
          var _this158;

          _classCallCheck(this, x);

          _this158 = _super80.call(this), m.add(_assertThisInitialized(_this158)), v.set(_assertThisInitialized(_this158), !1), y.set(_assertThisInitialized(_this158), new IntersectionObserver(function (e) {
            var _iterator21 = _createForOfIteratorHelper(e),
                _step21;

            try {
              for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
                var _t57 = _step21.value;

                if (_t57.isIntersecting) {
                  var _e72 = _t57.target;
                  if (E(_assertThisInitialized(_this158), y, "f").unobserve(_e72), !(_e72 instanceof x)) return;
                  "lazy" === _e72.loading && E(_assertThisInitialized(_this158), m, "m", b).call(_assertThisInitialized(_this158));
                }
              }
            } catch (err) {
              _iterator21.e(err);
            } finally {
              _iterator21.f();
            }
          }, {
            rootMargin: "0px 0px 256px 0px",
            threshold: .01
          })), _this158.attachShadow({
            mode: "open"
          }).innerHTML = "\n      <style> \n        :host {\n          display: block;\n        }\n      </style>\n      <slot></slot>";
          return _this158;
        }

        _createClass(x, [{
          key: "src",
          get: function get() {
            var e = this.getAttribute("src");

            if (e) {
              var _t58 = this.ownerDocument.createElement("a");

              return _t58.href = e, _t58.href;
            }

            return "";
          },
          set: function set(e) {
            this.setAttribute("src", e);
          }
        }, {
          key: "loading",
          get: function get() {
            return "lazy" === this.getAttribute("loading") ? "lazy" : "eager";
          },
          set: function set(e) {
            this.setAttribute("loading", e);
          }
        }, {
          key: "accept",
          get: function get() {
            return this.getAttribute("accept") || "";
          },
          set: function set(e) {
            this.setAttribute("accept", e);
          }
        }, {
          key: "data",
          get: function get() {
            return E(this, m, "m", w).call(this);
          }
        }, {
          key: "attributeChangedCallback",
          value: function attributeChangedCallback(e, t) {
            "src" === e ? this.isConnected && "eager" === this.loading && E(this, m, "m", b).call(this) : "loading" === e && this.isConnected && "eager" !== t && "eager" === this.loading && E(this, m, "m", b).call(this);
          }
        }, {
          key: "connectedCallback",
          value: function connectedCallback() {
            this.src && "eager" === this.loading && E(this, m, "m", b).call(this), "lazy" === this.loading && E(this, y, "f").observe(this);
          }
        }, {
          key: "request",
          value: function request() {
            var e = this.src;
            if (!e) throw new Error("missing src");
            return new Request(e, {
              method: "GET",
              credentials: "same-origin",
              headers: {
                Accept: this.accept || "text/html"
              }
            });
          }
        }, {
          key: "load",
          value: function load() {
            return E(this, m, "m", w).call(this);
          }
        }, {
          key: "fetch",
          value: function (_fetch) {
            function fetch(_x10) {
              return _fetch.apply(this, arguments);
            }

            fetch.toString = function () {
              return _fetch.toString();
            };

            return fetch;
          }(function (e) {
            return fetch(e);
          })
        }], [{
          key: "observedAttributes",
          get: function get() {
            return ["src", "loading"];
          }
        }]);

        return x;
      }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

      v = new WeakMap(), y = new WeakMap(), m = new WeakSet(), b = function b() {
        var _this159 = this;

        return E(this, v, "f") ? Promise.resolve() : (function (e, t, n, r, o) {
          if ("m" === r) throw new TypeError("Private method is not writable");
          if ("a" === r && !o) throw new TypeError("Private accessor was defined without a setter");
          if ("function" == typeof t ? e !== t || !o : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
          "a" === r ? o.call(e, n) : o ? o.value = n : t.set(e, n);
        }(this, v, !0, "f"), E(this, y, "f").unobserve(this), E(this, m, "m", w).call(this).then(function (e) {
          var t = document.createElement("template");
          t.innerHTML = e;
          var n = document.importNode(t.content, !0);
          !_this159.dispatchEvent(new CustomEvent("include-fragment-replace", {
            cancelable: !0,
            detail: {
              fragment: n
            }
          })) || (_this159.replaceWith(n), _this159.dispatchEvent(new CustomEvent("include-fragment-replaced")));
        }, function () {
          _this159.classList.add("is-error");
        }));
      }, w = function w() {
        var e = this.src;

        var t = _.get(this);

        return t && t.src === e ? t.data : (t = e ? E(this, m, "m", O).call(this) : Promise.reject(new Error("missing src")), _.set(this, {
          src: e,
          data: t
        }), t);
      }, O = function O() {
        var _this160 = this;

        return S().then(function () {
          return _this160.dispatchEvent(new Event("loadstart")), _this160.fetch(_this160.request());
        }).then(function (e) {
          if (200 !== e.status) throw new Error("Failed to load resource: the server responded with a status of ".concat(e.status));
          var t = e.headers.get("Content-Type");
          if (!((n = _this160.accept) && n.split(",").find(function (e) {
            return e.match(/^\s*\*\/\*/);
          }) || t && t.includes(_this160.accept ? _this160.accept : "text/html"))) throw new Error("Failed to load resource: expected ".concat(_this160.accept || "text/html", " but was ").concat(t));
          var n;
          return e.text();
        }).then(function (e) {
          return S().then(function () {
            _this160.dispatchEvent(new Event("load")), _this160.dispatchEvent(new Event("loadend"));
          }), e;
        }, function (e) {
          throw S().then(function () {
            _this160.dispatchEvent(new Event("error")), _this160.dispatchEvent(new Event("loadend"));
          }), e;
        });
      }, window.customElements.get("include-fragment") || (window.IncludeFragmentElement = x, window.customElements.define("include-fragment", x));

      var C = /*#__PURE__*/function (_HTMLElement3) {
        _inherits(C, _HTMLElement3);

        var _super81 = _createSuper(C);

        function C() {
          var _this161;

          _classCallCheck(this, C);

          _this161 = _super81.call(this), _this161.currentQuery = null, _this161.filter = null, _this161.debounceInputChange = function (e) {
            var t;
            return function () {
              clearTimeout(t), t = setTimeout(function () {
                clearTimeout(t), e();
              }, 300);
            };
          }(function () {
            return k(_assertThisInitialized(_this161), !0);
          }), _this161.boundFilterResults = function () {
            k(_assertThisInitialized(_this161), !1);
          };
          return _this161;
        }

        _createClass(C, [{
          key: "attributeChangedCallback",
          value: function attributeChangedCallback(e, t) {
            t && "aria-owns" === e && k(this, !1);
          }
        }, {
          key: "connectedCallback",
          value: function connectedCallback() {
            var e = this.input;
            e && (e.setAttribute("autocomplete", "off"), e.setAttribute("spellcheck", "false"), e.addEventListener("focus", this.boundFilterResults), e.addEventListener("change", this.boundFilterResults), e.addEventListener("input", this.debounceInputChange));
          }
        }, {
          key: "disconnectedCallback",
          value: function disconnectedCallback() {
            var e = this.input;
            e && (e.removeEventListener("focus", this.boundFilterResults), e.removeEventListener("change", this.boundFilterResults), e.removeEventListener("input", this.debounceInputChange));
          }
        }, {
          key: "input",
          get: function get() {
            var e = this.querySelector("input");
            return e instanceof HTMLInputElement ? e : null;
          }
        }, {
          key: "reset",
          value: function reset() {
            var e = this.input;
            e && (e.value = "", e.dispatchEvent(new Event("change", {
              bubbles: !0
            })));
          }
        }], [{
          key: "observedAttributes",
          get: function get() {
            return ["aria-owns"];
          }
        }]);

        return C;
      }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

      function k(_x11) {
        return _k2.apply(this, arguments);
      }

      function _k2() {
        _k2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(e) {
          var t,
              n,
              r,
              o,
              i,
              s,
              a,
              l,
              c,
              u,
              _i56,
              _Array$from8,
              _e82,
              _t71,
              d,
              h,
              f,
              _args15 = arguments;

          return _regeneratorRuntime.wrap(function _callee15$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  t = _args15.length > 1 && _args15[1] !== undefined ? _args15[1] : !1;
                  n = e.input;

                  if (n) {
                    _context15.next = 4;
                    break;
                  }

                  return _context15.abrupt("return");

                case 4:
                  r = n.value.trim(), o = e.getAttribute("aria-owns");

                  if (o) {
                    _context15.next = 7;
                    break;
                  }

                  return _context15.abrupt("return");

                case 7:
                  i = document.getElementById(o);

                  if (i) {
                    _context15.next = 10;
                    break;
                  }

                  return _context15.abrupt("return");

                case 10:
                  s = i.hasAttribute("data-filter-list") ? i : i.querySelector("[data-filter-list]");

                  if (s) {
                    _context15.next = 13;
                    break;
                  }

                  return _context15.abrupt("return");

                case 13:
                  if (!(e.dispatchEvent(new CustomEvent("filter-input-start", {
                    bubbles: !0
                  })), t && e.currentQuery === r)) {
                    _context15.next = 15;
                    break;
                  }

                  return _context15.abrupt("return");

                case 15:
                  e.currentQuery = r;
                  a = e.filter || P, l = s.childElementCount;
                  c = 0, u = !1;
                  _i56 = 0, _Array$from8 = Array.from(s.children);

                case 19:
                  if (!(_i56 < _Array$from8.length)) {
                    _context15.next = 28;
                    break;
                  }

                  _e82 = _Array$from8[_i56];

                  if (_e82 instanceof HTMLElement) {
                    _context15.next = 23;
                    break;
                  }

                  return _context15.abrupt("continue", 25);

                case 23:
                  _t71 = a(_e82, (((d = _e82).querySelector("[data-filter-item-text]") || d).textContent || "").trim(), r);
                  !0 === _t71.hideNew && (u = _t71.hideNew), _e82.hidden = !_t71.match, _t71.match && c++;

                case 25:
                  _i56++;
                  _context15.next = 19;
                  break;

                case 28:
                  h = i.querySelector("[data-filter-new-item]"), f = !!h && r.length > 0 && !u;
                  h instanceof HTMLElement && (h.hidden = !f, f && function (e, t) {
                    var n = e.querySelector("[data-filter-new-item-text]");
                    n && (n.textContent = t);
                    var r = e.querySelector("[data-filter-new-item-value]");
                    (r instanceof HTMLInputElement || r instanceof HTMLButtonElement) && (r.value = t);
                  }(h, r)), function (e, t) {
                    var n = e.querySelector("[data-filter-empty-state]");
                    n instanceof HTMLElement && (n.hidden = t);
                  }(i, c > 0 || f), e.dispatchEvent(new CustomEvent("filter-input-updated", {
                    bubbles: !0,
                    detail: {
                      count: c,
                      total: l
                    }
                  }));

                case 30:
                case "end":
                  return _context15.stop();
              }
            }
          }, _callee15);
        }));
        return _k2.apply(this, arguments);
      }

      function P(e, t, n) {
        return {
          match: -1 !== t.toLowerCase().indexOf(n.toLowerCase()),
          hideNew: t === n
        };
      }

      window.customElements.get("filter-input") || (window.FilterInputElement = C, window.customElements.define("filter-input", C));

      var j,
          T,
          D = function D(e, t, n, r) {
        if ("a" === n && !r) throw new TypeError("Private accessor was defined without a getter");
        if ("function" == typeof t ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
        return "m" === n ? r : "a" === n ? r.call(e) : r ? r.value : t.get(e);
      };

      var M = ["[data-md-button]", "md-header", "md-bold", "md-italic", "md-quote", "md-code", "md-link", "md-image", "md-unordered-list", "md-ordered-list", "md-task-list", "md-mention", "md-ref", "md-strikethrough"];

      function A(e) {
        var t = [];

        var _iterator22 = _createForOfIteratorHelper(e.querySelectorAll(M.join(", "))),
            _step22;

        try {
          for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
            var _n35 = _step22.value;
            _n35.hidden || _n35.offsetWidth <= 0 && _n35.offsetHeight <= 0 || _n35.closest("markdown-toolbar") === e && t.push(_n35);
          }
        } catch (err) {
          _iterator22.e(err);
        } finally {
          _iterator22.f();
        }

        return t;
      }

      var F = new WeakMap();

      var L = /*#__PURE__*/function (_HTMLElement4) {
        _inherits(L, _HTMLElement4);

        var _super82 = _createSuper(L);

        function L() {
          var _this162;

          _classCallCheck(this, L);

          _this162 = _super82.call(this);

          var e = function e() {
            var e = F.get(_assertThisInitialized(_this162));
            e && ie(_assertThisInitialized(_this162), e);
          };

          var t;
          _this162.addEventListener("keydown", (t = e, function (e) {
            " " !== e.key && "Enter" !== e.key || (e.preventDefault(), t(e));
          })), _this162.addEventListener("click", e);
          return _this162;
        }

        _createClass(L, [{
          key: "connectedCallback",
          value: function connectedCallback() {
            this.hasAttribute("role") || this.setAttribute("role", "button");
          }
        }, {
          key: "click",
          value: function click() {
            var e = F.get(this);
            e && ie(this, e);
          }
        }]);

        return L;
      }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

      var I = /*#__PURE__*/function (_L) {
        _inherits(I, _L);

        var _super83 = _createSuper(I);

        function I() {
          var _this163;

          _classCallCheck(this, I);

          _this163 = _super83.apply(this, arguments), j.add(_assertThisInitialized(_this163));
          return _this163;
        }

        _createClass(I, [{
          key: "connectedCallback",
          value: function connectedCallback() {
            var e = parseInt(this.getAttribute("level") || "3", 10);
            D(this, j, "m", T).call(this, e);
          }
        }, {
          key: "attributeChangedCallback",
          value: function attributeChangedCallback(e, t, n) {
            if ("level" !== e) return;
            var r = parseInt(n || "3", 10);
            D(this, j, "m", T).call(this, r);
          }
        }], [{
          key: "observedAttributes",
          get: function get() {
            return ["level"];
          }
        }]);

        return I;
      }(L);

      j = new WeakSet(), T = function T(e) {
        if (e < 1 || e > 6) return;
        var t = "".concat("#".repeat(e), " ");
        F.set(this, {
          prefix: t
        });
      }, window.customElements.get("md-header") || (window.MarkdownHeaderButtonElement = I, window.customElements.define("md-header", I));

      var R = /*#__PURE__*/function (_L2) {
        _inherits(R, _L2);

        var _super84 = _createSuper(R);

        function R() {
          _classCallCheck(this, R);

          return _super84.apply(this, arguments);
        }

        _createClass(R, [{
          key: "connectedCallback",
          value: function connectedCallback() {
            F.set(this, {
              prefix: "**",
              suffix: "**",
              trimFirst: !0
            });
          }
        }]);

        return R;
      }(L);

      window.customElements.get("md-bold") || (window.MarkdownBoldButtonElement = R, window.customElements.define("md-bold", R));

      var N = /*#__PURE__*/function (_L3) {
        _inherits(N, _L3);

        var _super85 = _createSuper(N);

        function N() {
          _classCallCheck(this, N);

          return _super85.apply(this, arguments);
        }

        _createClass(N, [{
          key: "connectedCallback",
          value: function connectedCallback() {
            F.set(this, {
              prefix: "_",
              suffix: "_",
              trimFirst: !0
            });
          }
        }]);

        return N;
      }(L);

      window.customElements.get("md-italic") || (window.MarkdownItalicButtonElement = N, window.customElements.define("md-italic", N));

      var B = /*#__PURE__*/function (_L4) {
        _inherits(B, _L4);

        var _super86 = _createSuper(B);

        function B() {
          _classCallCheck(this, B);

          return _super86.apply(this, arguments);
        }

        _createClass(B, [{
          key: "connectedCallback",
          value: function connectedCallback() {
            F.set(this, {
              prefix: "> ",
              multiline: !0,
              surroundWithNewlines: !0
            });
          }
        }]);

        return B;
      }(L);

      window.customElements.get("md-quote") || (window.MarkdownQuoteButtonElement = B, window.customElements.define("md-quote", B));

      var $ = /*#__PURE__*/function (_L5) {
        _inherits($, _L5);

        var _super87 = _createSuper($);

        function $() {
          _classCallCheck(this, $);

          return _super87.apply(this, arguments);
        }

        _createClass($, [{
          key: "connectedCallback",
          value: function connectedCallback() {
            F.set(this, {
              prefix: "`",
              suffix: "`",
              blockPrefix: "```",
              blockSuffix: "```"
            });
          }
        }]);

        return $;
      }(L);

      window.customElements.get("md-code") || (window.MarkdownCodeButtonElement = $, window.customElements.define("md-code", $));

      var H = /*#__PURE__*/function (_L6) {
        _inherits(H, _L6);

        var _super88 = _createSuper(H);

        function H() {
          _classCallCheck(this, H);

          return _super88.apply(this, arguments);
        }

        _createClass(H, [{
          key: "connectedCallback",
          value: function connectedCallback() {
            F.set(this, {
              prefix: "[",
              suffix: "](url)",
              replaceNext: "url",
              scanFor: "https?://"
            });
          }
        }]);

        return H;
      }(L);

      window.customElements.get("md-link") || (window.MarkdownLinkButtonElement = H, window.customElements.define("md-link", H));

      var U = /*#__PURE__*/function (_L7) {
        _inherits(U, _L7);

        var _super89 = _createSuper(U);

        function U() {
          _classCallCheck(this, U);

          return _super89.apply(this, arguments);
        }

        _createClass(U, [{
          key: "connectedCallback",
          value: function connectedCallback() {
            F.set(this, {
              prefix: "![",
              suffix: "](url)",
              replaceNext: "url",
              scanFor: "https?://"
            });
          }
        }]);

        return U;
      }(L);

      window.customElements.get("md-image") || (window.MarkdownImageButtonElement = U, window.customElements.define("md-image", U));

      var z = /*#__PURE__*/function (_L8) {
        _inherits(z, _L8);

        var _super90 = _createSuper(z);

        function z() {
          _classCallCheck(this, z);

          return _super90.apply(this, arguments);
        }

        _createClass(z, [{
          key: "connectedCallback",
          value: function connectedCallback() {
            F.set(this, {
              prefix: "- ",
              multiline: !0,
              unorderedList: !0
            });
          }
        }]);

        return z;
      }(L);

      window.customElements.get("md-unordered-list") || (window.MarkdownUnorderedListButtonElement = z, window.customElements.define("md-unordered-list", z));

      var Y = /*#__PURE__*/function (_L9) {
        _inherits(Y, _L9);

        var _super91 = _createSuper(Y);

        function Y() {
          _classCallCheck(this, Y);

          return _super91.apply(this, arguments);
        }

        _createClass(Y, [{
          key: "connectedCallback",
          value: function connectedCallback() {
            F.set(this, {
              prefix: "1. ",
              multiline: !0,
              orderedList: !0
            });
          }
        }]);

        return Y;
      }(L);

      window.customElements.get("md-ordered-list") || (window.MarkdownOrderedListButtonElement = Y, window.customElements.define("md-ordered-list", Y));

      var q = /*#__PURE__*/function (_L10) {
        _inherits(q, _L10);

        var _super92 = _createSuper(q);

        function q() {
          _classCallCheck(this, q);

          return _super92.apply(this, arguments);
        }

        _createClass(q, [{
          key: "connectedCallback",
          value: function connectedCallback() {
            F.set(this, {
              prefix: "- [ ] ",
              multiline: !0,
              surroundWithNewlines: !0
            });
          }
        }]);

        return q;
      }(L);

      window.customElements.get("md-task-list") || (window.MarkdownTaskListButtonElement = q, window.customElements.define("md-task-list", q));

      var V = /*#__PURE__*/function (_L11) {
        _inherits(V, _L11);

        var _super93 = _createSuper(V);

        function V() {
          _classCallCheck(this, V);

          return _super93.apply(this, arguments);
        }

        _createClass(V, [{
          key: "connectedCallback",
          value: function connectedCallback() {
            F.set(this, {
              prefix: "@",
              prefixSpace: !0
            });
          }
        }]);

        return V;
      }(L);

      window.customElements.get("md-mention") || (window.MarkdownMentionButtonElement = V, window.customElements.define("md-mention", V));

      var W = /*#__PURE__*/function (_L12) {
        _inherits(W, _L12);

        var _super94 = _createSuper(W);

        function W() {
          _classCallCheck(this, W);

          return _super94.apply(this, arguments);
        }

        _createClass(W, [{
          key: "connectedCallback",
          value: function connectedCallback() {
            F.set(this, {
              prefix: "#",
              prefixSpace: !0
            });
          }
        }]);

        return W;
      }(L);

      window.customElements.get("md-ref") || (window.MarkdownRefButtonElement = W, window.customElements.define("md-ref", W));

      var K = /*#__PURE__*/function (_L13) {
        _inherits(K, _L13);

        var _super95 = _createSuper(K);

        function K() {
          _classCallCheck(this, K);

          return _super95.apply(this, arguments);
        }

        _createClass(K, [{
          key: "connectedCallback",
          value: function connectedCallback() {
            F.set(this, {
              prefix: "~~",
              suffix: "~~",
              trimFirst: !0
            });
          }
        }]);

        return K;
      }(L);

      window.customElements.get("md-strikethrough") || (window.MarkdownStrikethroughButtonElement = K, window.customElements.define("md-strikethrough", K));

      var X = /*#__PURE__*/function (_HTMLElement5) {
        _inherits(X, _HTMLElement5);

        var _super96 = _createSuper(X);

        function X() {
          _classCallCheck(this, X);

          return _super96.apply(this, arguments);
        }

        _createClass(X, [{
          key: "connectedCallback",
          value: function connectedCallback() {
            this.hasAttribute("role") || this.setAttribute("role", "toolbar"), this.addEventListener("keydown", G), this.setAttribute("tabindex", "0"), this.addEventListener("focus", Q, {
              once: !0
            });
          }
        }, {
          key: "disconnectedCallback",
          value: function disconnectedCallback() {
            this.removeEventListener("keydown", G);
          }
        }, {
          key: "field",
          get: function get() {
            var e = this.getAttribute("for");
            if (!e) return null;
            var t = "getRootNode" in this ? this.getRootNode() : document;
            var n;
            return (t instanceof Document || t instanceof ShadowRoot) && (n = t.getElementById(e)), n instanceof HTMLTextAreaElement ? n : null;
          }
        }]);

        return X;
      }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

      function Q(_ref54) {
        var e = _ref54.target;
        if (!(e instanceof Element)) return;
        e.removeAttribute("tabindex");
        var t = "0";

        var _iterator23 = _createForOfIteratorHelper(A(e)),
            _step23;

        try {
          for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
            var _n36 = _step23.value;
            _n36.setAttribute("tabindex", t), "0" === t && (_n36.focus(), t = "-1");
          }
        } catch (err) {
          _iterator23.e(err);
        } finally {
          _iterator23.f();
        }
      }

      function G(e) {
        var t = e.key;
        if ("ArrowRight" !== t && "ArrowLeft" !== t && "Home" !== t && "End" !== t) return;
        var n = e.currentTarget;
        if (!(n instanceof HTMLElement)) return;
        var r = A(n),
            o = r.indexOf(e.target),
            i = r.length;
        if (-1 === o) return;
        var s = 0;
        "ArrowLeft" === t && (s = o - 1), "ArrowRight" === t && (s = o + 1), "End" === t && (s = i - 1), s < 0 && (s = i - 1), s > i - 1 && (s = 0);

        for (var _e73 = 0; _e73 < i; _e73 += 1) {
          r[_e73].setAttribute("tabindex", _e73 === s ? "0" : "-1");
        }

        e.preventDefault(), r[s].focus();
      }

      function J(e) {
        return e.trim().split("\n").length > 1;
      }

      function Z(e, t) {
        return Array(t + 1).join(e);
      }

      window.customElements.get("markdown-toolbar") || (window.MarkdownToolbarElement = X, window.customElements.define("markdown-toolbar", X));
      var ee = null;

      function te(e) {
        var t = e.value.slice(0, e.selectionStart),
            n = e.value.slice(e.selectionEnd),
            r = t.match(/\n*$/),
            o = n.match(/^\n*/),
            i = r ? r[0].length : 0,
            s = o ? o[0].length : 0;
        var a, l;
        return t.match(/\S/) && i < 2 && (a = Z("\n", 2 - i)), n.match(/\S/) && s < 2 && (l = Z("\n", 2 - s)), null == a && (a = ""), null == l && (l = ""), {
          newlinesToAppend: a,
          newlinesToPrepend: l
        };
      }

      function ne(e) {
        var t = e.split("\n"),
            n = /^\d+\.\s+/,
            r = t.every(function (e) {
          return n.test(e);
        });
        var o = t;
        return r && (o = t.map(function (e) {
          return e.replace(n, "");
        })), {
          text: o.join("\n"),
          processed: r
        };
      }

      function re(e) {
        var t = e.split("\n"),
            n = t.every(function (e) {
          return e.startsWith("- ");
        });
        var r = t;
        return n && (r = t.map(function (e) {
          return e.slice("- ".length, e.length);
        })), {
          text: r.join("\n"),
          processed: n
        };
      }

      function oe(e, t) {
        return t ? "- " : "".concat(e + 1, ". ");
      }

      function ie(e, t) {
        var n = e.closest("markdown-toolbar");
        if (!(n instanceof X)) return;
        var r = Object.assign(Object.assign({}, {
          prefix: "",
          suffix: "",
          blockPrefix: "",
          blockSuffix: "",
          multiline: !1,
          replaceNext: "",
          prefixSpace: !1,
          scanFor: "",
          surroundWithNewlines: !1,
          orderedList: !1,
          unorderedList: !1,
          trimFirst: !1
        }), t),
            o = n.field;
        o && (o.focus(), function (e, t) {
          var n = e.value.slice(e.selectionStart, e.selectionEnd);
          var r;
          r = t.orderedList || t.unorderedList ? function (e, t) {
            var n = e.selectionStart === e.selectionEnd;
            var r = e.selectionStart,
                o = e.selectionEnd;
            !function (e) {
              var t = e.value.split("\n");
              var n = 0;

              for (var _r38 = 0; _r38 < t.length; _r38++) {
                var _o22 = t[_r38].length + 1;

                e.selectionStart >= n && e.selectionStart < n + _o22 && (e.selectionStart = n), e.selectionEnd >= n && e.selectionEnd < n + _o22 && (e.selectionEnd = n + _o22 - 1), n += _o22;
              }
            }(e);

            var i = e.value.slice(e.selectionStart, e.selectionEnd),
                _ref55 = function (e, t) {
              var n, r, o;
              return e.orderedList ? (r = ne(t), n = re(r.text), o = n.text) : (r = re(t), n = ne(r.text), o = n.text), [r, n, o];
            }(t, i),
                _ref56 = _slicedToArray(_ref55, 3),
                s = _ref56[0],
                a = _ref56[1],
                l = _ref56[2],
                c = l.split("\n").map(function (e, n) {
              return "".concat(oe(n, t.unorderedList)).concat(e);
            }),
                u = c.reduce(function (e, n, r) {
              return e + oe(r, t.unorderedList).length;
            }, 0),
                d = c.reduce(function (e, n, r) {
              return e + oe(r, !t.unorderedList).length;
            }, 0);

            if (s.processed) return n ? (r = Math.max(r - oe(0, t.unorderedList).length, 0), o = r) : (r = e.selectionStart, o = e.selectionEnd - u), {
              text: l,
              selectionStart: r,
              selectionEnd: o
            };

            var _te = te(e),
                h = _te.newlinesToAppend,
                f = _te.newlinesToPrepend,
                p = h + c.join("\n") + f;

            return n ? (r = Math.max(r + oe(0, t.unorderedList).length + h.length, 0), o = r) : a.processed ? (r = Math.max(e.selectionStart + h.length, 0), o = e.selectionEnd + h.length + u - d) : (r = Math.max(e.selectionStart + h.length, 0), o = e.selectionEnd + h.length + u), {
              text: p,
              selectionStart: r,
              selectionEnd: o
            };
          }(e, t) : t.multiline && J(n) ? function (e, t) {
            var n = t.prefix,
                r = t.suffix,
                o = t.surroundWithNewlines;
            var i = e.value.slice(e.selectionStart, e.selectionEnd),
                s = e.selectionStart,
                a = e.selectionEnd;
            var l = i.split("\n");
            if (l.every(function (e) {
              return e.startsWith(n) && e.endsWith(r);
            })) i = l.map(function (e) {
              return e.slice(n.length, e.length - r.length);
            }).join("\n"), a = s + i.length;else if (i = l.map(function (e) {
              return n + e + r;
            }).join("\n"), o) {
              var _te2 = te(e),
                  _t59 = _te2.newlinesToAppend,
                  _n37 = _te2.newlinesToPrepend;

              s += _t59.length, a = s + i.length, i = _t59 + i + _n37;
            }
            return {
              text: i,
              selectionStart: s,
              selectionEnd: a
            };
          }(e, t) : function (e, t) {
            var n, r;
            var o = t.prefix,
                i = t.suffix,
                s = t.blockPrefix,
                a = t.blockSuffix,
                l = t.replaceNext,
                c = t.prefixSpace,
                u = t.scanFor,
                d = t.surroundWithNewlines,
                h = e.selectionStart,
                f = e.selectionEnd;
            var p = e.value.slice(e.selectionStart, e.selectionEnd),
                g = J(p) && s.length > 0 ? "".concat(s, "\n") : o,
                m = J(p) && a.length > 0 ? "\n".concat(a) : i;

            if (c) {
              var _t60 = e.value[e.selectionStart - 1];
              0 === e.selectionStart || null == _t60 || _t60.match(/\s/) || (g = " ".concat(g));
            }

            p = function (e, t, n) {
              var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
              if (e.selectionStart === e.selectionEnd) e.selectionStart = function (e, t) {
                var n = t;

                for (; e[n] && null != e[n - 1] && !e[n - 1].match(/\s/);) {
                  n--;
                }

                return n;
              }(e.value, e.selectionStart), e.selectionEnd = function (e, t, n) {
                var r = t;
                var o = n ? /\n/ : /\s/;

                for (; e[r] && !e[r].match(o);) {
                  r++;
                }

                return r;
              }(e.value, e.selectionEnd, r);else {
                var _r39 = e.selectionStart - t.length,
                    _o23 = e.selectionEnd + n.length,
                    _i55 = e.value.slice(_r39, e.selectionStart) === t,
                    _s8 = e.value.slice(e.selectionEnd, _o23) === n;

                _i55 && _s8 && (e.selectionStart = _r39, e.selectionEnd = _o23);
              }
              return e.value.slice(e.selectionStart, e.selectionEnd);
            }(e, g, m, t.multiline);

            var v = e.selectionStart,
                y = e.selectionEnd;
            var b = l.length > 0 && m.indexOf(l) > -1 && p.length > 0;

            if (d) {
              var _t61 = te(e);

              n = _t61.newlinesToAppend, r = _t61.newlinesToPrepend, g = n + o, m += r;
            }

            if (p.startsWith(g) && p.endsWith(m)) {
              var _e74 = p.slice(g.length, p.length - m.length);

              if (h === f) {
                var _t62 = h - g.length;

                _t62 = Math.max(_t62, v), _t62 = Math.min(_t62, v + _e74.length), v = y = _t62;
              } else y = v + _e74.length;

              return {
                text: _e74,
                selectionStart: v,
                selectionEnd: y
              };
            }

            if (b) {
              if (u.length > 0 && p.match(u)) {
                m = m.replace(l, p);

                var _e75 = g + m;

                return v = y = v + g.length, {
                  text: _e75,
                  selectionStart: v,
                  selectionEnd: y
                };
              }

              {
                var _e76 = g + p + m;

                return v = v + g.length + p.length + m.indexOf(l), y = v + l.length, {
                  text: _e76,
                  selectionStart: v,
                  selectionEnd: y
                };
              }
            }

            {
              var _e77 = g + p + m;

              v = h + g.length, y = f + g.length;

              var _n38 = p.match(/^\s*|\s*$/g);

              if (t.trimFirst && _n38) {
                var _t63 = _n38[0] || "",
                    _r40 = _n38[1] || "";

                _e77 = _t63 + g + p.trim() + m + _r40, v += _t63.length, y -= _r40.length;
              }

              return {
                text: _e77,
                selectionStart: v,
                selectionEnd: y
              };
            }
          }(e, t), function (e, _ref57) {
            var t = _ref57.text,
                n = _ref57.selectionStart,
                r = _ref57.selectionEnd;
            var o = e.selectionStart,
                i = e.value.slice(0, o),
                s = e.value.slice(e.selectionEnd);

            if (null === ee || !0 === ee) {
              e.contentEditable = "true";

              try {
                ee = document.execCommand("insertText", !1, t);
              } catch (e) {
                ee = !1;
              }

              e.contentEditable = "false";
            }

            if (ee && !e.value.slice(0, e.selectionStart).endsWith(t) && (ee = !1), !ee) {
              try {
                document.execCommand("ms-beginUndoUnit");
              } catch (e) {}

              e.value = i + t + s;

              try {
                document.execCommand("ms-endUndoUnit");
              } catch (e) {}

              e.dispatchEvent(new CustomEvent("input", {
                bubbles: !0,
                cancelable: !0
              }));
            }

            null != n && null != r ? e.setSelectionRange(n, r) : e.setSelectionRange(o, e.selectionEnd);
          }(e, r);
        }(o, r));
      }

      var se = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          ae = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

      function le(e) {
        return "0".concat(e).slice(-2);
      }

      function ce(e, t) {
        var n = e.getDay(),
            r = e.getDate(),
            o = e.getMonth(),
            i = e.getFullYear(),
            s = e.getHours(),
            a = e.getMinutes(),
            l = e.getSeconds();
        return t.replace(/%([%aAbBcdeHIlmMpPSwyYZz])/g, function (t) {
          var c;

          switch (t[1]) {
            case "%":
              return "%";

            case "a":
              return se[n].slice(0, 3);

            case "A":
              return se[n];

            case "b":
              return ae[o].slice(0, 3);

            case "B":
              return ae[o];

            case "c":
              return e.toString();

            case "d":
              return le(r);

            case "e":
              return String(r);

            case "H":
              return le(s);

            case "I":
              return le(ce(e, "%l"));

            case "l":
              return String(0 === s || 12 === s ? 12 : (s + 12) % 12);

            case "m":
              return le(o + 1);

            case "M":
              return le(a);

            case "p":
              return s > 11 ? "PM" : "AM";

            case "P":
              return s > 11 ? "pm" : "am";

            case "S":
              return le(l);

            case "w":
              return String(n);

            case "y":
              return le(i % 100);

            case "Y":
              return String(i);

            case "Z":
              return c = e.toString().match(/\((\w+)\)$/), c ? c[1] : "";

            case "z":
              return c = e.toString().match(/\w([+-]\d\d\d\d) /), c ? c[1] : "";
          }

          return "";
        });
      }

      function ue(e) {
        var t;
        return function () {
          if (t) return t;
          if ("Intl" in window) try {
            return t = new Intl.DateTimeFormat(void 0, e), t;
          } catch (e) {
            if (!(e instanceof RangeError)) throw e;
          }
        };
      }

      var de = null;
      var he = ue({
        day: "numeric",
        month: "short"
      });

      function fe() {
        if (null !== de) return de;
        var e = he();

        if (e) {
          var _t64 = e.format(new Date(0));

          return de = !!_t64.match(/^\d/), de;
        }

        return !1;
      }

      var pe = null;
      var ge = ue({
        day: "numeric",
        month: "short",
        year: "numeric"
      });

      function me(e) {
        var t = e.closest("[lang]");
        return t instanceof HTMLElement && t.lang ? t.lang : "default";
      }

      var ve = new WeakMap();

      var ye = /*#__PURE__*/function (_HTMLElement6) {
        _inherits(ye, _HTMLElement6);

        var _super97 = _createSuper(ye);

        function ye() {
          _classCallCheck(this, ye);

          return _super97.apply(this, arguments);
        }

        _createClass(ye, [{
          key: "connectedCallback",
          value: function connectedCallback() {
            var e = this.getFormattedTitle();
            e && !this.hasAttribute("title") && this.setAttribute("title", e);
            var t = this.getFormattedDate();
            t && (this.textContent = t);
          }
        }, {
          key: "attributeChangedCallback",
          value: function attributeChangedCallback(e, t, n) {
            var r = this.getFormattedTitle();

            if ("datetime" === e) {
              var _e78 = Date.parse(n);

              isNaN(_e78) ? ve.delete(this) : ve.set(this, new Date(_e78));
            }

            var o = this.getFormattedTitle(),
                i = this.getAttribute("title");
            "title" === e || !o || i && i !== r || this.setAttribute("title", o);
            var s = this.getFormattedDate();
            s && (this.textContent = s);
          }
        }, {
          key: "date",
          get: function get() {
            return ve.get(this);
          }
        }, {
          key: "getFormattedTitle",
          value: function getFormattedTitle() {
            var e = this.date;
            if (!e) return;
            var t = be();
            if (t) return t.format(e);

            try {
              return e.toLocaleString();
            } catch (t) {
              if (t instanceof RangeError) return e.toString();
              throw t;
            }
          }
        }, {
          key: "getFormattedDate",
          value: function getFormattedDate() {}
        }], [{
          key: "observedAttributes",
          get: function get() {
            return ["datetime", "day", "format", "lang", "hour", "minute", "month", "second", "title", "weekday", "year", "time-zone-name"];
          }
        }]);

        return ye;
      }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

      var be = ue({
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        timeZoneName: "short"
      }),
          we = new WeakMap();

      var Oe = /*#__PURE__*/function (_ye) {
        _inherits(Oe, _ye);

        var _super98 = _createSuper(Oe);

        function Oe() {
          _classCallCheck(this, Oe);

          return _super98.apply(this, arguments);
        }

        _createClass(Oe, [{
          key: "attributeChangedCallback",
          value: function attributeChangedCallback(e, t, n) {
            "hour" !== e && "minute" !== e && "second" !== e && "time-zone-name" !== e || we.delete(this), _get(_getPrototypeOf(Oe.prototype), "attributeChangedCallback", this).call(this, e, t, n);
          }
        }, {
          key: "getFormattedDate",
          value: function getFormattedDate() {
            var e = this.date;
            if (!e) return;

            var t = function (e, t) {
              var n = {
                weekday: {
                  short: "%a",
                  long: "%A"
                },
                day: {
                  numeric: "%e",
                  "2-digit": "%d"
                },
                month: {
                  short: "%b",
                  long: "%B"
                },
                year: {
                  numeric: "%Y",
                  "2-digit": "%y"
                }
              };
              var r = fe() ? "weekday day month year" : "weekday month day, year";

              for (var _t65 in n) {
                var _o24 = n[_t65][e.getAttribute(_t65) || ""];

                r = r.replace(_t65, _o24 || "");
              }

              return r = r.replace(/(\s,)|(,\s$)/, ""), ce(t, r).replace(/\s+/, " ").trim();
            }(this, e) || "",
                n = function (e, t) {
              var n = {},
                  r = e.getAttribute("hour");
              "numeric" !== r && "2-digit" !== r || (n.hour = r);
              var o = e.getAttribute("minute");
              "numeric" !== o && "2-digit" !== o || (n.minute = o);
              var i = e.getAttribute("second");
              "numeric" !== i && "2-digit" !== i || (n.second = i);
              var s = e.getAttribute("time-zone-name");
              if ("short" !== s && "long" !== s || (n.timeZoneName = s), 0 === Object.keys(n).length) return;
              var a = we.get(e);
              a || (a = ue(n), we.set(e, a));
              var l = a();
              return l ? l.format(t) : ce(t, n.second ? "%H:%M:%S" : "%H:%M");
            }(this, e) || "";

            return "".concat(t, " ").concat(n).trim();
          }
        }]);

        return Oe;
      }(ye);

      window.customElements.get("local-time") || (window.LocalTimeElement = Oe, window.customElements.define("local-time", Oe));

      var Ee = /*#__PURE__*/function () {
        function Ee(e, t) {
          _classCallCheck(this, Ee);

          this.date = e, this.locale = t;
        }

        _createClass(Ee, [{
          key: "toString",
          value: function toString() {
            var e = this.timeElapsed();
            if (e) return e;
            return this.timeAhead() || "on ".concat(this.formatDate());
          }
        }, {
          key: "timeElapsed",
          value: function timeElapsed() {
            var e = new Date().getTime() - this.date.getTime(),
                t = Math.round(e / 1e3),
                n = Math.round(t / 60),
                r = Math.round(n / 60),
                o = Math.round(r / 24);
            return e >= 0 && o < 30 ? this.timeAgoFromMs(e) : null;
          }
        }, {
          key: "timeAhead",
          value: function timeAhead() {
            var e = this.date.getTime() - new Date().getTime(),
                t = Math.round(e / 1e3),
                n = Math.round(t / 60),
                r = Math.round(n / 60),
                o = Math.round(r / 24);
            return e >= 0 && o < 30 ? this.timeUntil() : null;
          }
        }, {
          key: "timeAgo",
          value: function timeAgo() {
            var e = new Date().getTime() - this.date.getTime();
            return this.timeAgoFromMs(e);
          }
        }, {
          key: "timeAgoFromMs",
          value: function timeAgoFromMs(e) {
            var t = Math.round(e / 1e3),
                n = Math.round(t / 60),
                r = Math.round(n / 60),
                o = Math.round(r / 24),
                i = Math.round(o / 30),
                s = Math.round(i / 12);
            return e < 0 || t < 10 ? _e(this.locale, 0, "second") : t < 45 ? _e(this.locale, -t, "second") : t < 90 || n < 45 ? _e(this.locale, -n, "minute") : n < 90 || r < 24 ? _e(this.locale, -r, "hour") : r < 36 || o < 30 ? _e(this.locale, -o, "day") : i < 18 ? _e(this.locale, -i, "month") : _e(this.locale, -s, "year");
          }
        }, {
          key: "microTimeAgo",
          value: function microTimeAgo() {
            var e = new Date().getTime() - this.date.getTime(),
                t = Math.round(e / 1e3),
                n = Math.round(t / 60),
                r = Math.round(n / 60),
                o = Math.round(r / 24),
                i = Math.round(o / 30),
                s = Math.round(i / 12);
            return n < 1 ? "1m" : n < 60 ? "".concat(n, "m") : r < 24 ? "".concat(r, "h") : o < 365 ? "".concat(o, "d") : "".concat(s, "y");
          }
        }, {
          key: "timeUntil",
          value: function timeUntil() {
            var e = this.date.getTime() - new Date().getTime();
            return this.timeUntilFromMs(e);
          }
        }, {
          key: "timeUntilFromMs",
          value: function timeUntilFromMs(e) {
            var t = Math.round(e / 1e3),
                n = Math.round(t / 60),
                r = Math.round(n / 60),
                o = Math.round(r / 24),
                i = Math.round(o / 30),
                s = Math.round(i / 12);
            return i >= 18 || i >= 12 ? _e(this.locale, s, "year") : o >= 45 || o >= 30 ? _e(this.locale, i, "month") : r >= 36 || r >= 24 ? _e(this.locale, o, "day") : n >= 90 || n >= 45 ? _e(this.locale, r, "hour") : t >= 90 || t >= 45 ? _e(this.locale, n, "minute") : _e(this.locale, t >= 10 ? t : 0, "second");
          }
        }, {
          key: "microTimeUntil",
          value: function microTimeUntil() {
            var e = this.date.getTime() - new Date().getTime(),
                t = Math.round(e / 1e3),
                n = Math.round(t / 60),
                r = Math.round(n / 60),
                o = Math.round(r / 24),
                i = Math.round(o / 30),
                s = Math.round(i / 12);
            return o >= 365 ? "".concat(s, "y") : r >= 24 ? "".concat(o, "d") : n >= 60 ? "".concat(r, "h") : n > 1 ? "".concat(n, "m") : "1m";
          }
        }, {
          key: "formatDate",
          value: function formatDate() {
            var e = fe() ? "%e %b" : "%b %e";
            var t;
            return t = this.date, new Date().getUTCFullYear() !== t.getUTCFullYear() && (e += function () {
              if (null !== pe) return pe;
              var e = ge();

              if (e) {
                var _t66 = e.format(new Date(0));

                return pe = !!_t66.match(/\d,/), pe;
              }

              return !0;
            }() ? ", %Y" : " %Y"), ce(this.date, e);
          }
        }, {
          key: "formatTime",
          value: function formatTime() {
            var e = Se();
            return e ? e.format(this.date) : ce(this.date, "%l:%M%P");
          }
        }]);

        return Ee;
      }();

      function _e(e, t, n) {
        var r = function (e, t) {
          if ("Intl" in window && "RelativeTimeFormat" in window.Intl) try {
            return new Intl.RelativeTimeFormat(e, {
              numeric: "auto"
            });
          } catch (e) {
            if (!(e instanceof RangeError)) throw e;
          }
        }(e);

        return r ? r.format(t, n) : function (e, t) {
          if (0 === e) switch (t) {
            case "year":
            case "quarter":
            case "month":
            case "week":
              return "this ".concat(t);

            case "day":
              return "today";

            case "hour":
            case "minute":
              return "in 0 ".concat(t, "s");

            case "second":
              return "now";
          } else if (1 === e) switch (t) {
            case "year":
            case "quarter":
            case "month":
            case "week":
              return "next ".concat(t);

            case "day":
              return "tomorrow";

            case "hour":
            case "minute":
            case "second":
              return "in 1 ".concat(t);
          } else if (-1 === e) switch (t) {
            case "year":
            case "quarter":
            case "month":
            case "week":
              return "last ".concat(t);

            case "day":
              return "yesterday";

            case "hour":
            case "minute":
            case "second":
              return "1 ".concat(t, " ago");
          } else if (e > 1) switch (t) {
            case "year":
            case "quarter":
            case "month":
            case "week":
            case "day":
            case "hour":
            case "minute":
            case "second":
              return "in ".concat(e, " ").concat(t, "s");
          } else if (e < -1) switch (t) {
            case "year":
            case "quarter":
            case "month":
            case "week":
            case "day":
            case "hour":
            case "minute":
            case "second":
              return "".concat(-e, " ").concat(t, "s ago");
          }
          throw new RangeError("Invalid unit argument for format() '".concat(t, "'"));
        }(t, n);
      }

      var Se = ue({
        hour: "numeric",
        minute: "2-digit"
      });

      var xe = /*#__PURE__*/function (_ye2) {
        _inherits(xe, _ye2);

        var _super99 = _createSuper(xe);

        function xe() {
          _classCallCheck(this, xe);

          return _super99.apply(this, arguments);
        }

        _createClass(xe, [{
          key: "getFormattedDate",
          value: function getFormattedDate() {
            var e = this.date;
            if (e) return new Ee(e, me(this)).toString();
          }
        }, {
          key: "connectedCallback",
          value: function connectedCallback() {
            Ce.push(this), ke || (Pe(), ke = window.setInterval(Pe, 6e4)), _get(_getPrototypeOf(xe.prototype), "connectedCallback", this).call(this);
          }
        }, {
          key: "disconnectedCallback",
          value: function disconnectedCallback() {
            var e = Ce.indexOf(this);
            -1 !== e && Ce.splice(e, 1), Ce.length || ke && (clearInterval(ke), ke = null);
          }
        }]);

        return xe;
      }(ye);

      var Ce = [];
      var ke;

      function Pe() {
        var e, t, n;

        for (t = 0, n = Ce.length; t < n; t++) {
          e = Ce[t], e.textContent = e.getFormattedDate() || "";
        }
      }

      window.customElements.get("relative-time") || (window.RelativeTimeElement = xe, window.customElements.define("relative-time", xe));

      var je = /*#__PURE__*/function (_xe) {
        _inherits(je, _xe);

        var _super100 = _createSuper(je);

        function je() {
          _classCallCheck(this, je);

          return _super100.apply(this, arguments);
        }

        _createClass(je, [{
          key: "getFormattedDate",
          value: function getFormattedDate() {
            var e = this.getAttribute("format"),
                t = this.date;
            if (t) return "micro" === e ? new Ee(t, me(this)).microTimeAgo() : new Ee(t, me(this)).timeAgo();
          }
        }]);

        return je;
      }(xe);

      window.customElements.get("time-ago") || (window.TimeAgoElement = je, window.customElements.define("time-ago", je));

      var Te = /*#__PURE__*/function (_xe2) {
        _inherits(Te, _xe2);

        var _super101 = _createSuper(Te);

        function Te() {
          _classCallCheck(this, Te);

          return _super101.apply(this, arguments);
        }

        _createClass(Te, [{
          key: "getFormattedDate",
          value: function getFormattedDate() {
            var e = this.getAttribute("format"),
                t = this.date;
            if (t) return "micro" === e ? new Ee(t, me(this)).microTimeUntil() : new Ee(t, me(this)).timeUntil();
          }
        }]);

        return Te;
      }(xe);

      window.customElements.get("time-until") || (window.TimeUntilElement = Te, window.customElements.define("time-until", Te));
      var De = !!navigator.userAgent.match(/Macintosh/);

      var Me = /*#__PURE__*/function () {
        function Me(e, t) {
          var _this164 = this;

          _classCallCheck(this, Me);

          this.input = e, this.list = t, this.isComposing = !1, t.id || (t.id = "combobox-".concat(Math.random().toString().slice(2, 6))), this.keyboardEventHandler = function (e) {
            return function (e, t) {
              if (!(e.shiftKey || e.metaKey || e.altKey) && (De || !e.ctrlKey) && !t.isComposing) switch (e.key) {
                case "Enter":
                case "Tab":
                  (function (e, t) {
                    var n = t.querySelector('[aria-selected="true"]');
                    return !!n && ("true" === n.getAttribute("aria-disabled") || n.click(), !0);
                  })(t.input, t.list) && e.preventDefault();
                  break;

                case "Escape":
                  t.clearSelection();
                  break;

                case "ArrowDown":
                  t.navigate(1), e.preventDefault();
                  break;

                case "ArrowUp":
                  t.navigate(-1), e.preventDefault();
                  break;

                case "n":
                  De && e.ctrlKey && (t.navigate(1), e.preventDefault());
                  break;

                case "p":
                  De && e.ctrlKey && (t.navigate(-1), e.preventDefault());
                  break;

                default:
                  if (e.ctrlKey) break;
                  t.clearSelection();
              }
            }(e, _this164);
          }, this.compositionEventHandler = function (e) {
            return function (e, t) {
              t.isComposing = "compositionstart" === e.type, document.getElementById(t.input.getAttribute("aria-controls") || "") && t.clearSelection();
            }(e, _this164);
          }, this.inputHandler = this.clearSelection.bind(this), e.setAttribute("role", "combobox"), e.setAttribute("aria-controls", t.id), e.setAttribute("aria-expanded", "false"), e.setAttribute("aria-autocomplete", "list"), e.setAttribute("aria-haspopup", "listbox");
        }

        _createClass(Me, [{
          key: "destroy",
          value: function destroy() {
            this.clearSelection(), this.stop(), this.input.removeAttribute("role"), this.input.removeAttribute("aria-controls"), this.input.removeAttribute("aria-expanded"), this.input.removeAttribute("aria-autocomplete"), this.input.removeAttribute("aria-haspopup");
          }
        }, {
          key: "start",
          value: function start() {
            this.input.setAttribute("aria-expanded", "true"), this.input.addEventListener("compositionstart", this.compositionEventHandler), this.input.addEventListener("compositionend", this.compositionEventHandler), this.input.addEventListener("input", this.inputHandler), this.input.addEventListener("keydown", this.keyboardEventHandler), this.list.addEventListener("click", Ae);
          }
        }, {
          key: "stop",
          value: function stop() {
            this.clearSelection(), this.input.setAttribute("aria-expanded", "false"), this.input.removeEventListener("compositionstart", this.compositionEventHandler), this.input.removeEventListener("compositionend", this.compositionEventHandler), this.input.removeEventListener("input", this.inputHandler), this.input.removeEventListener("keydown", this.keyboardEventHandler), this.list.removeEventListener("click", Ae);
          }
        }, {
          key: "navigate",
          value: function navigate() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            var t = Array.from(this.list.querySelectorAll('[aria-selected="true"]')).filter(Fe)[0],
                n = Array.from(this.list.querySelectorAll('[role="option"]')).filter(Fe),
                r = n.indexOf(t);
            if (r === n.length - 1 && 1 === e || 0 === r && -1 === e) return this.clearSelection(), void this.input.focus();
            var o = 1 === e ? 0 : n.length - 1;

            if (t && r >= 0) {
              var _t67 = r + e;

              _t67 >= 0 && _t67 < n.length && (o = _t67);
            }

            var i = n[o];

            if (i) {
              var _iterator24 = _createForOfIteratorHelper(n),
                  _step24;

              try {
                for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
                  var _e79 = _step24.value;
                  i === _e79 ? (this.input.setAttribute("aria-activedescendant", i.id), i.setAttribute("aria-selected", "true"), Le(this.list, i)) : _e79.setAttribute("aria-selected", "false");
                }
              } catch (err) {
                _iterator24.e(err);
              } finally {
                _iterator24.f();
              }
            }
          }
        }, {
          key: "clearSelection",
          value: function clearSelection() {
            this.input.removeAttribute("aria-activedescendant");

            var _iterator25 = _createForOfIteratorHelper(this.list.querySelectorAll('[aria-selected="true"]')),
                _step25;

            try {
              for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
                var _e80 = _step25.value;

                _e80.setAttribute("aria-selected", "false");
              }
            } catch (err) {
              _iterator25.e(err);
            } finally {
              _iterator25.f();
            }
          }
        }]);

        return Me;
      }();

      function Ae(e) {
        if (!(e.target instanceof Element)) return;
        var t = e.target.closest('[role="option"]');
        t && "true" !== t.getAttribute("aria-disabled") && function (e) {
          e.dispatchEvent(new CustomEvent("combobox-commit", {
            bubbles: !0
          }));
        }(t);
      }

      function Fe(e) {
        return !e.hidden && !(e instanceof HTMLInputElement && "hidden" === e.type) && (e.offsetWidth > 0 || e.offsetHeight > 0);
      }

      function Le(e, t) {
        (function (e, t) {
          var n = e.scrollTop,
              r = n + e.clientHeight,
              o = t.offsetTop,
              i = o + t.clientHeight;
          return o >= n && i <= r;
        })(e, t) || (e.scrollTop = t.offsetTop);
      }

      var Ie = /\s|\(|\[/;

      function Re(e, t, n) {
        var _ref58 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
          multiWord: !1,
          lookBackIndex: 0,
          lastMatchPosition: null
        },
            r = _ref58.multiWord,
            o = _ref58.lookBackIndex,
            i = _ref58.lastMatchPosition;

        var s = e.lastIndexOf(t, n - 1);
        if (-1 === s) return;
        if (s < o) return;

        if (r) {
          if (null != i) {
            if (i === s) return;
            s = i - t.length;
          }

          if (" " === e[s + 1] && n >= s + t.length + 1) return;
          if (e.lastIndexOf("\n", n - 1) > s) return;
          if (e.lastIndexOf(".", n - 1) > s) return;
        } else if (e.lastIndexOf(" ", n - 1) > s) return;

        var a = e[s - 1];
        return !a || Ie.test(a) ? {
          text: e.substring(s + t.length, n),
          position: s + t.length
        } : void 0;
      }

      var Ne = ["position:absolute;", "overflow:auto;", "word-wrap:break-word;", "top:0px;", "left:-9999px;"],
          Be = ["box-sizing", "font-family", "font-size", "font-style", "font-variant", "font-weight", "height", "letter-spacing", "line-height", "max-height", "min-height", "padding-bottom", "padding-left", "padding-right", "padding-top", "border-bottom", "border-left", "border-right", "border-top", "text-decoration", "text-indent", "text-transform", "width", "word-spacing"],
          $e = new WeakMap();
      var He = new WeakMap();

      var Ue = /*#__PURE__*/function () {
        function Ue(e, t) {
          _classCallCheck(this, Ue);

          this.expander = e, this.input = t, this.combobox = null, this.menu = null, this.match = null, this.justPasted = !1, this.lookBackIndex = 0, this.oninput = this.onInput.bind(this), this.onpaste = this.onPaste.bind(this), this.onkeydown = this.onKeydown.bind(this), this.oncommit = this.onCommit.bind(this), this.onmousedown = this.onMousedown.bind(this), this.onblur = this.onBlur.bind(this), this.interactingWithList = !1, t.addEventListener("paste", this.onpaste), t.addEventListener("input", this.oninput), t.addEventListener("keydown", this.onkeydown), t.addEventListener("blur", this.onblur);
        }

        _createClass(Ue, [{
          key: "destroy",
          value: function destroy() {
            this.input.removeEventListener("paste", this.onpaste), this.input.removeEventListener("input", this.oninput), this.input.removeEventListener("keydown", this.onkeydown), this.input.removeEventListener("blur", this.onblur);
          }
        }, {
          key: "dismissMenu",
          value: function dismissMenu() {
            this.deactivate() && (this.lookBackIndex = this.input.selectionEnd || this.lookBackIndex);
          }
        }, {
          key: "activate",
          value: function activate(e, t) {
            var n, r;
            if (this.input !== document.activeElement && this.input !== (null === (r = null === (n = document.activeElement) || void 0 === n ? void 0 : n.shadowRoot) || void 0 === r ? void 0 : r.activeElement)) return;
            this.deactivate(), this.menu = t, t.id || (t.id = "text-expander-".concat(Math.floor(1e5 * Math.random()).toString())), this.expander.append(t), this.combobox = new Me(this.input, t);

            var _ref59 = function (e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e.selectionEnd;

              var _ref60 = function (e, t) {
                var n = e.nodeName.toLowerCase();
                if ("textarea" !== n && "input" !== n) throw new Error("expected textField to a textarea or input");
                var r = $e.get(e);
                if (r && r.parentElement === e.parentElement) r.innerHTML = "";else {
                  r = document.createElement("div"), $e.set(e, r);

                  var _t68 = window.getComputedStyle(e),
                      _o25 = Ne.slice(0);

                  "textarea" === n ? _o25.push("white-space:pre-wrap;") : _o25.push("white-space:nowrap;");

                  for (var _e81 = 0, _n39 = Be.length; _e81 < _n39; _e81++) {
                    var _n40 = Be[_e81];

                    _o25.push("".concat(_n40, ":").concat(_t68.getPropertyValue(_n40), ";"));
                  }

                  r.style.cssText = _o25.join(" ");
                }
                var o = document.createElement("span");
                var i, s;

                if (o.style.cssText = "position: absolute;", o.innerHTML = "&nbsp;", "number" == typeof t) {
                  var _n41 = e.value.substring(0, t);

                  _n41 && (i = document.createTextNode(_n41)), _n41 = e.value.substring(t), _n41 && (s = document.createTextNode(_n41));
                } else {
                  var _t69 = e.value;
                  _t69 && (i = document.createTextNode(_t69));
                }

                if (i && r.appendChild(i), r.appendChild(o), s && r.appendChild(s), !r.parentElement) {
                  if (!e.parentElement) throw new Error("textField must have a parentElement to mirror");
                  e.parentElement.insertBefore(r, e);
                }

                return r.scrollTop = e.scrollTop, r.scrollLeft = e.scrollLeft, {
                  mirror: r,
                  marker: o
                };
              }(e, t),
                  n = _ref60.mirror,
                  r = _ref60.marker,
                  o = n.getBoundingClientRect(),
                  i = r.getBoundingClientRect();

              return setTimeout(function () {
                n.remove();
              }, 5e3), {
                top: i.top - o.top,
                left: i.left - o.left
              };
            }(this.input, e.position),
                o = _ref59.top,
                i = _ref59.left;

            t.style.top = "".concat(o, "px"), t.style.left = "".concat(i, "px"), this.combobox.start(), t.addEventListener("combobox-commit", this.oncommit), t.addEventListener("mousedown", this.onmousedown), this.combobox.navigate(1);
          }
        }, {
          key: "deactivate",
          value: function deactivate() {
            var e = this.menu;
            return !(!e || !this.combobox || (this.menu = null, e.removeEventListener("combobox-commit", this.oncommit), e.removeEventListener("mousedown", this.onmousedown), this.combobox.destroy(), this.combobox = null, e.remove(), 0));
          }
        }, {
          key: "onCommit",
          value: function onCommit(_ref61) {
            var e = _ref61.target;
            var t = e;
            if (!(t instanceof HTMLElement)) return;
            if (!this.combobox) return;
            var n = this.match;
            if (!n) return;
            var r = this.input.value.substring(0, n.position - n.key.length),
                o = this.input.value.substring(n.position + n.text.length),
                i = {
              item: t,
              key: n.key,
              value: null
            };
            if (!this.expander.dispatchEvent(new CustomEvent("text-expander-value", {
              cancelable: !0,
              detail: i
            }))) return;
            if (!i.value) return;
            var s = "".concat(i.value, " ");
            this.input.value = r + s + o;
            var a = r.length + s.length;
            this.deactivate(), this.input.focus({
              preventScroll: !0
            }), this.input.selectionStart = a, this.input.selectionEnd = a, this.lookBackIndex = a, this.match = null;
          }
        }, {
          key: "onBlur",
          value: function onBlur() {
            this.interactingWithList ? this.interactingWithList = !1 : this.deactivate();
          }
        }, {
          key: "onPaste",
          value: function onPaste() {
            this.justPasted = !0;
          }
        }, {
          key: "onInput",
          value: function () {
            var _onInput = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
              var e, _t70;

              return _regeneratorRuntime.wrap(function _callee13$(_context13) {
                while (1) {
                  switch (_context13.prev = _context13.next) {
                    case 0:
                      if (!this.justPasted) {
                        _context13.next = 2;
                        break;
                      }

                      return _context13.abrupt("return", void (this.justPasted = !1));

                    case 2:
                      e = this.findMatch();

                      if (!e) {
                        _context13.next = 13;
                        break;
                      }

                      this.match = e;
                      _context13.next = 7;
                      return this.notifyProviders(e);

                    case 7:
                      _t70 = _context13.sent;

                      if (this.match) {
                        _context13.next = 10;
                        break;
                      }

                      return _context13.abrupt("return");

                    case 10:
                      _t70 ? this.activate(e, _t70) : this.deactivate();
                      _context13.next = 14;
                      break;

                    case 13:
                      this.match = null, this.deactivate();

                    case 14:
                    case "end":
                      return _context13.stop();
                  }
                }
              }, _callee13, this);
            }));

            function onInput() {
              return _onInput.apply(this, arguments);
            }

            return onInput;
          }()
        }, {
          key: "findMatch",
          value: function findMatch() {
            var e = this.input.selectionEnd || 0,
                t = this.input.value;
            e <= this.lookBackIndex && (this.lookBackIndex = e - 1);

            var _iterator26 = _createForOfIteratorHelper(this.expander.keys),
                _step26;

            try {
              for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
                var _ref63 = _step26.value;
                var _n42 = _ref63.key;
                var _r41 = _ref63.multiWord;

                var _o26 = Re(t, _n42, e, {
                  multiWord: _r41,
                  lookBackIndex: this.lookBackIndex,
                  lastMatchPosition: this.match ? this.match.position : null
                });

                if (_o26) return {
                  text: _o26.text,
                  key: _n42,
                  position: _o26.position
                };
              }
            } catch (err) {
              _iterator26.e(err);
            } finally {
              _iterator26.f();
            }
          }
        }, {
          key: "notifyProviders",
          value: function () {
            var _notifyProviders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(e) {
              var t;
              return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                while (1) {
                  switch (_context14.prev = _context14.next) {
                    case 0:
                      t = [];

                      if (!this.expander.dispatchEvent(new CustomEvent("text-expander-change", {
                        cancelable: !0,
                        detail: {
                          provide: function provide(e) {
                            return t.push(e);
                          },
                          text: e.text,
                          key: e.key
                        }
                      }))) {
                        _context14.next = 5;
                        break;
                      }

                      _context14.next = 4;
                      return Promise.all(t);

                    case 4:
                      return _context14.abrupt("return", _context14.sent.filter(function (e) {
                        return e.matched;
                      }).map(function (e) {
                        return e.fragment;
                      })[0]);

                    case 5:
                    case "end":
                      return _context14.stop();
                  }
                }
              }, _callee14, this);
            }));

            function notifyProviders(_x12) {
              return _notifyProviders.apply(this, arguments);
            }

            return notifyProviders;
          }()
        }, {
          key: "onMousedown",
          value: function onMousedown() {
            this.interactingWithList = !0;
          }
        }, {
          key: "onKeydown",
          value: function onKeydown(e) {
            "Escape" === e.key && (this.match = null, this.deactivate() && (this.lookBackIndex = this.input.selectionEnd || this.lookBackIndex, e.stopImmediatePropagation(), e.preventDefault()));
          }
        }]);

        return Ue;
      }();

      var ze = /*#__PURE__*/function (_HTMLElement7) {
        _inherits(ze, _HTMLElement7);

        var _super102 = _createSuper(ze);

        function ze() {
          _classCallCheck(this, ze);

          return _super102.apply(this, arguments);
        }

        _createClass(ze, [{
          key: "keys",
          get: function get() {
            var e = this.getAttribute("keys"),
                t = e ? e.split(" ") : [],
                n = this.getAttribute("multiword"),
                r = n ? n.split(" ") : [],
                o = 0 === r.length && this.hasAttribute("multiword");
            return t.map(function (e) {
              return {
                key: e,
                multiWord: o || r.includes(e)
              };
            });
          }
        }, {
          key: "connectedCallback",
          value: function connectedCallback() {
            var e = this.querySelector('input[type="text"], textarea');
            if (!(e instanceof HTMLInputElement || e instanceof HTMLTextAreaElement)) return;
            var t = new Ue(this, e);
            He.set(this, t);
          }
        }, {
          key: "disconnectedCallback",
          value: function disconnectedCallback() {
            var e = He.get(this);
            e && (e.destroy(), He.delete(this));
          }
        }, {
          key: "dismiss",
          value: function dismiss() {
            var e = He.get(this);
            e && e.dismissMenu();
          }
        }]);

        return ze;
      }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

      window.customElements.get("text-expander") || (window.TextExpanderElement = ze, window.customElements.define("text-expander", ze));
      var Ye = n(6599).Mx.start(),
          qe = n(321);
      Ye.load(function (e) {
        return e.keys().map(function (t) {
          return function (e, t) {
            var n = function (e) {
              var t = (e.match(/^(?:\.\/)?(.+)(?:[_-]controller\..+?)$/) || [])[1];
              if (t) return t.replace(/_/g, "-").replace(/\//g, "--");
            }(t);

            if (n) return function (e, t) {
              var n = e.default;
              if ("function" == typeof n) return {
                identifier: t,
                controllerConstructor: n
              };
            }(e(t), n);
          }(e, t);
        }).filter(function (e) {
          return e;
        });
      }(qe)), Ye.warnings = !1;
    }(), r;
  }();
});